
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("kWbha", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "JQLEditorUIWithErrorBoundaryOld", () => $4cb1f76047f3a579$export$92f0ecbbb0018d8e);
$parcel$export(module.exports, "default", () => $4cb1f76047f3a579$export$2e2bcd8739ae039);

var $3hlKc = parcelRequire("3hlKc");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7CMCs = parcelRequire("7CMCs");

var $gcl1l = parcelRequire("gcl1l");

var $koVbs = parcelRequire("koVbs");

var $3RNwj = parcelRequire("3RNwj");

var $OomEm = parcelRequire("OomEm");

var $8vNru = parcelRequire("8vNru");

var $caSpf = parcelRequire("caSpf");

var $iXVV6 = parcelRequire("iXVV6");
var $2NMNM = parcelRequire("2NMNM");

var $dCm1o = parcelRequire("dCm1o");

var $5Dsab = parcelRequire("5Dsab");

var $8OILN = parcelRequire("8OILN");

var $izCUH = parcelRequire("izCUH");

var $hJajZ = parcelRequire("hJajZ");

var $aFqsz = parcelRequire("aFqsz");

var $98azu = parcelRequire("98azu");

var $kG16F = parcelRequire("kG16F");

var $kQ256 = parcelRequire("kQ256");

var $lW1IZ = parcelRequire("lW1IZ");

var $b1PJk = parcelRequire("b1PJk");

var $f1i4L = parcelRequire("f1i4L");

var $2XDsM = parcelRequire("2XDsM");

var $9odpA = parcelRequire("9odpA");

var $1pbLo = parcelRequire("1pbLo");

var $cm9Cg = parcelRequire("cm9Cg");

var $dj8g2 = parcelRequire("dj8g2");

var $jfT3r = parcelRequire("jfT3r");

var $8chE6 = parcelRequire("8chE6");
/* eslint-disable @atlassian/relay/unused-fields, @atlassian/relay/graphql-naming  */ const $4cb1f76047f3a579$var$JQL_EDITOR_HYDRATION_FRAGMENT = (0, $3hlKc.default);
/* eslint-enable @atlassian/relay/unused-fields, @atlassian/relay/graphql-naming */ const $4cb1f76047f3a579$var$JQLEditorUIOld = ({ query: query, onSearch: onSearch, onSwitchToJql: onSwitchToJql, excludedFields: excludedFields = [], onReady: onReady, onJourneyStart: onJourneyStart, NoOptionComponent: NoOptionComponent, hydrationQueryRef: hydrationQueryRef, isHydrating: isHydrating, projectOptions: projectOptions, singleSelectFields: singleSelectFields, shouldUseListMarkup: shouldUseListMarkup, hideOperatorDropdown: hideOperatorDropdown = false, irremovableFields: irremovableFields, hideTextSearchInput: hideTextSearchInput = false, searchPlaceholder: searchPlaceholder, showOrderByPicker: showOrderByPicker = false, contextJql: contextJql, viewContext: viewContext, scope: scope = null, suggestedUsersCount: suggestedUsersCount })=>{
    const onPerformanceMark = (0, $caSpf.usePerformanceContext)();
    (0, $5uXOq.useLayoutEffect)(()=>{
        onPerformanceMark({
            mark: (0, $8vNru.JQL_BUILDER_PERFORMANCE_MARKS).JQL_BUILDER_BASIC_JS_END
        });
    }, [
        onPerformanceMark
    ]);
    // eslint-disable-next-line @atlassian/relay/query-restriction
    const hydratedData = (0, $8Uumt.usePreloadedQuery)((0, $OomEm.HYDRATION_QUERY), hydrationQueryRef);
    const fieldsHydrationData = (0, $8Uumt.useFragment)($4cb1f76047f3a579$var$JQL_EDITOR_HYDRATION_FRAGMENT, hydratedData);
    const loading = isHydrating ?? false;
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (loading === false) onReady && onReady();
    }, [
        loading,
        onReady
    ]);
    const intl = (0, $koVbs.default)();
    const [ast] = (0, $kG16F.useAST)();
    const [textSearchInputClause] = (0, $kG16F.useTextSearchInputClause)();
    const [{ astClauseOrder: astClauseOrder, clausesByFieldId: clausesByFieldId, secondaryClausesByFieldId: secondaryClausesByFieldId }] = (0, $lW1IZ.useSearchState)();
    const { isShortcutsDialogIntegrationAvailable: isShortcutsDialogIntegrationAvailable } = (0, $kQ256.useIntegrateDotDialogContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { internalState: internalState, setInternalState: setInternalState } = (0, $8chE6.useFieldsToRender)({
        query: query,
        loading: loading,
        fieldsHydrationData: fieldsHydrationData,
        excludedFields: excludedFields,
        irremovableFields: irremovableFields
    });
    const onSearchWrapper = (0, $5uXOq.useCallback)((jql)=>{
        if (onSearch) {
            setInternalState({
                internalJql: jql
            });
            onSearch(jql);
        }
    }, [
        onSearch,
        setInternalState
    ]);
    const onFieldsUpdate = (0, $5uXOq.useCallback)(({ fieldsToRender: fieldsToRender, selectedFields: selectedFields })=>{
        if (fieldsToRender !== undefined || selectedFields !== undefined) setInternalState({
            ...fieldsToRender !== undefined ? {
                fieldsToRender: fieldsToRender
            } : {},
            ...selectedFields !== undefined ? {
                selectedFields: selectedFields
            } : {}
        });
    }, [
        setInternalState
    ]);
    // Required fields are those that are never modified by the More dropdown (AddFilter component).
    // The More dropdown only manages optional fields.
    // Required fields:
    // - Cannot be added from the More dropdown
    // - Cannot be cleared from the More dropdown, if they are in the query, they remain in the query
    const requiredFields = (0, $5uXOq.useMemo)(()=>new Set([
            ...irremovableFields.keys(),
            ...excludedFields ?? []
        ]), [
        excludedFields,
        irremovableFields
    ]);
    const onClearAddFilterValues = (0, $5uXOq.useCallback)(()=>{
        const { fieldsToRender: fieldsToRender, optionalFieldsCount: optionalFieldsCount } = (0, $b1PJk.gatherFields)({
            selectedFields: [],
            excludedFields: excludedFields,
            intl: intl,
            fieldsHydratedData: fieldsHydrationData,
            irremovableFields: irremovableFields,
            astClauseOrder: astClauseOrder,
            clausesByFieldId: clausesByFieldId,
            secondaryClausesByFieldId: secondaryClausesByFieldId
        });
        setInternalState({
            selectedFields: [],
            fieldsToRender: fieldsToRender,
            optionalFieldsCount: optionalFieldsCount
        });
        onSearchWrapper((0, $2XDsM.removeOptionalFieldsFromJql)(ast, requiredFields, textSearchInputClause));
    }, [
        ast,
        excludedFields,
        intl,
        fieldsHydrationData,
        irremovableFields,
        astClauseOrder,
        clausesByFieldId,
        secondaryClausesByFieldId,
        setInternalState,
        onSearchWrapper,
        requiredFields,
        textSearchInputClause
    ]);
    const { showLoadingState: showLoadingState, fieldsToRender: fieldsToRender, selectedFields: selectedFields, optionalFieldsCount: optionalFieldsCount } = internalState;
    const StyledListItemChildComponent = (0, $dCm1o.isVisualRefreshEnabled)() ? (0, $hJajZ.default) : (0, $aFqsz.StyledListItemChild);
    const FieldWrapper = shouldUseListMarkup ? StyledListItemChildComponent : (0, $aFqsz.StyledChild);
    const orderByFieldCount = (0, $5uXOq.useMemo)(()=>showOrderByPicker ? (0, $f1i4L.getAstSortFields)(ast).length : undefined, [
        ast,
        showOrderByPicker
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, showLoadingState ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $izCUH.JQLEditorLoading), {
        fieldsToRender: fieldsToRender,
        optionalFieldsCount: optionalFieldsCount,
        shouldUseListMarkup: shouldUseListMarkup,
        hideTextSearchInput: hideTextSearchInput,
        searchPlaceholder: searchPlaceholder,
        showOrderByPicker: showOrderByPicker,
        orderByFieldsCount: orderByFieldCount
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $98azu.ActivePopupKeyContainer), {
        createAnalyticsEvent: createAnalyticsEvent,
        onJourneyStart: onJourneyStart
    }, !hideTextSearchInput && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            fieldType: (0, $5Dsab.getTextSearchInputField)(),
            searchTemplate: (0, $5Dsab.getTextSearchInputField)(),
            refinementType: (0, $8OILN.PickerTypes).Text,
            propType: (0, $8OILN.GenericPropTypes).NoProp
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jfT3r.TextSearchInput), {
        onSearchWrapper: onSearchWrapper,
        onJourneyStart: onJourneyStart,
        shouldUseListMarkup: shouldUseListMarkup,
        placeholder: searchPlaceholder
    })), fieldsToRender.map((fieldToRender)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
            key: fieldToRender.fieldId,
            attributes: {
                fieldType: fieldToRender.picker.fieldType,
                searchTemplate: fieldToRender.picker.searchTemplate,
                refinementType: fieldToRender.picker.pickerType,
                propType: fieldToRender.picker.propType
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1pbLo.default), {
            key: fieldToRender.fieldId,
            fieldToRender: fieldToRender,
            onSearchWrapper: onSearchWrapper,
            onSwitchToJql: onSwitchToJql,
            fieldsToRender: fieldsToRender,
            selectedFields: selectedFields,
            onClearPicker: onFieldsUpdate,
            loading: loading,
            hydratedData: hydratedData,
            projectOptions: projectOptions,
            singleSelectFields: singleSelectFields,
            shouldUseListMarkup: shouldUseListMarkup,
            hideOperatorDropdown: hideOperatorDropdown,
            contextJql: contextJql,
            viewContext: viewContext,
            scope: scope,
            suggestedUsersCount: suggestedUsersCount
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9odpA.AddFilter), {
        NoOptionComponent: NoOptionComponent,
        value: selectedFields,
        fieldsToRender: fieldsToRender,
        selectedFields: selectedFields,
        onSearchWrapper: onSearchWrapper,
        onClearValues: onClearAddFilterValues,
        onChange: onFieldsUpdate,
        excludeFields: requiredFields,
        contextJql: contextJql,
        viewContext: viewContext,
        scope: scope
    })), showOrderByPicker && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cm9Cg.default), {
        ast: ast,
        onChange: onSearchWrapper,
        contextJql: contextJql,
        hydrationData: fieldsHydrationData,
        viewContext: viewContext,
        scope: scope
    })), isShortcutsDialogIntegrationAvailable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dj8g2.AsyncRegisterSearchCriteriaToShortcutsDialog), {
        fieldsToRender: fieldsToRender,
        selectedFields: selectedFields,
        onChange: onFieldsUpdate
    })));
};
const $4cb1f76047f3a579$export$92f0ecbbb0018d8e = (props)=>{
    const [ast] = (0, $kG16F.useAST)();
    const getErrorAttributes = (0, $5uXOq.useCallback)((error)=>({
            ...(0, $gcl1l.isLoaderErrorAttributes)(error),
            anonymizedJql: ast.query ? ast.query.accept((0, $5Dsab.jqlAnonymizerVisitor)) : undefined
        }), [
        ast.query
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "ui.jql-builder-basic.jql-editor.error-boundary",
        packageName: (0, $5Dsab.PACKAGE_NAME),
        teamName: (0, $5Dsab.TEAM_NAME),
        sendToPrivacyUnsafeSplunk: true,
        attributes: getErrorAttributes,
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3RNwj.JQLBuilderErrorBoundryFallback), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4cb1f76047f3a579$var$JQLEditorUIOld, props));
};
const $4cb1f76047f3a579$var$JQLEditorUI = ({ query: query, onSearch: onSearch, onSwitchToJql: onSwitchToJql, excludedFields: excludedFields = [], onReady: onReady, onJourneyStart: onJourneyStart, NoOptionComponent: NoOptionComponent, AddFilterButtonComponent: AddFilterButtonComponent, hydrationData: hydrationData, isHydrating: isHydrating, projectOptions: projectOptions, singleSelectFields: singleSelectFields, shouldUseListMarkup: shouldUseListMarkup, hideOperatorDropdown: hideOperatorDropdown = false, irremovableFields: irremovableFields, hideTextSearchInput: hideTextSearchInput = false, searchPlaceholder: searchPlaceholder, showOrderByPicker: showOrderByPicker = false, contextJql: contextJql, viewContext: viewContext, scope: scope = null, suggestedUsersCount: suggestedUsersCount })=>{
    const onPerformanceMark = (0, $caSpf.usePerformanceContext)();
    (0, $5uXOq.useLayoutEffect)(()=>{
        onPerformanceMark({
            mark: (0, $8vNru.JQL_BUILDER_PERFORMANCE_MARKS).JQL_BUILDER_BASIC_JS_END
        });
    }, [
        onPerformanceMark
    ]);
    const fieldsHydrationData = (0, $8Uumt.useFragment)($4cb1f76047f3a579$var$JQL_EDITOR_HYDRATION_FRAGMENT, hydrationData);
    const loading = isHydrating ?? false;
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (loading === false) onReady && onReady();
    }, [
        loading,
        onReady
    ]);
    const intl = (0, $koVbs.default)();
    const [ast] = (0, $kG16F.useAST)();
    const [textSearchInputClause] = (0, $kG16F.useTextSearchInputClause)();
    const [{ astClauseOrder: astClauseOrder, clausesByFieldId: clausesByFieldId, secondaryClausesByFieldId: secondaryClausesByFieldId }] = (0, $lW1IZ.useSearchState)();
    const { isShortcutsDialogIntegrationAvailable: isShortcutsDialogIntegrationAvailable } = (0, $kQ256.useIntegrateDotDialogContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { internalState: internalState, setInternalState: setInternalState } = (0, $8chE6.useFieldsToRender)({
        query: query,
        loading: loading,
        fieldsHydrationData: fieldsHydrationData,
        excludedFields: excludedFields,
        irremovableFields: irremovableFields
    });
    const onSearchWrapper = (0, $5uXOq.useCallback)((jql)=>{
        if (onSearch) {
            setInternalState({
                internalJql: jql
            });
            onSearch(jql);
        }
    }, [
        onSearch,
        setInternalState
    ]);
    const onFieldsUpdate = (0, $5uXOq.useCallback)(({ fieldsToRender: fieldsToRender, selectedFields: selectedFields })=>{
        if (fieldsToRender !== undefined || selectedFields !== undefined) setInternalState({
            ...fieldsToRender !== undefined ? {
                fieldsToRender: fieldsToRender
            } : {},
            ...selectedFields !== undefined ? {
                selectedFields: selectedFields
            } : {}
        });
    }, [
        setInternalState
    ]);
    // Required fields are those that are never modified by the More dropdown (AddFilter component).
    // The More dropdown only manages optional fields.
    // Required fields:
    // - Cannot be added from the More dropdown
    // - Cannot be cleared from the More dropdown, if they are in the query, they remain in the query
    const requiredFields = (0, $5uXOq.useMemo)(()=>new Set([
            ...irremovableFields.keys(),
            ...excludedFields ?? []
        ]), [
        excludedFields,
        irremovableFields
    ]);
    const onClearAddFilterValues = (0, $5uXOq.useCallback)(()=>{
        const { fieldsToRender: fieldsToRender, optionalFieldsCount: optionalFieldsCount } = (0, $b1PJk.gatherFields)({
            selectedFields: [],
            excludedFields: excludedFields,
            intl: intl,
            fieldsHydratedData: fieldsHydrationData,
            irremovableFields: irremovableFields,
            astClauseOrder: astClauseOrder,
            clausesByFieldId: clausesByFieldId,
            secondaryClausesByFieldId: secondaryClausesByFieldId
        });
        setInternalState({
            selectedFields: [],
            fieldsToRender: fieldsToRender,
            optionalFieldsCount: optionalFieldsCount
        });
        onSearchWrapper((0, $2XDsM.removeOptionalFieldsFromJql)(ast, requiredFields, textSearchInputClause));
    }, [
        ast,
        excludedFields,
        intl,
        fieldsHydrationData,
        irremovableFields,
        astClauseOrder,
        clausesByFieldId,
        secondaryClausesByFieldId,
        setInternalState,
        onSearchWrapper,
        requiredFields,
        textSearchInputClause
    ]);
    const { showLoadingState: showLoadingState, fieldsToRender: fieldsToRender, selectedFields: selectedFields, optionalFieldsCount: optionalFieldsCount } = internalState;
    const StyledListItemChildComponent = (0, $dCm1o.isVisualRefreshEnabled)() ? (0, $hJajZ.default) : (0, $aFqsz.StyledListItemChild);
    const FieldWrapper = shouldUseListMarkup ? StyledListItemChildComponent : (0, $aFqsz.StyledChild);
    const orderByFieldCount = (0, $5uXOq.useMemo)(()=>showOrderByPicker ? (0, $f1i4L.getAstSortFields)(ast).length : undefined, [
        ast,
        showOrderByPicker
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, showLoadingState ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $izCUH.JQLEditorLoading), {
        fieldsToRender: fieldsToRender,
        optionalFieldsCount: optionalFieldsCount,
        shouldUseListMarkup: shouldUseListMarkup,
        hideTextSearchInput: hideTextSearchInput,
        searchPlaceholder: searchPlaceholder,
        showOrderByPicker: showOrderByPicker,
        orderByFieldsCount: orderByFieldCount
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $98azu.ActivePopupKeyContainer), {
        createAnalyticsEvent: createAnalyticsEvent,
        onJourneyStart: onJourneyStart
    }, !hideTextSearchInput && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            fieldType: (0, $5Dsab.getTextSearchInputField)(),
            searchTemplate: (0, $5Dsab.getTextSearchInputField)(),
            refinementType: (0, $8OILN.PickerTypes).Text,
            propType: (0, $8OILN.GenericPropTypes).NoProp
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jfT3r.TextSearchInput), {
        onSearchWrapper: onSearchWrapper,
        onJourneyStart: onJourneyStart,
        shouldUseListMarkup: shouldUseListMarkup,
        placeholder: searchPlaceholder
    })), fieldsToRender.map((fieldToRender)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
            key: fieldToRender.fieldId,
            attributes: {
                fieldType: fieldToRender.picker.fieldType,
                searchTemplate: fieldToRender.picker.searchTemplate,
                refinementType: fieldToRender.picker.pickerType,
                propType: fieldToRender.picker.propType
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1pbLo.default), {
            key: fieldToRender.fieldId,
            fieldToRender: fieldToRender,
            onSearchWrapper: onSearchWrapper,
            onSwitchToJql: onSwitchToJql,
            fieldsToRender: fieldsToRender,
            selectedFields: selectedFields,
            onClearPicker: onFieldsUpdate,
            loading: loading,
            hydratedData: hydrationData,
            projectOptions: projectOptions,
            singleSelectFields: singleSelectFields,
            shouldUseListMarkup: shouldUseListMarkup,
            hideOperatorDropdown: hideOperatorDropdown,
            contextJql: contextJql,
            viewContext: viewContext,
            scope: scope,
            suggestedUsersCount: suggestedUsersCount
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9odpA.AddFilter), {
        NoOptionComponent: NoOptionComponent,
        ButtonComponent: AddFilterButtonComponent,
        value: selectedFields,
        fieldsToRender: fieldsToRender,
        selectedFields: selectedFields,
        onSearchWrapper: onSearchWrapper,
        onClearValues: onClearAddFilterValues,
        onChange: onFieldsUpdate,
        excludeFields: requiredFields,
        contextJql: contextJql,
        viewContext: viewContext,
        scope: scope
    })), showOrderByPicker && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cm9Cg.default), {
        ast: ast,
        onChange: onSearchWrapper,
        contextJql: contextJql,
        hydrationData: fieldsHydrationData,
        viewContext: viewContext,
        scope: scope
    })), isShortcutsDialogIntegrationAvailable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dj8g2.AsyncRegisterSearchCriteriaToShortcutsDialog), {
        fieldsToRender: fieldsToRender,
        selectedFields: selectedFields,
        onChange: onFieldsUpdate
    })));
};
const $4cb1f76047f3a579$var$JQLEditorUIWithErrorBoundary = (props)=>{
    const [ast] = (0, $kG16F.useAST)();
    const getErrorAttributes = (0, $5uXOq.useCallback)((error)=>({
            ...(0, $gcl1l.isLoaderErrorAttributes)(error),
            anonymizedJql: ast.query ? ast.query.accept((0, $5Dsab.jqlAnonymizerVisitor)) : undefined
        }), [
        ast.query
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "ui.jql-builder-basic.jql-editor.error-boundary",
        packageName: (0, $5Dsab.PACKAGE_NAME),
        teamName: (0, $5Dsab.TEAM_NAME),
        sendToPrivacyUnsafeSplunk: true,
        attributes: getErrorAttributes,
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3RNwj.JQLBuilderErrorBoundryFallback), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4cb1f76047f3a579$var$JQLEditorUI, props));
};
var $4cb1f76047f3a579$export$2e2bcd8739ae039 = $4cb1f76047f3a579$var$JQLEditorUIWithErrorBoundary;

});
parcelRegister("3hlKc", function(module, exports) {

$parcel$export(module.exports, "default", () => $5417b95803cd62be$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ce939043dc0110b72159bd99be7eec83>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5417b95803cd62be$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "scope"
    }, v1 = {
        "kind": "Variable",
        "name": "viewContext",
        "variableName": "viewContext"
    }, v2 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v3 = [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "fields",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "jqlTerm"
                                },
                                {
                                    "concreteType": "JiraJqlField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "concreteType": "JiraJqlSearchTemplate",
                                            "kind": "LinkedField",
                                            "name": "searchTemplate",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "key"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "shouldShowInContext"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "description"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "operators"
                                        },
                                        {
                                            "concreteType": "JiraFieldType",
                                            "kind": "LinkedField",
                                            "name": "fieldType",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraJqlQueryHydratedField"
                        }
                    ]
                }
            ],
            "type": "JiraJqlHydratedQuery"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "filterAri"
            },
            {
                "kind": "RootArgument",
                "name": "includeJira"
            },
            {
                "kind": "RootArgument",
                "name": "isFilter"
            },
            {
                "kind": "RootArgument",
                "name": "jql"
            },
            {
                "kind": "RootArgument",
                "name": "scope"
            },
            {
                "kind": "RootArgument",
                "name": "viewContext"
            }
        ],
        "kind": "Fragment",
        "name": "jqlEditor_jqlBuilderBasic_JQLEditorUI",
        "selections": [
            {
                "condition": "includeJira",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudId",
                                        "variableName": "cloudId"
                                    }
                                ],
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "condition": "isFilter",
                                        "kind": "Condition",
                                        "passingValue": false,
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "query",
                                                        "variableName": "jql"
                                                    },
                                                    v0 /*: any*/ ,
                                                    v1 /*: any*/ 
                                                ],
                                                "kind": "LinkedField",
                                                "name": "hydrateJqlQuery",
                                                "plural": false,
                                                "selections": v3 /*: any*/ 
                                            }
                                        ]
                                    },
                                    {
                                        "condition": "isFilter",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "id",
                                                        "variableName": "filterAri"
                                                    },
                                                    v0 /*: any*/ ,
                                                    v1 /*: any*/ 
                                                ],
                                                "kind": "LinkedField",
                                                "name": "hydrateJqlQueryForFilter",
                                                "plural": false,
                                                "selections": v3 /*: any*/ 
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$5417b95803cd62be$var$node.hash = "e54634a653773f813b3e12b21b9e22c7";
var $5417b95803cd62be$export$2e2bcd8739ae039 = $5417b95803cd62be$var$node;

});

parcelRegister("3RNwj", function(module, exports) {

$parcel$export(module.exports, "JQLBuilderErrorBoundryFallback", () => $8e5460bcff63ee1a$export$4c766016a5659721);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $92Z2l = parcelRequire("92Z2l");

var $koVbs = parcelRequire("koVbs");

var $iWDqa = parcelRequire("iWDqa");
const $8e5460bcff63ee1a$var$onRefresh = ()=>{
    if (typeof window !== 'undefined') window.location.reload();
};
const $8e5460bcff63ee1a$export$4c766016a5659721 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "error",
        testId: "jql-builder-common.ui.error-boundry-fallback.section-message"
    }, formatMessage((0, $iWDqa.default).errorMessage, {
        link: (linkText)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                appearance: "link",
                spacing: "none",
                onClick: $8e5460bcff63ee1a$var$onRefresh
            }, linkText)
    }));
};

});
parcelRegister("92Z2l", function(module, exports) {

$parcel$export(module.exports, "default", () => $a97355a0cc6aeb06$export$2e2bcd8739ae039);
/* section-message.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
var $414Wj = parcelRequire("414Wj");

var $3HeRx = parcelRequire("3HeRx");
const $a97355a0cc6aeb06$var$sectionMessageStyles = {
    container: "_2rkoglpi _1nmz1hna",
    bleed: "_1mou1i6y _1e0c1txw",
    content: "_11c82smr _syaz1fxt",
    actionsContainer: "_11c82smr"
};
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ const $a97355a0cc6aeb06$var$SectionMessage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, icon: icon, testId: testId }, ref) {
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, $3HeRx.getAppearanceIconStyles)(appearance, icon);
    const actionElements = actions && actions.type === (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment ? actions.props.children : actions;
    const actionsArray = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(actionElements);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "section",
        backgroundColor: $a97355a0cc6aeb06$var$appearanceMap[appearance],
        padding: "space.200",
        testId: testId,
        ref: ref,
        xcss: $a97355a0cc6aeb06$var$sectionMessageStyles.container,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
            space: "space.200",
            alignBlock: "stretch",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    xcss: $a97355a0cc6aeb06$var$sectionMessageStyles.bleed,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                        size: "medium",
                        primaryColor: primaryColor,
                        secondaryColor: secondaryColor,
                        // props for new icon
                        LEGACY_size: "medium",
                        color: primaryColor,
                        spacing: "spacious"
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $414Wj.default), {
                    space: "space.100",
                    testId: testId && `${testId}--content`,
                    children: [
                        !!title && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                            as: "h2",
                            size: "small",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                            xcss: $a97355a0cc6aeb06$var$sectionMessageStyles.content,
                            children: children
                        }),
                        actionsArray.length > 0 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
                            shouldWrap: true,
                            testId: testId && `${testId}--actions`,
                            separator: "\xb7",
                            space: "space.100",
                            rowSpace: "space.0",
                            // Only use a list role if more than one action is present
                            role: actionsArray.length > 1 ? 'list' : undefined,
                            xcss: (0, $VSDnB.fg)('platform_ads_explicit_font_styles') && $a97355a0cc6aeb06$var$sectionMessageStyles.actionsContainer,
                            children: actionsArray.map((action, id)=>// Only use a listitem role if more than one action is present
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
                                    role: actionsArray.length > 1 ? 'listitem' : undefined,
                                    children: action
                                }, id))
                        })
                    ]
                })
            ]
        })
    });
});
const $a97355a0cc6aeb06$var$appearanceMap = {
    information: 'color.background.information',
    warning: 'color.background.warning',
    error: 'color.background.danger',
    success: 'color.background.success',
    discovery: 'color.background.discovery'
};
$a97355a0cc6aeb06$var$SectionMessage.displayName = 'SectionMessage';
var $a97355a0cc6aeb06$export$2e2bcd8739ae039 = $a97355a0cc6aeb06$var$SectionMessage;

});
parcelRegister("3HeRx", function(module, exports) {

$parcel$export(module.exports, "getAppearanceIconStyles", () => $d1d7dced94bb00f5$export$e9b82d2e21ac0c1f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dD7Zc = parcelRequire("dD7Zc");

var $1jWct = parcelRequire("1jWct");

var $dg0Fl = parcelRequire("dg0Fl");

var $c2i4s = parcelRequire("c2i4s");

var $bU3PY = parcelRequire("bU3PY");

const $d1d7dced94bb00f5$var$appearanceIconSchema = {
    information: {
        backgroundColor: `var(--ds-background-information, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($1jWct))),
        primaryIconColor: `var(--ds-icon-information, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`
    },
    warning: {
        backgroundColor: `var(--ds-background-warning, ${(0, $829f609a65d26a98$export$8d9596b529bbb9cf)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))),
        primaryIconColor: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$874739ea9e379ab6)})`
    },
    error: {
        backgroundColor: `var(--ds-background-danger, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))),
        primaryIconColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`
    },
    success: {
        backgroundColor: `var(--ds-background-success, ${(0, $829f609a65d26a98$export$8a6341c32b6a3ee6)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))),
        primaryIconColor: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$6fa04827ac68a4fb)})`
    },
    discovery: {
        backgroundColor: `var(--ds-background-discovery, ${(0, $829f609a65d26a98$export$363e4475840015bb)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($dg0Fl))),
        primaryIconColor: `var(--ds-icon-discovery, ${(0, $829f609a65d26a98$export$147899de772240ec)})`
    }
};
function $d1d7dced94bb00f5$export$e9b82d2e21ac0c1f(appearance, icon) {
    const appearanceIconStyles = $d1d7dced94bb00f5$var$appearanceIconSchema[appearance] || $d1d7dced94bb00f5$var$appearanceIconSchema.information;
    const AppearanceIcon = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, $2OMIu.jsx)(appearanceIconStyles.Icon, {
            LEGACY_size: size,
            color: primaryColor,
            spacing: "spacious",
            LEGACY_primaryColor: primaryColor,
            LEGACY_secondaryColor: secondaryColor,
            label: appearance
        });
    const Icon = icon || AppearanceIcon;
    return {
        ...appearanceIconStyles,
        Icon: Icon
    };
}

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';



parcelRegister("iWDqa", function(module, exports) {

$parcel$export(module.exports, "default", () => $c45ebd3e2c96181c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c45ebd3e2c96181c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorMessage: {
        "id": "jql-builder-common.error-boundry-fallback.error-message",
        "defaultMessage": "We couldn't load your search criteria. <link>Refresh the page</link> to try again."
    }
});

});


parcelRegister("98azu", function(module, exports) {

$parcel$export(module.exports, "ActivePopupKeyContainer", () => $dd77382a84af14bb$export$a23bda26408a297f);
$parcel$export(module.exports, "useActivePopupKey", () => $dd77382a84af14bb$export$f374a0a655a12cf3);

var $8zOmE = parcelRequire("8zOmE");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $5Dsab = parcelRequire("5Dsab");
const $dd77382a84af14bb$var$store = (0, $iXqE5.createStore)({
    initialState: {
        activeKey: ''
    },
    actions: {
        openPopup: (key)=>({ setState: setState }, { createAnalyticsEvent: createAnalyticsEvent, onJourneyStart: onJourneyStart })=>{
                setState({
                    activeKey: key
                });
                if (onJourneyStart) {
                    const analyticsEvent = createAnalyticsEvent({
                        action: 'opened',
                        actionSubject: 'dropdown'
                    });
                    const attributes = onJourneyStart();
                    // Only checking if it matches the "More +" dropdown.
                    // Not sending the key name directly as it would result in UGC for custom fields
                    attributes.isMoreFilters = String(key === (0, $5Dsab.ADD_FILTER_DROPDOWN));
                    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'refinementBarBasicPicker', attributes);
                }
            },
        closePopup: (key)=>({ getState: getState, setState: setState })=>{
                const { activeKey: activeKey } = getState();
                if (key === activeKey) setState({
                    activeKey: ''
                });
            },
        closeAllPopups: ()=>({ setState: setState })=>{
                setState({
                    activeKey: ''
                });
            }
    },
    name: 'JQLBasic-ActivePopup'
});
const $dd77382a84af14bb$export$a23bda26408a297f = (0, $gg7kZ.createContainer)($dd77382a84af14bb$var$store, {});
const $dd77382a84af14bb$export$f374a0a655a12cf3 = (0, $3sQ5x.createHook)($dd77382a84af14bb$var$store, {
    selector: ({ activeKey: activeKey })=>activeKey
});

});

parcelRegister("kQ256", function(module, exports) {

$parcel$export(module.exports, "useIntegrateDotDialogContext", () => $4f25f7900866c0e5$export$705d46354f301b1c);
$parcel$export(module.exports, "ShortcutsDialogIntegrationProvider", () => $4f25f7900866c0e5$export$97e3ca22c7078b46);

var $5uXOq = parcelRequire("5uXOq");
const $4f25f7900866c0e5$var$PRESET_VALUE = {
    DEFAULT: {
        isShortcutsDialogIntegrationAvailable: false
    },
    INTEGRATED: {
        isShortcutsDialogIntegrationAvailable: true
    }
};
const $4f25f7900866c0e5$var$IntegrateDotDialogContext = /*#__PURE__*/ (0, $5uXOq.createContext)($4f25f7900866c0e5$var$PRESET_VALUE.DEFAULT);
const $4f25f7900866c0e5$export$705d46354f301b1c = ()=>(0, $5uXOq.useContext)($4f25f7900866c0e5$var$IntegrateDotDialogContext);
const $4f25f7900866c0e5$export$97e3ca22c7078b46 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4f25f7900866c0e5$var$IntegrateDotDialogContext.Provider, {
        value: $4f25f7900866c0e5$var$PRESET_VALUE.INTEGRATED
    }, children);

});

parcelRegister("2XDsM", function(module, exports) {

$parcel$export(module.exports, "removeOptionalFieldsFromJql", () => $d01db46fac54d8af$export$b5bca93ddaa14d75);

var $l0V05 = parcelRequire("l0V05");
var $7CDw0 = parcelRequire("7CDw0");

var $04psE = parcelRequire("04psE");
const $d01db46fac54d8af$export$b5bca93ddaa14d75 = (ast, requiredFields, textSearchInputClause)=>{
    (0, $7CDw0.walkAST)({
        enterTerminalClause (terminalClause) {
            const isTextSearchInput = textSearchInputClause && new (0, $04psE.IsInCompoundClauseVisitor)(terminalClause).visit(textSearchInputClause);
            if (!requiredFields.has(terminalClause.field.value.toLowerCase()) && !isTextSearchInput) terminalClause.remove();
        }
    }, ast);
    return (0, $l0V05.print)(ast, {
        operatorCase: 'upper'
    });
};

});
parcelRegister("7CDw0", function(module, exports) {

$parcel$export(module.exports, "walkAST", () => $7a197641df0f0db3$export$a8de6ce748deffac);
const $7a197641df0f0db3$export$a8de6ce748deffac = (listener, jast)=>{
    jast.query && $7a197641df0f0db3$var$walkNode(listener, jast.query);
};
const $7a197641df0f0db3$var$walkNode = (listener, node)=>{
    listener.enterEveryNode && listener.enterEveryNode(node);
    node.enterNode(listener);
    node.getChildren().forEach((child)=>$7a197641df0f0db3$var$walkNode(listener, child));
    node.exitNode(listener);
    listener.exitEveryNode && listener.exitEveryNode(node);
};

});

parcelRegister("04psE", function(module, exports) {

$parcel$export(module.exports, "IsInCompoundClauseVisitor", () => $f4844e33c6a2bba0$export$e2ad94bc9eac2e29);

var $bv7J5 = parcelRequire("bv7J5");
class $f4844e33c6a2bba0$export$e2ad94bc9eac2e29 extends (0, $bv7J5.AbstractJastVisitor) {
    constructor(terminalClause){
        super(), this.visitCompoundClause = (compoundClause)=>compoundClause.clauses.reduce((result, clause)=>this.aggregateResult(clause.accept(this), result), false), this.visitTerminalClause = (terminalClause)=>terminalClause === this.terminalClause, this.aggregateResult = (aggregate, nextResult)=>aggregate || nextResult;
        this.terminalClause = terminalClause;
    }
    defaultResult() {
        return false;
    }
}

});


parcelRegister("9odpA", function(module, exports) {

$parcel$export(module.exports, "AddFilter", () => $e5a1742efac134f8$export$b317d04196c5962b);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $99M5v = parcelRequire("99M5v");

var $hORKG = parcelRequire("hORKG");

var $cgL5K = parcelRequire("cgL5K");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $6s1PB = parcelRequire("6s1PB");

var $86Rl2 = parcelRequire("86Rl2");

var $7mPT9 = parcelRequire("7mPT9");

var $lfTZh = parcelRequire("lfTZh");

var $5oFIy = parcelRequire("5oFIy");

var $dCm1o = parcelRequire("dCm1o");

var $kxZPA = parcelRequire("kxZPA");

var $cSD7y = parcelRequire("cSD7y");

var $6fhxU = parcelRequire("6fhxU");

var $98azu = parcelRequire("98azu");

var $kG16F = parcelRequire("kG16F");

var $i0Cp4 = parcelRequire("i0Cp4");

var $df3tg = parcelRequire("df3tg");

var $kYYJK = parcelRequire("kYYJK");

var $2royF = parcelRequire("2royF");

var $5Dsab = parcelRequire("5Dsab");

var $c5jWV = parcelRequire("c5jWV");

const $e5a1742efac134f8$export$ba25329847403e11 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("hDEjR")), {
    ssr: false,
    moduleId: "./src/packages/jql-builder/basic-picker/src/index.tsx"
});
const $e5a1742efac134f8$var$TriggerButtonWithMergeRef = ({ triggerRef: triggerRef, popupRef: popupRef, ButtonComponent: ButtonComponent, ...props })=>{
    const ref = (0, $7mPT9.default)(triggerRef, popupRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ButtonComponent, {
        ref: ref,
        ...props
    });
};
const $e5a1742efac134f8$var$isKeyboardEvent = (event)=>Object.hasOwn(event, 'key');
const $e5a1742efac134f8$export$372b15ab049a4156 = ({ value: value, fieldsToRender: fieldsToRender, selectedFields: selectedFields, onSearchWrapper: onSearchWrapper, onClearValues: onClearValues, NoOptionComponent: NoOptionComponent, onChange: onChange, excludeFields: excludeFields, contextJql: contextJql, viewContext: viewContext, scope: scope, ButtonComponent: ButtonComponent = (0, $fVnbM.default) })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [activePopupKey, { openPopup: openPopup, closePopup: closePopup }] = (0, $98azu.useActivePopupKey)();
    const onOpen = (0, $5uXOq.useCallback)(()=>{
        // Fire the experiment exposure
        (0, $6s1PB.expVal)('efa_and_project_fields_page_for_tmp', 'isEnabled', false);
        return openPopup((0, $5Dsab.ADD_FILTER_DROPDOWN));
    }, [
        openPopup
    ]);
    const onClose = (0, $5uXOq.useCallback)(()=>closePopup((0, $5Dsab.ADD_FILTER_DROPDOWN)), [
        closePopup
    ]);
    const [ast] = (0, $kG16F.useAST)();
    const [textSearchInputClause] = (0, $kG16F.useTextSearchInputClause)();
    const excludedFields = (0, $5uXOq.useMemo)(()=>Array.from(excludeFields), [
        excludeFields
    ]);
    const onLoadOptions = (0, $df3tg.useFields)({
        jql: contextJql,
        excludeFields: excludedFields,
        viewContext: viewContext,
        scope: scope
    });
    const isOpen = activePopupKey === (0, $5Dsab.ADD_FILTER_DROPDOWN);
    const sendAnalytics = (0, $2royF.useSendAnalytics)();
    const buttonRef = (0, $5uXOq.useRef)(null);
    const iconAfter = (0, $5uXOq.useMemo)(()=>(0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hORKG))), {
            label: "",
            color: // eslint-disable-next-line no-nested-ternary
            (0, $4R6GH.fg)('visual-refresh-headers-buttons') ? !isOpen ? "var(--ds-icon-subtle, #626F86)" : 'currentColor' : 'currentColor'
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($99M5v))), {
            label: "",
            LEGACY_size: "small"
        }), [
        isOpen
    ]);
    const buttonLabel = (0, $5uXOq.useMemo)(()=>{
        // eslint-disable-next-line no-nested-ternary
        return (0, $dCm1o.isVisualRefreshEnabled)() ? (0, $4R6GH.fg)('visual-refresh-headers-buttons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            weight: "medium",
            color: !isOpen ? 'color.text.subtle' : 'inherit'
        }, formatMessage((0, $6fhxU.default).moreButton)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, $6fhxU.default).moreButton)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, $6fhxU.default).moreButtonOld));
    }, [
        isOpen,
        formatMessage
    ]);
    const handleClose = (0, $5uXOq.useCallback)((event)=>{
        onClose();
        if ($e5a1742efac134f8$var$isKeyboardEvent(event) && event.key === 'Escape') buttonRef.current?.focus();
    }, [
        onClose
    ]);
    const CustomNoOptionsMessage = (0, $5uXOq.useCallback)(()=>NoOptionComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(NoOptionComponent, {
            onClickLink: onClose,
            sourceId: "moreFieldsPicker"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
            actionSubject: "unsupportedFieldsMessage",
            action: "viewed",
            actionSubjectId: "moreFieldsPicker"
        })) : undefined, [
        NoOptionComponent,
        onClose
    ]);
    const onTrigger = (0, $5uXOq.useCallback)(({ ref: ref })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e5a1742efac134f8$var$TriggerButtonWithMergeRef, {
            triggerRef: buttonRef,
            popupRef: ref,
            appearance: "default",
            iconAfter: iconAfter,
            isSelected: isOpen,
            "aria-expanded": isOpen,
            onClick: isOpen ? onClose : onOpen,
            label: formatMessage((0, $6fhxU.default).moreButtonLabel),
            "aria-label": formatMessage((0, $6fhxU.default).moreButtonLabel),
            testId: "jql-builder-basic.ui.jql-editor.add-filter.more-button",
            ButtonComponent: ButtonComponent
        }, buttonLabel);
    }, [
        iconAfter,
        isOpen,
        onClose,
        onOpen,
        formatMessage,
        ButtonComponent,
        buttonLabel
    ]);
    const handleChange = (0, $5uXOq.useCallback)((options, meta)=>{
        switch(meta.action){
            case (0, $86Rl2.MetaActions).selectOption:
                if ('option' in meta && meta.option?.optionType === 'field') {
                    const newSelectedFields = [
                        ...selectedFields,
                        meta.option
                    ];
                    const picker = (0, $i0Cp4.getPickerType)({
                        fieldType: meta.option.fieldType,
                        searchTemplate: meta.option.searchTemplate,
                        operators: meta.option.operators
                    });
                    const newFieldsToRender = [
                        ...fieldsToRender,
                        {
                            fieldId: meta.option.value,
                            fieldLabel: meta.option.label,
                            picker: picker,
                            clause: undefined,
                            secondaryClause: undefined,
                            fieldDescription: meta.option.fieldDescription,
                            fieldTypeDisplayName: meta.option.fieldTypeDisplayName
                        }
                    ];
                    onChange({
                        selectedFields: newSelectedFields,
                        fieldsToRender: newFieldsToRender
                    });
                    openPopup(meta.option.value);
                    sendAnalytics({
                        actionSubjectId: 'addFilter',
                        attributes: {
                            fieldType: picker.fieldType,
                            searchTemplate: picker.searchTemplate,
                            refinementType: picker.pickerType,
                            propType: picker.propType
                        }
                    });
                }
                break;
            case (0, $86Rl2.MetaActions).deselectOption:
                if ('option' in meta && meta.option?.optionType === 'field' && !meta.option.isDisabled) {
                    const newSelectedFields = selectedFields.filter((activeField)=>meta.option?.optionType === 'field' && meta.option.value !== activeField.value);
                    const newFieldsToRender = fieldsToRender.filter((fieldToRender)=>{
                        if (meta.option?.optionType === 'field' && meta.option?.value === fieldToRender.fieldId) {
                            onSearchWrapper && onSearchWrapper((0, $kYYJK.removeFieldsFromJql)(ast, new Set([
                                fieldToRender.fieldId
                            ]), textSearchInputClause));
                            return !!(fieldToRender.secondaryClause || fieldToRender.clause);
                        }
                        return true;
                    });
                    onChange({
                        selectedFields: newSelectedFields,
                        fieldsToRender: newFieldsToRender
                    });
                    const picker = (0, $i0Cp4.getPickerType)({
                        fieldType: meta.option.fieldType,
                        searchTemplate: meta.option.searchTemplate,
                        operators: meta.option.operators
                    });
                    sendAnalytics({
                        actionSubjectId: 'removeFilter',
                        attributes: {
                            fieldType: picker.fieldType,
                            searchTemplate: picker.searchTemplate,
                            refinementType: picker.pickerType,
                            propType: picker.propType,
                            isOnlyUnselectable: meta.option.isOnlyUnselectable ?? false
                        }
                    });
                }
                break;
            default:
        }
    }, [
        ast,
        fieldsToRender,
        onChange,
        onSearchWrapper,
        openPopup,
        textSearchInputClause,
        selectedFields,
        sendAnalytics
    ]);
    const TriggerButton = ButtonComponent ?? (0, $fVnbM.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "add-filter-picker",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TriggerButton, {
            iconAfter: iconAfter
        }, buttonLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e5a1742efac134f8$export$ba25329847403e11, {
        isOpen: isOpen,
        onClose: handleClose,
        value: value,
        id: (0, $5Dsab.ADD_FILTER_DROPDOWN),
        onChange: handleChange,
        onLoadOptions: onLoadOptions,
        enableFullList: false,
        onTrigger: onTrigger,
        onClearValues: onClearValues,
        CustomNoOptionsMessage: CustomNoOptionsMessage,
        shouldRenderToParent: true,
        searchInputPlaceholder: formatMessage((0, $6fhxU.default).searchMoreFiltersPlaceholder)
    }));
};
const $e5a1742efac134f8$export$b317d04196c5962b = (0, $cSD7y.componentWithFG)('jql_builder_lazy_picker_to_entrypoint', (0, $c5jWV.AddFilter), $e5a1742efac134f8$export$372b15ab049a4156);
var $e5a1742efac134f8$export$2e2bcd8739ae039 = $e5a1742efac134f8$export$b317d04196c5962b;

});
parcelRegister("86Rl2", function(module, exports) {

$parcel$export(module.exports, "MetaActions", () => $716472197bd84e50$export$50531cf3046c5956);
const $716472197bd84e50$export$50531cf3046c5956 = {
    setValue: 'set-value',
    inputChange: 'input-change',
    inputBlur: 'input-blur',
    menuClose: 'menu-close',
    selectOption: 'select-option',
    deselectOption: 'deselect-option',
    removeValue: 'remove-value',
    popValue: 'pop-value',
    clear: 'clear',
    createOption: 'create-option',
    clearOptions: 'clear-options',
    add: 'add',
    remove: 'remove',
    update: 'update'
};

});

parcelRegister("7mPT9", function(module, exports) {

$parcel$export(module.exports, "mergeRefs", () => $d1da29f25d5b5e0a$export$c9058316764c140e);
$parcel$export(module.exports, "default", () => $d1da29f25d5b5e0a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $d1da29f25d5b5e0a$export$c9058316764c140e(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref != null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref.current = value; // eslint-disable-line no-param-reassign
        });
    };
}
function $d1da29f25d5b5e0a$export$2e2bcd8739ae039(...refs) {
    return (0, $5uXOq.useMemo)(()=>$d1da29f25d5b5e0a$export$c9058316764c140e(...refs), // eslint-disable-next-line react-hooks/exhaustive-deps
    refs);
}

});

parcelRegister("df3tg", function(module, exports) {

$parcel$export(module.exports, "getOption", () => $e5a1f8af2787b304$export$6df0712d20d2cc08);
$parcel$export(module.exports, "useFields", () => $e5a1f8af2787b304$export$d25cd19bd4b6c629);

var $ipny0 = parcelRequire("ipny0");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");


var $cgL5K = parcelRequire("cgL5K");

var $jcw0u = parcelRequire("jcw0u");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $7pFAn = parcelRequire("7pFAn");

var $Nu4Sg = parcelRequire("Nu4Sg");

var $kHDIc = parcelRequire("kHDIc");

var $koeKL = parcelRequire("koeKL");

var $5Dsab = parcelRequire("5Dsab");

var $1dTaH = parcelRequire("1dTaH");

var $89g1C = parcelRequire("89g1C");

var $kqzZ0 = parcelRequire("kqzZ0");
const $e5a1f8af2787b304$var$WHERE_CLAUSE = 'WHERE';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $e5a1f8af2787b304$var$ORDER_BY_CLAUSE = 'ORDER_BY';
const $e5a1f8af2787b304$export$6df0712d20d2cc08 = (node, itemType, intl)=>{
    if (!node) return undefined;
    const { displayName: displayName, jqlTerm: jqlTerm, searchTemplate: searchTemplate, type: type, operators: operators, description: description, fieldType: fieldType, shouldShowInContext: shouldShowInContext } = node;
    // Search template & type are required; description can be null but not undefined
    if (searchTemplate == null || searchTemplate.key == null || type == null || description === undefined) {
        (0, $jcw0u.default)({
            meta: {
                id: 'getOption',
                packageName: (0, $5Dsab.PACKAGE_NAME),
                teamName: (0, $5Dsab.TEAM_NAME)
            },
            error: new Error('Field node missing required data'),
            attributes: {
                searchTemplate: searchTemplate == null ? 'missing' : {
                    key: searchTemplate.key
                },
                fieldType: type == null ? 'missing' : type,
                description: description === undefined ? 'missing' : 'present'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return undefined;
    }
    const isDisabledEpicLinkField = searchTemplate?.key === (0, $5Dsab.EPIC_LINK).searchTemplate;
    const fieldTypeDisplayName = fieldType?.displayName ?? null;
    const icon = type ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kHDIc.FieldTypeIcon), {
        type: type,
        size: "small"
    }) : undefined;
    const fieldLabel = displayName != null ? displayName : jqlTerm;
    let isOnlyUnselectable = false;
    let disabledMessage = isDisabledEpicLinkField ? intl.formatMessage((0, $kqzZ0.default).deprecatedEpicMessage, {
        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                as: "strong",
                color: "inherit",
                size: "UNSAFE_small"
            }, chunks)
    }) : undefined;
    if (shouldShowInContext === false) {
        isOnlyUnselectable = true;
        disabledMessage = intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $kqzZ0.default).notInContextFieldMessageIssueTermRefresh : (0, $kqzZ0.default).notInContextFieldMessage);
    }
    if (isDisabledEpicLinkField) {
        isOnlyUnselectable = true;
        disabledMessage = intl.formatMessage((0, $kqzZ0.default).deprecatedEpicMessage, {
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                    as: "strong",
                    color: "inherit",
                    size: "UNSAFE_small"
                }, chunks)
        });
    }
    return {
        optionType: 'field',
        label: fieldLabel,
        value: jqlTerm.toLowerCase(),
        searchTemplate: searchTemplate?.key,
        fieldType: type,
        fieldDescription: description,
        isOnlyUnselectable: isOnlyUnselectable,
        secondaryLabel: fieldTypeDisplayName && icon ? (0, $Nu4Sg.getSecondaryLabelWithIcon)(icon, fieldTypeDisplayName) : undefined,
        fieldTypeDisplayName: fieldTypeDisplayName,
        itemType: itemType,
        disabledMessage: disabledMessage,
        operators: operators?.map((0, $89g1C.mapOperators))
    };
};
const $e5a1f8af2787b304$export$d25cd19bd4b6c629 = ({ jql: jql = '', excludeFields: excludeFields = [], forClause: forClause = $e5a1f8af2787b304$var$WHERE_CLAUSE, viewContext: viewContext = null, scope: scope = null })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const intl = (0, $koVbs.default)();
    return (0, $5uXOq.useMemo)(()=>(0, $7pFAn.createGenericDebouncableDataLoader)(async (search, renderInitialValues, endCursor)=>{
            try {
                const data = await (0, $8Uumt.fetchQuery)(environment, (0, $ipny0.default), {
                    cloudId: cloudId,
                    first: 10,
                    searchString: search,
                    after: typeof endCursor === 'string' ? endCursor : undefined,
                    excludeFields: excludeFields,
                    forClause: forClause,
                    jqlContext: jql,
                    viewContext: viewContext,
                    scope: scope
                }, {
                    fetchPolicy: 'store-or-network'
                }).toPromise();
                if (data?.jira?.jqlBuilder?.fields?.__typename === 'JiraJqlFieldConnection') {
                    if (!data?.jira?.jqlBuilder?.fields?.edges) return (0, $1dTaH.generateOptions)([]);
                    const { edges: fields, totalCount: totalCount, pageInfo: { endCursor: newEndCursor } } = data.jira.jqlBuilder.fields;
                    return (0, $1dTaH.generateOptions)(fields.reduce((options, edge)=>{
                        const option = $e5a1f8af2787b304$export$6df0712d20d2cc08(edge?.node, (0, $49b29ef7baa2a152$export$38accfc5a5d1c113), intl);
                        if (option) options.push(option);
                        return options;
                    }, []), totalCount, newEndCursor || undefined);
                }
                return {
                    options: [],
                    totalCount: 0
                };
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $jcw0u.default)({
                    meta: {
                        id: 'fetchMoreFieldsOptions',
                        packageName: (0, $5Dsab.PACKAGE_NAME),
                        teamName: (0, $5Dsab.TEAM_NAME)
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                return {
                    options: [
                        {
                            optionType: 'error',
                            error: error,
                            onRetry: ()=>undefined
                        }
                    ],
                    totalCount: 0
                };
            }
        }), [
        cloudId,
        environment,
        excludeFields,
        forClause,
        intl,
        jql,
        viewContext,
        scope
    ]);
};

});
parcelRegister("ipny0", function(module, exports) {

$parcel$export(module.exports, "default", () => $edebc185e119894d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<04ff7804d9b1871263a147cfce618afa>>
 * @relayHash 9f3804059f817e66c9f5d118131a5d95
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 278d1d02ca9988a436ecd2ed0f40ed9bd2d6714d11a8385dc7bb75edb65af03b
const $edebc185e119894d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "excludeFields"
    }, v3 = {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "forClause"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jqlContext"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchString"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewContext"
    }, v9 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v10 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "excludeFields",
            "variableName": "excludeFields"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "forClause",
            "variableName": "forClause"
        },
        {
            "kind": "Variable",
            "name": "jqlContext",
            "variableName": "jqlContext"
        },
        {
            "kind": "Variable",
            "name": "scope",
            "variableName": "scope"
        },
        {
            "kind": "Variable",
            "name": "searchString",
            "variableName": "searchString"
        },
        {
            "kind": "Variable",
            "name": "viewContext",
            "variableName": "viewContext"
        }
    ], v11 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v12 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v13 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v14 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v15 = {
        "concreteType": "JiraJqlFieldEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
            {
                "concreteType": "JiraJqlField",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jqlTerm"
                    },
                    v14 /*: any*/ ,
                    {
                        "concreteType": "JiraJqlSearchTemplate",
                        "kind": "LinkedField",
                        "name": "searchTemplate",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "key"
                            }
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "operators"
                    },
                    {
                        "concreteType": "JiraFieldType",
                        "kind": "LinkedField",
                        "name": "fieldType",
                        "plural": false,
                        "selections": [
                            v14 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "shouldShowInContext"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "main_IssueTypeJqlBuilderBasicFieldsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v9 /*: any*/ ,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v10 /*: any*/ ,
                                        "kind": "LinkedField",
                                        "name": "fields",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v11 /*: any*/ ,
                                                    v12 /*: any*/ ,
                                                    v13 /*: any*/ ,
                                                    v15 /*: any*/ 
                                                ],
                                                "type": "JiraJqlFieldConnection"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v11 /*: any*/ 
                                                ],
                                                "type": "QueryError"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v7 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v8 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "main_IssueTypeJqlBuilderBasicFieldsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v9 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v10 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "fields",
                                    "plural": false,
                                    "selections": [
                                        v11 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v12 /*: any*/ ,
                                                v13 /*: any*/ ,
                                                v15 /*: any*/ 
                                            ],
                                            "type": "JiraJqlFieldConnection"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "278d1d02ca9988a436ecd2ed0f40ed9bd2d6714d11a8385dc7bb75edb65af03b",
            "metadata": {},
            "name": "main_IssueTypeJqlBuilderBasicFieldsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$edebc185e119894d$var$node.hash = "744e35745d428b3b4fc4514e1a4087bc";
var $edebc185e119894d$export$2e2bcd8739ae039 = $edebc185e119894d$var$node;

});

const $49b29ef7baa2a152$export$38accfc5a5d1c113 = 'value';
const $49b29ef7baa2a152$export$f6049126fd97001f = 'keyword';
const $49b29ef7baa2a152$export$19c7c729db381f9d = 'function';
const $49b29ef7baa2a152$export$fabec4aebba3f4df = 'list';
const $49b29ef7baa2a152$export$1c46dca02aac24dd = 'empty';

parcelRegister("7pFAn", function(module, exports) {

$parcel$export(module.exports, "createGenericDebouncableDataLoader", () => $b301ace3fb837e49$export$ea63a11564958c9e);

var $lFKmC = parcelRequire("lFKmC");
const $b301ace3fb837e49$export$ea63a11564958c9e = (dataLoader)=>{
    const debouncedDataLoader = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((search, enableFullList, endCursor, cb)=>dataLoader(search, enableFullList, endCursor).then((data)=>{
            cb(data);
            return data;
        }), 500);
    return (search, enableFullList, endCursor, cb)=>{
        // No need to debounce When no search string is provided.
        // We want the initial list displaying as quickly as possible when a user reopens the dropdown.
        // It will be cached by the GraphQL client and debouncing will show an unneccessary spinner.
        if (!search) {
            debouncedDataLoader.cancel();
            return dataLoader(search, enableFullList, endCursor).then((data)=>{
                cb(data);
                return data;
            });
        }
        return debouncedDataLoader(search, enableFullList, endCursor, cb);
    };
};
var $b301ace3fb837e49$export$2e2bcd8739ae039 = $b301ace3fb837e49$export$ea63a11564958c9e;

});

parcelRegister("Nu4Sg", function(module, exports) {

$parcel$export(module.exports, "getSecondaryLabelWithIcon", () => $f4ca1075411980d4$export$de24d837eb50c435);

var $5uXOq = parcelRequire("5uXOq");
const $f4ca1075411980d4$export$de24d837eb50c435 = (icon, fieldTypeDisplayName)=>({
        label: fieldTypeDisplayName,
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, icon, fieldTypeDisplayName)
    });

});

parcelRegister("kHDIc", function(module, exports) {

$parcel$export(module.exports, "fieldTypesIcons", () => $84df96f6dc813d24$export$67f993f3bbfb364d);
$parcel$export(module.exports, "panelIcons", () => $84df96f6dc813d24$export$4641b622f6c36f58);
$parcel$export(module.exports, "allFieldTypeGlyphs", () => $84df96f6dc813d24$export$14355977bfae6aaa);
$parcel$export(module.exports, "StrictFieldTypeIcon", () => $84df96f6dc813d24$export$aaac7dbe01e6025d);
$parcel$export(module.exports, "FieldTypeIcon", () => $84df96f6dc813d24$export$87c5289d8835f589);
$parcel$export(module.exports, "default", () => $84df96f6dc813d24$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");

var $4iV1e = parcelRequire("4iV1e");

var $b0XU0 = parcelRequire("b0XU0");

var $4hqZ5 = parcelRequire("4hqZ5");

var $h8cgU = parcelRequire("h8cgU");

var $fyC9a = parcelRequire("fyC9a");

var $5fc53 = parcelRequire("5fc53");

var $5fc53 = parcelRequire("5fc53");
var $3XO6n = parcelRequire("3XO6n");

var $VoGvu = parcelRequire("VoGvu");
// @ts-expect-error - TS2322 - Type '(props: { [key: string]: string; }) => ReactElement<any, string | JSXElementConstructor<any>>' is not assignable to type 'ComponentType<CustomGlyphProps> | undefined'.
const $84df96f6dc813d24$var$ResizedIcon = ({ glyph: glyph })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        label: "",
        glyph: glyph,
        size: "medium"
    });
const $84df96f6dc813d24$var$checkedFieldTypesIcons = {
    [(0, $5fc53.NUMBER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.numberGlyph)
    }),
    [(0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.numberGlyph)
    }),
    [(0, $5fc53.LABELS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.labelGlyph)
    }),
    [(0, $5fc53.DATE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dateGlyph)
    }),
    [(0, $5fc53.DATETIME_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.timeStampGlyph)
    }),
    [(0, $5fc53.RADIO_BUTTONS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.radioGlyph)
    }),
    [(0, $5fc53.SELECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    [(0, $5fc53.MULTI_SELECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    [(0, $5fc53.CASCADING_SELECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.doubleDropdownGlyph)
    }),
    [(0, $5fc53.MULTI_VERSION_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    [(0, $5fc53.VERSION_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    [(0, $5fc53.GROUP_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    [(0, $5fc53.MULTI_GROUP_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    [(0, $5fc53.USER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.peopleGlyph)
    }),
    [(0, $3XO6n.USERPICKER_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.peopleGlyph)
    }),
    [(0, $5fc53.MULTI_USER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.peopleGlyph)
    }),
    [(0, $3XO6n.MULTIUSERPICKER_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.peopleGlyph)
    }),
    [(0, $5fc53.PEOPLE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.peopleGlyph)
    }),
    [(0, $5fc53.FLAGGED_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.timeStampGlyph)
    }),
    [(0, $5fc53.URL_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.customFieldGlyph)
    }),
    [(0, $5fc53.TEAM_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.customFieldGlyph)
    }),
    // <ResizedIcon /> was introduced when SWIFT had a limited number of supported field types,
    // but it's no longer a scalable option. We should be using icons directly provided by @atlaskit,
    // and if it does not match our design constraints, then we'll need to investigate contributing to a new @atlaskit icon set.
    [(0, $5fc53.TEAMS_PLATFORM_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4hqZ5))), {
        spacing: "spacious",
        label: ""
    }),
    [(0, $5fc53.PARENT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.customFieldGlyph)
    }),
    [(0, $5fc53.BASELINE_START_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dateGlyph)
    }),
    [(0, $5fc53.BASELINE_END_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dateGlyph)
    }),
    [(0, $5fc53.SPRINT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.shipGlyph)
    }),
    [(0, $5fc53.REQUEST_PARTICIPANTS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.peopleGroupGlyph)
    }),
    [(0, $5fc53.ORGANIZATIONS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.officeBuildingGlyph)
    }),
    [(0, $5fc53.REPORTER_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.peopleGlyph)
    }),
    [(0, $5fc53.ATTACHMENT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.attachmentGlyph)
    }),
    [(0, $5fc53.ASSIGNEE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.peopleGlyph)
    }),
    [(0, $5fc53.LABELS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.labelGlyph)
    }),
    [(0, $5fc53.PRIORITY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.priorityGlyph)
    }),
    [(0, $5fc53.DUE_DATE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dateGlyph)
    }),
    [(0, $5fc53.TIME_ESTIMATE_CONFIG_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.timeStampGlyph)
    }),
    [(0, $5fc53.TIME_TRACKING_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.timeTrackingGlyph)
    }),
    [(0, $5fc53.TIME_ESTIMATE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.originalTimeEstimateGlyph)
    }),
    [(0, $5fc53.ASSETS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.screenGlyph)
    }),
    [(0, $5fc53.SERVICE_ENTITY_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.labelGlyph)
    }),
    [(0, $5fc53.STATUS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.arrowRightGlyph)
    }),
    [(0, $5fc53.SUMMARY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.shortTextGlyph)
    }),
    [(0, $3XO6n.DESCRIPTION_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.paragraphGlyph)
    }),
    [(0, $5fc53.TEXT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.shortTextGlyph)
    }),
    [(0, $3XO6n.TEXT_AREA_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.paragraphGlyph)
    }),
    [(0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.checkboxGlyph)
    }),
    [(0, $5fc53.ISSUE_LINKS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.customFieldGlyph)
    }),
    [(0, $3XO6n.ENVIRONMENT_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.paragraphGlyph)
    }),
    [(0, $5fc53.FIX_VERSIONS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    [(0, $5fc53.COMMENT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.commentGlyph)
    }),
    [(0, $5fc53.APPROVERS_LIST_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.appAccessGlyph)
    }),
    [(0, $5fc53.APPROVALS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.appAccessGlyph)
    }),
    [(0, $5fc53.PROJECT_PICKER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.folderGlyph)
    }),
    [(0, $5fc53.MESSAGE_EDIT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.paragraphGlyph)
    }),
    [(0, $5fc53.MESSAGE_VIEW_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.paragraphGlyph)
    }),
    [(0, $5fc53.CATEGORY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.jwmCategoryGlyph)
    }),
    [(0, $5fc53.ENTITLEMENT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    [(0, $5fc53.SENTIMENT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.customFieldGlyph)
    }),
    [(0, $5fc53.GOALS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4iV1e))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #44546F)"
    }),
    [(0, $5fc53.ORGANIZATION_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.customFieldGlyph)
    })
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
({
    ...$84df96f6dc813d24$var$checkedFieldTypesIcons
});
const $84df96f6dc813d24$export$67f993f3bbfb364d = $84df96f6dc813d24$var$checkedFieldTypesIcons;
const $84df96f6dc813d24$export$4641b622f6c36f58 = {
    development: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b0XU0))), {
        label: "",
        LEGACY_size: "medium",
        spacing: "spacious"
    }),
    devSummary: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b0XU0))), {
        label: "",
        LEGACY_size: "medium",
        spacing: "spacious"
    }),
    timetracking: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fyC9a))), {
        label: "",
        LEGACY_size: "medium",
        spacing: "spacious"
    })
};
/**
 * @deprecated - consider using allFieldTypeGlyphs or FieldTypeIcon instead
 */ const $84df96f6dc813d24$var$allIcons = {
    ...$84df96f6dc813d24$export$67f993f3bbfb364d,
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.paragraphGlyph)
    }),
    number: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.numberGlyph)
    }),
    date: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dateGlyph)
    }),
    datetime: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.timeStampGlyph)
    }),
    dropdown: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    addon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.addonGlyph)
    }),
    checkbox: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.checkboxGlyph)
    }),
    user: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.peopleGlyph)
    }),
    radio: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.radioGlyph)
    }),
    time: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.timeStampGlyph)
    }),
    message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.commentGlyph)
    }),
    bulletList: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.bulletListGlyph)
    }),
    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.labelGlyph)
    }),
    labelpicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.labelGlyph)
    }),
    close: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.closeGlyph)
    }),
    assetspicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.screenGlyph)
    }),
    select: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    multiselect: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    cascadingselect: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.doubleDropdownGlyph)
    }),
    multigrouppicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    grouppicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    multiversion: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    version: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    projectpicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    customField: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.customFieldGlyph)
    })
};
const $84df96f6dc813d24$var$checkedFieldTypesGlyphs = {
    [(0, $5fc53.NUMBER_CF_TYPE)]: (0, $VoGvu.numberGlyph),
    [(0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE)]: (0, $VoGvu.numberGlyph),
    [(0, $5fc53.LABELS_CF_TYPE)]: (0, $VoGvu.labelGlyph),
    [(0, $5fc53.DATE_CF_TYPE)]: (0, $VoGvu.dateGlyph),
    [(0, $5fc53.DATETIME_CF_TYPE)]: (0, $VoGvu.timeStampGlyph),
    [(0, $5fc53.RADIO_BUTTONS_CF_TYPE)]: (0, $VoGvu.radioGlyph),
    [(0, $5fc53.SELECT_CF_TYPE)]: (0, $VoGvu.dropdownGlyph),
    [(0, $5fc53.MULTI_SELECT_CF_TYPE)]: (0, $VoGvu.dropdownGlyph),
    [(0, $5fc53.CASCADING_SELECT_CF_TYPE)]: (0, $VoGvu.doubleDropdownGlyph),
    [(0, $5fc53.MULTI_VERSION_CF_TYPE)]: (0, $VoGvu.dropdownGlyph),
    [(0, $5fc53.VERSION_CF_TYPE)]: (0, $VoGvu.dropdownGlyph),
    [(0, $5fc53.GROUP_CF_TYPE)]: (0, $VoGvu.dropdownGlyph),
    [(0, $5fc53.MULTI_GROUP_CF_TYPE)]: (0, $VoGvu.dropdownGlyph),
    [(0, $5fc53.USER_CF_TYPE)]: (0, $VoGvu.peopleGlyph),
    [(0, $3XO6n.USERPICKER_FIELD_TYPE)]: (0, $VoGvu.peopleGlyph),
    [(0, $5fc53.MULTI_USER_CF_TYPE)]: (0, $VoGvu.peopleGlyph),
    [(0, $3XO6n.MULTIUSERPICKER_FIELD_TYPE)]: (0, $VoGvu.peopleGlyph),
    [(0, $5fc53.PEOPLE_CF_TYPE)]: (0, $VoGvu.peopleGlyph),
    [(0, $5fc53.FLAGGED_CF_TYPE)]: (0, $VoGvu.timeStampGlyph),
    [(0, $5fc53.URL_CF_TYPE)]: (0, $VoGvu.customFieldGlyph),
    [(0, $5fc53.TEAM_CF_TYPE)]: (0, $VoGvu.customFieldGlyph),
    [(0, $5fc53.PARENT_CF_TYPE)]: (0, $VoGvu.customFieldGlyph),
    [(0, $5fc53.BASELINE_START_CF_TYPE)]: (0, $VoGvu.dateGlyph),
    [(0, $5fc53.BASELINE_END_CF_TYPE)]: (0, $VoGvu.dateGlyph),
    [(0, $5fc53.SPRINT_TYPE)]: (0, $VoGvu.shipGlyph),
    [(0, $5fc53.REQUEST_PARTICIPANTS_CF_TYPE)]: (0, $VoGvu.peopleGroupGlyph),
    [(0, $5fc53.ORGANIZATIONS_CF_TYPE)]: (0, $VoGvu.officeBuildingGlyph),
    [(0, $5fc53.REPORTER_TYPE)]: (0, $VoGvu.peopleGlyph),
    [(0, $5fc53.ATTACHMENT_TYPE)]: (0, $VoGvu.attachmentGlyph),
    [(0, $5fc53.ASSIGNEE_TYPE)]: (0, $VoGvu.peopleGlyph),
    [(0, $5fc53.LABELS_TYPE)]: (0, $VoGvu.labelGlyph),
    [(0, $5fc53.PRIORITY_TYPE)]: (0, $VoGvu.priorityGlyph),
    [(0, $5fc53.DUE_DATE_TYPE)]: (0, $VoGvu.dateGlyph),
    [(0, $5fc53.TIME_ESTIMATE_CONFIG_TYPE)]: (0, $VoGvu.timeStampGlyph),
    [(0, $5fc53.TIME_TRACKING_TYPE)]: (0, $VoGvu.timeTrackingGlyph),
    [(0, $5fc53.TIME_ESTIMATE_TYPE)]: (0, $VoGvu.originalTimeEstimateGlyph),
    [(0, $5fc53.ASSETS_CF_TYPE)]: (0, $VoGvu.screenGlyph),
    [(0, $5fc53.SERVICE_ENTITY_CF_TYPE)]: (0, $VoGvu.labelGlyph),
    [(0, $5fc53.STATUS_TYPE)]: (0, $VoGvu.arrowRightGlyph),
    [(0, $5fc53.SUMMARY_TYPE)]: (0, $VoGvu.shortTextGlyph),
    [(0, $3XO6n.DESCRIPTION_FIELD_TYPE)]: (0, $VoGvu.paragraphGlyph),
    [(0, $5fc53.TEXT_CF_TYPE)]: (0, $VoGvu.shortTextGlyph),
    [(0, $3XO6n.TEXT_AREA_CF_TYPE)]: (0, $VoGvu.paragraphGlyph),
    [(0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)]: (0, $VoGvu.checkboxGlyph),
    [(0, $5fc53.ISSUE_LINKS_TYPE)]: (0, $VoGvu.customFieldGlyph),
    [(0, $3XO6n.ENVIRONMENT_FIELD_TYPE)]: (0, $VoGvu.paragraphGlyph),
    [(0, $5fc53.FIX_VERSIONS_TYPE)]: (0, $VoGvu.dropdownGlyph),
    [(0, $5fc53.COMMENT_TYPE)]: (0, $VoGvu.commentGlyph),
    [(0, $5fc53.APPROVERS_LIST_CF_TYPE)]: (0, $VoGvu.appAccessGlyph),
    [(0, $5fc53.APPROVALS_CF_TYPE)]: (0, $VoGvu.appAccessGlyph),
    [(0, $5fc53.PROJECT_PICKER_CF_TYPE)]: (0, $VoGvu.folderGlyph),
    [(0, $5fc53.MESSAGE_EDIT_CF_TYPE)]: (0, $VoGvu.paragraphGlyph),
    [(0, $5fc53.MESSAGE_VIEW_CF_TYPE)]: (0, $VoGvu.paragraphGlyph),
    [(0, $5fc53.CATEGORY_TYPE)]: (0, $VoGvu.jwmCategoryGlyph),
    [(0, $5fc53.ENTITLEMENT_CF_TYPE)]: (0, $VoGvu.dropdownGlyph),
    [(0, $5fc53.SENTIMENT_CF_TYPE)]: (0, $VoGvu.customFieldGlyph),
    [(0, $5fc53.ORGANIZATION_CF_TYPE)]: (0, $VoGvu.customFieldGlyph)
};
const $84df96f6dc813d24$export$14355977bfae6aaa = {
    ...$84df96f6dc813d24$var$checkedFieldTypesGlyphs,
    text: (0, $VoGvu.paragraphGlyph),
    number: (0, $VoGvu.numberGlyph),
    date: (0, $VoGvu.dateGlyph),
    datetime: (0, $VoGvu.timeStampGlyph),
    dropdown: (0, $VoGvu.dropdownGlyph),
    addon: (0, $VoGvu.addonGlyph),
    checkbox: (0, $VoGvu.checkboxGlyph),
    user: (0, $VoGvu.peopleGlyph),
    radio: (0, $VoGvu.radioGlyph),
    time: (0, $VoGvu.timeStampGlyph),
    message: (0, $VoGvu.commentGlyph),
    bulletList: (0, $VoGvu.bulletListGlyph),
    label: (0, $VoGvu.labelGlyph),
    labelpicker: (0, $VoGvu.labelGlyph),
    close: (0, $VoGvu.closeGlyph),
    assetspicker: (0, $VoGvu.screenGlyph),
    select: (0, $VoGvu.dropdownGlyph),
    multiselect: (0, $VoGvu.dropdownGlyph),
    cascadingselect: (0, $VoGvu.doubleDropdownGlyph),
    multigrouppicker: (0, $VoGvu.dropdownGlyph),
    grouppicker: (0, $VoGvu.dropdownGlyph),
    multiversion: (0, $VoGvu.dropdownGlyph),
    version: (0, $VoGvu.dropdownGlyph),
    projectpicker: (0, $VoGvu.dropdownGlyph),
    customField: (0, $VoGvu.customFieldGlyph)
};
const $84df96f6dc813d24$export$aaac7dbe01e6025d = /*#__PURE__*/ (0, $5uXOq.memo)(({ type: type, size: size = 'medium', testId: testId })=>{
    if (type === (0, $5fc53.TEAMS_PLATFORM_CF_TYPE)) // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h8cgU))), {
        label: "",
        size: size,
        testId: testId
    });
    if (type === (0, $5fc53.GOALS_CF_TYPE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4iV1e))), {
        label: "",
        spacing: "spacious",
        testId: testId,
        color: "var(--ds-icon, #44546F)"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        label: "",
        glyph: $84df96f6dc813d24$var$checkedFieldTypesGlyphs[type] || $84df96f6dc813d24$var$checkedFieldTypesGlyphs.customField,
        size: size,
        testId: testId
    });
});
const $84df96f6dc813d24$export$87c5289d8835f589 = /*#__PURE__*/ (0, $5uXOq.memo)(({ type: type, size: size = 'medium', testId: testId })=>{
    if (type === (0, $5fc53.TEAMS_PLATFORM_CF_TYPE)) // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h8cgU))), {
        label: "",
        size: size,
        testId: testId
    });
    if (type === (0, $5fc53.GOALS_CF_TYPE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4iV1e))), {
        label: "",
        spacing: "spacious",
        testId: testId,
        color: "var(--ds-icon, #44546F)"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        label: "",
        glyph: $84df96f6dc813d24$export$14355977bfae6aaa[type] || $84df96f6dc813d24$export$14355977bfae6aaa.customField,
        size: size,
        testId: testId
    });
});
var /**
 * @deprecated - Use allFieldTypeGlyphs or FieldTypeIcon instead.
 */ $84df96f6dc813d24$export$2e2bcd8739ae039 = $84df96f6dc813d24$var$allIcons;

});
parcelRegister("b0XU0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bf5f697d891cc6bba8e40c46639eb125>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $804e2928682a9df6$var$_react = $804e2928682a9df6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $804e2928682a9df6$var$_branch = $804e2928682a9df6$var$_interopRequireDefault((parcelRequire("4iPF3")));

var $804e2928682a9df6$var$_branches = $804e2928682a9df6$var$_interopRequireDefault((parcelRequire("9XvX5")));
function $804e2928682a9df6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for BranchIcon.
 * This component is BranchIcon, with `UNSAFE_fallbackIcon` set to "BitbucketBranchesIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $804e2928682a9df6$var$BranchIcon = (props)=>/*#__PURE__*/ $804e2928682a9df6$var$_react.default.createElement($804e2928682a9df6$var$_branch.default, Object.assign({
        LEGACY_fallbackIcon: $804e2928682a9df6$var$_branches.default
    }, props));
$804e2928682a9df6$var$BranchIcon.Name = 'BranchIconMigration';
var $804e2928682a9df6$var$_default = module.exports.default = $804e2928682a9df6$var$BranchIcon;

});
parcelRegister("4iPF3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bb7d4b05cefe88d0219507dc0673c3e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3220eab15e59539d$var$_react = $3220eab15e59539d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3220eab15e59539d$var$_baseNew = $3220eab15e59539d$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3220eab15e59539d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Branch".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3220eab15e59539d$var$BranchIcon = (props)=>/*#__PURE__*/ $3220eab15e59539d$var$_react.default.createElement($3220eab15e59539d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122V9H3.5V5.372A2.25 2.25 0 0 1 2 3.25m9.75-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 3 2.122v4.878a3.25 3.25 0 0 1-3.25 3.25H6.372a2.25 2.25 0 1 1 0-1.5H9.25A1.75 1.75 0 0 0 11 10.25V5.372A2.25 2.25 0 0 1 9.5 3.25M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$3220eab15e59539d$var$BranchIcon.displayName = 'BranchIcon';
var $3220eab15e59539d$var$_default = module.exports.default = $3220eab15e59539d$var$BranchIcon;

});

parcelRegister("9XvX5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $740268c474e86b43$var$_react = $740268c474e86b43$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $740268c474e86b43$var$_branch = $740268c474e86b43$var$_interopRequireDefault((parcelRequire("4iPF3")));
function $740268c474e86b43$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $740268c474e86b43$var$BitbucketBranchesIcon = (props)=>/*#__PURE__*/ $740268c474e86b43$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M19 11c0 1.3-.8 2.4-2 2.8V15c0 2.2-1.8 4-4 4h-2.2c-.4 1.2-1.5 2-2.8 2-1.7 0-3-1.3-3-3 0-1.3.8-2.4 2-2.8V8.8C5.9 8.4 5 7.3 5 6c0-1.7 1.3-3 3-3s3 1.3 3 3c0 1.3-.8 2.4-2.1 2.8v6.4c.9.3 1.6.9 1.9 1.8H13c1.1 0 2-.9 2-2v-1.2c-1.2-.4-2-1.5-2-2.8 0-1.7 1.3-3 3-3s3 1.3 3 3M8 5c-.5 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1m8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1m-8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1"/></svg>`
    }, props, {
        newIcon: $740268c474e86b43$var$_branch.default
    }));
$740268c474e86b43$var$BitbucketBranchesIcon.displayName = 'BitbucketBranchesIcon';
var $740268c474e86b43$var$_default = module.exports.default = $740268c474e86b43$var$BitbucketBranchesIcon;

});


parcelRegister("4hqZ5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ff23a711b4b109cded01cd0a5945034a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $31ddae7439c341a9$var$_react = $31ddae7439c341a9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $31ddae7439c341a9$var$_peopleGroup = $31ddae7439c341a9$var$_interopRequireDefault((parcelRequire("fptva")));

var $31ddae7439c341a9$var$_people = $31ddae7439c341a9$var$_interopRequireDefault((parcelRequire("h8cgU")));
function $31ddae7439c341a9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PeopleGroupIcon.
 * This component is PeopleGroupIcon, with `UNSAFE_fallbackIcon` set to "PeopleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $31ddae7439c341a9$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $31ddae7439c341a9$var$_react.default.createElement($31ddae7439c341a9$var$_peopleGroup.default, Object.assign({
        LEGACY_fallbackIcon: $31ddae7439c341a9$var$_people.default
    }, props));
$31ddae7439c341a9$var$PeopleGroupIcon.Name = 'PeopleGroupIconMigration';
var $31ddae7439c341a9$var$_default = module.exports.default = $31ddae7439c341a9$var$PeopleGroupIcon;

});

parcelRegister("fyC9a", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f8fa98d5af7aa71848cf5218e04fd5c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b5379f2924fc9e12$var$_react = $b5379f2924fc9e12$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b5379f2924fc9e12$var$_stopwatch = $b5379f2924fc9e12$var$_interopRequireDefault((parcelRequire("cXVn2")));

var $b5379f2924fc9e12$var$_stopwatch2 = $b5379f2924fc9e12$var$_interopRequireDefault((parcelRequire("63gsv")));
function $b5379f2924fc9e12$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StopwatchIcon.
 * This component is StopwatchIcon, with `UNSAFE_fallbackIcon` set to "StopwatchIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: timer in Confluence Whiteboards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b5379f2924fc9e12$var$StopwatchIcon = (props)=>/*#__PURE__*/ $b5379f2924fc9e12$var$_react.default.createElement($b5379f2924fc9e12$var$_stopwatch.default, Object.assign({
        LEGACY_fallbackIcon: $b5379f2924fc9e12$var$_stopwatch2.default
    }, props));
$b5379f2924fc9e12$var$StopwatchIcon.Name = 'StopwatchIconMigration';
var $b5379f2924fc9e12$var$_default = module.exports.default = $b5379f2924fc9e12$var$StopwatchIcon;

});
parcelRegister("cXVn2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::da0501648aefebd7252ab6523b352986>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $97077f52e189c3c9$var$_react = $97077f52e189c3c9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $97077f52e189c3c9$var$_baseNew = $97077f52e189c3c9$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $97077f52e189c3c9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Stopwatch".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: timer in Confluence Whiteboards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $97077f52e189c3c9$var$StopwatchIcon = (props)=>/*#__PURE__*/ $97077f52e189c3c9$var$_react.default.createElement($97077f52e189c3c9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 0h6v1.5H8.75v1.543a6.47 6.47 0 0 1 3.06 1.19l1.137-1.24 1.106 1.014-1.137 1.24a6.5 6.5 0 1 1-9.832 0l-1.137-1.24 1.106-1.014 1.137 1.24a6.47 6.47 0 0 1 3.06-1.19V1.5H5zm3 4.5a4.98 4.98 0 0 0-3.378 1.314A5 5 0 1 0 8 4.5m2.842 3.01-2.541 2.75-1.102-1.02 2.542-2.75z" clip-rule="evenodd"/>`
    }, props));
$97077f52e189c3c9$var$StopwatchIcon.displayName = 'StopwatchIcon';
var $97077f52e189c3c9$var$_default = module.exports.default = $97077f52e189c3c9$var$StopwatchIcon;

});

parcelRegister("63gsv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $467fca4622452061$var$_react = $467fca4622452061$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $467fca4622452061$var$_stopwatch = $467fca4622452061$var$_interopRequireDefault((parcelRequire("cXVn2")));
function $467fca4622452061$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $467fca4622452061$var$StopwatchIcon = (props)=>/*#__PURE__*/ $467fca4622452061$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.587 6.988.626-.664c.203-.215.481-.324.76-.324.247 0 .496.086.694.262a.98.98 0 0 1 .063 1.414l-.565.6a7 7 0 1 1-10.33 0l-.564-.6a.98.98 0 0 1 .062-1.414A1.04 1.04 0 0 1 7.03 6c.278 0 .556.109.76.324l.624.664a7 7 0 0 1 2.582-.916L10.998 5H10.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-.498l.001 1.071a7 7 0 0 1 2.584.917M12 18a5 5 0 1 0 0-10 5 5 0 0 0 0 10m.368-4.232a.796.796 0 0 1-1.14-.018.834.834 0 0 1 .018-1.163l2.386-2.355a.796.796 0 0 1 1.14.018.834.834 0 0 1-.018 1.163z"/></svg>`
    }, props, {
        newIcon: $467fca4622452061$var$_stopwatch.default
    }));
$467fca4622452061$var$StopwatchIcon.displayName = 'StopwatchIcon';
var $467fca4622452061$var$_default = module.exports.default = $467fca4622452061$var$StopwatchIcon;

});


parcelRegister("VoGvu", function(module, exports) {

$parcel$export(module.exports, "numberGlyph", () => $2e91e7edf801074a$export$b368272069fe93ea);
$parcel$export(module.exports, "checkboxGlyph", () => $2e91e7edf801074a$export$747056db840f2e62);
$parcel$export(module.exports, "folderGlyph", () => $2e91e7edf801074a$export$fc939f15c0ac57d8);
$parcel$export(module.exports, "dateGlyph", () => $2e91e7edf801074a$export$54ae6633cc16eed1);
$parcel$export(module.exports, "dropdownGlyph", () => $2e91e7edf801074a$export$d298f123ec74117c);
$parcel$export(module.exports, "doubleDropdownGlyph", () => $2e91e7edf801074a$export$b3ea0fc10228ca3e);
$parcel$export(module.exports, "labelGlyph", () => $2e91e7edf801074a$export$fc64eea29ed0831d);
$parcel$export(module.exports, "paragraphGlyph", () => $2e91e7edf801074a$export$cbee9ded46569696);
$parcel$export(module.exports, "peopleGlyph", () => $2e91e7edf801074a$export$2ade78849d2113ea);
$parcel$export(module.exports, "shortTextGlyph", () => $2e91e7edf801074a$export$1c6cf19eb34bcc14);
$parcel$export(module.exports, "timeStampGlyph", () => $2e91e7edf801074a$export$98a4a461fe316fce);
$parcel$export(module.exports, "timeTrackingGlyph", () => $2e91e7edf801074a$export$637d50811e2b7176);
$parcel$export(module.exports, "originalTimeEstimateGlyph", () => $2e91e7edf801074a$export$bc2bb299bed9df91);
$parcel$export(module.exports, "arrowRightGlyph", () => $2e91e7edf801074a$export$3a9d3f1c52f4dab9);
$parcel$export(module.exports, "addonGlyph", () => $2e91e7edf801074a$export$a4cdad58220c405a);
$parcel$export(module.exports, "attachmentGlyph", () => $2e91e7edf801074a$export$e6e85f1bc2e23bd4);
$parcel$export(module.exports, "bulletListGlyph", () => $2e91e7edf801074a$export$a6a7f7b7c0399a2a);
$parcel$export(module.exports, "commentGlyph", () => $2e91e7edf801074a$export$835d228e2a9d6a93);
$parcel$export(module.exports, "officeBuildingGlyph", () => $2e91e7edf801074a$export$fdad804cb16a6544);
$parcel$export(module.exports, "peopleGroupGlyph", () => $2e91e7edf801074a$export$a20644de4b67f161);
$parcel$export(module.exports, "radioGlyph", () => $2e91e7edf801074a$export$ce87e45dceec205d);
$parcel$export(module.exports, "shipGlyph", () => $2e91e7edf801074a$export$d95e2215202c8556);
$parcel$export(module.exports, "priorityGlyph", () => $2e91e7edf801074a$export$3062e49c5521698d);
$parcel$export(module.exports, "screenGlyph", () => $2e91e7edf801074a$export$17d48fc8b753df77);
$parcel$export(module.exports, "closeGlyph", () => $2e91e7edf801074a$export$cbbe21ca62a58ed6);
$parcel$export(module.exports, "appAccessGlyph", () => $2e91e7edf801074a$export$8fd991b9da3a43e5);
$parcel$export(module.exports, "jwmCategoryGlyph", () => $2e91e7edf801074a$export$f21213fb7b480582);
$parcel$export(module.exports, "customFieldGlyph", () => $2e91e7edf801074a$export$88453606d7da6ff7);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");
const $2e91e7edf801074a$export$b368272069fe93ea = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M7 4h10a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zm.417 10.636h1.15V9.141H7.42L6 10.12v1.07l1.348-.93h.069v4.376zm1.923-3.85v.02h1.067v-.024c0-.506.365-.857.898-.857.503 0 .861.313.861.755 0 .357-.194.643-.967 1.397l-1.794 1.756v.803h3.964v-.955h-2.406v-.069l1.05-1.002c.953-.895 1.277-1.409 1.277-2.007 0-.944-.8-1.603-1.947-1.603-1.188 0-2.003.724-2.003 1.786zm5.811 1.466h.682c.617 0 .994.297.994.777 0 .469-.4.792-.975.792-.59 0-.983-.293-1.017-.757h-1.1c.05 1.035.88 1.713 2.106 1.713 1.253 0 2.159-.697 2.159-1.66 0-.724-.472-1.226-1.226-1.31v-.069c.613-.125 1.013-.62 1.013-1.257 0-.864-.811-1.481-1.939-1.481-1.2 0-1.972.655-2.01 1.695H14.9c.03-.476.385-.777.918-.777.537 0 .88.282.88.723 0 .45-.355.754-.876.754h-.67v.857z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$747056db840f2e62 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M4 5.994C4 4.893 4.895 4 5.994 4h12.012C19.107 4 20 4.895 20 5.994v12.012A1.995 1.995 0 0 1 18.006 20H5.994A1.995 1.995 0 0 1 4 18.006V5.994zm5.707 5.299a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$fc939f15c0ac57d8 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M20 19V8h-9.154l-.503-1.258-.455-1.136C9.778 5.33 9.291 5 9.003 5H3.997C4.002 5 4 19 4 19h16zM12.2 6h7.809C21.109 6 22 6.893 22 7.992v11.016c0 1.1-.898 1.992-1.991 1.992H3.991C2.891 21 2 20.107 2 19.008V5.006C2 3.898 2.896 3 3.997 3h5.006c1.103 0 2.327.826 2.742 1.862L12.2 6z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$54ae6633cc16eed1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M8.667 6.167V7A.834.834 0 0 1 7 7V5.333a.834.834 0 0 1 1.667 0v.834zm6.666 0v-.834a.834.834 0 0 1 1.667 0V7a.834.834 0 0 1-1.667 0v-.833zm2.5 0h.005c.918 0 1.662.745 1.662 1.661v10.01c0 .918-.743 1.662-1.662 1.662H6.161A1.663 1.663 0 0 1 4.5 17.838V7.828c0-.917.743-1.661 1.662-1.661h.005V7c0 .927.746 1.667 1.666 1.667C8.76 8.667 9.5 7.92 9.5 7v-.833h5V7c0 .927.746 1.667 1.667 1.667.927 0 1.666-.747 1.666-1.667v-.833zm-10 6.667H9.5v-1.667H7.833v1.667zm0 3.334H9.5V14.5H7.833v1.668zm3.334-3.334h1.666v-1.667h-1.666v1.667zm0 3.334h1.666V14.5h-1.666v1.668zm3.333-3.334h1.667v-1.667H14.5v1.667zm0 3.334h1.667V14.5H14.5v1.668z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$d298f123ec74117c = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM15.708 11.723L12.779 14.678C12.566 14.893 12.288 15 12.009 15C11.73 15 11.449 14.893 11.231 14.678L8.291 11.713C7.903 11.321 7.903 10.686 8.291 10.294C8.679 9.902 9.309 9.902 9.698 10.294L12.005 12.621L14.303 10.304C14.69 9.912 15.32 9.912 15.708 10.304C16.097 10.696 16.097 11.331 15.708 11.723Z",
        fill: "currentColor"
    }));
const $2e91e7edf801074a$export$b3ea0fc10228ca3e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM10.0543 7.95865C9.72121 7.63948 9.17412 7.63199 8.83238 7.94192C8.49064 8.25184 8.48365 8.76182 8.81678 9.08099L11.3658 11.5232C11.5389 11.689 11.7698 11.7707 11.9997 11.7675C12.2295 11.7707 12.4604 11.689 12.6335 11.5232L15.1825 9.08099C15.5156 8.76182 15.5087 8.25184 15.1669 7.94192C14.8252 7.63199 14.2781 7.63948 13.945 7.95865L11.9997 9.82242L10.0543 7.95865ZM8.83238 12.3333C9.17412 12.0234 9.72121 12.0309 10.0543 12.35L11.9997 14.2138L13.945 12.35C14.2781 12.0309 14.8252 12.0234 15.1669 12.3333C15.5087 12.6432 15.5156 13.1532 15.1825 13.4724L12.6335 15.9146C12.4604 16.0804 12.2295 16.1621 11.9997 16.1588C11.7698 16.1621 11.5389 16.0804 11.3658 15.9146L8.81678 13.4724C8.48365 13.1532 8.49064 12.6432 8.83238 12.3333Z",
        fill: "currentColor"
    }));
const $2e91e7edf801074a$export$fc64eea29ed0831d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M11.433 5.428l-4.207.6a2 2 0 0 0-1.697 1.698l-.601 4.207a1 1 0 0 0 .283.849l6.894 6.894a1 1 0 0 0 1.414 0l5.657-5.657a1 1 0 0 0 0-1.414L12.282 5.71a1 1 0 0 0-.849-.283zm-.647 5.858a1.667 1.667 0 1 1-2.357-2.357 1.667 1.667 0 0 1 2.357 2.357z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$cbee9ded46569696 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M7 7h11a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2zm0 4h11a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2zm0 4h6a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$2ade78849d2113ea = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M12.12 20.249a8.398 8.398 0 0 1-.39-.003A8.25 8.25 0 0 1 3.75 12 8.25 8.25 0 0 1 12 3.75 8.25 8.25 0 0 1 20.25 12a8.25 8.25 0 0 1-8.13 8.25v-.001zm4.463-3.762A6.396 6.396 0 0 0 18.417 12 6.424 6.424 0 0 0 12 5.583 6.424 6.424 0 0 0 5.583 12c0 1.745.7 3.33 1.834 4.487v-1.27a2.291 2.291 0 0 1 2.292-2.292h4.582a2.292 2.292 0 0 1 2.292 2.291v1.27zM12 12a2.75 2.75 0 1 1 0-5.5 2.75 2.75 0 0 1 0 5.5z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$1c6cf19eb34bcc14 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M6.72 7.178l-2.93 8.627a.5.5 0 0 0 .473.661h.842a.75.75 0 0 0 .716-.53l.581-1.887h3.425l.58 1.887a.75.75 0 0 0 .717.53h.916a.5.5 0 0 0 .473-.66L9.578 7.177a1 1 0 0 0-.946-.678h-.966a1 1 0 0 0-.947.678zm1.37 1.228h.047l1.25 4.082H6.841l1.25-4.082zm10.187 1.872v-.23a.986.986 0 1 1 1.972 0v5.433a.986.986 0 0 1-1.972 0v-.217h-.08c-.36.802-1.13 1.32-2.217 1.32-1.81 0-2.952-1.479-2.952-3.834 0-2.334 1.149-3.805 2.952-3.805 1.075 0 1.858.546 2.216 1.333h.08zm-.04 2.486c0-1.347-.63-2.203-1.61-2.203-.978 0-1.58.843-1.58 2.203 0 1.368.602 2.196 1.58 2.196.988 0 1.61-.836 1.61-2.196z",
        fill: "currentColor"
    }));
const $2e91e7edf801074a$export$98a4a461fe316fce = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm.787-7.674V8.944c0-.52-.402-.944-.893-.944-.492 0-.894.425-.894.944v3.777c0 .263.104.5.269.672l2.207 2.332a.862.862 0 0 0 1.263 0 .985.985 0 0 0 0-1.336l-1.952-2.063z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$637d50811e2b7176 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M17.476 9.067A6.552 6.552 0 0 1 19 13.263C19 16.983 15.866 20 12 20s-7-3.016-7-6.737c0-1.587.57-3.045 1.524-4.196l-.383-.402a.82.82 0 0 1 .054-1.19.9.9 0 0 1 1.237.052l.345.363a7.116 7.116 0 0 1 3.348-1.312v-.894h-.438a.43.43 0 0 1-.437-.42V4.42a.43.43 0 0 1 .438-.42h2.624a.43.43 0 0 1 .438.421v.842a.43.43 0 0 1-.438.421h-.437v.894a7.116 7.116 0 0 1 3.348 1.312l.345-.363a.9.9 0 0 1 1.237-.052.82.82 0 0 1 .054 1.19l-.383.402zM12 18.316c2.9 0 5.25-2.262 5.25-5.053 0-2.79-2.35-5.052-5.25-5.052s-5.25 2.262-5.25 5.052c0 2.79 2.35 5.053 5.25 5.053zm.645-4.562a.9.9 0 0 1-1.237-.02.82.82 0 0 1 .02-1.19l2.588-2.412a.9.9 0 0 1 1.238.02.82.82 0 0 1-.02 1.19l-2.589 2.412z",
        fill: "currentColor"
    }));
const $2e91e7edf801074a$export$bc2bb299bed9df91 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8zm0 14.222A6.23 6.23 0 015.778 12 6.23 6.23 0 0112 5.778 6.23 6.23 0 0118.222 12 6.23 6.23 0 0112 18.222zm.889-6.59V8.448c0-.489-.4-.889-.889-.889s-.889.4-.889.89v3.555c0 .248.103.471.268.633l2.195 2.194a.891.891 0 001.257 0 .891.891 0 000-1.256l-1.942-1.943z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$3a9d3f1c52f4dab9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M12.268 4.934a.919.919 0 0 0 0 1.296l4.852 4.853H4.668A.92.92 0 0 0 3.75 12a.92.92 0 0 0 .917.917H17.12l-4.856 4.855a.917.917 0 0 0 1.296 1.296l6.416-6.415c.002 0 .003-.003.006-.004a.914.914 0 0 0 .267-.65.915.915 0 0 0-.274-.653l-6.412-6.412a.915.915 0 0 0-.648-.267.915.915 0 0 0-.648.267z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$a4cdad58220c405a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M5.928 6.917l4.81-2.846c.727-.429 1.8-.427 2.523 0l4.811 2.846c.726.43 1.261 1.382 1.261 2.238v5.69c0 .859-.537 1.81-1.26 2.238L13.26 19.93c-.726.429-1.799.427-2.522 0l-4.811-2.846c-.726-.43-1.261-1.382-1.261-2.238v-5.69c0-.859.537-1.81 1.26-2.238zm6.408-1.204c-.152-.09-.52-.09-.672 0L6.853 8.558c-.152.09-.336.416-.336.597v5.69c0 .18.183.507.336.597l4.81 2.845c.153.09.52.09.673 0l4.811-2.845c.152-.09.336-.416.336-.597v-5.69c0-.18-.183-.507-.336-.597l-4.81-2.845zM12 15.667a3.667 3.667 0 1 1 0-7.334 3.667 3.667 0 0 1 0 7.334zm0-1.834a1.833 1.833 0 1 0 0-3.666 1.833 1.833 0 0 0 0 3.666z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$e6e85f1bc2e23bd4 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M12.672 17.468c-1.402 1.37-3.68 1.37-5.08.004a3.458 3.458 0 0 1 .002-4.962l6.552-6.402a2.123 2.123 0 0 1 2.964-.003c.818.8.82 2.092.003 2.89L10.968 15a.599.599 0 0 1-.838-.008.568.568 0 0 1 0-.827l5.71-5.58a.863.863 0 0 0 0-1.24.912.912 0 0 0-1.268 0l-5.71 5.58a2.294 2.294 0 0 0 0 3.307 2.423 2.423 0 0 0 3.375.008l6.145-6.005a3.735 3.735 0 0 0-.003-5.37 3.947 3.947 0 0 0-5.502.003L6.325 11.27a5.184 5.184 0 0 0-.001 7.442c2.1 2.052 5.514 2.051 7.617-.004l6.13-5.99a.863.863 0 0 0 0-1.24.912.912 0 0 0-1.27 0l-6.129 5.99z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$a6a7f7b7c0399a2a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M5.5 7.59a1 1 0 0 1 1.007-1.007h.152a1 1 0 0 1 1.008 1.008v.152A1 1 0 0 1 6.659 8.75h-.152A1 1 0 0 1 5.5 7.743V7.59zm4.333 8.667a.999.999 0 0 1 .995-1.007h6.678c.549 0 .994.438.994 1.007v.152a.999.999 0 0 1-.994 1.008h-6.678a.993.993 0 0 1-.995-1.008v-.152zm-4.333 0a1 1 0 0 1 1.007-1.007h.152a1 1 0 0 1 1.008 1.007v.152a1 1 0 0 1-1.008 1.008h-.152A1 1 0 0 1 5.5 16.409v-.152zm4.333-4.333a.999.999 0 0 1 .995-1.007h6.678c.549 0 .994.438.994 1.007v.152a.999.999 0 0 1-.994 1.007h-6.678a.993.993 0 0 1-.995-1.007v-.152zm-4.333 0a1 1 0 0 1 1.007-1.007h.152a1 1 0 0 1 1.008 1.007v.152a1 1 0 0 1-1.008 1.007h-.152A1 1 0 0 1 5.5 12.076v-.152zM9.833 7.59a.999.999 0 0 1 .995-1.008h6.678c.549 0 .994.439.994 1.008v.152a.999.999 0 0 1-.994 1.007h-6.678a.993.993 0 0 1-.995-1.007V7.59z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$835d228e2a9d6a93 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M4.998 11.513c0-3.038 3.141-5.51 7.002-5.51 3.861 0 7.002 2.472 7.002 5.51 0 3.039-3.141 5.51-7.002 5.51-3.861 0-7.002-2.471-7.002-5.51zm14.84 7.771v-.002s-1.564-2.26-.767-3.116l-.037.02C20.261 14.902 21 13.279 21 11.513 21 7.371 16.963 4 12 4s-9 3.37-9 7.513 4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003a.524.524 0 0 0 .164.033.515.515 0 0 0 .474-.716zM7 10c0-.552.456-1 .995-1h8.01c.55 0 .995.444.995 1 0 .552-.456 1-.995 1h-8.01A.995.995 0 0 1 7 10zm0 3c0-.552.444-1 1-1h3c.552 0 1 .444 1 1 0 .552-.444 1-1 1H8c-.552 0-1-.444-1-1z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$fdad804cb16a6544 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M8.444 14.667V20H5.785C4.8 20 4 19.146 4 18.09V8.577c0-1.055.802-1.91 1.785-1.91h2.66v3.556H6.666V12h1.777v.889H6.667v1.778h1.777zm.89-8.894A1.78 1.78 0 0 1 11.119 4h7.096A1.78 1.78 0 0 1 20 5.773v12.454c0 .979-.802 1.773-1.785 1.773H9.333V5.773zM12 7.556v1.777h1.778V7.556H12zm0 2.666V12h1.778v-1.778H12zm0 2.667v1.778h1.778v-1.778H12zm1.778 2.667v2.666h1.778v-2.666h-1.778zm1.778-8v1.777h1.777V7.556h-1.777zm0 2.666V12h1.777v-1.778h-1.777zm0 2.667v1.778h1.777v-1.778h-1.777z",
        fill: "currentColor"
    }));
const $2e91e7edf801074a$export$a20644de4b67f161 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M12 12a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm-3.228-1.667A3.333 3.333 0 0 0 9.795 12H9.5A2.501 2.501 0 0 0 7 14.497v2.469c-1.771-.147-3.333-.766-3.333-1.858V12c0-.92.74-1.667 1.666-1.667h3.439zm6.456 0h3.439c.92 0 1.666.738 1.666 1.667v3.108c0 1.092-1.562 1.711-3.333 1.858v-2.47A2.5 2.5 0 0 0 14.5 12h-.295a3.333 3.333 0 0 0 1.023-1.667zM10.306 6.63A3.332 3.332 0 0 0 8.67 9.357a2.5 2.5 0 1 1 1.636-2.728zm5.024 2.728a3.328 3.328 0 0 0-1.636-2.73 2.5 2.5 0 1 1 1.636 2.73zm-7.497 5.456c0-1.093.892-1.98 1.996-1.98h4.342a2 2 0 0 1 1.996 1.994v2.781c0 2.523-8.334 2.523-8.334 0v-2.795z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$ce87e45dceec205d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm0-6a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$d95e2215202c8556 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M6.5 12h7.333v-1.833H6.5V12zM4.667 9.242c0-.502.417-.909.919-.909h9.162c.507 0 .919.414.919.909v4.591h-11V9.242zm.458 7.341h12.828l.919-2.75H4.795l.33 2.75zm-2.287-3.677A.79.79 0 0 1 3.643 12h16.86c.504 0 .786.382.625.865l-1.565 4.686c-.16.478-.695.866-1.205.866H4.415c-.506 0-.964-.402-1.025-.906l-.552-4.605zM6.5 7.42c0-1.015.823-1.838 1.831-1.838h1.838c1.011 0 1.831.82 1.831 1.838v2.746H6.5V7.42zm3.667 0v-.004H8.331c.005 0 .002.002.002.004v.912h1.834V7.42z",
        fill: "currentColor"
    }));
const $2e91e7edf801074a$export$3062e49c5521698d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M7.959 15.833V8.474l-2.868 2.868a.541.541 0 1 1-.766-.766l3.79-3.789.001-.004a.544.544 0 0 1 .77.003l3.791 3.792a.543.543 0 0 1 0 .766.543.543 0 0 1-.765 0l-2.87-2.87v7.36a.543.543 0 0 1-.541.541.543.543 0 0 1-.542-.542zm7-6.666v7.359l-2.868-2.868a.541.541 0 1 0-.766.766l3.79 3.789.001.004a.544.544 0 0 0 .77-.003l3.791-3.792a.543.543 0 0 0 0-.766.543.543 0 0 0-.765 0l-2.87 2.87v-7.36a.543.543 0 0 0-.541-.541.543.543 0 0 0-.542.542z",
        fill: "currentColor",
        stroke: "currentColor",
        strokeWidth: ".5",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$17d48fc8b753df77 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M4 6.772C4 5.793 4.793 5 5.773 5h12.454C19.206 5 20 5.796 20 6.772v7.044c0 .979-.793 1.772-1.773 1.772H5.773A1.774 1.774 0 0 1 4 13.816V6.772zm1.778 7.052h12.444v-7.06H5.778v7.06zm8 5.294h.452c.241 0 .437.204.437.44V20H9.333v-.441c0-.244.203-.441.437-.441h.452V16.47h3.556v2.647z",
        fill: "currentColor"
    }));
const $2e91e7edf801074a$export$cbbe21ca62a58ed6 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M16.244 6.244a.833.833 0 1 1 1.179 1.179l-4.412 4.41 4.412 4.411a.834.834 0 0 1 .074 1.093l-.074.086a.833.833 0 0 1-1.179 0l-4.411-4.412-4.41 4.412a.834.834 0 0 1-1.094.074l-.085-.074a.833.833 0 0 1 0-1.179l4.411-4.411-4.41-4.41a.834.834 0 0 1-.076-1.094l.075-.085a.833.833 0 0 1 1.179 0l4.41 4.411z",
        fill: "currentColor"
    }));
const $2e91e7edf801074a$export$8fd991b9da3a43e5 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M12.682 12H5.01A2.006 2.006 0 0 0 3 14v4.446c0 2.162 4.836 2.951 8.368 2.368A5.975 5.975 0 0 1 10 17a5.994 5.994 0 0 1 2.682-5z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        fill: "currentColor",
        cx: "9",
        cy: "7",
        r: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        fill: "currentColor",
        cx: "16",
        cy: "17",
        r: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M14.674 19.331c.36.36.941.36 1.3 0l2.758-2.763a.92.92 0 0 0-1.301-1.298l-2.108 2.11-.755-.754a.92.92 0 0 0-1.3 1.3l1.406 1.405z",
        fill: "inherit"
    })));
const $2e91e7edf801074a$export$f21213fb7b480582 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M6 12c0-.552.456-1 1.002-1h9.996a.999.999 0 110 2H7.002A.999.999 0 016 12zm0 4c0-.552.456-1 1.002-1h9.996a.999.999 0 110 2H7.002A.999.999 0 016 16zm0-8c0-.552.456-1 1.002-1h9.996a.999.999 0 110 2H7.002A.999.999 0 016 8z",
        fill: "currentColor"
    }));
const $2e91e7edf801074a$export$88453606d7da6ff7 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        role: "presentation",
        focusable: "false",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M3 6C2.44772 6 2 6.44772 2 7C2 7.55228 2.44772 8 3 8H11C11.5523 8 12 7.55228 12 7C12 6.44772 11.5523 6 11 6H3ZM4 16V12H20V16H4ZM2 12C2 10.8954 2.89543 10 4 10H20C21.1046 10 22 10.8954 22 12V16C22 17.1046 21.1046 18 20 18H4C2.89543 18 2 17.1046 2 16V12Z",
        fill: "currentColor"
    })));

});


parcelRegister("kqzZ0", function(module, exports) {

$parcel$export(module.exports, "default", () => $b903b0ec65d00fd5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $b903b0ec65d00fd5$var$messages = (0, $7VHMR.defineMessages)({
    deprecatedEpicMessage: {
        "id": "jql-builder-basic.services.use-fields.deprecated-epic-message",
        "defaultMessage": "<strong>Epic Link</strong> is replaced by <strong>Parent</strong>. Use the <strong>Parent</strong> field instead."
    },
    notInContextFieldMessage: {
        "id": "jql-builder-basic.services.use-fields.not-in-context-field-message",
        "defaultMessage": "This field is unavailable for the selected project and/or issue type."
    },
    notInContextFieldMessageIssueTermRefresh: {
        "id": "jql-builder-basic.services.use-fields.not-in-context-field-message-issue-term-refresh",
        "defaultMessage": "This field is unavailable for the selected project and/or work type."
    }
});
var $b903b0ec65d00fd5$export$2e2bcd8739ae039 = $b903b0ec65d00fd5$var$messages;

});


parcelRegister("kYYJK", function(module, exports) {

$parcel$export(module.exports, "removeFieldsFromJql", () => $ab6496c45464ea74$export$cc86b3e973172951);

var $l0V05 = parcelRequire("l0V05");
var $7CDw0 = parcelRequire("7CDw0");

var $04psE = parcelRequire("04psE");
const $ab6496c45464ea74$export$cc86b3e973172951 = (ast, clausesToRemove, textSearchInputClause)=>{
    (0, $7CDw0.walkAST)({
        enterTerminalClause (terminalClause) {
            const isTextSearchInput = textSearchInputClause && new (0, $04psE.IsInCompoundClauseVisitor)(terminalClause).visit(textSearchInputClause);
            if (clausesToRemove.has(terminalClause.field.value.toLowerCase()) && !isTextSearchInput) terminalClause.remove();
        }
    }, ast);
    return (0, $l0V05.print)(ast, {
        operatorCase: 'upper'
    });
};

});

parcelRegister("2royF", function(module, exports) {

$parcel$export(module.exports, "useSendAnalytics", () => $4fa1635798f3a177$export$a8fd9767f372c6ec);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $4fa1635798f3a177$export$a8fd9767f372c6ec = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const sendAnalytics = (0, $5uXOq.useCallback)(({ actionSubjectId: actionSubjectId, attributes: attributes = {} })=>{
        const analyticsEvent = createAnalyticsEvent({
            eventType: 'UI',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: actionSubjectId
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, actionSubjectId, attributes);
    }, [
        createAnalyticsEvent
    ]);
    return sendAnalytics;
};

});

parcelRegister("c5jWV", function(module, exports) {

$parcel$export(module.exports, "AddFilter", () => $5b24df1f97a6d902$export$b317d04196c5962b);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $99M5v = parcelRequire("99M5v");

var $hORKG = parcelRequire("hORKG");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $cgL5K = parcelRequire("cgL5K");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $6s1PB = parcelRequire("6s1PB");

var $F7vyc = parcelRequire("F7vyc");

var $86Rl2 = parcelRequire("86Rl2");

var $7mPT9 = parcelRequire("7mPT9");

var $5oFIy = parcelRequire("5oFIy");

var $dCm1o = parcelRequire("dCm1o");

var $6fhxU = parcelRequire("6fhxU");

var $98azu = parcelRequire("98azu");

var $kG16F = parcelRequire("kG16F");

var $i0Cp4 = parcelRequire("i0Cp4");

var $df3tg = parcelRequire("df3tg");

var $kYYJK = parcelRequire("kYYJK");

var $2royF = parcelRequire("2royF");

var $5Dsab = parcelRequire("5Dsab");
const $5b24df1f97a6d902$var$TriggerButtonWithMergeRef = ({ triggerRef: triggerRef, popupRef: popupRef, buttonRef: buttonRef, ButtonComponent: ButtonComponent, ...props })=>{
    const ref = (0, $7mPT9.default)(triggerRef, popupRef, buttonRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ButtonComponent, {
        ref: ref,
        ...props
    });
};
const $5b24df1f97a6d902$var$isKeyboardEvent = (event)=>Object.hasOwn(event, 'key');
const $5b24df1f97a6d902$export$b317d04196c5962b = ({ value: value, fieldsToRender: fieldsToRender, selectedFields: selectedFields, onSearchWrapper: onSearchWrapper, onClearValues: onClearValues, NoOptionComponent: NoOptionComponent, onChange: onChange, excludeFields: excludeFields, contextJql: contextJql, viewContext: viewContext, scope: scope, ButtonComponent: ButtonComponent = (0, $fVnbM.default) })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [activePopupKey, { openPopup: openPopup, closePopup: closePopup }] = (0, $98azu.useActivePopupKey)();
    const onOpen = (0, $5uXOq.useCallback)(()=>{
        // Fire the experiment exposure
        (0, $6s1PB.expVal)('efa_and_project_fields_page_for_tmp', 'isEnabled', false);
        return openPopup((0, $5Dsab.ADD_FILTER_DROPDOWN));
    }, [
        openPopup
    ]);
    const onClose = (0, $5uXOq.useCallback)(()=>closePopup((0, $5Dsab.ADD_FILTER_DROPDOWN)), [
        closePopup
    ]);
    const [ast] = (0, $kG16F.useAST)();
    const [textSearchInputClause] = (0, $kG16F.useTextSearchInputClause)();
    const excludedFields = (0, $5uXOq.useMemo)(()=>Array.from(excludeFields), [
        excludeFields
    ]);
    const onLoadOptions = (0, $df3tg.useFields)({
        jql: contextJql,
        excludeFields: excludedFields,
        viewContext: viewContext,
        scope: scope
    });
    const isOpen = activePopupKey === (0, $5Dsab.ADD_FILTER_DROPDOWN);
    const sendAnalytics = (0, $2royF.useSendAnalytics)();
    const buttonRef = (0, $5uXOq.useRef)(null);
    const iconAfter = (0, $5uXOq.useMemo)(()=>(0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hORKG))), {
            label: "",
            color: // eslint-disable-next-line no-nested-ternary
            (0, $4R6GH.fg)('visual-refresh-headers-buttons') ? !isOpen ? "var(--ds-icon-subtle, #626F86)" : 'currentColor' : 'currentColor'
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($99M5v))), {
            label: (0, $4R6GH.fg)('calendar_accessibility_fix') ? '' : 'addIcon',
            LEGACY_size: "small"
        }), [
        isOpen
    ]);
    const buttonLabel = (0, $5uXOq.useMemo)(()=>{
        // eslint-disable-next-line no-nested-ternary
        return (0, $dCm1o.isVisualRefreshEnabled)() ? (0, $4R6GH.fg)('visual-refresh-headers-buttons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            weight: "medium",
            color: !isOpen ? 'color.text.subtle' : 'inherit'
        }, formatMessage((0, $6fhxU.default).moreButton)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, $6fhxU.default).moreButton)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, $6fhxU.default).moreButtonOld));
    }, [
        isOpen,
        formatMessage
    ]);
    const handleClose = (0, $5uXOq.useCallback)((event)=>{
        onClose();
        if ($5b24df1f97a6d902$var$isKeyboardEvent(event) && event.key === 'Escape') buttonRef.current?.focus();
    }, [
        onClose
    ]);
    const CustomNoOptionsMessage = (0, $5uXOq.useCallback)(()=>NoOptionComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(NoOptionComponent, {
            onClickLink: onClose,
            sourceId: "moreFieldsPicker"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
            actionSubject: "unsupportedFieldsMessage",
            action: "viewed",
            actionSubjectId: "moreFieldsPicker"
        })) : undefined, [
        NoOptionComponent,
        onClose
    ]);
    const onTrigger = (0, $5uXOq.useCallback)(({ ref: ref }, triggerRef)=>{
        const Trigger = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5b24df1f97a6d902$var$TriggerButtonWithMergeRef, {
            triggerRef: triggerRef,
            buttonRef: buttonRef,
            popupRef: ref,
            appearance: "default",
            iconAfter: iconAfter,
            isSelected: isOpen,
            "aria-expanded": isOpen,
            onClick: isOpen ? onClose : onOpen,
            label: (0, $4R6GH.fg)('calendar_accessibility_fix') ? formatMessage((0, $6fhxU.default).moreButtonLabel) : 'addButton',
            ...(0, $4R6GH.fg)('calendar_accessibility_fix') && {
                'aria-label': formatMessage((0, $6fhxU.default).moreButtonLabel)
            },
            testId: "jql-builder-basic.ui.jql-editor.add-filter.more-button",
            ButtonComponent: ButtonComponent
        }, buttonLabel);
        return (0, $4R6GH.fg)('nin-text-fields-new-text-search-field') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
            name: "jql-builder-spotlight-more-dropdown"
        }, Trigger) : Trigger;
    }, [
        iconAfter,
        isOpen,
        onClose,
        onOpen,
        formatMessage,
        ButtonComponent,
        buttonLabel
    ]);
    const handleChange = (0, $5uXOq.useCallback)((options, meta)=>{
        switch(meta.action){
            case (0, $86Rl2.MetaActions).selectOption:
                if ('option' in meta && meta.option?.optionType === 'field') {
                    const newSelectedFields = [
                        ...selectedFields,
                        meta.option
                    ];
                    const picker = (0, $i0Cp4.getPickerType)({
                        fieldType: meta.option.fieldType,
                        searchTemplate: meta.option.searchTemplate,
                        operators: meta.option.operators
                    });
                    const newFieldsToRender = [
                        ...fieldsToRender,
                        {
                            fieldId: meta.option.value,
                            fieldLabel: meta.option.label,
                            picker: picker,
                            clause: undefined,
                            secondaryClause: undefined,
                            fieldDescription: meta.option.fieldDescription,
                            fieldTypeDisplayName: meta.option.fieldTypeDisplayName
                        }
                    ];
                    onChange({
                        selectedFields: newSelectedFields,
                        fieldsToRender: newFieldsToRender
                    });
                    openPopup(meta.option.value);
                    sendAnalytics({
                        actionSubjectId: 'addFilter',
                        attributes: {
                            fieldType: picker.fieldType,
                            searchTemplate: picker.searchTemplate,
                            refinementType: picker.pickerType,
                            propType: picker.propType
                        }
                    });
                }
                break;
            case (0, $86Rl2.MetaActions).deselectOption:
                if ('option' in meta && meta.option?.optionType === 'field' && !meta.option.isDisabled) {
                    const newSelectedFields = selectedFields.filter((activeField)=>meta.option?.optionType === 'field' && meta.option.value !== activeField.value);
                    const newFieldsToRender = fieldsToRender.filter((fieldToRender)=>{
                        if (meta.option?.optionType === 'field' && meta.option?.value === fieldToRender.fieldId) {
                            onSearchWrapper && onSearchWrapper((0, $kYYJK.removeFieldsFromJql)(ast, new Set([
                                fieldToRender.fieldId
                            ]), textSearchInputClause));
                            return !!(fieldToRender.secondaryClause || fieldToRender.clause);
                        }
                        return true;
                    });
                    onChange({
                        selectedFields: newSelectedFields,
                        fieldsToRender: newFieldsToRender
                    });
                    const picker = (0, $i0Cp4.getPickerType)({
                        fieldType: meta.option.fieldType,
                        searchTemplate: meta.option.searchTemplate,
                        operators: meta.option.operators
                    });
                    sendAnalytics({
                        actionSubjectId: 'removeFilter',
                        attributes: {
                            fieldType: picker.fieldType,
                            searchTemplate: picker.searchTemplate,
                            refinementType: picker.pickerType,
                            propType: picker.propType,
                            isOnlyUnselectable: meta.option.isOnlyUnselectable ?? false
                        }
                    });
                }
                break;
            default:
        }
    }, [
        ast,
        fieldsToRender,
        onChange,
        onSearchWrapper,
        openPopup,
        textSearchInputClause,
        selectedFields,
        sendAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $F7vyc.PickerEntryPoint), {
        isOpen: isOpen,
        onClose: handleClose,
        value: value,
        id: (0, $5Dsab.ADD_FILTER_DROPDOWN),
        onChange: handleChange,
        onLoadOptions: onLoadOptions,
        enableFullList: false,
        onTrigger: onTrigger,
        onClearValues: onClearValues,
        CustomNoOptionsMessage: CustomNoOptionsMessage,
        shouldRenderToParent: true,
        searchInputPlaceholder: formatMessage((0, $6fhxU.default).searchMoreFiltersPlaceholder)
    });
};
var $5b24df1f97a6d902$export$2e2bcd8739ae039 = $5b24df1f97a6d902$export$b317d04196c5962b;

});
parcelRegister("F7vyc", function(module, exports) {

$parcel$export(module.exports, "PickerEntryPoint", () => $4a1525c9a1e673cc$export$387da09c4a56975f);

var $5uXOq = parcelRequire("5uXOq");

var $1I7E8 = parcelRequire("1I7E8");

var $dC5iT = parcelRequire("dC5iT");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $47gW9 = parcelRequire("47gW9");

var $4R6GH = parcelRequire("4R6GH");

var $fANIs = parcelRequire("fANIs");

var $4yuwq = parcelRequire("4yuwq");

var $iYO0e = parcelRequire("iYO0e");
const $4a1525c9a1e673cc$export$387da09c4a56975f = ({ isOpen: isPickerOpen, value: value, onClose: onClose, onClearValues: onClearValues, onRestoreDefaults: onRestoreDefaults, id: id, invalidLabel: invalidLabel, onChange: onChange, formatOptionLabel: formatOptionLabel = (0, $fANIs.default), onLoadOptions: onLoadOptions, enableFullList: enableFullList, operandDisplayValues: operandDisplayValues, showOperandDisplayValuesInFullList: showOperandDisplayValuesInFullList, PopupComponent: PopupComponent, onTrigger: onTrigger, placement: placement = 'bottom-start', zIndex: zIndex, CustomNoOptionsMessage: CustomNoOptionsMessage, pickerComponents: pickerComponents, fallbackPlacements: fallbackPlacements, showOperatorSelect: showOperatorSelect = false, onChangeOperator: onChangeOperator, allowedOperators: allowedOperators, selectedOperator: selectedOperator, isMulti: isMulti, searchInputPlaceholder: searchInputPlaceholder, shouldRenderToParent: shouldRenderToParent = false, experienceAnalyticsAttributes: experienceAnalyticsAttributes, isLoading: isLoading = false, CustomFooter: CustomFooter })=>{
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({}), []);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $iYO0e.asyncSelectEntryPoint), entryPointParams);
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        role: "presentation",
        onKeyDown: (event)=>{
            if (event.key === 'Escape') {
                // avoid closing a modal on closing a picker with esc key
                isPickerOpen && event.stopPropagation();
                onClose && onClose(event);
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
        key: id,
        zIndex: zIndex,
        placement: placement,
        isOpen: isPickerOpen,
        onClose: onClose,
        popupComponent: PopupComponent ?? (0, $4yuwq.FixedWidthPopupComponent),
        trigger: (triggerProps)=>onTrigger(triggerProps, triggerRef),
        autoFocus: false,
        fallbackPlacements: fallbackPlacements,
        testId: `jql-builder-basic-picker-${id}`,
        shouldRenderToParent: shouldRenderToParent,
        /* Our default popup component supports resizing to fit the viewport. */ shouldFitViewport: PopupComponent === undefined,
        content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                id: "jql-builder-basic-picker",
                packageName: "@atlassian/jira-jql-builder-basic-picker",
                errorFallback: "flag",
                runtimeProps: {
                    id: id,
                    invalidLabel: invalidLabel,
                    enableFullList: enableFullList,
                    operandDisplayValues: operandDisplayValues,
                    showOperandDisplayValuesInFullList: showOperandDisplayValuesInFullList,
                    loadOptions: onLoadOptions,
                    onChange: onChange,
                    value: value,
                    formatOptionLabel: formatOptionLabel,
                    onClear: onClearValues,
                    onRestoreDefaults: onRestoreDefaults,
                    NoOptionsMessage: CustomNoOptionsMessage,
                    components: pickerComponents,
                    showOperatorSelect: showOperatorSelect,
                    onChangeOperator: onChangeOperator,
                    allowedOperators: allowedOperators,
                    selectedOperator: selectedOperator,
                    isMulti: isMulti,
                    placeholder: searchInputPlaceholder,
                    experienceAnalyticsAttributes: experienceAnalyticsAttributes,
                    isLoading: isLoading,
                    CustomFooter: (0, $4R6GH.fg)('jira_inline_field_config_gate') ? CustomFooter : undefined,
                    setInitialFocusRef: setInitialFocusRef
                }
            })
    }));
};

});
parcelRegister("fANIs", function(module, exports) {

$parcel$export(module.exports, "default", () => $7efdf47793cb4a4c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kHLGf = parcelRequire("kHLGf");

var $gPO5A = parcelRequire("gPO5A");

var $1mn96 = parcelRequire("1mn96");
const $7efdf47793cb4a4c$var$formatOptionLabel = (data)=>{
    switch(data.optionType){
        case 'avatar':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kHLGf.default), {
                data: data
            });
        case 'lozenge':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1mn96.default), {
                data: data
            });
        case 'option':
        case 'field':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gPO5A.default), {
                data: data
            });
        default:
            return null;
    }
};
var $7efdf47793cb4a4c$export$2e2bcd8739ae039 = $7efdf47793cb4a4c$var$formatOptionLabel;

});
parcelRegister("kHLGf", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8a42684d08c1d1c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ujWmd = parcelRequire("ujWmd");

var $ckyDP = parcelRequire("ckyDP");

var $koVbs = parcelRequire("koVbs");

var $fKpEJ = parcelRequire("fKpEJ");

var $hJUJt = parcelRequire("hJUJt");

var $hKa8k = parcelRequire("hKa8k");
const $e8a42684d08c1d1c$export$fe00f602c942368a = ({ data: data })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [labelOverflows, setLabelOverflows] = (0, $5uXOq.useState)(false);
    const onLabelRef = (0, $5uXOq.useCallback)((node)=>{
        if (node != null) setLabelOverflows(node.offsetWidth < node.scrollWidth);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fKpEJ.ConditionalTooltip), {
        condition: labelOverflows,
        content: data.label,
        position: "right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hJUJt.StyledOption), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hJUJt.StyledLabel), null, data.hideAvatar !== true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hJUJt.StyledLabelIcon), null, data.isGroup === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hJUJt.StylesGroupIconContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ckyDP))), {
        LEGACY_size: "small",
        testId: "jql-builder-basic-picker.ui.format-option-label.avatar-option-label.group-icon",
        label: formatMessage((0, $hKa8k.default).groupIcon)
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        src: typeof data.avatar !== 'string' ? undefined : data.avatar,
        size: "xsmall",
        testId: "jql-builder-basic-picker.ui.format-option-label.avatar-option-label.avatar",
        appearance: typeof data.square === 'boolean' && data.square === true ? 'square' : 'circle'
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hJUJt.StyledLabelText), {
        ref: onLabelRef
    }, data.label))));
};
var $e8a42684d08c1d1c$export$2e2bcd8739ae039 = $e8a42684d08c1d1c$export$fe00f602c942368a;

});
parcelRegister("fKpEJ", function(module, exports) {

$parcel$export(module.exports, "ConditionalTooltip", () => $68dbfbed07ea6c84$export$d8abb7a1cfbd4b6b);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");
const $68dbfbed07ea6c84$export$d8abb7a1cfbd4b6b = ({ condition: condition, children: children, ...rest })=>condition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), rest, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);

});

parcelRegister("hJUJt", function(module, exports) {

$parcel$export(module.exports, "PICKER_DROPDOWN_WIDTH", () => $a439f325bae06de0$export$ca493ca2aa631e47);
$parcel$export(module.exports, "StyledOption", () => $a439f325bae06de0$export$844bee7de236d7ec);
$parcel$export(module.exports, "StyledLabel", () => $a439f325bae06de0$export$eea83358d9434634);
$parcel$export(module.exports, "StyledLabelIcon", () => $a439f325bae06de0$export$282e0b7f297acea7);
$parcel$export(module.exports, "StyledIcon", () => $a439f325bae06de0$export$7c8f159da0dc916);
$parcel$export(module.exports, "StyledLabelText", () => $a439f325bae06de0$export$601dc5d21f1e8182);
$parcel$export(module.exports, "StyledLozenge", () => $a439f325bae06de0$export$fb418b53e6535057);
$parcel$export(module.exports, "StyledLozengeLabel", () => $a439f325bae06de0$export$cd2803f359bf9865);
$parcel$export(module.exports, "StyledSecondaryLabel", () => $a439f325bae06de0$export$385a11497793b305);
$parcel$export(module.exports, "StylesGroupIconContainer", () => $a439f325bae06de0$export$56cfb14c006d4229);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $a439f325bae06de0$export$ca493ca2aa631e47 = 300;
const $a439f325bae06de0$export$844bee7de236d7ec = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $a439f325bae06de0$export$eea83358d9434634 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _4t3i1tcg",
            __cmplp.className
        ])
    });
});
const $a439f325bae06de0$export$282e0b7f297acea7 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _18u0v77o",
            __cmplp.className
        ])
    });
});
const $a439f325bae06de0$export$7c8f159da0dc916 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1ssb _4t3i7vkz _1bsb7vkz _1e0c1txw _19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
            __cmplp.className
        ])
    });
});
const $a439f325bae06de0$export$601dc5d21f1e8182 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bto1l2s _18u01b66",
            __cmplp.className
        ])
    });
});
const $a439f325bae06de0$export$fb418b53e6535057 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _18u01b66 _p12f1osq",
            __cmplp.className
        ])
    });
});
const $a439f325bae06de0$export$cd2803f359bf9865 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1o8l _1bsb1osq _1bto1l2s _s7n4jp4b",
            __cmplp.className
        ])
    });
});
const $a439f325bae06de0$export$385a11497793b305 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _11c81o8v _zulpv77o _1bto1l2s _syaz131l _19pk1i6y _18u01b66 _4cvr1h6o _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $a439f325bae06de0$export$56cfb14c006d4229 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("hKa8k", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf4e6dd74a61f1d7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bf4e6dd74a61f1d7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    groupIcon: {
        "id": "jql-builder-basic-picker.format-option-label.avatar-option-label.group-icon",
        "defaultMessage": "Group Icon"
    }
});

});


parcelRegister("gPO5A", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b4f469acf524e79$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fKpEJ = parcelRequire("fKpEJ");

var $hJUJt = parcelRequire("hJUJt");
const $1b4f469acf524e79$export$914fa095fc1e0a45 = ({ data: data })=>{
    const [labelOverflows, setLabelOverflows] = (0, $5uXOq.useState)(false);
    const [secondaryLabelOverflows, setSecondaryLabelOverflows] = (0, $5uXOq.useState)(false);
    const showSecondaryLabel = (input)=>typeof input.secondaryLabel === 'string' && input.secondaryLabel.length > 0 || // remove !isValidElement(data.secondaryLabel) with cleanup with m7.3-mm2-custom-fields-with-existing-uis_vzhn7
        typeof input.secondaryLabel === 'object' && !/*#__PURE__*/ (0, $5uXOq.isValidElement)(input.secondaryLabel) && /*#__PURE__*/ (0, $5uXOq.isValidElement)(input.secondaryLabel.element);
    const onLabelRef = (0, $5uXOq.useCallback)((node)=>{
        if (node != null) setLabelOverflows(node.offsetWidth < node.scrollWidth);
    }, []);
    const onSecondaryLabelRef = (0, $5uXOq.useCallback)((node)=>{
        if (node != null) setSecondaryLabelOverflows(node.offsetWidth < node.scrollWidth);
    }, []);
    const tooltipContent = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, data.label), typeof data.secondaryLabel === 'string' && data.secondaryLabel.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, "(", data.secondaryLabel, ")")), [
        data
    ]);
    const getSecondaryLabelComponent = (option)=>{
        if (typeof option === 'object' && !/*#__PURE__*/ (0, $5uXOq.isValidElement)(option)) return option.element;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, option);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fKpEJ.ConditionalTooltip), {
        condition: labelOverflows || secondaryLabelOverflows,
        content: tooltipContent,
        position: "right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hJUJt.StyledOption), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hJUJt.StyledLabel), null, data.icon != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hJUJt.StyledLabelIcon), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hJUJt.StyledIcon), {
        src: data.icon,
        alt: data.label
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hJUJt.StyledLabelText), {
        ref: onLabelRef
    }, data.label)), showSecondaryLabel(data) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hJUJt.StyledSecondaryLabel), {
        ref: onSecondaryLabelRef,
        "data-testid": "jql-builder-basic-picker.ui.format-option-label.icon-option-label.secondary-label"
    }, data.secondaryLabel && getSecondaryLabelComponent(data.secondaryLabel))));
};
var $1b4f469acf524e79$export$2e2bcd8739ae039 = $1b4f469acf524e79$export$914fa095fc1e0a45;

});

parcelRegister("1mn96", function(module, exports) {

$parcel$export(module.exports, "default", () => $e00004c2a8970b7a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3u0c5 = parcelRequire("3u0c5");

var $gwIPs = parcelRequire("gwIPs");

var $fKpEJ = parcelRequire("fKpEJ");

var $hJUJt = parcelRequire("hJUJt");
// Checkbox icon width = 3 * gridSize
// Margins and paddings around checkbox icon = 2 * gridSize
// Option right padding = (3 / 2) * gridSize
const $e00004c2a8970b7a$var$DEFAULT_MAX_WIDTH = (0, $hJUJt.PICKER_DROPDOWN_WIDTH) - 3 * (0, $gwIPs.gridSize) - 2 * (0, $gwIPs.gridSize) - 1.5 * (0, $gwIPs.gridSize);
const $e00004c2a8970b7a$export$5f70fe304106fcb1 = ({ data: data })=>{
    const [labelOverflows, setLabelOverflows] = (0, $5uXOq.useState)(false);
    const onLabelRef = (0, $5uXOq.useCallback)((node)=>{
        if (node != null) setLabelOverflows(node.offsetWidth < node.scrollWidth);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hJUJt.StyledOption), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hJUJt.StyledLabel), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hJUJt.StyledLozenge), {
        "data-testid": "jql-builder-basic-picker.ui.format-option-label.lozenge-option-label.lozenge"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
        appearance: data.appearance,
        isBold: data.isBold,
        maxWidth: data.maxWidth ?? $e00004c2a8970b7a$var$DEFAULT_MAX_WIDTH
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fKpEJ.ConditionalTooltip), {
        condition: labelOverflows,
        content: data.label,
        position: "right",
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hJUJt.StyledLozengeLabel), {
        ref: onLabelRef
    }, data.label))))));
};
var $e00004c2a8970b7a$export$2e2bcd8739ae039 = $e00004c2a8970b7a$export$5f70fe304106fcb1;

});


parcelRegister("4yuwq", function(module, exports) {

$parcel$export(module.exports, "DefaultPopupComponent", () => $49a1498ba83c84c7$export$5038854ec49970e4);
$parcel$export(module.exports, "FixedWidthPopupComponent", () => $49a1498ba83c84c7$export$84690c88a5faffa0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $5uXOq = parcelRequire("5uXOq");

var $k5uoT = parcelRequire("k5uoT");

var $hJUJt = parcelRequire("hJUJt");
const $49a1498ba83c84c7$var$getPopupComponent = (width)=>/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($49a1498ba83c84c7$var$PopupComponentContainer, {
            ...props,
            ref: ref,
            width: width
        }));
const $49a1498ba83c84c7$export$5038854ec49970e4 = $49a1498ba83c84c7$var$getPopupComponent();
const $49a1498ba83c84c7$export$84690c88a5faffa0 = $49a1498ba83c84c7$var$getPopupComponent((0, $hJUJt.PICKER_DROPDOWN_WIDTH));
// Workaround for https://github.com/atlassian-labs/compiled/issues/1200
const $49a1498ba83c84c7$var$layerValue = (0, $k5uoT.layers).layer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $49a1498ba83c84c7$var$PopupComponentContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1vcp0mh": (0, $lD23V.default)(__cmplp.width, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _16jlkb7n _1o9zkb7n _i0dl1wug _1reoewfl _18m9ewfl _bfhk1bhr _16qs1cd0 _vchhusvi _1e0c1txw _2lx21bp4 _1pby1nn1 _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.width && "_1bsb1efm",
            __cmplp.className
        ])
    });
});

});

parcelRegister("iYO0e", function(module, exports) {

$parcel$export(module.exports, "asyncSelectEntryPoint", () => $202013b90d991bdb$export$8e45ad33288ae801);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $202013b90d991bdb$export$8e45ad33288ae801 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("atVFR"))).then((module)=>module.PaginatedAsyncSelectViewExperience), {
        moduleId: "a7e2dd9c"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("atVFR", function(module, exports) {

$parcel$export(module.exports, "default", () => $026ccb03b7a13a7c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "PaginatedAsyncSelectViewExperience", () => $026ccb03b7a13a7c$export$2590d00ec46c6754);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fW7cr = parcelRequire("fW7cr");

var $ajpes = parcelRequire("ajpes");

var $9fuVs = parcelRequire("9fuVs");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $jG2IE = parcelRequire("jG2IE");

var $jjMKx = parcelRequire("jjMKx");

var $tG7a9 = parcelRequire("tG7a9");

var $fHaff = parcelRequire("fHaff");

var $bLfwu = parcelRequire("bLfwu");

var $6xfyp = parcelRequire("6xfyp");

var $k3vJi = parcelRequire("k3vJi");

var $9x2Xf = parcelRequire("9x2Xf");

var $gJcRP = parcelRequire("gJcRP");

var $aNitm = parcelRequire("aNitm");
const $026ccb03b7a13a7c$var$MAX_TOTAL_COUNT = 1000; // To be cleaned up in EM-3568
const $026ccb03b7a13a7c$var$addFullListToOptions = (options, fullList)=>options.map((option)=>{
        switch(option.optionType){
            case 'group':
                return {
                    ...option,
                    options: $026ccb03b7a13a7c$var$addFullListToOptions(option.options, fullList)
                };
            // Need separate cases so flow can correctly infer types for this union
            case 'avatar':
                return {
                    ...option,
                    fullList: fullList
                };
            // Need separate cases so flow can correctly infer types for this union
            case 'lozenge':
                return {
                    ...option,
                    fullList: fullList
                };
            // Need separate cases so flow can correctly infer types for this union
            case 'option':
                return {
                    ...option,
                    fullList: fullList
                };
            default:
                return option;
        }
    });
const $026ccb03b7a13a7c$var$selectStyles = {
    container: (baseStyles)=>({
            ...baseStyles,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
        })
};
const $026ccb03b7a13a7c$var$PaginatedAsyncSelectView = ({ id: id, onMenuScrollToBottom: onMenuScrollToBottom, onMenuScrollToTop: onMenuScrollToTop, placeholder: placeholder, invalidLabel: invalidLabel, enableFullList: enableFullListProp, operandDisplayValues: operandDisplayValues, showOperandDisplayValuesInFullList: showOperandDisplayValuesInFullList, loadOptions: loadOptions, onInputChange: onInputChange, value: value, onChange: onChange, onChangeOperator: onChangeOperator, onClear: onClear, onRestoreDefaults: onRestoreDefaults, components: customComponents, showOperatorSelect: showOperatorSelect, allowedOperators: allowedOperators, selectedOperator: selectedOperator, isMulti: isMulti = true, setInitialFocusRef: setInitialFocusRef, isLoading: isLoadingExternal, CustomFooter: CustomFooter, ...restProps })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const paginatedComponents = (0, $5uXOq.useMemo)(()=>({
            ...(0, $k3vJi.selectComponents),
            MenuList: $tG7a9.MenuList
        }), []);
    const paginatedSingleSelectComponents = (0, $5uXOq.useMemo)(()=>({
            ...(0, $k3vJi.singleSelectComponents),
            Option: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9x2Xf.default), {
                    ...props,
                    isMulti: false
                }),
            MenuList: $tG7a9.MenuList
        }), []);
    const [isLoadingInternal, setIsLoading] = (0, $5uXOq.useState)(true);
    const [isPaginationLoading, setIsPaginationLoading] = (0, $5uXOq.useState)(false);
    const [inputValue, setInputValue] = (0, $5uXOq.useState)('');
    const [loadedOptions, setLoadedOptions] = (0, $5uXOq.useState)([]);
    const [enableFullList, setEnableFullList] = (0, $5uXOq.useState)(enableFullListProp || false);
    const [totalCount, setTotalCount] = (0, $5uXOq.useState)(null);
    const [endCursor, setEndCursor] = (0, $5uXOq.useState)(undefined);
    const [error, setError] = (0, $5uXOq.useState)({
        isError: false,
        error: null,
        onRetry: null
    });
    const isLoading = isLoadingInternal || isLoadingExternal;
    const searchRef = (0, $5uXOq.useRef)('');
    const itemCount = (0, $5uXOq.useMemo)(()=>loadedOptions.flatMap((option)=>option.optionType === 'group' ? option.options : option).length, [
        loadedOptions
    ]);
    const getTotalCountWithFunctions = (0, $5uXOq.useCallback)((newTotalCount)=>{
        if (newTotalCount === null || !operandDisplayValues?.length) return newTotalCount;
        let newTotalCountWithKeywords;
        if (showOperandDisplayValuesInFullList === true) newTotalCountWithKeywords = newTotalCount + operandDisplayValues.length;
        else newTotalCountWithKeywords = newTotalCount + value.filter((option)=>(0, $jG2IE.isSingleValueOption)(option) && operandDisplayValues.includes(option.value)).length;
        return newTotalCountWithKeywords < $026ccb03b7a13a7c$var$MAX_TOTAL_COUNT ? newTotalCountWithKeywords : $026ccb03b7a13a7c$var$MAX_TOTAL_COUNT;
    }, [
        operandDisplayValues,
        showOperandDisplayValuesInFullList,
        value
    ]);
    const checkIfError = (0, $5uXOq.useCallback)((search, options, onRetry)=>{
        const errorOption = options.find((option)=>option.optionType === 'error' && option.error instanceof Error);
        if (errorOption && errorOption.optionType === 'error') {
            setError({
                isError: true,
                error: errorOption.error,
                onRetry: onRetry
            });
            setIsLoading(false);
            return true;
        }
        setError({
            isError: false,
            error: null,
            onRetry: null
        });
        return false;
    }, []);
    const handleLoadOptions = (0, $5uXOq.useCallback)((search, overridenValue, renderInitialValues = enableFullList)=>{
        if (!loadOptions) return;
        searchRef.current = search;
        setIsLoading(true);
        loadOptions(search, renderInitialValues, undefined, ({ options: options, totalCount: newTotalCount, endCursor: newEndCursor })=>{
            // Handle error
            if (checkIfError(search, options, ()=>{
                handleLoadOptions(search);
            })) return; // This is to prevent outdated options/results from overriding if a race condition occurs
            if (searchRef.current !== search) return;
            if (search) {
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(loadedOptions, options)) {
                    setLoadedOptions(options);
                    setTotalCount(newTotalCount);
                }
            } else {
                const newLoadedOptions = (0, $aNitm.generateOptions)([
                    ...overridenValue ?? value
                ], options, formatMessage);
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(loadedOptions, newLoadedOptions)) {
                    setLoadedOptions(newLoadedOptions);
                    setTotalCount(getTotalCountWithFunctions(newTotalCount));
                }
            }
            setEndCursor(newEndCursor);
            setIsLoading(false);
        });
    }, [
        loadOptions,
        enableFullList,
        checkIfError,
        value,
        loadedOptions,
        getTotalCountWithFunctions,
        formatMessage
    ]);
    const handleShowMore = (0, $5uXOq.useCallback)((firstLoad = false, isRetry = false)=>{
        if (!loadOptions || !loadedOptions) return;
        let originalLoadedOptions;
        if (firstLoad) {
            originalLoadedOptions = [];
            setIsLoading(true);
        } else {
            originalLoadedOptions = loadedOptions;
            if (isRetry) setIsLoading(true);
            else setIsPaginationLoading(true);
        }
        loadOptions(inputValue, false, endCursor, ({ options: options, totalCount: newTotalCount, endCursor: newEndCursor })=>{
            if (checkIfError(inputValue, options, ()=>{
                handleShowMore(firstLoad, true);
            })) return;
            const newLoadedOptions = inputValue ? originalLoadedOptions.concat(options) : (0, $aNitm.generateOptions)(value, options, formatMessage, originalLoadedOptions, firstLoad);
            setEnableFullList(false);
            setTotalCount(inputValue ? newTotalCount : getTotalCountWithFunctions(newTotalCount));
            setLoadedOptions(newLoadedOptions);
            setIsPaginationLoading(false);
            setIsLoading(false);
            setEndCursor(newEndCursor);
        });
    }, [
        loadOptions,
        loadedOptions,
        inputValue,
        endCursor,
        checkIfError,
        value,
        getTotalCountWithFunctions,
        formatMessage
    ]);
    const handleShowFullList = (0, $5uXOq.useCallback)(()=>{
        handleShowMore(true);
    }, [
        handleShowMore
    ]);
    const handleInputChange = (0, $5uXOq.useCallback)((newInputValue)=>{
        // on empty search: reset to default state for pickers where enableFullListProp==true
        if (newInputValue.length === 0 && enableFullListProp) {
            setEnableFullList(true);
            handleLoadOptions(newInputValue, undefined, true);
        } else {
            setEnableFullList(false);
            handleLoadOptions(newInputValue);
        }
        setInputValue(newInputValue);
        onInputChange && onInputChange();
    }, [
        enableFullListProp,
        handleLoadOptions,
        onInputChange
    ]);
    const handleOnChange = (0, $5uXOq.useCallback)((options, meta)=>{
        if ('option' in meta && meta.option) {
            const selectedIndex = (0, (/*@__PURE__*/$parcel$interopDefault($fW7cr)))(loadedOptions, (option)=>(0, $jG2IE.isSingleValueOption)(option) && meta.option !== undefined && (0, $jG2IE.isSingleValueOption)(meta.option) && option.value === meta.option.value);
            onChange && onChange(options, meta, {
                selectedIndex: selectedIndex
            }, undefined, (0, $4R6GH.fg)('jira_inline_field_config_gate') ? ()=>setLoadedOptions(loadedOptions) : undefined);
        } else onChange && onChange(options, meta, undefined, undefined, (0, $4R6GH.fg)('jira_inline_field_config_gate') ? ()=>setLoadedOptions(loadedOptions) : undefined);
        if ((0, $4R6GH.fg)('jira_inline_field_config_gate')) {
            const newLoadedOptions = (0, $aNitm.generateOptions)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            options, loadedOptions, formatMessage);
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(loadedOptions, newLoadedOptions)) setLoadedOptions(newLoadedOptions);
        }
    }, [
        onChange,
        loadedOptions,
        formatMessage
    ]);
    const handleOnRestoreDefaults = (0, $5uXOq.useCallback)(()=>{
        if (typeof onRestoreDefaults === 'function') {
            const defaultOptions = onRestoreDefaults(); // Reset picker input and force update of options to go back to an initial-like state where selected options are on top
            setInputValue('');
            handleLoadOptions('', defaultOptions);
        }
    }, [
        handleLoadOptions,
        onRestoreDefaults
    ]); // We only want to call this on init, so it's ok to disable react-hooks/exhaustive-deps
    (0, $5uXOq.useEffect)(()=>{
        handleLoadOptions(''); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const loadedOptionsWithFullList = (0, $5uXOq.useMemo)(()=>$026ccb03b7a13a7c$var$addFullListToOptions(loadedOptions, !enableFullList), [
        loadedOptions,
        enableFullList
    ]);
    const components = (0, $5uXOq.useMemo)(()=>isMulti ? {
            ...paginatedComponents,
            ...customComponents
        } : {
            ...paginatedSingleSelectComponents,
            ...customComponents
        }, [
        customComponents,
        isMulti,
        paginatedComponents,
        paginatedSingleSelectComponents
    ]);
    const selectedValue = (0, $5uXOq.useMemo)(/**
   * This method is to form the value from loadedOptionsWithFullList Array so that the 'Options' and 'Value' props of
   * select component will have same object references, This is a workaround to meet the below condition in the '@atlaskit/select'
   * component's ariaFocused method
   * var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));.
   * This condition must work to announce the state of selection.
   *
   * The below method can be removed if the above condition is improved to check just the value instead of reference.
   */ ()=>(0, $aNitm.getValueFromOptions)(loadedOptionsWithFullList, value), [
        loadedOptionsWithFullList,
        value
    ]);
    const showFooterType = (0, $5uXOq.useMemo)(()=>{
        const showFooter = !isLoading && loadedOptions && Boolean(loadedOptions.length) && !error.isError;
        if (showFooter && CustomFooter != null && (0, $4R6GH.fg)('jira_inline_field_config_gate')) return 'custom';
        if (showFooter) return 'default';
    }, [
        CustomFooter,
        error.isError,
        isLoading,
        loadedOptions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, showOperatorSelect && onChangeOperator && allowedOperators && Boolean(allowedOperators.length) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fHaff.OperatorsSelect), {
        onChange: onChangeOperator,
        allowedOperators: allowedOperators,
        selectedOperator: selectedOperator
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k3vJi.BaseSelect), {
        components: components,
        inputValue: inputValue,
        onInputChange: handleInputChange,
        onMenuScrollToBottom: onMenuScrollToBottom,
        onMenuScrollToTop: onMenuScrollToTop,
        placeholder: placeholder,
        id: id,
        invalidLabel: invalidLabel,
        options: loadedOptionsWithFullList,
        setInitialFocusRef: setInitialFocusRef,
        menuListProps: {
            error: error,
            handleShowMore: handleShowMore,
            isLoading: isLoading,
            isPaginationLoading: isPaginationLoading,
            showShowMoreButton: totalCount !== null && itemCount < totalCount
        },
        onChange: handleOnChange,
        value: selectedValue,
        styles: $026ccb03b7a13a7c$var$selectStyles,
        ...restProps,
        isMulti: isMulti,
        totalCount: totalCount
    }), showFooterType === 'default' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($026ccb03b7a13a7c$var$Footer, null, onRestoreDefaults !== undefined ? typeof onRestoreDefaults === 'function' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6xfyp.default), {
        onRestoreDefaults: handleOnRestoreDefaults
    }) : Boolean(value.length) && isMulti && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jjMKx.default), {
        onClear: onClear
    }), (!value.length || !isMulti) && enableFullList && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gJcRP.default), {
        onShowFullList: handleShowFullList
    }), !enableFullList && totalCount !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bLfwu.default), {
        itemsCount: itemCount,
        totalCount: totalCount
    })), showFooterType === 'custom' && CustomFooter, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null));
};
var $026ccb03b7a13a7c$export$2e2bcd8739ae039 = $026ccb03b7a13a7c$var$PaginatedAsyncSelectView;
const $026ccb03b7a13a7c$export$2590d00ec46c6754 = ({ props: props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($026ccb03b7a13a7c$var$PaginatedAsyncSelectView, props);
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $026ccb03b7a13a7c$var$Footer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_x3dog0l8 _ca0q1b66 _n3td1b66 _1e0c1txw _2lx2vrvc _4cvr1h6o _4t3i1ylp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fW7cr", function(module, exports) {

var $b5dwA = parcelRequire("b5dwA");

var $bxDef = parcelRequire("bxDef");

var $kPZpS = parcelRequire("kPZpS");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b9a1db7d7901532f$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $b9a1db7d7901532f$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $kPZpS(fromIndex);
    if (index < 0) index = $b9a1db7d7901532f$var$nativeMax(length + index, 0);
    return $b5dwA(array, $bxDef(predicate, 3), index);
}
module.exports = $b9a1db7d7901532f$var$findIndex;

});

parcelRegister("jG2IE", function(module, exports) {

$parcel$export(module.exports, "isSingleValueOption", () => $4dbead67dfc4bb06$export$35faed52a6bc243e);
const $4dbead67dfc4bb06$export$35faed52a6bc243e = (option)=>option.optionType === 'option' || option.optionType === 'avatar' || option.optionType === 'lozenge' || option.optionType === 'field';

});

parcelRegister("jjMKx", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d5d641183d91634$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $gqosm = parcelRequire("gqosm");

var $3RdLe = parcelRequire("3RdLe");
const $6d5d641183d91634$export$1d4b7cda9e589b53 = ({ onClear: onClear })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onClearSelectedItems = (0, $5uXOq.useCallback)((mouseEvent, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'filterSearchClearSelectedItems', {
            // If number of clicks is 0, button was actioned using the keyboard
            keyboard: mouseEvent.detail === 0
        });
        onClear && onClear();
    }, [
        onClear
    ]);
    const message = formatMessage((0, $3RdLe.default).clearAllSelectedItemsButtonText);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gqosm.LeftFooterButton), {
        message: message,
        onClick: onClearSelectedItems,
        appearance: "subtle-link",
        testId: "jql-builder-basic-picker.ui.async-select.clear-selection-button.clear-selected-items",
        hasTooltip: true
    });
};
var $6d5d641183d91634$export$2e2bcd8739ae039 = $6d5d641183d91634$export$1d4b7cda9e589b53;

});
parcelRegister("gqosm", function(module, exports) {

$parcel$export(module.exports, "LeftFooterButton", () => $8382e616dfcbfdff$export$edc8e1365283b1f0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $dCm1o = parcelRequire("dCm1o");
const $8382e616dfcbfdff$export$edc8e1365283b1f0 = ({ message: message, onClick: onClick, testId: testId, appearance: appearance, hasTooltip: hasTooltip, label: label })=>{
    const shouldApplyVisualRefresh = (0, $dCm1o.isVisualRefreshEnabled)();
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: appearance,
        onClick: onClick,
        testId: testId
    }, message);
    if (!hasTooltip) {
        if (shouldApplyVisualRefresh) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            padding: "space.050",
            xcss: $8382e616dfcbfdff$var$leftFooterButtonContainerStyles
        }, content);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8382e616dfcbfdff$var$LeftFooterButtonContainerOld, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: appearance,
            onClick: onClick,
            testId: testId
        }, message));
    }
    if (shouldApplyVisualRefresh) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        padding: "space.050",
        xcss: $8382e616dfcbfdff$var$leftFooterButtonContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: message
    }, content));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8382e616dfcbfdff$var$LeftFooterButtonContainerOld, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: message
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: appearance,
        onClick: onClick,
        testId: testId,
        ...label && {
            'aria-label': label
        }
    }, message)));
};
const $8382e616dfcbfdff$var$leftFooterButtonContainerStyles = (0, $8CUq3.xcss)({
    overflow: 'hidden',
    marginInlineStart: 'space.300'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8382e616dfcbfdff$var$LeftFooterButtonContainerOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _ahbqu2gc",
            __cmplp.className
        ])
    });
});

});

parcelRegister("3RdLe", function(module, exports) {

$parcel$export(module.exports, "default", () => $74e59d905f825042$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $74e59d905f825042$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    clearAllSelectedItemsButtonText: {
        "id": "jql-builder-basic-picker.async-select.clear-selection-button.clear-all-selected-items-button-text",
        "defaultMessage": "Clear selection"
    }
});

});


parcelRegister("tG7a9", function(module, exports) {

$parcel$export(module.exports, "MenuList", () => $8f0debcde274ccd2$export$d4c4e98c5044dc8);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $2NMNM = parcelRequire("2NMNM");

var $bChGW = parcelRequire("bChGW");

var $eZJjh = parcelRequire("eZJjh");

var $8zOmE = parcelRequire("8zOmE");

var $4R6GH = parcelRequire("4R6GH");

var $4lwHt = parcelRequire("4lwHt");

var $8lkoH = parcelRequire("8lkoH");

var $dRSRG = parcelRequire("dRSRG");
const $8f0debcde274ccd2$export$d4c4e98c5044dc8 = (props)=>{
    const [clickCount, setClickCount] = (0, $5uXOq.useState)(1);
    const { selectProps: { menuListProps: { error: { isError: isError, onRetry: onRetry }, handleShowMore: handleShowMore, isLoading: isLoading, isPaginationLoading: isPaginationLoading, showShowMoreButton: showShowMoreButton } } } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleOnShowMore = (0, $5uXOq.useCallback)((mouseEvent, analyticsEvent)=>{
        setClickCount(clickCount + 1);
        if ((0, $4R6GH.fg)('jql_basic_picker_infinite_scroll')) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'options',
            action: 'scrolled'
        }), 'filterSearchShowMore');
        else analyticsEvent && (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'filterSearchShowMore', {
            clickCount: clickCount,
            // If number of clicks is 0, button was actioned using the keyboard
            keyboard: mouseEvent?.detail === 0
        });
        handleShowMore();
    }, [
        clickCount,
        handleShowMore,
        createAnalyticsEvent
    ]);
    if (isLoading && clickCount > 1) setClickCount(1);
    if ((0, $4R6GH.fg)('jql_basic_picker_infinite_scroll')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).MenuList, props, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8lkoH.default), null), !isLoading && isError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4lwHt.default), {
        onRetry: onRetry
    }), !isLoading && !isError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children, showShowMoreButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dRSRG.default), {
        onShowMore: handleOnShowMore,
        isPaginationLoading: isPaginationLoading
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).MenuList, props, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8lkoH.default), null), !isLoading && isError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4lwHt.default), {
        onRetry: onRetry
    }), !isLoading && !isError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children, isPaginationLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8f0debcde274ccd2$var$LoadingWrapper, {
        testid: "jql-builder-basic-picker.ui.async-select.menu-list.loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), null)), showShowMoreButton && !isPaginationLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dRSRG.default), {
        onShowMore: handleOnShowMore
    })));
};
var $8f0debcde274ccd2$export$2e2bcd8739ae039 = $8f0debcde274ccd2$export$d4c4e98c5044dc8;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8f0debcde274ccd2$var$LoadingWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _19pku2gc _2hwxze3t _otyru2gc _18u0ze3t",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4lwHt", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b7cff63e4a16547$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $dD7Zc = parcelRequire("dD7Zc");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4YzBg = parcelRequire("4YzBg");

var $fZAS4 = parcelRequire("fZAS4");
const $1b7cff63e4a16547$var$ErrorMessage = ({ onRetry: onRetry })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onClick = (0, $5uXOq.useCallback)(()=>{
        onRetry?.();
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'refinementBarSelectRetry clicked');
    }, [
        onRetry,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4YzBg.StyledBox), {
        height: 144,
        "data-testid": "jql-builder-basic-picker.ui.async-select.menu-list.error-message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4YzBg.StyledBox), {
        height: 72,
        iconSize: 72
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        spacing: "spacious",
        color: "var(--ds-icon, #44546F)",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4YzBg.StyledText), null, formatMessage((0, $fZAS4.default).errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onClick: onClick,
        appearance: "link",
        testId: "jql-builder-basic-picker.ui.async-select.menu-list.error-message.retry-button"
    }, formatMessage((0, $fZAS4.default).retryMessage)));
};
var $1b7cff63e4a16547$export$2e2bcd8739ae039 = $1b7cff63e4a16547$var$ErrorMessage;

});
parcelRegister("4YzBg", function(module, exports) {

$parcel$export(module.exports, "DropdownIndicatorWrapper", () => $71e21e0e3e4add09$export$30c615a45297e297);
$parcel$export(module.exports, "StyledBox", () => $71e21e0e3e4add09$export$d675f139b342d51a);
$parcel$export(module.exports, "StyledText", () => $71e21e0e3e4add09$export$31ea92f3997410dd);
$parcel$export(module.exports, "StyledControl", () => $71e21e0e3e4add09$export$5c7b7f0e517b89f8);
$parcel$export(module.exports, "CloseIconWrapper", () => $71e21e0e3e4add09$export$94756becb802e330);
$parcel$export(module.exports, "DisplayWrapper", () => $71e21e0e3e4add09$export$6833d6d22987ee7f);
$parcel$export(module.exports, "CustomOptionStyles", () => $71e21e0e3e4add09$export$fa3694617a82202b);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $l1N8i = parcelRequire("l1N8i");
const $71e21e0e3e4add09$export$30c615a45297e297 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwxv77o _y3gn1h6o _1bsbzwfg",
            __cmplp.className
        ])
    });
});
const $71e21e0e3e4add09$export$d675f139b342d51a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { iconSize: iconSize, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_10ib6lf": (0, $lD23V.default)(__cmplp.height, "px"),
            "--_1kpj8xj": (0, $lD23V.default)(__cmplp.iconSize, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _1bah1h6o",
            __cmplp.height ? "_4t3it1jn" : "_4t3i1qr7",
            __cmplp.iconSize && "_w8l51dmb _17521dmb",
            __cmplp.className
        ])
    });
});
const $71e21e0e3e4add09$var$StyledTextComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});
const $71e21e0e3e4add09$export$31ea92f3997410dd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($71e21e0e3e4add09$var$StyledTextComponent, props));
const $71e21e0e3e4add09$export$5c7b7f0e517b89f8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_n7zl1pvm _1e0c1txw _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
            __cmplp.className
        ])
    });
});
const $71e21e0e3e4add09$export$94756becb802e330 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_80omtlke _30l31bsc",
            __cmplp.className
        ])
    });
});
const $71e21e0e3e4add09$export$6833d6d22987ee7f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { displayFlag: displayFlag, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.displayFlag ? "_1e0c1ule" : "_1e0cglyw",
            __cmplp.className
        ])
    });
});
const $71e21e0e3e4add09$export$fa3694617a82202b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasIconAfter: hasIconAfter, isSingleSelect: isSingleSelect, isFocused: isFocused, isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1kfm9xv": (0, $lD23V.default)(__cmplp.isFocused ? `inset 2px 0px 0px ${"var(--ds-border-focused, #388BFF)"}` : 'none'),
            "--_1p23kyf": (0, $lD23V.default)(__cmplp.isDisabled ? 'color.text.disabled' : 'color.text')
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _dzc2v2br _m3zku2gc",
            __cmplp.hasIconAfter ? "_sktr1ejb" : "_sktrze3t",
            __cmplp.isSingleSelect && "_bp7o1fcu _ngc03plq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("fZAS4", function(module, exports) {

$parcel$export(module.exports, "default", () => $bed2c53858b71aa0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bed2c53858b71aa0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorMessage: {
        "id": "jql-builder-basic-picker.async-select.menu-list.error-message.error-message",
        "defaultMessage": "Couldn't retrieve data"
    },
    retryMessage: {
        "id": "jql-builder-basic-picker.async-select.menu-list.error-message.retry-message",
        "defaultMessage": "Click to retry"
    }
});

});


parcelRegister("8lkoH", function(module, exports) {

$parcel$export(module.exports, "default", () => $4336854db3f61d28$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");

var $ousew = parcelRequire("ousew");

var $4YzBg = parcelRequire("4YzBg");

var $dGPQO = parcelRequire("dGPQO");
const $4336854db3f61d28$export$e928a71d039d3102 = ()=>// eslint disabled because it is valid for options, see recommended https://github.com/jsx-eslint/eslint-plugin-jsx-a11y/blob/main/docs/rules/no-noninteractive-element-to-interactive-role.md
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "li",
        xcss: $4336854db3f61d28$var$listItemStyle,
        role: "option",
        "aria-selected": false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4YzBg.StyledBox), {
        "data-testid": "jql-builder-basic-picker.ui.async-select.menu-list.loading-message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4YzBg.StyledBox), {
        height: 72
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "large"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4YzBg.StyledText), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $dGPQO.default).loadingMessage))));
var $4336854db3f61d28$export$2e2bcd8739ae039 = $4336854db3f61d28$export$e928a71d039d3102;
const $4336854db3f61d28$var$listItemStyle = (0, $8CUq3.xcss)({
    listStyle: 'none'
});

});
parcelRegister("dGPQO", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9107b1f56911e79$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e9107b1f56911e79$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    loadingMessage: {
        "id": "jql-builder-basic-picker.async-select.menu-list.loading-message.loading-message",
        "defaultMessage": "Loading..."
    }
});

});


parcelRegister("dRSRG", function(module, exports) {

$parcel$export(module.exports, "default", () => $861e6b6afb035048$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");

var $koVbs = parcelRequire("koVbs");

var $cSD7y = parcelRequire("cSD7y");

var $lQYCz = parcelRequire("lQYCz");

var $gqosm = parcelRequire("gqosm");

var $6LU7P = parcelRequire("6LU7P");
const $861e6b6afb035048$var$ShowMoreButton = ({ onShowMore: onShowMore })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gqosm.LeftFooterButton), {
        message: formatMessage((0, $6LU7P.default).showMoreButtonText),
        onClick: onShowMore,
        appearance: "link",
        testId: "jql-builder-basic-picker.ui.async-select.menu-list.show-more-button",
        hasTooltip: false,
        label: formatMessage((0, $6LU7P.default).showMoreButtonLabel)
    });
};
const $861e6b6afb035048$var$LoadMoreTrigger = ({ onShowMore: onShowMore, isPaginationLoading: isPaginationLoading })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const loadMoreRef = (0, $lQYCz.useIntersectionObserver)({
        margin: 10,
        onIntersection: ()=>!isPaginationLoading && onShowMore()
    });
    return(// eslint disabled because it is valid for options, see recommended https://github.com/jsx-eslint/eslint-plugin-jsx-a11y/blob/main/docs/rules/no-noninteractive-element-to-interactive-role.md
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "li",
        xcss: $861e6b6afb035048$var$listItemStyle,
        role: "option",
        "aria-hidden": "true",
        "aria-selected": false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $861e6b6afb035048$var$loadingContainerStyles,
        justifyContent: "center",
        alignItems: "center",
        ref: loadMoreRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        label: formatMessage((0, $6LU7P.default).loadingLabel)
    }))));
};
const $861e6b6afb035048$var$loadingContainerStyles = (0, $8CUq3.xcss)({
    height: '56px'
});
const $861e6b6afb035048$var$listItemStyle = (0, $8CUq3.xcss)({
    listStyle: 'none'
});
var $861e6b6afb035048$export$2e2bcd8739ae039 = (0, $cSD7y.componentWithFG)('jql_basic_picker_infinite_scroll', $861e6b6afb035048$var$LoadMoreTrigger, $861e6b6afb035048$var$ShowMoreButton);

});
parcelRegister("lQYCz", function(module, exports) {

$parcel$export(module.exports, "useIntersectionObserver", () => $a631eb23b7c62b0c$export$a7395f9832c00176);

var $5uXOq = parcelRequire("5uXOq");
const $a631eb23b7c62b0c$export$a7395f9832c00176 = ({ margin: margin, threshold: threshold = 0, onIntersection: onIntersection })=>{
    const [observedElement, setObservedElement] = (0, $5uXOq.useState)(null);
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (observedElement === null || window.IntersectionObserver === undefined) return undefined;
        const observerCallback = (entries)=>entries.forEach(({ isIntersecting: isIntersecting, time: time })=>{
                if (isIntersecting) onIntersection(time);
            });
        const observer = new IntersectionObserver(observerCallback, {
            rootMargin: `${margin}px`,
            threshold: threshold
        });
        observer.observe(observedElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        observedElement,
        onIntersection,
        margin,
        threshold
    ]);
    return setObservedElement;
};

});

parcelRegister("6LU7P", function(module, exports) {

$parcel$export(module.exports, "default", () => $f107e66425bd88a0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f107e66425bd88a0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    showMoreButtonText: {
        "id": "jql-builder-basic-picker.async-select.menu-list.show-more-button.show-more-button-text",
        "defaultMessage": "Show more"
    },
    showMoreButtonLabel: {
        "id": "jql-builder-basic-picker.async-select.menu-list.show-more-button.show-more-button-label",
        "defaultMessage": "Show more filter options"
    },
    loadingLabel: {
        "id": "jql-builder-basic-picker.async-select.menu-list.show-more-button.loading-label",
        "defaultMessage": "Loading"
    }
});

});



parcelRegister("fHaff", function(module, exports) {

$parcel$export(module.exports, "OperatorsSelect", () => $5556a62cac1397ae$export$72ded8b112fe0b1);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $7K5PP = parcelRequire("7K5PP");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $9LrfT = parcelRequire("9LrfT");
const $5556a62cac1397ae$var$selectStyles = {
    control: (baseStyles)=>({
            ...baseStyles,
            backgroundColor: "var(--ds-background-neutral, #091E420F)"
        })
};
const $5556a62cac1397ae$var$getOptionLabel = (option)=>option.ariaLabel;
const $5556a62cac1397ae$var$formatOptionLabel = (option)=>option.label;
const $5556a62cac1397ae$export$72ded8b112fe0b1 = ({ onChange: onChange, allowedOperators: allowedOperators, selectedOperator: selectedOperator })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onChangeWithAnalytics = (0, $5uXOq.useCallback)((option)=>{
        onChange && onChange(option);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        });
        option && (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'operatorSelect', {
            option: option.value,
            selectType: 'dropdown'
        });
    }, [
        createAnalyticsEvent,
        onChange
    ]);
    const onMenuOpenAnalytics = (0, $5uXOq.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'opened',
            actionSubject: 'dropdown'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'operatorSelect', {
            selectType: 'dropdown'
        });
    }, [
        createAnalyticsEvent
    ]);
    const onKeyDown = (0, $5uXOq.useCallback)((event)=>{
        event.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $5556a62cac1397ae$var$operatorsSelectStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        "aria-label": formatMessage((0, $9LrfT.default).operatorLabel),
        value: selectedOperator || allowedOperators[0],
        options: allowedOperators,
        onChange: onChangeWithAnalytics,
        spacing: "compact",
        appearance: "subtle",
        styles: $5556a62cac1397ae$var$selectStyles,
        onKeyDown: onKeyDown,
        onMenuOpen: onMenuOpenAnalytics,
        isSearchable: false,
        getOptionLabel: $5556a62cac1397ae$var$getOptionLabel,
        formatOptionLabel: $5556a62cac1397ae$var$formatOptionLabel
    }));
};
const $5556a62cac1397ae$var$operatorsSelectStyles = (0, $8CUq3.xcss)({
    padding: 'space.150',
    paddingTop: 'space.100',
    paddingBottom: 'space.050'
});

});
parcelRegister("9LrfT", function(module, exports) {

$parcel$export(module.exports, "default", () => $a58d8b257ee2210b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $a58d8b257ee2210b$var$messages = (0, $7VHMR.defineMessages)({
    operatorLabel: {
        "id": "jql-builder-basic-picker.async-select.operator-select.operator-label",
        "defaultMessage": "Operator dropdown"
    }
});
var $a58d8b257ee2210b$export$2e2bcd8739ae039 = $a58d8b257ee2210b$var$messages;

});


parcelRegister("bLfwu", function(module, exports) {

$parcel$export(module.exports, "default", () => $6306d1a8c678ae99$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $cCzmn = parcelRequire("cCzmn");
const $6306d1a8c678ae99$export$33eb0288c0936a84 = ({ itemsCount: itemsCount, totalCount: totalCount })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6306d1a8c678ae99$var$PaginationDetailsStyled, {
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        "data-testid": "jql-builder-basic.ui.jql-editor.picker.async-select.pagination-details"
    }, formatMessage((0, $cCzmn.default).ofTotalCount, {
        itemsCount: itemsCount,
        totalCount: totalCount
    }));
};
var $6306d1a8c678ae99$export$2e2bcd8739ae039 = $6306d1a8c678ae99$export$33eb0288c0936a84;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6306d1a8c678ae99$var$PaginationDetailsStyled = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _y3gnusic _syaz131l _16jlkb7n _1o9zidpf _i0dl1wug _19pkze3t _2hwxutpp _otyrze3t _18u0utpp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cCzmn", function(module, exports) {

$parcel$export(module.exports, "default", () => $710621214b1a52e2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $710621214b1a52e2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    ofTotalCount: {
        "id": "jql-builder-basic-picker.async-select.pagination-details.of-total-count",
        "defaultMessage": "{itemsCount} of {totalCount}"
    }
});

});


parcelRegister("6xfyp", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ece6183fadc2cc5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $gqosm = parcelRequire("gqosm");

var $foG3c = parcelRequire("foG3c");
const $0ece6183fadc2cc5$export$2543cc45221bf5bc = ({ onRestoreDefaults: onRestoreDefaults })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleRestoreDefaults = (0, $5uXOq.useCallback)((mouseEvent, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'filterSearchRestoreDefaults', {
            // If number of clicks is 0, button was actioned using the keyboard
            keyboard: mouseEvent.detail === 0
        });
        onRestoreDefaults && onRestoreDefaults();
    }, [
        onRestoreDefaults
    ]);
    const message = formatMessage((0, $foG3c.default).restoreDefaultsButtonText);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gqosm.LeftFooterButton), {
        message: message,
        onClick: handleRestoreDefaults,
        appearance: "subtle-link",
        testId: "jql-builder-basic-picker.ui.async-select.restore-defaults-button",
        hasTooltip: true
    });
};
var $0ece6183fadc2cc5$export$2e2bcd8739ae039 = $0ece6183fadc2cc5$export$2543cc45221bf5bc;

});
parcelRegister("foG3c", function(module, exports) {

$parcel$export(module.exports, "default", () => $13d64b65f0cf6e53$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $13d64b65f0cf6e53$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    restoreDefaultsButtonText: {
        "id": "jql-builder-basic-picker.async-select.restore-defaults-button.restore-defaults-button-text",
        "defaultMessage": "Restore defaults"
    }
});

});


parcelRegister("k3vJi", function(module, exports) {

$parcel$export(module.exports, "selectComponents", () => $7e3855138faecd30$export$c34d65c0f5a1c617);
$parcel$export(module.exports, "singleSelectComponents", () => $7e3855138faecd30$export$6161e15c6859b0c9);
$parcel$export(module.exports, "BaseSelect", () => $7e3855138faecd30$export$dcee1aa94a106d27);

var $5uXOq = parcelRequire("5uXOq");

var $7K5PP = parcelRequire("7K5PP");

var $hh0bW = parcelRequire("hh0bW");

var $fZneA = parcelRequire("fZneA");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $86Rl2 = parcelRequire("86Rl2");

var $jG2IE = parcelRequire("jG2IE");


var $e0Yfp = parcelRequire("e0Yfp");

var $c7h7q = parcelRequire("c7h7q");

var $7A2dP = parcelRequire("7A2dP");

var $775vS = parcelRequire("775vS");

var $kuqz4 = parcelRequire("kuqz4");

var $9x2Xf = parcelRequire("9x2Xf");

var $lpDvx = parcelRequire("lpDvx");
const $7e3855138faecd30$export$c34d65c0f5a1c617 = {
    Control: $e0Yfp.default,
    DropdownIndicator: $c7h7q.default,
    LoadingIndicator: ()=>null,
    Menu: $7A2dP.default,
    Option: $9x2Xf.default
};
const $7e3855138faecd30$export$6161e15c6859b0c9 = {
    Control: $e0Yfp.default,
    DropdownIndicator: $c7h7q.default,
    LoadingIndicator: undefined,
    Menu: $7A2dP.default
};
const $7e3855138faecd30$var$onIsOptionDisabled = (option, value)=>{
    if (option.optionType === 'error') return true;
    // if an option is only unselectable and currently selected, it should not be a disabled option
    if ('isOnlyUnselectable' in option && option.isOnlyUnselectable) {
        const isSelectedOption = (0, $jG2IE.isSingleValueOption)(option) && value.map((v)=>(0, $jG2IE.isSingleValueOption)(v) && v.value).includes(option.value);
        return !(isSelectedOption && option.isOnlyUnselectable);
    }
    if ('isDisabled' in option && option.isDisabled) return option.isDisabled;
    return false;
};
// Needed to disable filtering from react-select
const $7e3855138faecd30$var$noFilterOptions = ()=>true;
const $7e3855138faecd30$export$dcee1aa94a106d27 = ({ onReload: onReload, placeholder: placeholder, NoOptionsMessage: NoOptionsMessage = (0, $kuqz4.default), isMulti: isMulti = true, setInitialFocusRef: setInitialFocusRef, totalCount: totalCount, components: componentsSelect, options: options, isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled, ...restProps })=>{
    const { onInputChange: onInputChangeProp, inputValue: inputValueProp, id: id, menuListProps: { isLoading: isLoading, error: { isError: isError, error: error } }, experienceAnalyticsAttributes: experienceAnalyticsAttributes, value: value } = restProps;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const selectRef = /*#__PURE__*/ (0, $5uXOq.createRef)(); // use any type for react-select ref
    const [inputValue, setInputValue] = (0, $5uXOq.useState)(inputValueProp ?? '');
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    (0, $5uXOq.useEffect)(()=>{
        // only set once when the component mounted
        if (selectRef.current && setInitialFocusRef) setInitialFocusRef(selectRef.current.select.inputRef);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (options && !(isLoading ?? false)) {
            let errorType = 'unknown';
            if (error != null && (0, $fZneA.isClientFetchError)(error)) errorType = 'networkError';
            const errorAttributes = error ? {
                errorType: errorType,
                message: error.message
            } : null;
            (0, $hh0bW.default)({
                analyticsSource: 'refinement-bar-select',
                wasExperienceSuccesful: error == null,
                experience: 'showOptions',
                application: null,
                edition: null,
                additionalAttributes: {
                    filter: id ?? 'unknown',
                    ...experienceAnalyticsAttributes,
                    ...errorAttributes
                }
            });
        }
    }, [
        isError,
        error,
        isLoading,
        options,
        id,
        experienceAnalyticsAttributes
    ]);
    const hasEnabledOption = (0, $5uXOq.useMemo)(()=>options?.some((option)=>!$7e3855138faecd30$var$onIsOptionDisabled(option, value)), [
        options,
        value
    ]);
    const onInputChange = (0, $5uXOq.useCallback)((newInputValue, meta)=>{
        /**
     * Do not clear the filter input value when an input is selected or blured.
     * NOTE: We are also returning when 'menu-close' event are triggered,
     * which happens when the input is clicked for some reason, but not when we click outside of the dropdown
     * */ if (Array.from([
            (0, $86Rl2.MetaActions).setValue,
            (0, $86Rl2.MetaActions).inputBlur,
            (0, $86Rl2.MetaActions).menuClose
        ]).includes(meta.action) && !newInputValue.length) return;
        // Reload defaultOptions in case of potential error by changing key on AsyncSelect
        if (meta.action === (0, $86Rl2.MetaActions).inputChange && !newInputValue.length) onReload?.('');
        onInputChangeProp && onInputChangeProp(newInputValue, meta);
        setInputValue(newInputValue);
    }, [
        onInputChangeProp,
        onReload
    ]);
    (0, $5uXOq.useEffect)(()=>{
        setInputValue(inputValueProp);
    }, [
        inputValueProp
    ]);
    const getOptionLabel = (0, $5uXOq.useCallback)((option)=>{
        if ((0, $jG2IE.isSingleValueOption)(option)) {
            if (typeof option.secondaryLabel === 'string') return `${option.label}, ${option.secondaryLabel}`;
            if (// remove !isValidElement(data.secondaryLabel) with cleanup with m7.3-mm2-custom-fields-with-existing-uis_vzhn7
            typeof option.secondaryLabel === 'object' && !/*#__PURE__*/ (0, $5uXOq.isValidElement)(option.secondaryLabel)) return `${option.label}, ${option.secondaryLabel.label}`;
            return option.label;
        }
        return option.optionType === 'group' ? option?.label ?? '' : '';
    }, []);
    // placeholder type is reactNode and aria-label won't allow, for safe side checking the type and empty value
    const ariaLabel = typeof placeholder === 'string' && placeholder ? placeholder : formatMessage((0, $775vS.default).searchPlaceholder);
    const OriginalOptionComponent = componentsSelect?.Option || undefined;
    // Note: this is a workaround to not visually focus any option, when there are only disabled options in the list
    // react-select autofocuses the first option, see more here: https://github.com/JedWatson/react-select/pull/4080
    // tracked bug ticket: https://product-fabric.atlassian.net/browse/DSP-17138
    const OptionComponentExtended = (0, $5uXOq.useCallback)((props)=>OriginalOptionComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(OriginalOptionComponent, {
            ...props,
            isFocused: hasEnabledOption ? props.isFocused : false
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null), [
        OriginalOptionComponent,
        hasEnabledOption
    ]);
    const unselectedOptions = (0, $5uXOq.useMemo)(()=>{
        if (!isInBetweenColumnPickerEnabled) return [];
        if (!inputValue) return (0, $4R6GH.fg)('jira_inline_field_config_gate') ? options?.filter((option)=>option.optionType === 'group' && option.id !== (0, $bea3c4ed636e3ee7$export$bfd1c05c2e5a5a01)) || [] : options?.filter((option)=>option.optionType === 'group') || [];
        const selectedOptions = new Set(value.map((v)=>(0, $jG2IE.isSingleValueOption)(v) ? v.value : ''));
        return options?.filter((option)=>(0, $jG2IE.isSingleValueOption)(option) && !selectedOptions.has(option.value)) || [];
    }, [
        isInBetweenColumnPickerEnabled,
        inputValue,
        options,
        value
    ]);
    const memoizedComponents = (0, $5uXOq.useMemo)(()=>{
        return {
            ...componentsSelect,
            ...(0, $4R6GH.fg)('jira_inline_field_config_gate') ? {
                GroupHeading: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lpDvx.GroupHeading), {
                        ...props,
                        totalCount: totalCount
                    })
            } : {},
            ...OriginalOptionComponent !== undefined ? {
                Option: OptionComponentExtended
            } : {}
        };
    }, [
        OriginalOptionComponent,
        componentsSelect,
        OptionComponentExtended,
        totalCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        ...restProps,
        options: isInBetweenColumnPickerEnabled && (0, $4R6GH.fg)('jira_inline_field_config_gate') ? unselectedOptions : options,
        // Using classNamePrefix to identify the select component in cypress test, testId doesn't work (doc https://atlassian.design/components/select/testing)
        classNamePrefix: "jql-builder-basic-picker-atlaskit-select",
        components: memoizedComponents,
        cacheOptions: false,
        ref: selectRef,
        autoFocus: !setInitialFocusRef,
        backspaceRemovesValue: false,
        blurInputOnSelect: false,
        closeMenuOnSelect: false,
        controlShouldRenderValue: false,
        hideSelectedOptions: false,
        isClearable: false,
        isMulti: isMulti,
        inputValue: inputValue,
        menuIsOpen: true,
        menuShouldScrollIntoView: false,
        tabSelectsValue: false,
        onInputChange: onInputChange,
        isOptionDisabled: $7e3855138faecd30$var$onIsOptionDisabled,
        reload: onReload,
        filterOption: $7e3855138faecd30$var$noFilterOptions,
        placeholder: placeholder ?? formatMessage((0, $775vS.default).searchPlaceholder),
        label: ariaLabel,
        noOptionsMessage: NoOptionsMessage,
        getOptionLabel: getOptionLabel
    });
};

});
const $bea3c4ed636e3ee7$export$eb85a4c9b5d9ce7b = 'all-columns';
const $bea3c4ed636e3ee7$export$bfd1c05c2e5a5a01 = 'selected-columns';

parcelRegister("e0Yfp", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a794a1e6cef7f30$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $26g7Y = parcelRequire("26g7Y");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $4YzBg = parcelRequire("4YzBg");
const $9a794a1e6cef7f30$export$7a7fa4424cb20976 = ({ children: children, innerProps: innerProps, innerRef: innerRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4YzBg.StyledControl), {
        ref: innerRef ?? undefined,
        ...innerProps
    }, (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_6') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $9a794a1e6cef7f30$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($26g7Y))), {
        LEGACY_size: "small",
        label: ""
    })), children);
const $9a794a1e6cef7f30$var$wrapperStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 'space.100'
});
var $9a794a1e6cef7f30$export$2e2bcd8739ae039 = $9a794a1e6cef7f30$export$7a7fa4424cb20976;

});

parcelRegister("c7h7q", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebdf3135bf0add58$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kxFlx = parcelRequire("kxFlx");

var $26g7Y = parcelRequire("26g7Y");

var $bChGW = parcelRequire("bChGW");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $4YzBg = parcelRequire("4YzBg");
const $ebdf3135bf0add58$export$ec98719d3db7f2e4 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).DropdownIndicator, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4YzBg.DropdownIndicatorWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4YzBg.DisplayWrapper), {
        displayFlag: props.selectProps.inputValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4YzBg.CloseIconWrapper), {
        "data-testid": "jql-builder-basic-picker.ui.async-select.select.dropdown-indicator.dropdown-close-icon",
        onClick: (event)=>{
            event.preventDefault();
            props.selectProps.onInputChange && props.selectProps.onInputChange('', {
                action: 'input-change',
                prevInputValue: props.selectProps.inputValue
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kxFlx))), {
        LEGACY_size: "small",
        label: ""
    }))), !((0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_6')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4YzBg.DisplayWrapper), {
        displayFlag: !props.selectProps.inputValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($26g7Y))), {
        LEGACY_size: "small",
        label: ""
    }))));
var $ebdf3135bf0add58$export$2e2bcd8739ae039 = $ebdf3135bf0add58$export$ec98719d3db7f2e4;

});

parcelRegister("7A2dP", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd81aac73589c009$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $bd81aac73589c009$var$Menu = ({ innerRef: innerRef, innerProps: innerProps, children: children })=>// eslint-disable-next-line jira/integration/test-id-by-folder-structure
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bd81aac73589c009$var$MenuBox, {
        "data-testid": "refinement-bar.common.ui.select.menu",
        ref: innerRef,
        ...innerProps
    }, children);
var $bd81aac73589c009$export$2e2bcd8739ae039 = $bd81aac73589c009$var$Menu;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $bd81aac73589c009$var$MenuBox = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});

parcelRegister("775vS", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4a45b694e3e2c88$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $c4a45b694e3e2c88$var$messages = (0, $7VHMR.defineMessages)({
    searchPlaceholder: {
        "id": "jql-builder-basic-picker.async-select.select.search-placeholder",
        "defaultMessage": "Search"
    }
});
var $c4a45b694e3e2c88$export$2e2bcd8739ae039 = $c4a45b694e3e2c88$var$messages;

});

parcelRegister("kuqz4", function(module, exports) {

$parcel$export(module.exports, "default", () => $f009d6067c0c2823$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hMVoD = parcelRequire("hMVoD");

var $eJS47 = parcelRequire("eJS47");

var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");

var $ousew = parcelRequire("ousew");

var $5oFIy = parcelRequire("5oFIy");

var $dCm1o = parcelRequire("dCm1o");

var $4YzBg = parcelRequire("4YzBg");

var $lKfsz = parcelRequire("lKfsz");
const $f009d6067c0c2823$var$NoOptionsMessageContainer = ({ children: children })=>{
    if ((0, $dCm1o.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.150",
        alignInline: "center"
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: "color.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $lKfsz.default).noOptionsPrimaryMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "small",
        color: "color.text.subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $lKfsz.default).noOptionsSecondaryMessage)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4YzBg.StyledBox), {
        height: 72
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4YzBg.StyledText), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $lKfsz.default).noOptionsMessage)));
};
const $f009d6067c0c2823$export$d58b72b7d3c4072c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4YzBg.StyledBox), {
        "data-testid": "jql-builder-basic.ui.jql-editor.picker.async-select.select.no-options-message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f009d6067c0c2823$var$NoOptionsMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMVoD))), {
        label: "",
        color: "var(--ds-icon, #44546F)",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($eJS47))),
        LEGACY_size: "xlarge"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
        actionSubject: "emptyState",
        action: "viewed",
        actionSubjectId: "noMatches"
    }));
var $f009d6067c0c2823$export$2e2bcd8739ae039 = $f009d6067c0c2823$export$d58b72b7d3c4072c;

});
parcelRegister("lKfsz", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5931b60fb6cec89$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f5931b60fb6cec89$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noOptionsMessage: {
        "id": "jql-builder-basic-picker.async-select.select.no-options-message.no-options-message",
        "defaultMessage": "No matches found"
    },
    noOptionsPrimaryMessage: {
        "id": "jql-builder-basic-picker.async-select.select.no-options-message.no-options-primary-message",
        "defaultMessage": "We couldn't find what you're looking for"
    },
    noOptionsSecondaryMessage: {
        "id": "jql-builder-basic-picker.async-select.select.no-options-message.no-options-secondary-message",
        "defaultMessage": "Try using different search terms."
    }
});

});


parcelRegister("9x2Xf", function(module, exports) {

$parcel$export(module.exports, "default", () => $d56ee43362009743$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hMVoD = parcelRequire("hMVoD");

var $6tRzQ = parcelRequire("6tRzQ");

var $7vYo9 = parcelRequire("7vYo9");

var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $itpgN = parcelRequire("itpgN");
var $bChGW = parcelRequire("bChGW");

var $3bDjY = parcelRequire("3bDjY");

var $4YzBg = parcelRequire("4YzBg");

var $jIVfw = parcelRequire("jIVfw");
const $d56ee43362009743$export$36d18380658d5d20 = ({ isMulti: isMulti = true, ...props })=>{
    const { isOnlyUnselectable: isOnlyUnselectable, disabledMessage: disabledMessage, invalid: invalid } = props.data?.optionType === 'option' || props.data?.optionType === 'avatar' || props.data?.optionType === 'lozenge' || props.data?.optionType === 'field' ? props.data : {
        isOnlyUnselectable: undefined,
        disabledMessage: undefined,
        invalid: undefined
    };
    // Only disable checkbox for an only unselectable option when it is not a selected option
    const optionState = (0, $jIVfw.getOptionState)(props.isDisabled, Boolean(isOnlyUnselectable), props.isSelected, Boolean(invalid));
    const hasIconAfter = ()=>{
        switch(optionState){
            case 'only-unselectable-unselected':
            case 'only-unselectable-selected':
            case 'disabled':
                return Boolean(disabledMessage);
            case 'invalid':
                return true;
            default:
                return undefined;
        }
    };
    const OptionInner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        spread: "space-between",
        alignBlock: "center",
        xcss: $d56ee43362009743$export$d318e19053d98641[optionState].xcss
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4YzBg.CustomOptionStyles), {
        hasIconAfter: hasIconAfter(),
        isFocused: props.isFocused,
        isDisabled: props.isDisabled,
        isSingleSelect: true
    }, isMulti ? /* @ts-expect-error - This component has stricter OptionType args which isn't compatible with ErrorOption in SelectOption. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $itpgN.CheckboxOption), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, {
        ...props,
        isMulti: false
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d56ee43362009743$var$TooltipContainer, null, (optionState === 'only-unselectable-unselected' || optionState === 'only-unselectable-selected' || optionState === 'disabled') && Boolean(disabledMessage) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: disabledMessage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6tRzQ))), {
        testId: "jql-builder-basic-picker.ui.async-select.select.option.info-icon",
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #44546F)",
        LEGACY_primaryColor: "var(--ds-icon, #44546F)"
    })), optionState === 'invalid' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: props.selectProps.invalidLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMVoD))), {
        testId: "jql-builder-basic-picker.ui.async-select.select.option.invalid-icon",
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon-danger, #C9372C)",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($7vYo9)))
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": $d56ee43362009743$export$d318e19053d98641[optionState].testid
    }, optionState === 'only-unselectable-unselected' || optionState === 'disabled' || optionState === 'invalid' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d56ee43362009743$var$UnsafeStyledCheckboxOption, null, OptionInner) : OptionInner);
};
var $d56ee43362009743$export$2e2bcd8739ae039 = $d56ee43362009743$export$36d18380658d5d20;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d56ee43362009743$var$UnsafeStyledCheckboxOption = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_nrk9jdj5",
            __cmplp.className
        ])
    });
});
const $d56ee43362009743$var$TooltipContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _18u0p1rm _u5f3utpp _4t3i1tcg",
            __cmplp.className
        ])
    });
});
const $d56ee43362009743$var$DisabledCheckboxOptionStyles = (0, $8CUq3.xcss)({
    color: 'color.text.disabled'
});
const $d56ee43362009743$var$InvalidCheckboxOptionStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.danger'
});
const $d56ee43362009743$export$d318e19053d98641 = {
    disabled: {
        testid: 'jql-builder-basic.ui.jql-editor.picker.async-select.select.option.disabled-option',
        xcss: [
            $d56ee43362009743$var$DisabledCheckboxOptionStyles
        ]
    },
    invalid: {
        testid: 'jql-builder-basic.ui.jql-editor.picker.async-select.select.option.invalid-option',
        xcss: [
            $d56ee43362009743$var$InvalidCheckboxOptionStyles
        ]
    },
    selected: {
        testid: 'jql-builder-basic.ui.jql-editor.picker.async-select.select.selected-option',
        xcss: []
    },
    unselected: {
        testid: 'jql-builder-basic.ui.jql-editor.picker.async-select.select.option',
        xcss: []
    },
    'only-unselectable-unselected': {
        testid: 'jql-builder-basic.ui.jql-editor.picker.async-select.select.option.only-unselectable',
        xcss: [
            $d56ee43362009743$var$DisabledCheckboxOptionStyles
        ]
    },
    'only-unselectable-selected': {
        testid: 'jql-builder-basic.ui.jql-editor.picker.async-select.select.selected-option.only-unselectable',
        xcss: []
    }
};

});
parcelRegister("7vYo9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $578a4594e75c360e$var$_react = $578a4594e75c360e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $578a4594e75c360e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $578a4594e75c360e$var$JiraFailedBuildStatusIcon = (props)=>/*#__PURE__*/ $578a4594e75c360e$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$578a4594e75c360e$var$JiraFailedBuildStatusIcon.displayName = 'JiraFailedBuildStatusIcon';
var $578a4594e75c360e$var$_default = module.exports.default = $578a4594e75c360e$var$JiraFailedBuildStatusIcon;

});

parcelRegister("jIVfw", function(module, exports) {

$parcel$export(module.exports, "getOptionState", () => $f5a02469bfd37c75$export$e651787bf17e8335);
const $f5a02469bfd37c75$export$e651787bf17e8335 = (isDisabled, isOnlyUnselectable, isSelected, isInvalid)=>{
    if (isDisabled) return 'disabled';
    if (isOnlyUnselectable && !isSelected) return 'only-unselectable-unselected';
    if (isInvalid) return 'invalid';
    if (isOnlyUnselectable && isSelected) return 'only-unselectable-selected';
    if (isSelected) return 'selected';
    return 'unselected';
};

});


parcelRegister("lpDvx", function(module, exports) {

$parcel$export(module.exports, "GroupHeading", () => $79b7ab2d52a02133$export$85c8b41a3cd87edc);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $bChGW = parcelRequire("bChGW");

const $79b7ab2d52a02133$var$HeadingContent = ({ label: label, totalCount: totalCount })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $79b7ab2d52a02133$var$groupHeadingStyles,
        paddingBlockEnd: "space.075",
        paddingInline: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "small",
        weight: "bold",
        color: "color.text.subtle"
    }, label?.toLocaleUpperCase()), totalCount && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "small",
        color: "color.text.subtle"
    }, totalCount));
};
const $79b7ab2d52a02133$export$85c8b41a3cd87edc = ({ data: data, totalCount: totalCount, ...restProps })=>{
    const { id: id, label: label } = data;
    switch(id){
        case 0, $bea3c4ed636e3ee7$export$bfd1c05c2e5a5a01:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($79b7ab2d52a02133$var$HeadingContent, {
                label: label
            });
        case 0, $bea3c4ed636e3ee7$export$eb85a4c9b5d9ce7b:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($79b7ab2d52a02133$var$HeadingContent, {
                label: label,
                totalCount: totalCount
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).GroupHeading, {
                ...restProps,
                data: data
            });
    }
};
const $79b7ab2d52a02133$var$groupHeadingStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
});

});


parcelRegister("gJcRP", function(module, exports) {

$parcel$export(module.exports, "default", () => $788338c25ed9c19d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $gqosm = parcelRequire("gqosm");

var $lsIRo = parcelRequire("lsIRo");
const $788338c25ed9c19d$export$bf0956d66cd7566b = ({ onShowFullList: onShowFullList })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleShowFullList = (0, $5uXOq.useCallback)((e)=>{
        const analyticsEvent = createAnalyticsEvent({
            eventType: 'UI',
            action: 'expanded',
            actionSubject: 'filterSearch',
            actionSubjectId: 'refinementBarFilterSearch'
        });
        const attributes = {
            // If number of clicks is 0, button was actioned using the keyboard
            keyboard: e.detail === 0
        };
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'refinementBarFilterSearch', attributes);
        onShowFullList();
    }, [
        createAnalyticsEvent,
        onShowFullList
    ]);
    const message = formatMessage((0, $lsIRo.default).showFullListButtonText);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gqosm.LeftFooterButton), {
        message: message,
        onClick: handleShowFullList,
        appearance: "subtle-link",
        testId: "jql-builder-basic-picker.ui.async-select.show-full-list-button.show-full-list-button",
        hasTooltip: true
    });
};
var $788338c25ed9c19d$export$2e2bcd8739ae039 = $788338c25ed9c19d$export$bf0956d66cd7566b;

});
parcelRegister("lsIRo", function(module, exports) {

$parcel$export(module.exports, "default", () => $7352625b85a42c60$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7352625b85a42c60$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    showFullListButtonText: {
        "id": "jql-builder-basic-picker.async-select.show-full-list-button.show-full-list-button-text",
        "defaultMessage": "Show full list"
    }
});

});


parcelRegister("aNitm", function(module, exports) {

$parcel$export(module.exports, "generateOptions", () => $9c962c617526f695$export$c21133b4499f5374);
$parcel$export(module.exports, "getValueFromOptions", () => $9c962c617526f695$export$cc4ee748665ecf20);

var $4R6GH = parcelRequire("4R6GH");

var $jG2IE = parcelRequire("jG2IE");


var $kN8Y2 = parcelRequire("kN8Y2");
const $9c962c617526f695$export$17aec06b00a4043e = (keys, options, option)=>{
    if ((0, $jG2IE.isSingleValueOption)(option) && !keys.has(option.value)) {
        keys.add(option.value);
        options.push(option);
    }
    // If the option is a group, we either append to an existing group or add a new group
    if (option.optionType === 'group') {
        const foundDuplicateGroup = (0, $4R6GH.fg)('jira_inline_field_config_gate') ? options.some((o)=>'id' in o && o.id === option.id || 'label' in o && o.label === option.label) : options.some((o)=>'label' in o && o.label === option.label);
        if (foundDuplicateGroup) option.options.forEach((groupVal)=>{
            const existingGroup = options.find((o)=>'label' in o && o.label === option.label);
            if (existingGroup && existingGroup.optionType === 'group') {
                const newOptions = [
                    ...existingGroup?.options,
                    groupVal
                ];
                existingGroup.options = newOptions;
            }
        });
        else {
            if ((0, $4R6GH.fg)('jira_inline_field_config_gate')) option.options.forEach((groupVal)=>{
                if ((0, $jG2IE.isSingleValueOption)(groupVal)) keys.add(groupVal.value);
            });
            options.push(option);
        }
    }
};
const $9c962c617526f695$export$c21133b4499f5374 = (selected, data, formatMessage, previousData, addSelectedFirst = true)=>{
    // Handle currently selected
    const optionKeys = new Set();
    const options = [];
    if (addSelectedFirst) {
        if ((0, $4R6GH.fg)('jira_inline_field_config_gate')) $9c962c617526f695$export$17aec06b00a4043e(optionKeys, options, {
            id: (0, $bea3c4ed636e3ee7$export$bfd1c05c2e5a5a01),
            optionType: 'group',
            options: selected,
            label: formatMessage((0, $kN8Y2.default).selectedLabel)
        });
        else // add currently selected options
        selected && selected.forEach((val)=>{
            $9c962c617526f695$export$17aec06b00a4043e(optionKeys, options, val);
        });
    }
    if (previousData) // add previous loaded options
    previousData.forEach((val)=>{
        $9c962c617526f695$export$17aec06b00a4043e(optionKeys, options, val);
    });
    data && data.forEach((val)=>{
        // Add group options
        if (val && val.optionType === 'group') {
            const groupOptions = [];
            val.options.forEach((groupVal)=>{
                // removing values from the group that are already in the options list (e.g. selected values, values from previousData)
                $9c962c617526f695$export$17aec06b00a4043e(optionKeys, groupOptions, groupVal);
            });
            if (groupOptions.length > 0) $9c962c617526f695$export$17aec06b00a4043e(optionKeys, options, {
                ...val,
                options: groupOptions,
                optionType: 'group'
            });
            return;
        }
        // add individual options
        $9c962c617526f695$export$17aec06b00a4043e(optionKeys, options, val);
    });
    return options;
};
const $9c962c617526f695$export$cc4ee748665ecf20 = (loadedOptionsWithFullList, value)=>{
    if (loadedOptionsWithFullList.length === 0) return value;
    const loadedOptionsWithFullListFlat = loadedOptionsWithFullList.flatMap((option)=>option.optionType === 'group' ? option.options : option);
    return value.map((selectedValue)=>loadedOptionsWithFullListFlat.find((option)=>(0, $jG2IE.isSingleValueOption)(option) && (0, $jG2IE.isSingleValueOption)(selectedValue) && selectedValue.value === option.value) || selectedValue);
};

});
parcelRegister("kN8Y2", function(module, exports) {

$parcel$export(module.exports, "default", () => $efb675a005ef325c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $efb675a005ef325c$var$messages = (0, $7VHMR.defineMessages)({
    selectedLabel: {
        "id": "jql-builder-basic-picker.async-select.selected-label",
        "defaultMessage": "Selected"
    }
});
var $efb675a005ef325c$export$2e2bcd8739ae039 = $efb675a005ef325c$var$messages;

});






parcelRegister("hDEjR", function(module, exports) {

let $cd755abf2e0a4df7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cd755abf2e0a4df7$var$load("dc4ab").then(()=>parcelRequire('29u5J'));

});


parcelRegister("1pbLo", function(module, exports) {

$parcel$export(module.exports, "default", () => $de0825eda1c9e481$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");


var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dCm1o = parcelRequire("dCm1o");

var $8OILN = parcelRequire("8OILN");

var $hJajZ = parcelRequire("hJajZ");

var $aFqsz = parcelRequire("aFqsz");

var $98azu = parcelRequire("98azu");

var $5Sv2f = parcelRequire("5Sv2f");

var $2WRsY = parcelRequire("2WRsY");

var $6RuoT = parcelRequire("6RuoT");

var $kxBJw = parcelRequire("kxBJw");

var $169o0 = parcelRequire("169o0");

var $2eN5z = parcelRequire("2eN5z");

var $05h2Y = parcelRequire("05h2Y");

var $6OkIx = parcelRequire("6OkIx");
const $de0825eda1c9e481$var$analyticsAttributes = {
    pickerType: 'field'
};
const $de0825eda1c9e481$var$FieldWrapperNew = ({ children: children, useListElement: useListElement, handleKeyDown: handleKeyDown })=>{
    const StyledListItemChildComponent = (0, $dCm1o.isVisualRefreshEnabled)() ? (0, $hJajZ.default) : (0, $aFqsz.StyledListItemChild);
    return useListElement ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(StyledListItemChildComponent, {
        "data-vc": "jql-builder-basic-field-list-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        role: "presentation",
        onKeyDown: handleKeyDown
    }, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aFqsz.StyledChild), {
        onKeyDown: handleKeyDown
    }, children);
};
const $de0825eda1c9e481$export$a455218a85c89869 = ({ fieldToRender: fieldToRender, onSearchWrapper: onSearchWrapper, onSwitchToJql: onSwitchToJql, fieldsToRender: fieldsToRender, loading: loading, hydratedData: hydratedData, selectedFields: selectedFields, onClearPicker: onClearPicker, projectOptions: projectOptions, singleSelectFields: singleSelectFields = [], shouldUseListMarkup: shouldUseListMarkup, hideOperatorDropdown: hideOperatorDropdown, contextJql: contextJql, viewContext: viewContext, scope: scope, suggestedUsersCount: suggestedUsersCount })=>{
    const { clause: clause, secondaryClause: secondaryClause, fieldId: fieldId, fieldLabel: fieldLabel, picker: picker, fieldDescription: fieldDescription, isIrremovable: isIrremovable } = fieldToRender;
    const sendOptionAnalytics = (0, $5Sv2f.useSendOptionAnalytics)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { pickerType: pickerType, propType: propType, fieldType: fieldType } = picker;
    const [activePopupKey, { openPopup: openPopup, closePopup: closePopup, closeAllPopups: closeAllPopups }] = (0, $98azu.useActivePopupKey)();
    const onOpen = (0, $5uXOq.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdown'
        });
        const attributes = {
            actionType: 'open'
        };
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'refinementBarBasicPicker', attributes);
        return openPopup(fieldId);
    }, [
        createAnalyticsEvent,
        fieldId,
        openPopup
    ]);
    const onClose = (0, $5uXOq.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdown'
        });
        const attributes = {
            actionType: 'close'
        };
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'refinementBarBasicPicker', attributes);
        return closePopup(fieldId);
    }, [
        closePopup,
        fieldId,
        createAnalyticsEvent
    ]);
    const onClearCallback = (0, $5uXOq.useCallback)((onClearJqlClause)=>{
        const newSelectedFields = selectedFields.filter((selectedField)=>selectedField.value.toLowerCase() !== fieldId.toLowerCase());
        if (onClearJqlClause !== undefined) {
            onClearPicker({
                selectedFields: newSelectedFields
            });
            onSearchWrapper && onSearchWrapper(onClearJqlClause);
        } else onClearPicker({
            selectedFields: newSelectedFields,
            fieldsToRender: fieldsToRender.filter((field)=>fieldId.toLowerCase() !== field.fieldId)
        });
    }, [
        fieldId,
        fieldsToRender,
        onClearPicker,
        onSearchWrapper,
        selectedFields
    ]);
    const handleOnKeyDown = (event)=>{
        if (event.key === 'Escape') {
            // avoid closing a modal on closing a picker with esc key
            const isOpen = activePopupKey === fieldId;
            isOpen && event.stopPropagation();
            onClose();
        }
    };
    const UnsupportedFieldPicker = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($de0825eda1c9e481$var$FieldWrapperNew, {
        useListElement: Boolean(shouldUseListMarkup),
        handleKeyDown: handleOnKeyDown
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OkIx.UnsupportedPickerWrapper), {
        activePopupKey: activePopupKey,
        clause: clause,
        fieldDescription: fieldDescription,
        fieldId: fieldId,
        fieldLabel: fieldLabel,
        onClose: onClose,
        onOpen: onOpen,
        onClear: onClearCallback,
        onSwitchToJql: onSwitchToJql
    }));
    switch(pickerType){
        case (0, $8OILN.PickerTypes).Picker:
            if (clause && clause.clauseType !== (0, $e9a0ef16a223cbc7$export$ae56b4ef248a2b6a)) throw new Error(`Picker type ${pickerType} cannot be used with a non terminal clause`);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
                sourceName: "valueSearch",
                sourceType: (0, $4d5e0871c06cee03$export$cae2783c9279926),
                attributes: $de0825eda1c9e481$var$analyticsAttributes
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($de0825eda1c9e481$var$FieldWrapperNew, {
                useListElement: Boolean(shouldUseListMarkup),
                handleKeyDown: handleOnKeyDown
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2eN5z.PickerWrapper), {
                onSearchWrapper: onSearchWrapper,
                fieldId: fieldId,
                fieldLabel: fieldLabel,
                picker: picker,
                terminalClause: clause || undefined,
                activePopupKey: activePopupKey,
                onOpen: onOpen,
                onClose: onClose,
                onSendOptionAnalytics: sendOptionAnalytics,
                loading: loading,
                hydratedData: hydratedData,
                onClear: onClearCallback,
                projectOptions: projectOptions,
                isMulti: !singleSelectFields.includes(fieldId),
                fieldDescription: fieldDescription,
                onOpenOperatorPicker: closeAllPopups,
                hideOperatorDropdown: hideOperatorDropdown,
                isIrremovable: isIrremovable,
                contextJql: contextJql,
                viewContext: viewContext,
                scope: scope,
                suggestedUsersCount: suggestedUsersCount
            })));
        case (0, $8OILN.PickerTypes).TextArea:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($de0825eda1c9e481$var$FieldWrapperNew, {
                useListElement: Boolean(shouldUseListMarkup),
                handleKeyDown: handleOnKeyDown
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $05h2Y.TextAreaPicker), {
                clause: clause,
                fieldId: fieldId,
                fieldLabel: fieldLabel,
                fieldType: fieldType,
                activePopupKey: activePopupKey,
                onSearchWrapper: onSearchWrapper,
                onClear: onClearCallback,
                onOpen: onOpen,
                onClose: onClose,
                fieldDescription: fieldDescription,
                propType: propType,
                isIrremovable: isIrremovable
            }));
        case (0, $8OILN.PickerTypes).DateTime:
        case (0, $8OILN.PickerTypes).DueDate:
        case (0, $8OILN.PickerTypes).DateTimeRange:
            if (clause && clause.clauseType !== (0, $e9a0ef16a223cbc7$export$ae56b4ef248a2b6a) || secondaryClause && secondaryClause.clauseType !== (0, $e9a0ef16a223cbc7$export$ae56b4ef248a2b6a)) throw new Error(`Picker type ${pickerType} cannot be used with a non terminal clause`);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($de0825eda1c9e481$var$FieldWrapperNew, {
                useListElement: Boolean(shouldUseListMarkup),
                handleKeyDown: handleOnKeyDown
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6RuoT.DatePickerWrapper), {
                clause: clause,
                fieldId: fieldId,
                fieldLabel: fieldLabel,
                pickerType: pickerType,
                activePopupKey: activePopupKey,
                onSearchWrapper: onSearchWrapper,
                onClear: onClearCallback,
                onOpen: onOpen,
                onClose: onClose,
                secondaryClause: secondaryClause,
                fieldDescription: fieldDescription,
                isIrremovable: isIrremovable
            }));
        case (0, $8OILN.PickerTypes).CascadeSelect:
            if (clause && clause.clauseType !== (0, $e9a0ef16a223cbc7$export$ae56b4ef248a2b6a)) throw new Error(`Picker type ${pickerType} cannot be used with a non terminal clause`);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($de0825eda1c9e481$var$FieldWrapperNew, {
                useListElement: Boolean(shouldUseListMarkup),
                handleKeyDown: handleOnKeyDown
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2WRsY.CascadeSelectPicker), {
                activePopupKey: activePopupKey,
                clause: clause,
                fieldDescription: fieldDescription,
                fieldId: fieldId,
                fieldLabel: fieldLabel,
                hydratedData: hydratedData,
                onClose: onClose,
                onOpen: onOpen,
                onSearchWrapper: onSearchWrapper,
                onSendOptionAnalytics: sendOptionAnalytics,
                onClear: onClearCallback,
                isIrremovable: isIrremovable,
                contextJql: contextJql
            }));
        case (0, $8OILN.PickerTypes).NumberRange:
            if (clause && clause.clauseType !== (0, $e9a0ef16a223cbc7$export$ae56b4ef248a2b6a) || secondaryClause && secondaryClause.clauseType !== (0, $e9a0ef16a223cbc7$export$ae56b4ef248a2b6a)) throw new Error(`Picker type ${pickerType} cannot be used with a non terminal clause`);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($de0825eda1c9e481$var$FieldWrapperNew, {
                useListElement: Boolean(shouldUseListMarkup),
                handleKeyDown: handleOnKeyDown
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $169o0.NumberRangePicker), {
                fieldId: fieldId,
                fieldLabel: fieldLabel,
                activePopupKey: activePopupKey,
                clause: clause,
                secondaryClause: secondaryClause,
                onSearchWrapper: onSearchWrapper,
                onClear: onClearCallback,
                onOpen: onOpen,
                onClose: onClose,
                fieldDescription: fieldDescription,
                onSendOptionAnalytics: sendOptionAnalytics,
                isIrremovable: isIrremovable
            }));
        case (0, $8OILN.PickerTypes).BooleanType:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($de0825eda1c9e481$var$FieldWrapperNew, {
                useListElement: Boolean(shouldUseListMarkup),
                handleKeyDown: handleOnKeyDown
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kxBJw.LastUserCommentedPickerWrapper), {
                activePopupKey: activePopupKey,
                clause: clause,
                fieldDescription: fieldDescription,
                fieldId: fieldId,
                fieldLabel: fieldLabel,
                onClose: onClose,
                onOpen: onOpen,
                onSearchWrapper: onSearchWrapper,
                onClear: onClearCallback,
                isIrremovable: isIrremovable
            }));
        default:
            return UnsupportedFieldPicker;
    }
};
var $de0825eda1c9e481$export$2e2bcd8739ae039 = $de0825eda1c9e481$export$a455218a85c89869;

});
const $e9a0ef16a223cbc7$export$7a58b23488ea076b = 'compound';
const $e9a0ef16a223cbc7$export$ae56b4ef248a2b6a = 'terminal';
const $e9a0ef16a223cbc7$export$e356b89f8c8d2fcb = 'not';

// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("5Sv2f", function(module, exports) {

$parcel$export(module.exports, "useSendOptionAnalytics", () => $c619259aae6c1a7c$export$dd648d2c308aa842);

var $5uXOq = parcelRequire("5uXOq");

var $fr1K2 = parcelRequire("fr1K2");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $c619259aae6c1a7c$export$dd648d2c308aa842 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)((attributes)=>{
        const actionSubjectId = 'refinementBarFilterSearch';
        const analyticsEvent = createAnalyticsEvent({
            eventType: 'UI',
            action: 'changed',
            actionSubject: 'filterSearch',
            actionSubjectId: actionSubjectId
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, actionSubjectId, (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(attributes, 'fieldId'));
    }, [
        createAnalyticsEvent
    ]);
};

});

parcelRegister("2WRsY", function(module, exports) {

$parcel$export(module.exports, "CascadeSelectPicker", () => $0a18ade674c87374$export$d469cbf777198f76);

var $5uXOq = parcelRequire("5uXOq");


var $eWn4R = parcelRequire("eWn4R");

var $4Hz9T = parcelRequire("4Hz9T");

var $kG16F = parcelRequire("kG16F");

var $lqlI4 = parcelRequire("lqlI4");

var $kztU6 = parcelRequire("kztU6");

var $bAxNm = parcelRequire("bAxNm");

var $7wgFq = parcelRequire("7wgFq");

var $6T94T = parcelRequire("6T94T");
const $0a18ade674c87374$export$d469cbf777198f76 = ({ activePopupKey: activePopupKey, clause: clause, fieldId: fieldId, fieldLabel: fieldLabel, fieldDescription: fieldDescription, hydratedData: hydratedData, onClose: onClose, onOpen: onOpen, onClear: onClear, onSearchWrapper: onSearchWrapper, onSendOptionAnalytics: onSendOptionAnalytics, isIrremovable: isIrremovable, contextJql: contextJql })=>{
    if (clause !== undefined && clause.clauseType !== (0, $e9a0ef16a223cbc7$export$ae56b4ef248a2b6a)) throw new Error('cascadeSelectPicker attempted to hydrate using a query that should have been handled by query-too-complex');
    // match the hydrated value to the option from the clause & handle optimistic updates
    const selectedOptionsFromHydration = (0, $7wgFq.useHydratedValues)({
        fieldId: fieldId,
        clause: clause,
        hydratedData: hydratedData
    });
    const [selectedOption, setSelectedOption] = (0, $6T94T.useSelectedValues)(hydratedData, selectedOptionsFromHydration);
    const [ast] = (0, $kG16F.useAST)();
    /**
	 * fieldLabel comes from field displayName from the hydration data.
	 * It is defined in the fragment `jqlEditor_jqlBuilderBasic_JQLEditorUI` in
	 * `src/packages/jql-builder/basic/src/ui/jql-editor/index.tsx`
	 * we never expect it to be undefined but since we are not using the @required
	 * directive in the fragment, this check is required.
	 */ const safeFieldLabel = fieldLabel ?? '';
    const triggerTextContent = {
        fieldLabel: safeFieldLabel,
        parentOption: selectedOption?.parentOption?.label,
        childOption: selectedOption?.childOption?.label
    };
    const triggerHasValues = Boolean(triggerTextContent.parentOption || triggerTextContent.childOption);
    const triggerHasInvalidValues = Boolean(selectedOption?.parentOption?.isInvalid || selectedOption?.childOption?.isInvalid);
    const isOpen = activePopupKey === fieldId;
    const onTriggerClick = (0, $5uXOq.useCallback)(()=>isOpen ? onClose() : onOpen(), [
        isOpen,
        onClose,
        onOpen
    ]);
    const triggerRenderer = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Hz9T.default), {
            ...triggerProps,
            fieldDescription: fieldDescription,
            isInvalid: triggerHasInvalidValues,
            isSelected: isOpen,
            isLoading: false,
            hasValues: triggerHasValues,
            onClear: ()=>onClear(clause ? (0, $eWn4R.default)(ast, clause) : undefined),
            onClick: onTriggerClick,
            testId: "jql-builder-basic.ui.jql-editor.field.cascade-select-picker.picker-trigger",
            isIrremovable: isIrremovable
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kztU6.TriggerLabelContainer), {
            fieldLabel: triggerTextContent.fieldLabel,
            parentValue: triggerTextContent.parentOption,
            childValue: triggerTextContent.childOption
        })), [
        fieldDescription,
        triggerHasInvalidValues,
        isOpen,
        triggerHasValues,
        onTriggerClick,
        isIrremovable,
        triggerTextContent.fieldLabel,
        triggerTextContent.parentOption,
        triggerTextContent.childOption,
        onClear,
        clause,
        ast
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lqlI4.CascadeSelectPickerPopup), {
        fieldId: fieldId,
        initialValue: selectedOption,
        isOpen: isOpen,
        onClose: onClose,
        onChange: (newValue)=>{
            setSelectedOption(newValue);
            onSendOptionAnalytics && onSendOptionAnalytics({
                hasParentOption: Boolean(newValue.parentOption),
                hasChildOption: Boolean(newValue.childOption)
            });
            onSearchWrapper && onSearchWrapper((0, $bAxNm.getUpdatedJql)(ast, clause, fieldId, newValue));
            onClose();
        },
        renderTrigger: triggerRenderer,
        contextJql: contextJql
    });
};

});
parcelRegister("eWn4R", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7618525ab9ced0ee$export$2e2bcd8739ae039);


var $4g5bl = parcelRequire("4g5bl");

var $at2MP = parcelRequire("at2MP");
const $7618525ab9ced0ee$var$removeFieldClauseFromJql = (ast, clauseToRemove)=>{
    const jqlString = ast.represents;
    let previousClause;
    let nextClause;
    const where = ast.query?.where;
    if (where && where.clauseType === (0, $e9a0ef16a223cbc7$export$7a58b23488ea076b)) for(let index = 0; index < where.clauses.length; index += 1){
        const clause = where.clauses[index];
        const clausePosition = clause.position;
        const clauseToRemovePosition = clauseToRemove.position;
        // Early exit if position data is unavailable for our clause
        if (!clausePosition || !clauseToRemovePosition) return jqlString;
        if (clausePosition[0] === clauseToRemovePosition[0] && clausePosition[1] === clauseToRemovePosition[1]) {
            previousClause = where.clauses[index - 1];
            nextClause = where.clauses[index + 1];
        }
    }
    const clauseToRemovePosition = (0, $at2MP.getClausePosition)(jqlString, clauseToRemove);
    // Early exit if position data is unavailable for our clause
    if (!clauseToRemovePosition) return jqlString;
    const [clauseToRemoveStart, clauseToRemoveEnd] = clauseToRemovePosition;
    if (previousClause) {
        // preserve AND inbetween
        if (nextClause) {
            const nextClausePosition = (0, $at2MP.getClausePosition)(jqlString, nextClause);
            // Early exit if position data is unavailable for our clause
            if (!nextClausePosition) return jqlString;
            return (0, $4g5bl.substring)(jqlString, 0, clauseToRemoveStart) + (0, $4g5bl.substring)(jqlString, nextClausePosition[0]);
        }
        const previousClausePosition = (0, $at2MP.getClausePosition)(jqlString, previousClause);
        // Early exit if position data is unavailable for our clause
        if (!previousClausePosition) return jqlString;
        return (0, $4g5bl.substring)(jqlString, 0, previousClausePosition[1]) + (0, $4g5bl.substring)(jqlString, clauseToRemoveEnd);
    }
    if (!previousClause) {
        if (nextClause) {
            const nextClausePosition = (0, $at2MP.getClausePosition)(jqlString, nextClause);
            // Early exit if position data is unavailable for our clause
            if (!nextClausePosition) return jqlString;
            return (0, $4g5bl.substring)(jqlString, 0, clauseToRemoveStart) + (0, $4g5bl.substring)(jqlString, nextClausePosition[0]);
        }
        return (0, $4g5bl.substring)(jqlString, 0, clauseToRemoveStart) + (0, $4g5bl.substring)(jqlString, clauseToRemoveEnd);
    }
    return jqlString;
};
var $7618525ab9ced0ee$export$2e2bcd8739ae039 = $7618525ab9ced0ee$var$removeFieldClauseFromJql;

});
parcelRegister("4g5bl", function(module, exports) {

$parcel$export(module.exports, "substring", () => $2d42e337a14476e7$export$662d3818631fba36);
/**
 * Returns the substring at the specified location within a String object while supporting Emojis.
 *
 * This method is to be used instead of String.substring. String.substring does not handle emojis correctly as they can be multi-char length.
 *
 * @param start — The zero-based index number indicating the beginning of the substring.
 * @param end Zero-based index number indicating the end of the substring. The substring includes the characters up to, but not including, the character indicated by end. If end is omitted, the characters from start through the end of the original string are returned.
 */ const $2d42e337a14476e7$export$662d3818631fba36 = (str, start, end)=>[
        ...str
    ].slice(start, end).join('');

});

parcelRegister("at2MP", function(module, exports) {

$parcel$export(module.exports, "getClausePosition", () => $31ac501758f9a6d3$export$9a8cf65f444b696f);
const $31ac501758f9a6d3$var$whiteSpaceRegex = /\s/;
const $31ac501758f9a6d3$export$9a8cf65f444b696f = (jql, clause)=>{
    if (!clause.position) return null;
    let [start, end] = [
        undefined,
        undefined
    ];
    // Spreading the jql will account for multi-char unicode characters
    const jqlSymbols = [
        ...jql
    ];
    // Start
    for(let i = clause.position[0] - 1; i >= 0; i -= 1){
        const symbol = jqlSymbols[i];
        if (symbol === '(') {
            start = i;
            break;
        }
        // The use of continue here to check for
        if (!$31ac501758f9a6d3$var$whiteSpaceRegex.test(symbol)) break;
    }
    // short circuit here if no '(' is found
    if (start === undefined) return clause.position;
    // End
    for(let i = clause.position[1]; i <= jqlSymbols.length; i += 1){
        const symbol = jqlSymbols[i];
        if (symbol === ')') {
            end = i + 1;
            break;
        }
        if (!$31ac501758f9a6d3$var$whiteSpaceRegex.test(symbol)) break;
    }
    return start !== undefined && end !== undefined ? [
        start,
        end
    ] : clause.position;
};

});


parcelRegister("lqlI4", function(module, exports) {

$parcel$export(module.exports, "CascadeSelectPickerPopup", () => $dacfa739e5d33d68$export$f74bfb091b432a99);

var $5uXOq = parcelRequire("5uXOq");

var $7h4fA = parcelRequire("7h4fA");

var $4yuwq = parcelRequire("4yuwq");

var $jgJNO = parcelRequire("jgJNO");
const $dacfa739e5d33d68$export$f74bfb091b432a99 = ({ fieldId: fieldId, initialValue: initialValue, isOpen: isOpen, onClose: onClose, onChange: onChange, renderTrigger: renderTrigger, contextJql: contextJql })=>{
    const renderContent = (0, $5uXOq.useCallback)(({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7h4fA.CascadingSelectView), {
            jqlTerm: fieldId,
            jqlContext: contextJql,
            initialValue: initialValue,
            onChange: onChange,
            setInitialFocusRef: setInitialFocusRef
        }), [
        fieldId,
        contextJql,
        initialValue,
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        content: renderContent,
        isOpen: isOpen,
        onClose: onClose,
        placement: "bottom-start",
        messageId: "jql-builder-basic.ui.jql-editor.field.cascade-select-picker.popup",
        messageType: "transactional",
        popupComponent: (0, $4yuwq.FixedWidthPopupComponent),
        shouldRenderToParent: true,
        trigger: renderTrigger
    });
};

});
parcelRegister("7h4fA", function(module, exports) {

$parcel$export(module.exports, "CascadingSelectView", () => $f6a2e28fb5975d4b$export$468e769561d652ac);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $2x3Cb = parcelRequire("2x3Cb");

var $qfj8c = parcelRequire("qfj8c");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $d7FF4 = parcelRequire("d7FF4");

var $koVbs = parcelRequire("koVbs");

var $6l9PY = parcelRequire("6l9PY");

var $9GEYJ = parcelRequire("9GEYJ");

var $k7VuC = parcelRequire("k7VuC");
const $f6a2e28fb5975d4b$var$PARENT_INPUT_ID = 'jql-builder-cascading-select-parent-options-select';
const $f6a2e28fb5975d4b$var$CHILD_INPUT_ID = 'jql-builder-cascading-select-child-options-select';
const $f6a2e28fb5975d4b$export$468e769561d652ac = ({ jqlTerm: jqlTerm, jqlContext: jqlContext, initialValue: initialValue, onChange: onChange, setInitialFocusRef: setInitialFocusRef })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    // Parent data
    const [selectedParentOption, setSelectedParentOption] = (0, $5uXOq.useState)(initialValue?.parentOption);
    const { loadOptions: loadParentOptions } = (0, $6l9PY.useCascadingSelectValuesLoader)({
        jqlTerm: jqlTerm,
        optionType: 'PARENT',
        jqlContext: jqlContext
    });
    // Child data
    const [selectedChildOption, setSelectedChildOption] = (0, $5uXOq.useState)(initialValue?.childOption);
    const { loadOptions: loadChildOptions } = (0, $6l9PY.useCascadingSelectValuesLoader)({
        jqlTerm: jqlTerm,
        optionType: 'CHILD',
        jqlContext: jqlContext,
        parentOptionId: selectedParentOption?.value.toString() ?? undefined
    });
    const onSelectRef = (0, $5uXOq.useCallback)((ref)=>{
        if (ref?.select?.inputRef && setInitialFocusRef) setInitialFocusRef(ref.select.inputRef);
    }, [
        setInitialFocusRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $f6a2e28fb5975d4b$var$dropdownGroupContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $f6a2e28fb5975d4b$var$parentDropdownContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2x3Cb.Label), {
        htmlFor: $f6a2e28fb5975d4b$var$PARENT_INPUT_ID
    }, formatMessage((0, $9GEYJ.default).parentSelectLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d7FF4.default), {
        ref: onSelectRef,
        inputId: $f6a2e28fb5975d4b$var$PARENT_INPUT_ID,
        testId: "jql-builder-basic-cascading-select.ui.select-parent",
        formatOptionLabel: (0, $k7VuC.formatOptionLabel),
        placeholder: formatMessage((0, $9GEYJ.default).parentSelectPlaceholder),
        noOptionsMessage: ()=>formatMessage((0, $9GEYJ.default).noOptions),
        value: selectedParentOption,
        loadOptions: loadParentOptions,
        onChange: (newValue)=>{
            if (!newValue || newValue !== selectedParentOption) setSelectedChildOption(undefined);
            setSelectedParentOption(newValue ?? undefined);
        },
        defaultOptions: true,
        isClearable: true,
        isInvalid: selectedParentOption?.isInvalid
    }), selectedParentOption?.isInvalid && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, selectedParentOption?.invalidMessage ?? formatMessage((0, $9GEYJ.default).invalidOptionMessage, {
        selectField: formatMessage((0, $9GEYJ.default).parentSelectLabel)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $f6a2e28fb5975d4b$var$childDropdownContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2x3Cb.Label), {
        htmlFor: $f6a2e28fb5975d4b$var$CHILD_INPUT_ID
    }, formatMessage((0, $9GEYJ.default).childSelectLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d7FF4.default), {
        key: selectedParentOption?.value,
        inputId: $f6a2e28fb5975d4b$var$CHILD_INPUT_ID,
        testId: "jql-builder-basic-cascading-select.ui.select-child",
        formatOptionLabel: (0, $k7VuC.formatOptionLabel),
        placeholder: formatMessage((0, $9GEYJ.default).childSelectPlaceholder),
        noOptionsMessage: ()=>formatMessage((0, $9GEYJ.default).noOptions),
        value: selectedChildOption,
        loadOptions: selectedParentOption ? loadChildOptions : undefined,
        onChange: (newValue)=>setSelectedChildOption(newValue ?? undefined),
        isDisabled: !selectedParentOption,
        defaultOptions: true,
        isClearable: true,
        isInvalid: selectedChildOption?.isInvalid
    }), selectedChildOption?.isInvalid && !selectedParentOption?.isInvalid && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, selectedParentOption?.invalidMessage ?? formatMessage((0, $9GEYJ.default).invalidOptionMessage, {
        selectField: formatMessage((0, $9GEYJ.default).parentSelectLabel)
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f6a2e28fb5975d4b$var$StyledButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "primary",
        onClick: (e)=>{
            e.preventDefault();
            onChange({
                parentOption: selectedParentOption,
                childOption: selectedChildOption
            });
        },
        type: "submit",
        isDisabled: false,
        testId: "jql-builder-basic-cascading-select.ui.update-button"
    }, formatMessage((0, $9GEYJ.default).updateButtonText))));
};
const $f6a2e28fb5975d4b$var$dropdownGroupContainerStyles = (0, $8CUq3.xcss)({
    paddingLeft: 'space.150',
    paddingRight: 'space.150'
});
const $f6a2e28fb5975d4b$var$parentDropdownContainerStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.100',
    marginBottom: 'space.100'
});
const $f6a2e28fb5975d4b$var$childDropdownContainerStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.100',
    marginBottom: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f6a2e28fb5975d4b$var$StyledButtonContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_x3dozgxb _ca0q12x7 _u5f3utpp _n3td12x7 _19bvutpp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("d7FF4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac4d84cf4438daea$export$2e2bcd8739ae039);

var $eAthk = parcelRequire("eAthk");

var $3c98u = parcelRequire("3c98u");
const $ac4d84cf4438daea$var$AsyncSelect = (0, $3c98u.default)((0, $eAthk.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ac4d84cf4438daea$export$2e2bcd8739ae039 = $ac4d84cf4438daea$var$AsyncSelect;

});

parcelRegister("6l9PY", function(module, exports) {

$parcel$export(module.exports, "useCascadingSelectValuesLoader", () => $4b3f60f8770c121b$export$34980bb479d0f067);

var $kzIue = parcelRequire("kzIue");

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $8Uumt = parcelRequire("8Uumt");

var $jcw0u = parcelRequire("jcw0u");

var $koVbs = parcelRequire("koVbs");

var $koeKL = parcelRequire("koeKL");


var $jOHN9 = parcelRequire("jOHN9");
const $4b3f60f8770c121b$export$c52a35aaea869872 = async (environment, variables)=>{
    const result = await (0, $8Uumt.fetchQuery)(environment, (0, $kzIue.default), variables, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    if (!result) throw new Error('Unexpected empty result received from useCascadingSelectValuesLoaderQuery');
    const { pageInfo: pageInfo, edges: edges } = result.jira.jqlBuilder.cascadingSelectValues;
    const options = edges.map((edge)=>edge ? {
            label: edge.node.displayName,
            value: edge.node.optionId
        } : undefined).filter(Boolean);
    return pageInfo.hasNextPage && pageInfo.endCursor ? options.concat(await $4b3f60f8770c121b$export$c52a35aaea869872(environment, {
        ...variables,
        after: pageInfo.endCursor
    })) : options;
};
const $4b3f60f8770c121b$export$34980bb479d0f067 = ({ jqlTerm: jqlTerm, jqlContext: jqlContext, optionType: optionType, parentOptionId: parentOptionId })=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return (0, $5uXOq.useMemo)(()=>({
            loadOptions: (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(// Must return void/undefined. AK select ignores the callback if a promise/async is returned.
            (searchString, cb)=>{
                $4b3f60f8770c121b$export$c52a35aaea869872(environment, {
                    searchString: searchString,
                    cloudId: cloudId,
                    jqlTerm: jqlTerm,
                    jqlContext: jqlContext,
                    optionType: optionType,
                    parentOptionId: parentOptionId
                }).catch((error)=>{
                    (0, $jcw0u.default)({
                        error: error,
                        sendToPrivacyUnsafeSplunk: true,
                        meta: {
                            id: 'useCascadingSelectValuesLoaderError',
                            packageName: (0, $1fff6735923fa96c$export$355546c9851d0c23),
                            teamName: 'empanada'
                        }
                    });
                    return [
                        {
                            label: formatMessage((0, $jOHN9.default).fetchError),
                            value: '',
                            isDisabled: true
                        }
                    ];
                }).then(cb);
            }, 500)
        }), [
        cloudId,
        environment,
        formatMessage,
        jqlContext,
        jqlTerm,
        optionType,
        parentOptionId
    ]);
};

});
parcelRegister("kzIue", function(module, exports) {

$parcel$export(module.exports, "default", () => $a91367465b44c661$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f5a55b2db0d39bf05e1c7d776024275e>>
 * @relayHash c58b78e997cd2d1bf926e8e2e8d669a4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2e5ce2c8910f5a8665b5d15e181d1b534162ee1416e674e05e682caad7c9f62d
const $a91367465b44c661$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jqlContext"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jqlTerm"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "optionType"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "parentOptionId"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchString"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v8 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "optionType",
                    "variableName": "optionType"
                },
                {
                    "kind": "Variable",
                    "name": "parentOptionId",
                    "variableName": "parentOptionId"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Variable",
            "name": "jqlContext",
            "variableName": "jqlContext"
        },
        {
            "kind": "Variable",
            "name": "jqlTerm",
            "variableName": "jqlTerm"
        },
        {
            "kind": "Variable",
            "name": "searchString",
            "variableName": "searchString"
        }
    ], v9 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v11 = {
        "kind": "ScalarField",
        "name": "optionId"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useCascadingSelectValuesLoaderQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v7 /*: any*/ ,
                                    "concreteType": "JiraJqlBuilder",
                                    "kind": "LinkedField",
                                    "name": "jqlBuilder",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "args": v8 /*: any*/ ,
                                                "concreteType": "JiraJqlCascadingOptionFieldValueConnection",
                                                "kind": "LinkedField",
                                                "name": "cascadingSelectValues",
                                                "plural": false,
                                                "selections": [
                                                    v9 /*: any*/ ,
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraJqlCascadingOptionFieldValueEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "JiraJqlCascadingOptionFieldValue",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v10 /*: any*/ ,
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v11 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "jira.jqlBuilder.cascadingSelectValues.edges.node.optionId"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "jira.jqlBuilder.cascadingSelectValues.edges.node"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "jira.jqlBuilder.cascadingSelectValues.edges"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.jqlBuilder.cascadingSelectValues"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jqlBuilder"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v6 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useCascadingSelectValuesLoaderQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v8 /*: any*/ ,
                                    "concreteType": "JiraJqlCascadingOptionFieldValueConnection",
                                    "kind": "LinkedField",
                                    "name": "cascadingSelectValues",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        {
                                            "concreteType": "JiraJqlCascadingOptionFieldValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraJqlCascadingOptionFieldValue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "2e5ce2c8910f5a8665b5d15e181d1b534162ee1416e674e05e682caad7c9f62d",
            "metadata": {},
            "name": "useCascadingSelectValuesLoaderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a91367465b44c661$var$node.hash = "deb7ed0e1bb076edffe453408ba24625";
var $a91367465b44c661$export$2e2bcd8739ae039 = $a91367465b44c661$var$node;

});

const $1fff6735923fa96c$export$355546c9851d0c23 = 'jira-jql-builder-basic-cascading-select';

parcelRegister("jOHN9", function(module, exports) {

$parcel$export(module.exports, "default", () => $4363b4cea4375d60$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4363b4cea4375d60$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    fetchError: {
        "id": "jql-builder-basic-cascading-select.services.use-cascading-select-values-loader.fetch-error",
        "defaultMessage": "Something went wrong, please refresh and try again."
    }
});

});


parcelRegister("9GEYJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e6305dec03d4256$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1e6305dec03d4256$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    updateButtonText: {
        "id": "jql-builder-basic-cascading-select.update-button-text",
        "defaultMessage": "Update"
    },
    parentSelectLabel: {
        "id": "jql-builder-basic-cascading-select.parent-select-label",
        "defaultMessage": "Parent option"
    },
    parentSelectPlaceholder: {
        "id": "jql-builder-basic-cascading-select.parent-select-placeholder",
        "defaultMessage": "Select parent option"
    },
    childSelectLabel: {
        "id": "jql-builder-basic-cascading-select.child-select-label",
        "defaultMessage": "Child option"
    },
    childSelectPlaceholder: {
        "id": "jql-builder-basic-cascading-select.child-select-placeholder",
        "defaultMessage": "Select child option"
    },
    noOptions: {
        "id": "jql-builder-basic-cascading-select.no-options",
        "defaultMessage": "No options available"
    },
    invalidOptionMessage: {
        "id": "jql-builder-basic-cascading-select.invalid-option-message",
        "defaultMessage": "\"{selectField}\" selection is not valid for the current project."
    }
});

});

parcelRegister("k7VuC", function(module, exports) {

$parcel$export(module.exports, "formatOptionLabel", () => $beed4369a6488e92$export$322216d90ffb8d0e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hMVoD = parcelRequire("hMVoD");

var $7vYo9 = parcelRequire("7vYo9");
const $beed4369a6488e92$export$322216d90ffb8d0e = ({ label: label, isInvalid: isInvalid, invalidMessage: invalidMessage })=>{
    if (isInvalid) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($beed4369a6488e92$var$InvalidOption, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($beed4369a6488e92$var$InvalidOptionText, null, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($beed4369a6488e92$var$InvalidOptionIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMVoD))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: invalidMessage ?? '',
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($7vYo9)))
    })));
    return label;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $beed4369a6488e92$var$InvalidOption = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1tmw _1e0c1txw _2lx2vrvc _4cvr1h6o _1bah1yb4",
            __cmplp.className
        ])
    });
});
const $beed4369a6488e92$var$InvalidOptionText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1o9zkb7n _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $beed4369a6488e92$var$InvalidOptionIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1o9zidpf",
            __cmplp.className
        ])
    });
});

});



parcelRegister("kztU6", function(module, exports) {

$parcel$export(module.exports, "TriggerLabelContainer", () => $eb732a5661412a19$export$2c19d76757def6a5);

var $5uXOq = parcelRequire("5uXOq");

var $3AuGJ = parcelRequire("3AuGJ");
const $eb732a5661412a19$export$2c19d76757def6a5 = ({ fieldLabel: fieldLabel, parentValue: parentValue, childValue: childValue })=>{
    const parentDisplay = parentValue ? `${parentValue}` : '';
    const childDisplay = parentValue && childValue ? ` - ${childValue}` : '';
    const displayValue = `${parentDisplay}${childDisplay}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3AuGJ.LabelContainer), {
        "data-testid": "jql-builder-basic.ui.jql-editor.field.cascade-select-picker.trigger-label-container.label-container"
    }, !parentValue && !childValue ? fieldLabel : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3AuGJ.StyledLabel), null, fieldLabel, ": "), displayValue));
};

});

parcelRegister("bAxNm", function(module, exports) {

$parcel$export(module.exports, "getUpdatedJql", () => $c3d37ef51021865b$export$1625bb7ada97d007);

var $iEIQF = parcelRequire("iEIQF");
var $bzbto = parcelRequire("bzbto");
var $l0V05 = parcelRequire("l0V05");

var $5Dsab = parcelRequire("5Dsab");

var $1dTaH = parcelRequire("1dTaH");
const $c3d37ef51021865b$var$createTerminalClause = (fieldId, value)=>{
    const args = [];
    if (value.parentOption) // parent value first
    args.push(value.parentOption.value);
    if (value.childOption) // followed by child value
    args.push(value.childOption.value);
    return (0, $iEIQF.default).terminalClause((0, $iEIQF.default).field((0, $1dTaH.escapeBackslashes)(fieldId)), (0, $iEIQF.default).operator((0, $bzbto.OPERATOR_IN)), (0, $iEIQF.default).functionOperand((0, $iEIQF.default).functionString((0, $5Dsab.CASCADE_OPTION_FUNCTION_NAME)), args.map((argString)=>(0, $iEIQF.default).argument(argString.toString()))));
};
const $c3d37ef51021865b$export$1625bb7ada97d007 = (ast, clause, fieldId, value)=>{
    const hasValue = Boolean(value.parentOption || value.childOption);
    if (!clause) {
        if (!ast.query || !hasValue) return ast.represents;
        ast.query.appendClause($c3d37ef51021865b$var$createTerminalClause(fieldId, value), (0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97));
    } else if (!hasValue) clause.remove();
    else clause.replace($c3d37ef51021865b$var$createTerminalClause(fieldId, value));
    return (0, $l0V05.print)(ast, {
        operatorCase: 'upper'
    });
};

});
const $3cef51f82b2cbe1d$export$6d6d48d210d3ca97 = 'and';
const $3cef51f82b2cbe1d$export$7b8f0a728d79a753 = 'or';


parcelRegister("7wgFq", function(module, exports) {

$parcel$export(module.exports, "useHydratedValues", () => $180148f15679b785$export$dc23a21ad032e5fa);

var $e39Qu = parcelRequire("e39Qu");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $i00hv = parcelRequire("i00hv");
const $180148f15679b785$export$dc23a21ad032e5fa = ({ fieldId: fieldId, clause: clause, hydratedData: hydratedData })=>{
    /* eslint-disable @atlassian/relay/graphql-naming, @atlassian/relay/unused-fields */ const data = (0, $8Uumt.useFragment)((0, $e39Qu.default), hydratedData);
    /* eslint-enable @atlassian/relay/graphql-naming, @atlassian/relay/unused-fields */ return (0, $5uXOq.useMemo)(()=>{
        const hydratedValues = (data.jira?.jqlBuilder?.hydrateJqlQuery ?? data.jira?.jqlBuilder?.hydrateJqlQueryForFilter)?.fields?.find((field)=>field.jqlTerm?.toLowerCase() === fieldId)?.values;
        const unambiguousCascadeFieldValue = (0, $i00hv.findUnambiguousCascadeFieldValue)({
            clause: clause,
            hydratedValues: hydratedValues
        });
        return unambiguousCascadeFieldValue;
    }, [
        clause,
        data.jira?.jqlBuilder?.hydrateJqlQuery,
        data.jira?.jqlBuilder?.hydrateJqlQueryForFilter,
        fieldId
    ]);
};

});
parcelRegister("e39Qu", function(module, exports) {

$parcel$export(module.exports, "default", () => $873c8c112b325705$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<03ac623fc1b9a207f6465549a3bccf93>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $873c8c112b325705$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "scope"
    }, v1 = {
        "kind": "Variable",
        "name": "viewContext",
        "variableName": "viewContext"
    }, v2 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v5 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v6 = [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "fields",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "values",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "values",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                v2 /*: any*/ ,
                                                                v4 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraJqlCascadingOptionFieldValue",
                                                                    "kind": "LinkedField",
                                                                    "name": "parentOption",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v4 /*: any*/ ,
                                                                        v2 /*: any*/ ,
                                                                        v5 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlCascadingOptionFieldValue"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlQueryHydratedValue"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v2 /*: any*/ 
                                            ],
                                            "type": "JiraJqlQueryHydratedError"
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraJqlQueryHydratedField"
                        }
                    ]
                }
            ],
            "type": "JiraJqlHydratedQuery"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "filterAri"
            },
            {
                "kind": "RootArgument",
                "name": "includeJira"
            },
            {
                "kind": "RootArgument",
                "name": "isFilter"
            },
            {
                "kind": "RootArgument",
                "name": "jql"
            },
            {
                "kind": "RootArgument",
                "name": "scope"
            },
            {
                "kind": "RootArgument",
                "name": "viewContext"
            }
        ],
        "kind": "Fragment",
        "name": "useHydratedValues_cascadeSelectPicker",
        "selections": [
            {
                "condition": "includeJira",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudId",
                                        "variableName": "cloudId"
                                    }
                                ],
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "condition": "isFilter",
                                        "kind": "Condition",
                                        "passingValue": false,
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "query",
                                                        "variableName": "jql"
                                                    },
                                                    v0 /*: any*/ ,
                                                    v1 /*: any*/ 
                                                ],
                                                "kind": "LinkedField",
                                                "name": "hydrateJqlQuery",
                                                "plural": false,
                                                "selections": v6 /*: any*/ 
                                            }
                                        ]
                                    },
                                    {
                                        "condition": "isFilter",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "id",
                                                        "variableName": "filterAri"
                                                    },
                                                    v0 /*: any*/ ,
                                                    v1 /*: any*/ 
                                                ],
                                                "kind": "LinkedField",
                                                "name": "hydrateJqlQueryForFilter",
                                                "plural": false,
                                                "selections": v6 /*: any*/ 
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$873c8c112b325705$var$node.hash = "92d338efa13872bf45e89b5f9f1155af";
var $873c8c112b325705$export$2e2bcd8739ae039 = $873c8c112b325705$var$node;

});


parcelRegister("6T94T", function(module, exports) {

$parcel$export(module.exports, "useSelectedValues", () => $a9ddb6069421a547$export$e10928cdf9450649);

var $5uXOq = parcelRequire("5uXOq");
const $a9ddb6069421a547$export$e10928cdf9450649 = (hydratedData, selectedOptionsFromHydration)=>{
    const prevHydrationData = (0, $5uXOq.useRef)(hydratedData);
    const [hydrated, setHydrated] = (0, $5uXOq.useState)(true);
    // Allow optimistic updates when a value is selected while hydration is taking place
    const [optimisticValues, setOptimisticValues] = (0, $5uXOq.useState)();
    // Only flag values as hydrated after a data change
    (0, $5uXOq.useEffect)(()=>{
        if (!hydrated && hydratedData !== prevHydrationData.current) setHydrated(true);
        prevHydrationData.current = hydratedData;
    }, [
        hydrated,
        hydratedData
    ]);
    const setSelectedValues = (0, $5uXOq.useCallback)((values)=>{
        setHydrated(false);
        setOptimisticValues(values);
    }, []);
    const selectedValues = !hydrated && optimisticValues ? optimisticValues : selectedOptionsFromHydration;
    return [
        selectedValues,
        setSelectedValues
    ];
};

});


parcelRegister("6RuoT", function(module, exports) {

$parcel$export(module.exports, "DatePickerWrapper", () => $981e5c9859be4ece$export$a915f81916d25a71);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $cv9D1 = parcelRequire("cv9D1");

var $5Ntu9 = parcelRequire("5Ntu9");

var $4yuwq = parcelRequire("4yuwq");

var $fKpEJ = parcelRequire("fKpEJ");

var $aUQOl = parcelRequire("aUQOl");

var $jgJNO = parcelRequire("jgJNO");

var $4Hz9T = parcelRequire("4Hz9T");

var $kG16F = parcelRequire("kG16F");

var $5Sv2f = parcelRequire("5Sv2f");
const $981e5c9859be4ece$export$a915f81916d25a71 = ({ activePopupKey: activePopupKey, clause: clause, secondaryClause: secondaryClause, fieldId: fieldId, fieldLabel: fieldLabel, pickerType: pickerType, onOpen: onOpen, onClose: onClose, onClear: onClear, onSearchWrapper: onSearchWrapper, fieldDescription: fieldDescription, isIrremovable: isIrremovable })=>{
    const intl = (0, $koVbs.default)();
    const [ast] = (0, $kG16F.useAST)();
    const sendOptionAnalytics = (0, $5Sv2f.useSendOptionAnalytics)();
    const variation = (0, $cv9D1.DateTimeVariations)[pickerType] || 'DateTime';
    const dateRefinementValueFromJql = (0, $5Ntu9.getValueFromClauses)(variation, clause, secondaryClause);
    const tooltip = (0, $5Ntu9.getTooltip)({
        intl: intl,
        label: fieldLabel || '',
        variation: variation,
        value: dateRefinementValueFromJql
    });
    const isOpen = activePopupKey === fieldId;
    const handleOnClick = (0, $5uXOq.useCallback)(()=>{
        isOpen ? onClose() : onOpen();
    }, [
        isOpen,
        onClose,
        onOpen
    ]);
    const handleOnClear = (0, $5uXOq.useCallback)(()=>{
        onClear && onClear(clause ? (0, $aUQOl.default)(fieldId, ast, undefined) : undefined);
    }, [
        onClear,
        clause,
        fieldId,
        ast
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        key: fieldId,
        placement: "bottom-start",
        isOpen: isOpen,
        onClose: onClose,
        popupComponent: (0, $4yuwq.DefaultPopupComponent),
        shouldRenderToParent: true,
        messageId: "jql-builder-basic.ui.jql-editor.field.date-picker-wrapper.popup",
        messageType: "transactional",
        trigger: ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fKpEJ.ConditionalTooltip), {
                condition: tooltip !== undefined,
                content: tooltip ?? null,
                position: "top"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Hz9T.default), {
                isInvalid: false,
                isSelected: isOpen,
                hasValues: Boolean(clause || secondaryClause),
                onClick: handleOnClick,
                onClear: !isIrremovable ? handleOnClear : undefined,
                ref: ref,
                testId: `refinement-bar.filter-button.${fieldId}`,
                fieldDescription: fieldDescription,
                isIrremovable: isIrremovable
            }, (0, $5Ntu9.formatLabel)({
                intl: intl,
                label: fieldLabel || '',
                variation: variation,
                value: dateRefinementValueFromJql
            }))),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Ntu9.default), {
                fieldLabel: fieldLabel,
                variation: variation,
                value: dateRefinementValueFromJql,
                onSendOptionAnalytics: sendOptionAnalytics,
                onClosePopup: onClose,
                onChange: (value)=>onSearchWrapper && onSearchWrapper((0, $aUQOl.default)(fieldId, ast, (0, $5Ntu9.getJqlInfo)(value, variation)))
            })
    });
};

});
parcelRegister("cv9D1", function(module, exports) {

$parcel$export(module.exports, "TimeUnits", () => $acd41f18a0ef1260$export$5d7753c8ad881494);
$parcel$export(module.exports, "NowOverdue", () => $acd41f18a0ef1260$export$28c868305da91826);
$parcel$export(module.exports, "BetweenComponent", () => $acd41f18a0ef1260$export$709f90f7ba10389);
$parcel$export(module.exports, "BetweenDateTimeComponent", () => $acd41f18a0ef1260$export$abb0f24cc549194b);
$parcel$export(module.exports, "InRangeComponent", () => $acd41f18a0ef1260$export$68448428cc911d39);
$parcel$export(module.exports, "TimeInputComponent", () => $acd41f18a0ef1260$export$1bc14371a5279585);
$parcel$export(module.exports, "IsNotSetComponent", () => $acd41f18a0ef1260$export$112000efafa8ead5);
$parcel$export(module.exports, "DateTimeVariations", () => $acd41f18a0ef1260$export$efd605d50e9e79ce);
const $acd41f18a0ef1260$export$5d7753c8ad881494 = {
    m: 'minutes',
    h: 'hours',
    d: 'days',
    w: 'weeks'
};
const $acd41f18a0ef1260$export$75843c31a96775e0 = 'within_the_last';
const $acd41f18a0ef1260$export$7d35a296ea2a6822 = 'more_than';
const $acd41f18a0ef1260$export$7df927301bd2f537 = 'between';
const $acd41f18a0ef1260$export$5ec4ea40f310605c = 'in_range';
const $acd41f18a0ef1260$export$28c868305da91826 = 'now_overdue';
const $acd41f18a0ef1260$export$7441c1214e39d97f = 'due_in_next';
const $acd41f18a0ef1260$export$de656838e950fdb9 = 'between_date_time';
const $acd41f18a0ef1260$export$709f90f7ba10389 = 'between';
const $acd41f18a0ef1260$export$abb0f24cc549194b = 'between_date_time';
const $acd41f18a0ef1260$export$68448428cc911d39 = 'in_range';
const $acd41f18a0ef1260$export$1bc14371a5279585 = 'time_input';
const $acd41f18a0ef1260$export$112000efafa8ead5 = 'is_not_set';
const $acd41f18a0ef1260$export$efd605d50e9e79ce = {
    DueDate: 'DueDate',
    DateTime: 'DateTime',
    DateTimeRange: 'DateTimeRange'
};

});

parcelRegister("5Ntu9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ebee7f0dd6ca187$export$2e2bcd8739ae039);
$parcel$export(module.exports, "formatLabel", () => $7ebee7f0dd6ca187$export$957d7daebd899f12);
$parcel$export(module.exports, "getTooltip", () => $7ebee7f0dd6ca187$export$46455b4476d4b8e1);
$parcel$export(module.exports, "getJqlInfo", () => $7ebee7f0dd6ca187$export$8299afa491becffd);
$parcel$export(module.exports, "getValueFromClauses", () => $7ebee7f0dd6ca187$export$66bd7052943865c8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6Csk1 = parcelRequire("6Csk1");

var $eCeGD = parcelRequire("eCeGD");

var $dD7Zc = parcelRequire("dD7Zc");


var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $cv9D1 = parcelRequire("cv9D1");

var $8sS9o = parcelRequire("8sS9o");

var $hBIsZ = parcelRequire("hBIsZ");

var $k1RQ8 = parcelRequire("k1RQ8");

var $5v4cH = parcelRequire("5v4cH");

var $6IpN3 = parcelRequire("6IpN3");

var $b6HWX = parcelRequire("b6HWX");

var $dJttO = parcelRequire("dJttO");

var $e5geY = parcelRequire("e5geY");
const $7ebee7f0dd6ca187$var$hasValue = (dateTimePickerValue)=>{
    if (dateTimePickerValue) {
        const { type: type, value: value } = dateTimePickerValue;
        if (type === 'now_overdue') return {
            type: type,
            value: value
        };
        if (value === null) return false;
        switch(type){
            case 'more_than':
            case 'due_in_next':
            case 'within_the_last':
                return value !== undefined && Boolean(value.value1 && value.value2) ? {
                    value: value,
                    type: type
                } : false;
            case 'between':
            case 'between_date_time':
            case 'in_range':
                return value !== undefined && Boolean(value.value1 || value.value2) ? {
                    value: value,
                    type: type
                } : false;
            default:
                return false;
        }
    }
    return false;
};
const $7ebee7f0dd6ca187$var$getFilterTypes = (name = '')=>{
    if (name === 'DueDate') return 0, $dJttO.DueDateTypeConfig;
    if (name === 'DateTimeRange') return 0, $dJttO.DateTimeTypeConfig;
    return 0, $dJttO.DateTypeConfig;
};
const $7ebee7f0dd6ca187$var$getDateInput = (componentType)=>{
    switch(componentType){
        case 0, $cv9D1.BetweenComponent:
            return 0, $k1RQ8.default;
        case 0, $cv9D1.BetweenDateTimeComponent:
            return 0, $hBIsZ.default;
        case 0, $cv9D1.InRangeComponent:
            return 0, $5v4cH.default;
        case 0, $cv9D1.TimeInputComponent:
            return 0, $b6HWX.default;
        default:
            return null;
    }
};
const $7ebee7f0dd6ca187$var$DateTimeView = ({ fieldLabel: fieldLabel, value: valueProp, variation: variation, onChange: onChange, onClosePopup: onClosePopup, onSendOptionAnalytics: onSendOptionAnalytics })=>{
    const intl = (0, $koVbs.default)();
    const [selectedTypeConfig, setSelectedTypeConfig] = (0, $5uXOq.useState)(valueProp !== undefined && valueProp.type ? $7ebee7f0dd6ca187$var$getFilterTypes(variation).filter((filterType)=>valueProp && filterType.type === valueProp.type)[0] : undefined);
    const [value, setValue] = (0, $5uXOq.useState)({
        between: {
            value1: '',
            value2: ''
        },
        between_date_time: {
            value1: '',
            value2: ''
        },
        in_range: {
            value1: '',
            value2: ''
        },
        within_the_last: {
            value1: '',
            value2: ''
        },
        more_than: {
            value1: '',
            value2: ''
        },
        due_in_next: {
            value1: '',
            value2: '',
            excludeOverdue: true
        },
        ...valueProp && {
            [`${valueProp.type}`]: {
                ...valueProp.value
            }
        }
    });
    const onChangeCheckbox = (0, $5uXOq.useCallback)((event)=>{
        const type = event.currentTarget.value;
        const typeConfig = $7ebee7f0dd6ca187$var$getFilterTypes(variation).find((t)=>t.type === type);
        setSelectedTypeConfig(typeConfig);
    }, [
        variation
    ]);
    const onChangeInput = (0, $5uXOq.useCallback)((val)=>{
        setValue((0, (/*@__PURE__*/$parcel$interopDefault($6Csk1)))({}, value, selectedTypeConfig ? {
            [selectedTypeConfig.type]: val
        } : {}));
    }, [
        selectedTypeConfig,
        value
    ]);
    const errorMessage = (0, $5uXOq.useMemo)(()=>{
        let message;
        $7ebee7f0dd6ca187$var$getFilterTypes(variation).forEach((m)=>{
            const isCurrent = selectedTypeConfig ? m.type === selectedTypeConfig.type : false;
            const currentValue = selectedTypeConfig && value[selectedTypeConfig.type];
            if (m.getErrorMessage && isCurrent) message = m.getErrorMessage(intl, currentValue);
        });
        return message;
    }, [
        intl,
        selectedTypeConfig,
        value,
        variation
    ]);
    const onUpdate = (0, $5uXOq.useCallback)(()=>{
        if (errorMessage !== undefined) return;
        const val = selectedTypeConfig && selectedTypeConfig.type !== (0, $cv9D1.NowOverdue) ? value[selectedTypeConfig.type] : undefined;
        const datePickerValue = selectedTypeConfig !== undefined ? {
            type: selectedTypeConfig.type,
            value: selectedTypeConfig.componentType !== (0, $cv9D1.IsNotSetComponent) ? val : undefined
        } : undefined;
        onChange(datePickerValue);
        if (typeof onClosePopup === 'function') onClosePopup();
        onSendOptionAnalytics && onSendOptionAnalytics({
            timeConstraints: datePickerValue?.type
        });
    }, [
        errorMessage,
        onChange,
        onClosePopup,
        onSendOptionAnalytics,
        selectedTypeConfig,
        value
    ]);
    const handleOnClick = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
        onUpdate();
    }, [
        onUpdate
    ]);
    const handleOnKeyDown = (0, $5uXOq.useCallback)((event)=>{
        if (event.key === 'Enter') {
            event.stopPropagation();
            event.preventDefault();
            onUpdate();
        }
    }, [
        onUpdate
    ]);
    const DateInputType = selectedTypeConfig ? $7ebee7f0dd6ca187$var$getDateInput(selectedTypeConfig.componentType) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7ebee7f0dd6ca187$var$StyledDialogInner, {
        onKeyDown: handleOnKeyDown
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "fieldset",
        xcss: $7ebee7f0dd6ca187$var$fieldsetStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "legend",
        xcss: $7ebee7f0dd6ca187$var$legendStyles
    }, intl.formatMessage((0, $e5geY.default).legendText, {
        fieldLabel: fieldLabel
    })), $7ebee7f0dd6ca187$var$getFilterTypes(variation).map((m)=>{
        const isCurrent = !!selectedTypeConfig && m.type === selectedTypeConfig.type;
        const currentValue = selectedTypeConfig && value[selectedTypeConfig.type];
        const messageDescriptor = (0, $e5geY.messageLookup)[m.label];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7ebee7f0dd6ca187$var$StyledOptionContainer, {
            key: m.type
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6IpN3.Radio), {
            checked: isCurrent,
            name: "mode",
            onChange: onChangeCheckbox,
            value: m.type,
            testId: `jql-builder-basic-datetime.ui.radio.${m.type}`
        }, messageDescriptor ? intl.formatMessage(messageDescriptor) : null), isCurrent && m.hasInput && currentValue && DateInputType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DateInputType, {
            isInvalid: isCurrent && errorMessage !== undefined,
            typeConfig: m,
            onChange: onChangeInput,
            value: currentValue
        }), isCurrent && errorMessage !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7ebee7f0dd6ca187$var$ErrorContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
            LEGACY_size: "small",
            label: "",
            color: "var(--ds-icon-danger, #C9372C)"
        }), errorMessage));
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $7ebee7f0dd6ca187$var$buttonWrapperStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "primary",
        testId: "jql-builder-basic-datetime.ui.update-button",
        spacing: "default",
        isDisabled: errorMessage !== undefined,
        onClick: handleOnClick
    }, intl.formatMessage((0, $e5geY.default).updateButtonText))));
};
$7ebee7f0dd6ca187$var$DateTimeView.whyDidYouRender = true;
var $7ebee7f0dd6ca187$export$2e2bcd8739ae039 = $7ebee7f0dd6ca187$var$DateTimeView;
const $7ebee7f0dd6ca187$export$957d7daebd899f12 = ({ intl: intl, variation: variation, label: label, value: field })=>{
    const typeConfig = field ? $7ebee7f0dd6ca187$var$getFilterTypes(variation).find((f)=>f.type === field.type) : undefined;
    if (typeConfig === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        weight: "medium",
        color: "inherit"
    }, label);
    const value = typeConfig.getFormattedValue(intl, field && field.value);
    return value !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        weight: "medium",
        color: "inherit"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "strong"
    }, label, ": "), typeConfig.getFormattedValue(intl, field && field.value)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        weight: "medium",
        color: "inherit"
    }, label);
};
const $7ebee7f0dd6ca187$export$46455b4476d4b8e1 = ({ intl: intl, variation: variation, value: field })=>{
    const typeConfig = field ? $7ebee7f0dd6ca187$var$getFilterTypes(variation).find((f)=>f.type === field.type) : undefined;
    if (typeConfig === undefined || !typeConfig.getTooltip) return undefined;
    return typeConfig.getTooltip(intl, field && field.value);
};
const $7ebee7f0dd6ca187$export$8299afa491becffd = (dateTimePickerValue, variation)=>{
    if (dateTimePickerValue) {
        const { type: type, value: value } = dateTimePickerValue;
        const typeConfig = $7ebee7f0dd6ca187$var$getFilterTypes(variation).find((f)=>f.type === type);
        const hasValuePresent = $7ebee7f0dd6ca187$var$hasValue({
            type: type,
            value: value
        });
        if (!hasValuePresent) return undefined;
        if (typeConfig) {
            if (typeConfig.type === (0, $cv9D1.NowOverdue)) return typeConfig.getJqlData();
            if (value) return typeConfig.getJqlData(value);
        }
    }
    return undefined;
};
const $7ebee7f0dd6ca187$export$f82c5f277c92418 = (variation, jqlData)=>{
    const possibleValues = $7ebee7f0dd6ca187$var$getFilterTypes(variation).map((typeConfig)=>{
        const value = typeConfig.getValueFromJqlData(jqlData);
        if (value) return {
            type: typeConfig.type,
            value: value
        };
        return undefined;
    }).filter(Boolean);
    if (possibleValues.length > 0) return possibleValues[0];
    return undefined;
};
const $7ebee7f0dd6ca187$export$82f46aa4e6535a45 = (intl, dateTimePickerValue, variation)=>{
    if (dateTimePickerValue) {
        const typeConfig = $7ebee7f0dd6ca187$var$getFilterTypes(variation).filter((filterType)=>filterType.type === dateTimePickerValue.type)[0];
        if (dateTimePickerValue && typeConfig && typeConfig.getErrorMessage) return typeConfig.getErrorMessage(intl, dateTimePickerValue.value);
    }
    return undefined;
};
const $7ebee7f0dd6ca187$export$66bd7052943865c8 = (variation, primaryClause, secondaryClause)=>{
    const jqlData = primaryClause === undefined && secondaryClause === undefined ? undefined : {
        primaryClause: primaryClause !== undefined && primaryClause.operator && primaryClause.operand && primaryClause.operand.operandType === (0, $49b29ef7baa2a152$export$38accfc5a5d1c113) ? {
            operator: primaryClause.operator.value,
            operand: (0, $8sS9o.removeSurroundingQuotes)(primaryClause.operand.text)
        } : undefined,
        secondaryClause: secondaryClause !== undefined && secondaryClause.operator && secondaryClause.operand && secondaryClause.operand.operandType === (0, $49b29ef7baa2a152$export$38accfc5a5d1c113) ? {
            operator: secondaryClause.operator.value,
            operand: (0, $8sS9o.removeSurroundingQuotes)(secondaryClause.operand.text)
        } : undefined
    };
    return $7ebee7f0dd6ca187$export$f82c5f277c92418(variation, jqlData);
};
const $7ebee7f0dd6ca187$var$fieldsetStyles = (0, $8CUq3.xcss)({
    border: 'none',
    margin: 'space.0',
    paddingBlockStart: 'space.200',
    paddingBlockEnd: 'space.100',
    paddingInlineStart: 'space.150',
    paddingInlineEnd: 'space.150'
});
const $7ebee7f0dd6ca187$var$legendStyles = (0, $8CUq3.xcss)({
    width: '1px',
    height: '1px',
    padding: 'space.0',
    position: 'absolute',
    border: 'none',
    clip: 'rect(1px, 1px, 1px, 1px)',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});
const $7ebee7f0dd6ca187$var$buttonWrapperStyle = (0, $8CUq3.xcss)({
    borderTop: `1px solid ${"var(--ds-border, #091E4224)"}`,
    paddingInlineStart: 'space.150',
    paddingBlockStart: 'space.075',
    paddingBlockEnd: 'space.075'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $7ebee7f0dd6ca187$var$StyledOptionContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyrpxbi _1tke1ou6 _dmhjze3t",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $7ebee7f0dd6ca187$var$ErrorContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _18u01ejb _19pk1b66 _syaz1tmw _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $7ebee7f0dd6ca187$var$StyledDialogInner = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbxilx",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8sS9o", function(module, exports) {

$parcel$export(module.exports, "removeSurroundingQuotes", () => $2f0f6e38ba8fb238$export$8de447c869ac6d85);

var $eK6AG = parcelRequire("eK6AG");
const $2f0f6e38ba8fb238$export$5378ca09aae39be8 = (jql, fieldIdentifier)=>{
    const ast = new (0, $eK6AG.JastBuilder)().build(jql);
    const fieldsToReturn = [];
    if (ast && ast.query && ast.query.where) {
        if (ast.query.where.clauseType === (0, $e9a0ef16a223cbc7$export$7a58b23488ea076b)) ast.query.where.clauses.forEach((clause)=>{
            if (clause.clauseType === (0, $e9a0ef16a223cbc7$export$ae56b4ef248a2b6a)) {
                const fieldId = clause.field.value.toLowerCase();
                if (fieldIdentifier.toLowerCase() === fieldId) fieldsToReturn.push(clause);
            }
        });
        else if (ast.query.where.clauseType === (0, $e9a0ef16a223cbc7$export$ae56b4ef248a2b6a)) {
            const fieldId = ast.query.where.field.value.toLowerCase();
            if (fieldIdentifier.toLowerCase() === fieldId) {
                if (ast.query && ast.query.where) fieldsToReturn.push(ast.query.where);
            }
        }
    }
    return fieldsToReturn;
};
const $2f0f6e38ba8fb238$export$8de447c869ac6d85 = (maybeQuotedString)=>maybeQuotedString.replace(/^["']|["']$/g, '');

});

parcelRegister("hBIsZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb2b1ac34000a357$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jovBr = parcelRequire("jovBr");

var $eZDAP = parcelRequire("eZDAP");

var $7qZ1x = parcelRequire("7qZ1x");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $6yeNV = parcelRequire("6yeNV");

var $DVljb = parcelRequire("DVljb");

var $iQsVU = parcelRequire("iQsVU");

var $caKWk = parcelRequire("caKWk");
const $cb2b1ac34000a357$var$ONE_DAY_IN_MILLISECONDS = 86400000;
const $cb2b1ac34000a357$var$isDateValueInvalid = (value)=>!(0, $jovBr.default)((0, $eZDAP.default)(value)) && value !== '';
const $cb2b1ac34000a357$var$BetweenDateTime = ({ value: { value1: value1, value2: value2 }, onChange: onChange })=>{
    const locale = (0, $DVljb.useLocale)();
    const standardizedLocale = (0, $6yeNV.standardizeLocale)(locale);
    const [localizationProvider] = (0, $5uXOq.useState)((0, $7qZ1x.createLocalizationProvider)(standardizedLocale));
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onChangeValue1Date = (0, $5uXOq.useCallback)((value)=>{
        onChange({
            value1: value,
            value2: value2
        });
    }, [
        onChange,
        value2
    ]);
    const onChangeValue2Date = (0, $5uXOq.useCallback)((value)=>{
        onChange({
            value1: value1,
            value2: value
        });
    }, [
        onChange,
        value1
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $cb2b1ac34000a357$var$wrapperStyles,
        paddingBlockStart: "space.075",
        paddingInlineStart: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iQsVU.DateTimePicker), {
        locale: standardizedLocale,
        onChange: onChangeValue1Date,
        isInvalid: $cb2b1ac34000a357$var$isDateValueInvalid(value1),
        dateLabel: formatMessage((0, $caKWk.default).startDateLabel),
        placeholder: localizationProvider.formatDate(new Date(new Date().getTime() - $cb2b1ac34000a357$var$ONE_DAY_IN_MILLISECONDS)),
        value: !$cb2b1ac34000a357$var$isDateValueInvalid(value1) ? value1 : '',
        testId: "jql-builder-basic-datetime.ui.between-date-time.value-1",
        timeLabel: formatMessage((0, $caKWk.default).startTimeLabel),
        defaultTime: "00:00"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage((0, $caKWk.default).and)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iQsVU.DateTimePicker), {
        locale: standardizedLocale,
        isInvalid: $cb2b1ac34000a357$var$isDateValueInvalid(value2),
        onChange: onChangeValue2Date,
        dateLabel: formatMessage((0, $caKWk.default).endDateLabel),
        placeholder: localizationProvider.formatDate(new Date(new Date().getTime() + $cb2b1ac34000a357$var$ONE_DAY_IN_MILLISECONDS)),
        value: !$cb2b1ac34000a357$var$isDateValueInvalid(value2) ? value2 : '',
        testId: "jql-builder-basic-datetime.ui.between-date-time.value-2",
        timeLabel: formatMessage((0, $caKWk.default).endTimeLabel),
        defaultTime: "23:59"
    })));
};
var $cb2b1ac34000a357$export$2e2bcd8739ae039 = $cb2b1ac34000a357$var$BetweenDateTime;
const $cb2b1ac34000a357$var$wrapperStyles = (0, $8CUq3.xcss)({
    width: '265px'
});

});
parcelRegister("7qZ1x", function(module, exports) {

$parcel$export(module.exports, "createLocalizationProvider", () => $71bdd27445bf5301$export$ea56ca58f08ffa52);

var $lCAti = parcelRequire("lCAti");

var $is0Fy = parcelRequire("is0Fy");

var $1cWOp = parcelRequire("1cWOp");
const $71bdd27445bf5301$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $lCAti.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date, options = {})=>(0, $is0Fy.createDateParser)(normalizedLocale)(date, options);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
		 * Safari has a bug that returns the wrong month for years 2005 and before.
		 * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
		 * Not all the months fail in each year. To ensure the correct output,
		 * we select 2020 as the base year for the whole date,
		 * then we replace in the result the original input year
		 */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $1cWOp.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $1cWOp.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
		 * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
		 * We fix it by detecting the real time with getHours method
		 */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};

});
parcelRegister("lCAti", function(module, exports) {

$parcel$export(module.exports, "normalizeLocale", () => $13af55a9724edafd$export$dca0327c9b9c6498);
const $13af55a9724edafd$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');

});

parcelRegister("is0Fy", function(module, exports) {

$parcel$export(module.exports, "createDateParser", () => $d8bb223589902df4$export$cfa2ef2687faeda2);

var $lCAti = parcelRequire("lCAti");

var $3wYKB = parcelRequire("3wYKB");
const $d8bb223589902df4$var$INVALID_DATE = new Date(NaN);
const $d8bb223589902df4$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $d8bb223589902df4$var$INVARIANT_DATE = (0, $3wYKB.toDate)($d8bb223589902df4$var$INVARIANT);
const $d8bb223589902df4$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $d8bb223589902df4$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $d8bb223589902df4$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $d8bb223589902df4$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $d8bb223589902df4$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $lCAti.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($d8bb223589902df4$var$INVARIANT_DATE);
    const shortDate = $d8bb223589902df4$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($d8bb223589902df4$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $d8bb223589902df4$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.day);
    return (date, options = {})=>{
        const dateMatch = $d8bb223589902df4$var$stripExtras(date).match($d8bb223589902df4$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $d8bb223589902df4$var$INVALID_DATE;
        const dateParts = $d8bb223589902df4$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $3wYKB.normalizeDate)(extractedDate, options?.defaultFirstDay);
        if (!(0, $3wYKB.isValid)(normalizedDate)) return $d8bb223589902df4$var$INVALID_DATE;
        return (0, $3wYKB.toDate)(normalizedDate);
    };
};

});
parcelRegister("3wYKB", function(module, exports) {

$parcel$export(module.exports, "toDate", () => $121d324fc62f760d$export$e67a095c620b86fe);
$parcel$export(module.exports, "isValid", () => $121d324fc62f760d$export$1ea939691cdc45b8);
$parcel$export(module.exports, "normalizeDate", () => $121d324fc62f760d$export$fcc71269590ba0a8);
/**
 * A numerical representation of a date:
 *  - year: any positive integer
 *  - month: 1 - 12 (Jan - Dec)
 *  - day: 1 - [28, 29, 30, 31] (depending on month)
 */ const $121d324fc62f760d$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
const $121d324fc62f760d$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
const $121d324fc62f760d$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
const $121d324fc62f760d$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && $121d324fc62f760d$export$553d7fa8e3805fc0(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
const $121d324fc62f760d$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = $121d324fc62f760d$export$f645ddd439eb259d(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
const $121d324fc62f760d$export$fcc71269590ba0a8 = (date, defaultFirstDay = false)=>{
    const now = $121d324fc62f760d$export$abe96da78d4f59dd(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : month !== 0 && defaultFirstDay ? 1 : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};

});


parcelRegister("1cWOp", function(module, exports) {

$parcel$export(module.exports, "toFormattedParts", () => $56bd04270448c035$export$9b7ca29af37c192);
const $56bd04270448c035$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});

});


parcelRegister("6yeNV", function(module, exports) {

$parcel$export(module.exports, "standardizeLocale", () => $e3b19be89da6c3f8$export$ca06804549ae25fb);
$parcel$export(module.exports, "verifyTimeZone", () => $e3b19be89da6c3f8$export$93ff13646da25bd);

var $lzeFL = parcelRequire("lzeFL");

var $2YZCu = parcelRequire("2YZCu");
const $e3b19be89da6c3f8$export$95b7602913551865 = 'en-US';
const $e3b19be89da6c3f8$export$ca06804549ae25fb = (jiraLocale)=>{
    if (typeof jiraLocale !== 'string') {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jira-issue-format-date.standardize-locale', `Invalid input type for locale was passed in: ${jiraLocale}. Falling back to ${$e3b19be89da6c3f8$export$95b7602913551865}.`);
        return $e3b19be89da6c3f8$export$95b7602913551865;
    }
    const standardizedLocale = jiraLocale.replace('_', '-');
    switch(standardizedLocale){
        case 'en':
            return 'en-US';
        case 'en-UK':
            return 'en-GB';
        default:
            if (!(0, $lzeFL.default).includes(jiraLocale)) (0, $2YZCu.default).safeWarnWithoutCustomerData('jira-issue-format-date.standardize-locale', `Discovered unsupported locale: ${jiraLocale}. This value was not modified, but its use may lead to unpredictable behaviour for formatting.`);
            return standardizedLocale;
    }
};
const $e3b19be89da6c3f8$export$93ff13646da25bd = (timeZone)=>{
    try {
        Intl.DateTimeFormat($e3b19be89da6c3f8$export$95b7602913551865, {
            timeZone: timeZone
        });
        return timeZone;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jira-issue-format-date.verify-time-zone', `Invalid timeZone: ${String(timeZone)}. Date time formatting cannot be performed with this value. Falling back to undefined`, error);
        return undefined;
    }
};

});

parcelRegister("iQsVU", function(module, exports) {

$parcel$export(module.exports, "DateTimePicker", () => $a62cb30aee9ba03a$export$ccdfd7928785632e);

var $5uXOq = parcelRequire("5uXOq");

var $cHapz = parcelRequire("cHapz");
var $jdTq6 = parcelRequire("jdTq6");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $8C78M = parcelRequire("8C78M");

var $jy5cU = parcelRequire("jy5cU");
const $a62cb30aee9ba03a$export$ccdfd7928785632e = ({ locale: locale, isInvalid: isInvalid = false, onChange: onChange, value: value, placeholder: placeholder, dateLabel: dateLabel, timeLabel: timeLabel, testId: testId, defaultTime: defaultTime = '00:00' })=>{
    const [internalDateValue, setInternalDateValue] = (0, $5uXOq.useState)(()=>value ? (0, $jy5cU.parseDateValue)(value) : '');
    const [internalTimeValue, setInternalTimeValue] = (0, $5uXOq.useState)(()=>value ? (0, $jy5cU.parseTimeValue)(value) : '');
    const handleOnDateChange = (0, $5uXOq.useCallback)((dateValue)=>{
        setInternalDateValue(dateValue);
        const parsedDateTime = dateValue ? (0, $jy5cU.parseDateTimeToISO)(dateValue, internalTimeValue || defaultTime) : '';
        onChange(parsedDateTime);
    }, [
        defaultTime,
        internalTimeValue,
        onChange
    ]);
    const handleOnTimeChange = (0, $5uXOq.useCallback)((timeValue)=>{
        setInternalTimeValue(timeValue);
        if (internalDateValue) {
            const parsedDateTime = (0, $jy5cU.parseDateTimeToISO)(internalDateValue, timeValue || defaultTime);
            onChange(parsedDateTime);
        }
    }, [
        defaultTime,
        internalDateValue,
        onChange
    ]);
    const timePlaceholder = (0, $5uXOq.useMemo)(()=>{
        return (0, $jy5cU.getTimePlaceholder)(defaultTime, locale);
    }, [
        defaultTime,
        locale
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $a62cb30aee9ba03a$var$baseContainerStyles,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $a62cb30aee9ba03a$var$datePickerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cHapz.default), {
        locale: locale,
        isInvalid: isInvalid,
        onChange: handleOnDateChange,
        placeholder: placeholder,
        label: dateLabel,
        value: internalDateValue,
        spacing: "compact",
        testId: `${testId}--datepicker`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $a62cb30aee9ba03a$var$timePickerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jdTq6.default), {
        locale: locale,
        isInvalid: isInvalid,
        onChange: handleOnTimeChange,
        label: timeLabel,
        value: internalTimeValue,
        spacing: "compact",
        timeIsEditable: true,
        times: (0, $8C78M.default),
        testId: `${testId}--timepicker`,
        placeholder: timePlaceholder
    })));
};
const $a62cb30aee9ba03a$var$datePickerContainerStyles = (0, $8CUq3.xcss)({
    flexBasis: '50%',
    flexGrow: 1,
    flexShrink: 0
});
const $a62cb30aee9ba03a$var$timePickerContainerStyles = (0, $8CUq3.xcss)({
    flexBasis: '50%',
    flexGrow: 1
});
const $a62cb30aee9ba03a$var$baseContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    gap: 'space.050'
});

});
parcelRegister("cHapz", function(module, exports) {

$parcel$export(module.exports, "default", () => $a844b50b385d50f7$export$2e2bcd8739ae039);

var $VSDnB = parcelRequire("VSDnB");

var $cKsfY = parcelRequire("cKsfY");

var $2TI0z = parcelRequire("2TI0z");

var $jcbUF = parcelRequire("jcbUF");
const $a844b50b385d50f7$var$DatePicker = (0, $cKsfY.componentWithCondition)(()=>(0, $VSDnB.fg)('dst-date-picker-use-functional-component'), (0, $jcbUF.default), (0, $2TI0z.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a844b50b385d50f7$export$2e2bcd8739ae039 = $a844b50b385d50f7$var$DatePicker;

});
parcelRegister("cKsfY", function(module, exports) {

$parcel$export(module.exports, "componentWithCondition", () => $8f027f90da2b6bac$export$6e8ea24b15199873);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $8f027f90da2b6bac$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>condition() ? /*#__PURE__*/ (0, $2OMIu.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    return ComponentWithCondition;
}

});

parcelRegister("2TI0z", function(module, exports) {

$parcel$export(module.exports, "default", () => $19201d0a1f7d7d54$export$2e2bcd8739ae039);
/* date-picker-class.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $gB4mS = parcelRequire("gB4mS");
var $994MI = parcelRequire("994MI");
var $cb25w = parcelRequire("cb25w");

var $42CjB = parcelRequire("42CjB");

var $3JT92 = parcelRequire("3JT92");

var $9KnKW = parcelRequire("9KnKW");

var $acknU = parcelRequire("acknU");

var $7qZ1x = parcelRequire("7qZ1x");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $7K5PP = parcelRequire("7K5PP");
var $7VXAu = parcelRequire("7VXAu");

var $jHBnA = parcelRequire("jHBnA");

var $5RLF6 = parcelRequire("5RLF6");

var $iaQLg = parcelRequire("iaQLg");

var $gtijU = parcelRequire("gtijU");

var $6AqCE = parcelRequire("6AqCE");

var $dBs4v = parcelRequire("dBs4v");
const $19201d0a1f7d7d54$var$packageName = "platform-pkg";
const $19201d0a1f7d7d54$var$packageVersion = "0.0.0-use.local";
const $19201d0a1f7d7d54$var$datePickerDefaultProps = {
    defaultIsOpen: false,
    defaultValue: '',
    disabled: [],
    disabledDateFilter: (_)=>false,
    locale: 'en-US',
    // These disables are here for proper typing when used as defaults. They
    // should *not* use the `noop` function.
    /* eslint-disable @repo/internal/react/use-noop */ onBlur: (_event)=>{},
    onChange: (_value)=>{},
    onFocus: (_event)=>{} /* eslint-enable @repo/internal/react/use-noop */ 
};
const $19201d0a1f7d7d54$var$styles = {
    pickerContainerStyles: "_kqswh2mm",
    iconContainerStyles: "_v564vrg3 _1e0c1txw _4t3i1osq _kqswstnw _4cvr1h6o _i0dl1kw7 _syaz131l _152tze3t _rjxpze3t _30l31gjq",
    iconSpacingWithClearButtonStyles: "_12l2xy5q",
    iconSpacingWithoutClearButtonStyles: "_12l21b66",
    dropdownIndicatorStyles: "_1ul91k8s _1tke1k8s _1e0c1txw _4cvr1h6o _1bah1h6o"
}; // eslint-disable-next-line @repo/internal/react/no-class-components
class $19201d0a1f7d7d54$export$df43d21f5faca9f7 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = $19201d0a1f7d7d54$var$datePickerDefaultProps;
    }
    constructor(props){
        super(props), this.containerRef = null, this.calendarRef = /*#__PURE__*/ (0, $5uXOq.createRef)(), this.calendarButtonRef = /*#__PURE__*/ (0, $5uXOq.createRef)(), // correctly to allow controlled/uncontrolled usage.
        this.getValue = ()=>this.props.value ?? this.state.value, this.getIsOpen = ()=>this.props.isOpen ?? this.state.isOpen, this.onCalendarChange = ({ iso: iso })=>{
            this.setState({
                calendarValue: (0, $5RLF6.getParsedISO)({
                    iso: iso
                })
            });
        }, this.onCalendarSelect = ({ iso: iso })=>{
            this.setState({
                selectInputValue: '',
                isOpen: false,
                calendarValue: iso,
                value: iso,
                wasOpenedFromCalendarButton: false
            });
            this.props.onChange(iso); // Yes, this is not ideal. The alternative is to be able to place a ref
            // on the inner input of Select itself, which would require a lot of
            // extra stuff in the Select component for only this one thing. While
            // this would be more "React-y", it doesn't seem to pose any other
            // benefits. Performance-wise, we are only searching within the
            // container, so it's quick.
            if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
            else {
                const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                innerCombobox?.focus();
            }
            this.setState({
                isOpen: false
            });
        }, this.onInputClick = ()=>{
            if (!this.props.isDisabled && !this.getIsOpen()) this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
        }, this.onContainerBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (!this.containerRef?.contains(newlyFocusedElement)) {
                this.setState({
                    isOpen: false,
                    shouldSetFocusOnCurrentDay: false,
                    wasOpenedFromCalendarButton: false
                });
                this.props.onBlur(event);
            }
        }, this.onContainerFocus = ()=>{
            this.setState({
                shouldSetFocusOnCurrentDay: false
            });
        }, this.onSelectBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (this.state.clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else if (!this.containerRef?.contains(newlyFocusedElement)) // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            this.setState({
                isOpen: false,
                isFocused: false,
                wasOpenedFromCalendarButton: false
            });
        }, this.onSelectFocus = (event)=>{
            const { clearingFromIcon: clearingFromIcon } = this.state;
            const value = this.getValue();
            if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else this.setState({
                // Don't open when focused into via keyboard if the calendar button is present
                isOpen: !this.props.shouldShowCalendarButton,
                calendarValue: value,
                isFocused: true,
                wasOpenedFromCalendarButton: false
            });
            this.props.onFocus(event);
        }, this.onTextInput = (event)=>{
            const inputValue = event.target.value;
            if (inputValue) {
                const parsed = (0, $5RLF6.parseDate)(inputValue, {
                    parseInputValue: this.props.parseInputValue,
                    dateFormat: this.props.dateFormat,
                    l10n: this.state.l10n
                }); // Only try to set the date if we have month & day
                if (parsed && (0, $jovBr.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
                // this is the format expected by the @atlaskit/calendar component
                this.setState({
                    calendarValue: (0, $6AqCE.getShortISOString)(parsed)
                });
            }
            this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
        }, this.onInputKeyDown = (event)=>{
            const { calendarValue: calendarValue } = this.state;
            const value = this.getValue();
            const keyPressed = event.key.toLowerCase(); // If the input is focused and the calendar is not visible, handle space and enter clicks
            if (!this.state.isOpen && (keyPressed === 'enter' || keyPressed === ' ')) this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
            switch(keyPressed){
                case 'escape':
                    // Yes, this is not ideal. The alternative is to be able to place a ref
                    // on the inner input of Select itself, which would require a lot of
                    // extra stuff in the Select component for only this one thing. While
                    // this would be more "React-y", it doesn't seem to pose any other
                    // benefits. Performance-wise, we are only searching within the
                    // container, so it's quick.
                    if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
                    else {
                        const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                        innerCombobox?.focus();
                    }
                    this.setState({
                        isOpen: false,
                        shouldSetFocusOnCurrentDay: false,
                        wasOpenedFromCalendarButton: false
                    });
                    break;
                case 'backspace':
                case 'delete':
                    {
                        const inputCount = 0;
                        if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) // If being cleared from keyboard, don't change behaviour
                        this.setState({
                            clearingFromIcon: false,
                            value: ''
                        });
                        break;
                    }
                case 'enter':
                    if (!this.state.isOpen) return;
                     // Prevent form submission when a date is selected
                    // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                    // for more details.
                    event.preventDefault();
                    if (!(0, $5RLF6.isDateDisabled)(calendarValue, {
                        disabled: this.props.disabled
                    })) {
                        // Get a safe `calendarValue` in case the value exceeds the maximum
                        // allowed by ISO 8601
                        const safeCalendarValue = (0, $6AqCE.getSafeCalendarValue)(calendarValue);
                        const valueChanged = safeCalendarValue !== value;
                        this.setState({
                            selectInputValue: '',
                            isOpen: false,
                            value: safeCalendarValue,
                            calendarValue: safeCalendarValue,
                            wasOpenedFromCalendarButton: false
                        });
                        if (valueChanged) this.props.onChange(safeCalendarValue);
                    }
                    break;
                case 'arrowdown':
                case 'arrowup':
                    if (!this.state.shouldSetFocusOnCurrentDay) this.setState({
                        isOpen: true,
                        shouldSetFocusOnCurrentDay: true
                    });
                    break;
                default:
                    break;
            }
        }, this.onCalendarButtonKeyDown = (e)=>{
            // Don't allow an arrow up or down to open the menu, since the input key
            // down handler is actually on the parent.
            if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
             // We want to stop this from triggering other keydown events, particularly
            // for space and enter presses. Otherwise, it opens and then closes
            // immediately.
            if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
                e.stopPropagation();
                this.setState({
                    isKeyDown: true,
                    wasOpenedFromCalendarButton: true
                });
            }
        } // This event handler is triggered from both keydown and click. It's weird.
        , this.onCalendarButtonClick = (e)=>{
            this.setState({
                isOpen: !this.state.isOpen,
                wasOpenedFromCalendarButton: true
            }, ()=>{
                // We don't want the focus to move if this is a click event
                if (!this.state.isKeyDown) return;
                this.setState({
                    isKeyDown: false
                }); // Focus on the first button within the calendar
                this.calendarRef?.current?.querySelector('button')?.focus();
            });
            e.stopPropagation();
        }, this.onClear = ()=>{
            let changedState = {
                value: '',
                calendarValue: this.props.defaultValue || (0, $6AqCE.getShortISOString)(new Date())
            };
            if (!this.props.hideIcon) changedState = {
                ...changedState,
                clearingFromIcon: true
            };
            this.setState(changedState);
            this.props.onChange('');
        } // `unknown` is used because `value` is unused so it does not matter.
        , this.onSelectChange = (_value, action)=>{
            // Used for native clear event in React Select
            // Triggered when clicking ClearIndicator or backspace with no value
            if (action.action === 'clear') this.onClear();
        }, this.handleSelectInputChange = (selectInputValue, actionMeta)=>{
            const onInputChange = this.props.selectProps?.onInputChange;
            if (onInputChange) onInputChange(selectInputValue, actionMeta);
            this.setState({
                selectInputValue: selectInputValue
            });
        }, this.getContainerRef = (ref)=>{
            const oldRef = this.containerRef;
            this.containerRef = ref; // Cause a re-render if we're getting the container ref for the first time
            // as the layered menu requires it for dimension calculation
            if (oldRef == null && ref != null) this.forceUpdate();
        };
        this.state = {
            isKeyDown: false,
            isOpen: this.props.defaultIsOpen,
            isFocused: false,
            clearingFromIcon: false,
            selectInputValue: this.props.selectProps?.inputValue || '',
            value: this.props.value || this.props.defaultValue,
            calendarValue: this.props.value || this.props.defaultValue || (0, $6AqCE.getShortISOString)(new Date()),
            l10n: (0, $7qZ1x.createLocalizationProvider)(this.props.locale),
            locale: this.props.locale,
            shouldSetFocusOnCurrentDay: false,
            wasOpenedFromCalendarButton: false
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.locale !== prevState.locale) return {
            l10n: (0, $7qZ1x.createLocalizationProvider)(nextProps.locale),
            locale: nextProps.locale
        };
        else return null;
    }
    render() {
        const { appearance: appearance = 'default', 'aria-describedby': ariaDescribedBy, autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', disabled: disabled, disabledDateFilter: disabledDateFilter, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($acknU))), id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', locale: locale, maxDate: maxDate, minDate: minDate, name: name = '', nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', testId: testId, weekStartDay: weekStartDay } = this.props;
        const { calendarValue: calendarValue, selectInputValue: selectInputValue } = this.state;
        const value = this.getValue();
        let actualSelectInputValue;
        actualSelectInputValue = selectInputValue;
        const menuIsOpen = this.getIsOpen() && !isDisabled;
        const showClearIndicator = Boolean((value || selectInputValue) && !hideIcon);
        let clearIndicator = Icon; // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons')) clearIndicator = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                xcss: $19201d0a1f7d7d54$var$styles.dropdownIndicatorStyles,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                    ...props
                })
            });
        const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
        const SingleValue = (0, $dBs4v.makeSingleValue)({
            lang: this.props.locale
        });
        const selectComponents = {
            DropdownIndicator: shouldShowCalendarButton ? (0, $jHBnA.EmptyComponent) : dropDownIcon,
            // Only use this new container component if the calendar button is shown.
            // Otherwise, it throws errors downstream for some reason
            ...shouldShowCalendarButton ? {
                IndicatorsContainer: (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $iaQLg.IndicatorsContainer), {
                        ...props,
                        showClearIndicator: showClearIndicator
                    })
            } : {},
            Menu: $gtijU.Menu,
            SingleValue: SingleValue,
            ...!showClearIndicator && {
                ClearIndicator: (0, $jHBnA.EmptyComponent)
            },
            ...selectProps.components
        };
        const { styles: selectStyles = {} } = selectProps;
        const disabledStyle = isDisabled ? {
            pointerEvents: 'none',
            color: "var(--ds-icon-disabled, inherit)"
        } : {};
        const calendarProps = {
            calendarContainerRef: this.containerRef,
            calendarDisabled: disabled,
            calendarDisabledDateFilter: disabledDateFilter,
            calendarMaxDate: maxDate,
            calendarMinDate: minDate,
            calendarRef: this.calendarRef,
            calendarValue: value && (0, $6AqCE.getShortISOString)((0, $eZDAP.default)(value)),
            calendarView: calendarValue,
            onCalendarChange: this.onCalendarChange,
            onCalendarSelect: this.onCalendarSelect,
            calendarLocale: locale,
            calendarWeekStartDay: weekStartDay,
            shouldSetFocusOnCurrentDay: this.state.shouldSetFocusOnCurrentDay,
            menuInnerWrapper: this.props.menuInnerWrapper
        }; // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
        const mergedStyles = (0, $7VXAu.mergeStyles)(selectStyles, {
            control: (base)=>({
                    ...base,
                    ...disabledStyle
                }),
            indicatorsContainer: (base)=>({
                    ...base,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    // ICON_PADDING = 2
                    paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
                })
        });
        const initialValue = value ? {
            label: (0, $5RLF6.formatDate)(value, {
                formatDisplayLabel: this.props.formatDisplayLabel,
                dateFormat: this.props.dateFormat,
                l10n: this.state.l10n
            }),
            value: value
        } : null; // `label` takes precedence of the `inputLabel`
        const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel}, ${openCalendarLabel}` : openCalendarLabel;
        return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            ...innerProps,
            role: "presentation",
            onBlur: this.onContainerBlur,
            onFocus: this.onContainerFocus,
            onClick: this.onInputClick,
            onInput: this.onTextInput,
            onKeyDown: this.onInputKeyDown,
            ref: this.getContainerRef,
            "data-testid": testId && `${testId}--container`,
            className: (0, $bwpsq.default)([
                $19201d0a1f7d7d54$var$styles.pickerContainerStyles
            ]),
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: value,
                    "data-testid": testId && `${testId}--input`
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7K5PP.default), {
                    appearance: this.props.appearance,
                    "aria-describedby": ariaDescribedBy,
                    label: label || undefined,
                    autoFocus: autoFocus,
                    clearControlLabel: clearControlLabel,
                    closeMenuOnSelect: true,
                    enableAnimation: false,
                    inputId: id,
                    inputValue: actualSelectInputValue,
                    isDisabled: isDisabled,
                    isRequired: isRequired,
                    menuIsOpen: menuIsOpen,
                    onBlur: this.onSelectBlur,
                    onChange: this.onSelectChange,
                    onFocus: this.onSelectFocus,
                    onInputChange: this.handleSelectInputChange,
                    placeholder: (0, $5RLF6.getPlaceholder)({
                        placeholder: this.props.placeholder,
                        l10n: this.state.l10n
                    }),
                    styles: mergedStyles,
                    value: initialValue,
                    ...selectProps,
                    // up when you alter some of the properties in the `selectComponents`
                    // object. These errors are still present, and I suspect have always
                    // been present, without changing the unrelated code. Ignoring as the
                    // component still works as expected despite this error. And also
                    // because the select refresh team may solve it later.
                    components: selectComponents,
                    // selectProps or not and what wil be overwritten
                    isClearable: true,
                    isInvalid: isInvalid,
                    spacing: spacing,
                    testId: testId,
                    // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
                    calendarContainerRef: calendarProps.calendarContainerRef,
                    calendarDisabled: calendarProps.calendarDisabled,
                    calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
                    calendarLocale: calendarProps.calendarLocale,
                    calendarMaxDate: calendarProps.calendarMaxDate,
                    calendarMinDate: calendarProps.calendarMinDate,
                    calendarRef: calendarProps.calendarRef,
                    calendarValue: calendarProps.calendarValue,
                    calendarView: calendarProps.calendarView,
                    calendarWeekStartDay: calendarProps.calendarWeekStartDay,
                    nextMonthLabel: nextMonthLabel,
                    onCalendarChange: calendarProps.onCalendarChange,
                    onCalendarSelect: calendarProps.onCalendarSelect,
                    previousMonthLabel: previousMonthLabel,
                    shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay,
                    menuInnerWrapper: calendarProps.menuInnerWrapper
                }),
                shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9KnKW.IdProvider), {
                    prefix: "open-calendar-label--",
                    children: ({ id: openCalendarLabelId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                            xcss: (0, $3JT92.cx)($19201d0a1f7d7d54$var$styles.iconContainerStyles, value && !hideIcon ? $19201d0a1f7d7d54$var$styles.iconSpacingWithClearButtonStyles : $19201d0a1f7d7d54$var$styles.iconSpacingWithoutClearButtonStyles),
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                                appearance: "subtle",
                                label: !inputLabelId ? fullopenCalendarLabel : openCalendarLabel,
                                "aria-labelledby": inputLabelId ? `${inputLabelId} ${openCalendarLabelId}` : undefined,
                                id: openCalendarLabelId,
                                icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acknU))), {
                                        ...iconProps,
                                        color: "var(--ds-icon, #44546F)"
                                    }),
                                onClick: this.onCalendarButtonClick,
                                onKeyDown: this.onCalendarButtonKeyDown,
                                ref: this.calendarButtonRef,
                                testId: testId && `${testId}--open-calendar-button`
                            })
                        })
                }) : null
            ]
        });
    }
}
const $19201d0a1f7d7d54$var$DatePicker = (0, $994MI.default)({
    componentName: 'datePicker',
    packageName: $19201d0a1f7d7d54$var$packageName,
    packageVersion: $19201d0a1f7d7d54$var$packageVersion
})((0, $cb25w.default)({
    onChange: (0, $gB4mS.default)('atlaskit')({
        action: 'selectedDate',
        actionSubject: 'datePicker',
        attributes: {
            componentName: 'datePicker',
            packageName: $19201d0a1f7d7d54$var$packageName,
            packageVersion: $19201d0a1f7d7d54$var$packageVersion
        }
    })
})($19201d0a1f7d7d54$export$df43d21f5faca9f7));
var $19201d0a1f7d7d54$export$2e2bcd8739ae039 = $19201d0a1f7d7d54$var$DatePicker;

});
parcelRegister("acknU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9571ec76557171a7f54748c218c48225>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76cad653a4883392$var$_react = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $76cad653a4883392$var$_calendar = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("3fesp")));

var $76cad653a4883392$var$_calendar2 = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("cTemL")));
function $76cad653a4883392$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CalendarIcon.
 * This component is CalendarIcon, with `UNSAFE_fallbackIcon` set to "CalendarIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $76cad653a4883392$var$CalendarIcon = (props)=>/*#__PURE__*/ $76cad653a4883392$var$_react.default.createElement($76cad653a4883392$var$_calendar.default, Object.assign({
        LEGACY_fallbackIcon: $76cad653a4883392$var$_calendar2.default
    }, props));
$76cad653a4883392$var$CalendarIcon.Name = 'CalendarIconMigration';
var $76cad653a4883392$var$_default = module.exports.default = $76cad653a4883392$var$CalendarIcon;

});
parcelRegister("3fesp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43a4f9fcd22489798c1322bda48936cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25cdfcb8bb836404$var$_react = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $25cdfcb8bb836404$var$_baseNew = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $25cdfcb8bb836404$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25cdfcb8bb836404$var$CalendarIcon = (props)=>/*#__PURE__*/ $25cdfcb8bb836404$var$_react.default.createElement($25cdfcb8bb836404$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$25cdfcb8bb836404$var$CalendarIcon.displayName = 'CalendarIcon';
var $25cdfcb8bb836404$var$_default = module.exports.default = $25cdfcb8bb836404$var$CalendarIcon;

});

parcelRegister("cTemL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9625c3edd02eaf26$var$_react = $9625c3edd02eaf26$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $9625c3edd02eaf26$var$_calendar = $9625c3edd02eaf26$var$_interopRequireDefault((parcelRequire("3fesp")));
function $9625c3edd02eaf26$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9625c3edd02eaf26$var$CalendarIcon = (props)=>/*#__PURE__*/ $9625c3edd02eaf26$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
    }, props, {
        newIcon: $9625c3edd02eaf26$var$_calendar.default
    }));
$9625c3edd02eaf26$var$CalendarIcon.displayName = 'CalendarIcon';
var $9625c3edd02eaf26$var$_default = module.exports.default = $9625c3edd02eaf26$var$CalendarIcon;

});


parcelRegister("jHBnA", function(module, exports) {

$parcel$export(module.exports, "EmptyComponent", () => $91948b176ea23188$export$5e30e9a24d6c1203);
$parcel$export(module.exports, "placeholderDatetime", () => $91948b176ea23188$export$fff8babee5abe3e2);
$parcel$export(module.exports, "defaultTimes", () => $91948b176ea23188$export$b42ffb9f09b1861b);
$parcel$export(module.exports, "defaultTimeFormat", () => $91948b176ea23188$export$9e6d8fcf62256b85);
$parcel$export(module.exports, "defaultDateFormat", () => $91948b176ea23188$export$75032c84f56650eb);
$parcel$export(module.exports, "padToTwo", () => $91948b176ea23188$export$a7de57e5b672ccdb);
$parcel$export(module.exports, "formatDateTimeZoneIntoIso", () => $91948b176ea23188$export$2eeb05a2ecc2ce0a);
/**
 * This component is used to hide portions of Select component.
 */ const $91948b176ea23188$export$5e30e9a24d6c1203 = ()=>null;
const $91948b176ea23188$export$fff8babee5abe3e2 = new Date(1993, 1, 18, 13);
const $91948b176ea23188$export$b42ffb9f09b1861b = [
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00'
];
const $91948b176ea23188$export$9e6d8fcf62256b85 = 'h:mma';
const $91948b176ea23188$export$75032c84f56650eb = 'YYYY/MM/DD';
function $91948b176ea23188$export$a7de57e5b672ccdb(number) {
    return number <= 99 ? `0${number}`.slice(-2) : `${number}`;
}
function $91948b176ea23188$export$2eeb05a2ecc2ce0a(date, time, zone) {
    // 12:00 => 12:00, 1:00 => 01:00
    const needsLeadingZero = /^\d:/;
    const sanitizedTime = needsLeadingZero.test(time) ? `0${time}` : time;
    return `${date}T${sanitizedTime}${zone}`;
}

});

parcelRegister("5RLF6", function(module, exports) {

$parcel$export(module.exports, "isDateDisabled", () => $e0db4b6edb7dbfac$export$d38e7e283938128c);
$parcel$export(module.exports, "getParsedISO", () => $e0db4b6edb7dbfac$export$38db26406d1a1ee2);
$parcel$export(module.exports, "parseDate", () => $e0db4b6edb7dbfac$export$6b862160d295c8e);
$parcel$export(module.exports, "formatDate", () => $e0db4b6edb7dbfac$export$3ae94a2503e890a1);
$parcel$export(module.exports, "getPlaceholder", () => $e0db4b6edb7dbfac$export$d3f5c5e0a5023fa0);
/**
 * Everything in this file is to smooth out the migration of the new date picker
 * (https://product-fabric.atlassian.net/browse/DSP-20682). When that ticket is
 * complete, all of these functions will ilkely be merged back into the date
 * picker. Please do not pre-optimize and put these back into the date picker
 * unless you are working on the DTP Refresh and you have a good reason to do
 * so, thank you!
 *
 * All variables within the `di` objects are dependency injections. They should
 * be read from within the component at the end of the day. But because we are
 * extracting them, we have to inject them in every place manually. When we
 * re-introduce them to the components, we can likely remove the `di` variables
 * and instead use internal variables.
 *
 * If component _only_ has injected variables, it is fully internal and was
 * broken out to be it's own function.
 */ 
var $k7m40 = parcelRequire("k7m40");
var $5I2ju = parcelRequire("5I2ju");
var $eZDAP = parcelRequire("eZDAP");

var $2ucUe = parcelRequire("2ucUe");

var $jHBnA = parcelRequire("jHBnA");
const $e0db4b6edb7dbfac$export$d38e7e283938128c = (date, di)=>{
    const { disabled: disabled } = di;
    return disabled.indexOf(date) > -1;
};
const $e0db4b6edb7dbfac$export$38db26406d1a1ee2 = (di)=>{
    const { iso: iso } = di;
    const [year, month, date] = iso.split('-');
    let newIso = iso;
    const parsedDate = parseInt(date, 10);
    const parsedMonth = parseInt(month, 10);
    const parsedYear = parseInt(year, 10);
    const lastDayInMonth = (0, $5I2ju.default)(new Date(parsedYear, parsedMonth - 1)).getDate();
    if (lastDayInMonth < parsedDate) newIso = `${parsedYear}-${(0, $jHBnA.padToTwo)(parsedMonth)}-${(0, $jHBnA.padToTwo)(lastDayInMonth)}`;
    else newIso = `${parsedYear}-${(0, $jHBnA.padToTwo)(parsedMonth)}-${(0, $jHBnA.padToTwo)(parsedDate)}`;
    return newIso;
};
const $e0db4b6edb7dbfac$export$6b862160d295c8e = (date, di)=>{
    const { parseInputValue: parseInputValue, dateFormat: dateFormat, l10n: l10n } = di;
    if (parseInputValue) return parseInputValue(date, dateFormat || (0, $jHBnA.defaultDateFormat));
    return l10n.parseDate(date);
};
const $e0db4b6edb7dbfac$export$3ae94a2503e890a1 = (value, di)=>{
    const { formatDisplayLabel: formatDisplayLabel, dateFormat: dateFormat, l10n: l10n } = di;
    if (formatDisplayLabel) return formatDisplayLabel(value, dateFormat || (0, $jHBnA.defaultDateFormat));
    const date = (0, $eZDAP.default)(value);
    return dateFormat ? (0, $k7m40.default)(date, (0, $2ucUe.convertTokens)(dateFormat)) : l10n.formatDate(date);
};
const $e0db4b6edb7dbfac$export$d3f5c5e0a5023fa0 = (di)=>{
    const { placeholder: placeholder, l10n: l10n } = di;
    return placeholder || l10n.formatDate((0, $jHBnA.placeholderDatetime));
};

});
parcelRegister("2ucUe", function(module, exports) {

$parcel$export(module.exports, "convertTokens", () => $ca6f20a476eda5dc$export$4d5430175be73d45);
// https://github.com/date-fns/date-fns-upgrade/blob/master/src/v2/convertTokens/index.ts
const $ca6f20a476eda5dc$var$tokensMap = {
    // 'D MMMM': '',
    // 'Do MMMM': '',
    // 'DD MMMM': '',
    M: 'L',
    Mo: 'Mo',
    MM: 'LL',
    MMM: 'LLL',
    MMMM: 'LLLL',
    Q: 'q',
    Qo: 'qo',
    D: 'd',
    Do: 'do',
    DD: 'dd',
    DDD: 'D',
    DDDo: 'Do',
    DDDD: 'DDD',
    d: 'i',
    do: 'io',
    dd: 'iiiiii',
    ddd: 'iii',
    dddd: 'iiii',
    A: 'a',
    a: 'a',
    aa: 'aaaa',
    E: 'i',
    W: 'I',
    Wo: 'Io',
    WW: 'II',
    YY: 'yy',
    YYYY: 'yyyy',
    GG: 'RR',
    GGGG: 'RRRR',
    H: 'H',
    HH: 'HH',
    h: 'h',
    hh: 'hh',
    m: 'm',
    mm: 'mm',
    s: 's',
    ss: 'ss',
    S: 'S',
    SS: 'SS',
    SSS: 'SSS',
    Z: 'xxx',
    ZZ: 'xx',
    X: 't',
    x: 'T'
};
const $ca6f20a476eda5dc$var$v1tokens = Object.keys($ca6f20a476eda5dc$var$tokensMap).sort().reverse();
const $ca6f20a476eda5dc$var$tokensRegExp = new RegExp(// v1 escape string (unsure the purpose of post-pipe capture group)
"(\\[[^\\[]*\\])|(\\\\)?('.+'|" + // All v1 tokens
$ca6f20a476eda5dc$var$v1tokens.join('|') + '|.)', 'g');
function $ca6f20a476eda5dc$export$4d5430175be73d45(format) {
    const tokensCaptures = format.match($ca6f20a476eda5dc$var$tokensRegExp);
    if (!tokensCaptures) return format;
    return tokensCaptures.reduce((parsed, tokenString, index)=>{
        const v2token = $ca6f20a476eda5dc$var$tokensMap[tokenString];
        if (!v2token) {
            const escapedCaptures = tokenString.match(/^\[(.+)\]$/);
            if (escapedCaptures) parsed.escapedTextBuffer.push(escapedCaptures[1]);
            else parsed.escapedTextBuffer.push(tokenString);
        }
        const endOfString = index === tokensCaptures.length - 1;
        if (parsed.escapedTextBuffer.length && (v2token || endOfString)) {
            // This allows double parentheses to be rendered correctly
            // according to date-fns's spec.
            // https://date-fns.org/v2.29.3/docs/format
            //
            // We have to keep the single quote and then remove it because
            // browser support for lookahead/behind is low and causes breaking
            // errors (HOT-104152)
            const filteredEscapedTextBuffer = parsed.escapedTextBuffer.map((token)=>token[0] === "'" && token.slice(-1) === "'" ? token.slice(1, -1) : token).filter((token)=>token !== "'").join('');
            parsed.formatBuffer.push(`'${filteredEscapedTextBuffer}'`);
            parsed.escapedTextBuffer = [];
        }
        if (v2token) parsed.formatBuffer.push(v2token);
        return parsed;
    }, {
        formatBuffer: [],
        escapedTextBuffer: []
    }).formatBuffer.join('');
}

});


parcelRegister("iaQLg", function(module, exports) {

$parcel$export(module.exports, "IndicatorsContainer", () => $d73476b891de3e0c$export$d0ffd7e649cab6f);
/* indicators-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bChGW = parcelRequire("bChGW");
const $d73476b891de3e0c$var$styles = {
    calendarButtonInclusionStyles: "_ahbqxy5q",
    calendarButtonOnlyInclusionStyles: "_ahbq1ejb"
};
const $d73476b891de3e0c$export$d0ffd7e649cab6f = ({ showClearIndicator: showClearIndicator, ...rest })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            showClearIndicator ? $d73476b891de3e0c$var$styles.calendarButtonInclusionStyles : $d73476b891de3e0c$var$styles.calendarButtonOnlyInclusionStyles
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).IndicatorsContainer, {
            ...rest
        })
    });

});

parcelRegister("gtijU", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $e800a879ee1613fc$export$d9b273488cd8ce6f);
/* menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $1f0Hs = parcelRequire("1f0Hs");

var $9MHPe = parcelRequire("9MHPe");

var $avHVh = parcelRequire("avHVh");
/**
 * @param isos A series of ISO dates.
 * @returns The last valid date within the array of ISO strings.
 */ function $e800a879ee1613fc$var$getValidDate(isos) {
    return isos.reduce((acc, iso)=>{
        const date = (0, $eZDAP.default)(iso);
        return (0, $jovBr.default)(date) ? {
            day: date.getDate(),
            month: date.getMonth() + 1,
            year: date.getFullYear()
        } : acc;
    }, {});
}
const $e800a879ee1613fc$var$menuStyles = null;
const $e800a879ee1613fc$export$d9b273488cd8ce6f = ({ selectProps: selectProps, innerProps: innerProps })=>{
    const { calendarValue: calendarValue, calendarView: calendarView, menuInnerWrapper: MenuInnerWrapper } = selectProps;
    const { day: day, month: month, year: year } = $e800a879ee1613fc$var$getValidDate([
        calendarValue,
        calendarView
    ]);
    const onMenuMouseDown = (event)=>{
        if (event.button !== 0) return;
        event.stopPropagation();
        event.preventDefault();
    };
    const Wrapper = typeof MenuInnerWrapper === 'function' ? MenuInnerWrapper : (0, $5uXOq.Fragment);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9MHPe.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $avHVh.default), {
            inputValue: selectProps.inputValue,
            containerRef: selectProps.calendarContainerRef,
            content: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                ...innerProps,
                onMouseDown: onMenuMouseDown,
                className: (0, $bwpsq.default)([
                    "_2rkoglpi _1reo15vq _18m915vq _1pbyowjs _bfhk1bhr _16qs1cd0"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(Wrapper, {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1f0Hs.default), {
                        day: day,
                        month: month,
                        year: year,
                        disabled: selectProps.calendarDisabled,
                        disabledDateFilter: selectProps.calendarDisabledDateFilter,
                        minDate: selectProps.calendarMinDate,
                        maxDate: selectProps.calendarMaxDate,
                        nextMonthLabel: selectProps.nextMonthLabel,
                        onChange: selectProps.onCalendarChange,
                        onSelect: selectProps.onCalendarSelect,
                        previousMonthLabel: selectProps.previousMonthLabel,
                        ref: selectProps.calendarRef,
                        selected: [
                            selectProps.calendarValue
                        ],
                        shouldSetFocusOnCurrentDay: selectProps.shouldSetFocusOnCurrentDay,
                        locale: selectProps.calendarLocale,
                        testId: selectProps.testId && `${selectProps.testId}--calendar`,
                        weekStartDay: selectProps.calendarWeekStartDay
                    })
                })
            }),
            testId: selectProps.testId
        })
    });
};

});
parcelRegister("1f0Hs", function(module, exports) {

$parcel$export(module.exports, "default", () => $16abbcd9b9109722$export$2e2bcd8739ae039);
/* calendar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $9KnKW = parcelRequire("9KnKW");

var $MHKc7 = parcelRequire("MHKc7");
var $414Wj = parcelRequire("414Wj");

var $ePz3p = parcelRequire("ePz3p");

var $lJWdi = parcelRequire("lJWdi");

var $avO9B = parcelRequire("avO9B");

var $iioJV = parcelRequire("iioJV");

var $jihAA = parcelRequire("jihAA");

var $bbnGB = parcelRequire("bbnGB");

var $hbcve = parcelRequire("hbcve");

var $2TGJ3 = parcelRequire("2TGJ3");

var $f9D1v = parcelRequire("f9D1v");

var $9efze = parcelRequire("9efze");
const $16abbcd9b9109722$var$styles = {
    box: "_1e0c1o8l _uiztglyw"
};
const $16abbcd9b9109722$var$analyticsAttributes = {
    componentName: 'calendar',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $16abbcd9b9109722$var$InnerCalendar = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function Calendar({ day: day, defaultDay: defaultDay = 0, defaultMonth: defaultMonth = 0, defaultPreviouslySelected: defaultPreviouslySelected = (0, $iioJV.blankStringArray), defaultSelected: defaultSelected = (0, $iioJV.blankStringArray), defaultYear: defaultYear = 0, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDate, maxDate: maxDate, month: month, nextMonthLabel: nextMonthLabel, onBlur: onBlur = (0, $eGmKJ.default), onChange: onChange = (0, $eGmKJ.default), onFocus: onFocus = (0, $eGmKJ.default), onSelect: onSelect = (0, $eGmKJ.default), previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay = false, today: today, locale: locale = 'en-US', year: year, analyticsContext: analyticsContext, weekStartDay: weekStartDay = 0, testId: testId, className: className, style: style, tabIndex: tabIndex = 0 }, ref) {
    const { day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], today: [todayValue], selected: [selectedValue, setSelectedValue], previous: [previouslySelectedValue, setPreviouslySelectedValue] } = (0, $jihAA.default)({
        day: day,
        defaultDay: defaultDay,
        month: month,
        defaultMonth: defaultMonth,
        year: year,
        defaultYear: defaultYear,
        today: today,
        selected: selected,
        defaultSelected: defaultSelected,
        previouslySelected: previouslySelected,
        defaultPreviouslySelected: defaultPreviouslySelected
    });
    const [shouldSetFocus, setShouldSetFocus] = (0, $5uXOq.useState)(false);
    const onChangeWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        ...$16abbcd9b9109722$var$analyticsAttributes
    });
    const { navigate: navigate, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear } = (0, $2TGJ3.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        shouldSetFocus: [
            shouldSetFocus,
            setShouldSetFocus
        ],
        onChange: onChangeWithAnalytics
    });
    const onSelectWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onSelect,
        action: 'selected',
        analyticsData: analyticsContext,
        ...$16abbcd9b9109722$var$analyticsAttributes
    });
    const { handleClickDay: handleClickDay, handleContainerKeyDown: handleContainerKeyDown } = (0, $f9D1v.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            ,
            setPreviouslySelectedValue
        ],
        onSelect: onSelectWithAnalytics,
        navigate: navigate
    });
    const { handleContainerBlur: handleContainerBlur, handleContainerFocus: handleContainerFocus } = (0, $bbnGB.default)({
        onFocus: onFocus,
        onBlur: onBlur
    });
    const { monthsLong: monthsLong, daysShort: daysShort, daysLong: daysLong } = (0, $9efze.default)({
        locale: locale,
        weekStartDay: weekStartDay
    });
    const weeks = (0, $hbcve.default)({
        day: dayValue,
        month: monthValue,
        year: yearValue,
        today: todayValue,
        selected: selectedValue,
        previouslySelected: previouslySelectedValue,
        disabled: disabled,
        disabledDateFilter: disabledDateFilter,
        minDate: minDate,
        maxDate: maxDate,
        daysLong: daysLong,
        weekStartDay: weekStartDay
    });
    const getNextMonthHeading = ()=>{
        // Next month is (currentMonth - 1) + 1, or just currentMonth in this
        // instance.
        const nextMonth = monthValue % 12;
        const showNextYear = monthValue === 12;
        return `${monthsLong[nextMonth]} ${showNextYear ? yearValue + 1 : yearValue}`;
    };
    const getNextYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth = (monthValue - 1) % 12;
        const nextYear = yearValue + 1;
        return `${monthsLong[thisMonth]} ${nextYear}`;
    };
    const getPreviousMonthHeading = ()=>{
        // Previous month is (monthValue - 1) - 1. Need to add 12 so the modulo
        // works as expected and stays positive.
        const previousMonth = (monthValue + 12 - 2) % 12;
        const showPreviousYear = monthValue === 1;
        return `${monthsLong[previousMonth]} ${showPreviousYear ? yearValue - 1 : yearValue}`;
    };
    const getPreviousYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth = (monthValue - 1) % 12;
        const previousYear = yearValue - 1;
        return `${monthsLong[thisMonth]} ${previousYear}`;
    };
    const headerId = (0, $9KnKW.useId)();
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $2OMIu.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: className,
        style: style,
        onBlur: handleContainerBlur,
        onFocus: handleContainerFocus,
        "data-testid": testId && `${testId}--container`,
        ref: ref,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            xcss: $16abbcd9b9109722$var$styles.box,
            padding: "space.200",
            "aria-label": "calendar",
            testId: testId && `${testId}--calendar`,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $414Wj.default), {
                space: "space.150",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ePz3p.default // The month number needs to be translated to index in the month
                    ), {
                        // name array e.g. 1 (January) -> 0
                        monthLongTitle: monthsLong[monthValue - 1],
                        year: yearValue,
                        nextMonthLabel: nextMonthLabel,
                        previousMonthLabel: previousMonthLabel,
                        nextMonthHeading: getNextMonthHeading(),
                        nextYearHeading: getNextYearHeading(),
                        previousMonthHeading: getPreviousMonthHeading(),
                        previousYearHeading: getPreviousYearHeading(),
                        handleClickNextMonth: handleClickNextMonth,
                        handleClickNextYear: handleClickNextYear,
                        handleClickPrevMonth: handleClickPrevMonth,
                        handleClickPrevYear: handleClickPrevYear,
                        headerId: headerId,
                        tabIndex: tabIndex,
                        testId: testId
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $MHKc7.default), {
                        role: "grid",
                        onKeyDown: handleContainerKeyDown,
                        "aria-labelledby": headerId,
                        testId: testId && `${testId}--calendar-dates`,
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $avO9B.default), {
                                daysShort: daysShort,
                                testId: testId
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lJWdi.default), {
                                weeks: weeks,
                                handleClickDay: handleClickDay,
                                monthsLong: monthsLong,
                                shouldSetFocus: shouldSetFocus || shouldSetFocusOnCurrentDay,
                                tabIndex: tabIndex,
                                testId: testId
                            })
                        ]
                    })
                ]
            })
        })
    }));
});
/**
 * __Calendar__
 *
 * A calendar is used for date selection.
 *
 * - [Examples](https://atlassian.design/components/calendar/examples)
 * - [Code](https://atlassian.design/components/calendar/code)
 * - [Usage](https://atlassian.design/components/calendar/usage)
 */ const $16abbcd9b9109722$var$Calendar = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Calendar(props, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)($16abbcd9b9109722$var$InnerCalendar, {
        ...props,
        ref: ref
    });
}));
$16abbcd9b9109722$var$Calendar.displayName = 'Calendar';
var $16abbcd9b9109722$export$2e2bcd8739ae039 = $16abbcd9b9109722$var$Calendar;

});
parcelRegister("ePz3p", function(module, exports) {

$parcel$export(module.exports, "default", () => $995afee12cb828f6$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $9KnKW = parcelRequire("9KnKW");

var $l1N8i = parcelRequire("l1N8i");

var $iPF0X = parcelRequire("iPF0X");

var $dq6Kz = parcelRequire("dq6Kz");

var $lRheX = parcelRequire("lRheX");

var $3dGN0 = parcelRequire("3dGN0");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
const $995afee12cb828f6$var$Header = /*#__PURE__*/ (0, $5uXOq.memo)(function Header({ monthLongTitle: monthLongTitle, year: year, previousMonthLabel: previousMonthLabel = 'Previous month', previousYearLabel: previousYearLabel = 'Previous year', previousMonthHeading: previousMonthHeading, previousYearHeading: previousYearHeading, nextMonthLabel: nextMonthLabel = 'Next month', nextYearLabel: nextYearLabel = 'Next year', nextMonthHeading: nextMonthHeading, nextYearHeading: nextYearHeading, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, headerId: headerId, tabIndex: tabIndex, testId: testId }) {
    const announceId = (0, $9KnKW.useId)();
    // All of this is because `aria-atomic` is not fully supported for different
    // assistive technologies. We want the value of the current month and year to
    // be announced, but *only* if that value has been interacted with since
    // being mounted. This allows us to conditionally apply the `aria-live`
    // attribute.  Without this, the `aria-live` property is set on mount and
    // overrides the default input's readout in downstream consumers (e.g.
    // datetime picker).
    const [hasInteractedWithMonthOrYear, setHasInteractedWithMonthOrYear] = (0, $5uXOq.useState)(false);
    const handlePrevMonthInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevMonth(e);
    };
    const handlePrevYearInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevYear(e);
    };
    const handleNextMonthInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextMonth(e);
    };
    const handleNextYearInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextYear(e);
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
            space: "space.0",
            alignBlock: "center",
            spread: "space-between",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                    space: "space.100",
                    alignBlock: "start",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handlePrevYearInteraction,
                            testId: testId && `${testId}--previous-year`,
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iPF0X))),
                            label: `${previousYearLabel}, ${previousYearHeading}`
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handlePrevMonthInteraction,
                            testId: testId && `${testId}--previous-month`,
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lRheX))),
                            label: `${previousMonthLabel}, ${previousMonthHeading}`
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    "aria-live": hasInteractedWithMonthOrYear ? 'polite' : undefined,
                    id: announceId,
                    testId: testId && `${testId}--current-month-year--container`,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                        size: "xsmall",
                        as: "h2",
                        id: headerId,
                        testId: testId && `${testId}--current-month-year`,
                        children: `${monthLongTitle} ${year}`
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                    space: "space.100",
                    alignBlock: "end",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handleNextMonthInteraction,
                            testId: testId && `${testId}--next-month`,
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($3dGN0))),
                            label: `${nextMonthLabel}, ${nextMonthHeading}`
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handleNextYearInteraction,
                            testId: testId && `${testId}--next-year`,
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($dq6Kz))),
                            label: `${nextYearLabel}, ${nextYearHeading}`
                        })
                    ]
                })
            ]
        })
    });
});
$995afee12cb828f6$var$Header.displayName = 'Header';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$995afee12cb828f6$export$2e2bcd8739ae039 = $995afee12cb828f6$var$Header;

});
parcelRegister("iPF0X", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4694b4334ad7c5c52e5a3aa3cac3904d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db5cce05fac9743f$var$_react = $db5cce05fac9743f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $db5cce05fac9743f$var$_baseNew = $db5cce05fac9743f$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $db5cce05fac9743f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDoubleLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for calendar year button.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $db5cce05fac9743f$var$ChevronDoubleLeftIcon = (props)=>/*#__PURE__*/ $db5cce05fac9743f$var$_react.default.createElement($db5cce05fac9743f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m2.31 6 3.97-3.97L5.22.97l-4.5 4.5a.75.75 0 0 0 0 1.06l4.5 4.5 1.06-1.06zm4.75 0 3.97-3.97L9.97.97l-4.5 4.5a.75.75 0 0 0 0 1.06l4.5 4.5 1.06-1.06z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$db5cce05fac9743f$var$ChevronDoubleLeftIcon.displayName = 'ChevronDoubleLeftIcon';
var $db5cce05fac9743f$var$_default = module.exports.default = $db5cce05fac9743f$var$ChevronDoubleLeftIcon;

});

parcelRegister("dq6Kz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::efb038f49280a8a959174d8021780f6d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9c52f081c61754ba$var$_react = $9c52f081c61754ba$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9c52f081c61754ba$var$_baseNew = $9c52f081c61754ba$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $9c52f081c61754ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDoubleRight".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for calendar year button.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9c52f081c61754ba$var$ChevronDoubleRightIcon = (props)=>/*#__PURE__*/ $9c52f081c61754ba$var$_react.default.createElement($9c52f081c61754ba$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m6.78.97 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06L9.69 6 5.72 2.03zm-4.75 0 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5L.97 9.97 4.94 6 .97 2.03z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$9c52f081c61754ba$var$ChevronDoubleRightIcon.displayName = 'ChevronDoubleRightIcon';
var $9c52f081c61754ba$var$_default = module.exports.default = $9c52f081c61754ba$var$ChevronDoubleRightIcon;

});

parcelRegister("lRheX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::29f3eb59553566fe46c3ae42f5cce545>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fe9bebc953515e63$var$_react = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $fe9bebc953515e63$var$_baseNew = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $fe9bebc953515e63$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fe9bebc953515e63$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $fe9bebc953515e63$var$_react.default.createElement($fe9bebc953515e63$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.06 6 3.97-3.97L6.97.97l-4.5 4.5a.75.75 0 0 0 0 1.06l4.5 4.5 1.06-1.06z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$fe9bebc953515e63$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $fe9bebc953515e63$var$_default = module.exports.default = $fe9bebc953515e63$var$ChevronLeftIcon;

});


parcelRegister("lJWdi", function(module, exports) {

$parcel$export(module.exports, "default", () => $43f22a52ec309eeb$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");

var $1q4y8 = parcelRequire("1q4y8");

var $h581D = parcelRequire("h581D");
const $43f22a52ec309eeb$var$WeekDays = /*#__PURE__*/ (0, $5uXOq.memo)(function WeekDays({ weeks: weeks, handleClickDay: handleClickDay, monthsLong: monthsLong, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        role: "rowgroup",
        testId: testId && `${testId}--month`,
        children: weeks.map((week, i)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $h581D.default), {
                testId: testId && `${testId}--week`,
                children: week.values.map((weekDay)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $1q4y8.default), {
                        isDisabled: weekDay.isDisabled,
                        isFocused: weekDay.isFocused,
                        isToday: weekDay.isToday,
                        dayLong: weekDay.weekDayName,
                        month: weekDay.month,
                        monthLong: monthsLong[weekDay.month - 1],
                        onClick: handleClickDay,
                        isPreviouslySelected: weekDay.isPreviouslySelected,
                        isSelected: weekDay.isSelected,
                        isSibling: weekDay.isSiblingMonth,
                        year: weekDay.year,
                        shouldSetFocus: shouldSetFocus,
                        tabIndex: tabIndex,
                        testId: testId,
                        children: weekDay.day
                    }, `${week.id}-${weekDay.id}`))
            }, i))
    });
});
$43f22a52ec309eeb$var$WeekDays.displayName = 'WeekDays';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$43f22a52ec309eeb$export$2e2bcd8739ae039 = $43f22a52ec309eeb$var$WeekDays;

});
parcelRegister("1q4y8", function(module, exports) {

$parcel$export(module.exports, "default", () => $d70b02566a310b79$export$2e2bcd8739ae039);
/* date.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eGmKJ = parcelRequire("eGmKJ");

var $joKkQ = parcelRequire("joKkQ");
const $d70b02566a310b79$var$dateCellSiblingStyle = null;
const $d70b02566a310b79$var$dateCellTodayStyle = null;
const $d70b02566a310b79$var$dateCellPrevSelectedStyle = null;
const $d70b02566a310b79$var$dateCellSelectedStyle = null;
const $d70b02566a310b79$var$dateCellDisabledStyle = null;
const $d70b02566a310b79$var$dateCellStyles = null;
const $d70b02566a310b79$var$Date = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Date({ children: day, isDisabled: isDisabled = false, isFocused: isFocused = false, isToday: isToday = false, dayLong: dayLong, month: month, monthLong: monthLong, onClick: onClick = (0, $eGmKJ.default), isPreviouslySelected: isPreviouslySelected = false, isSelected: isSelected = false, isSibling: isSibling = false, year: year, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }, _ref) {
    const dateRef = (0, $5uXOq.useRef)({
        day: day,
        month: month,
        year: year,
        isDisabled: isDisabled
    });
    (0, $5uXOq.useEffect)(()=>{
        dateRef.current = {
            day: day,
            month: month,
            year: year,
            isDisabled: isDisabled
        };
    }, [
        day,
        month,
        year,
        isDisabled
    ]);
    const focusRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (isFocused && shouldSetFocus && focusRef.current) focusRef.current.focus();
    }, [
        isFocused,
        shouldSetFocus
    ]);
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        const { day: dayValue, month: monthValue, year: yearValue, isDisabled: isDisabledValue } = dateRef.current;
        if (!isDisabledValue) onClick({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $joKkQ.default), {
        role: "gridcell",
        alignItems: "center",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
            "aria-current": isToday ? 'date' : undefined,
            "aria-disabled": isDisabled || undefined,
            "aria-label": `${day}, ${dayLong} ${monthLong} ${year}`,
            "aria-pressed": isSelected ? 'true' : 'false',
            tabIndex: isFocused ? tabIndex : -1,
            type: "button",
            onClick: handleClick,
            ref: focusRef,
            "data-disabled": isDisabled || undefined,
            "data-focused": isFocused || undefined,
            "data-prev-selected": isPreviouslySelected || undefined,
            "data-selected": isSelected || undefined,
            "data-sibling": isSibling || undefined,
            "data-today": isToday || undefined,
            "data-testid": testId && (isSelected ? `${testId}--selected-day` : `${testId}--day`),
            className: (0, $bwpsq.default)([
                "_kkk2n7od _2rko1l7b _11c82smr _1h6d3acm _1dqonqa1 _189eyh40 _1e0c1ule _kqswh2mm _16jlkb7n _bfhk18uv _syazj3m3 _80omtlke _85i51b66 _1q511b66 _y4tirdoj _bozgrdoj _y3gn1h6o _pojj194a _10knnqa1 _1wysyh40 _irr314ae _30l3j3m3 _1di61l7b _9h8hj3m3",
                isSibling && "_syaz1wmz _30l31wmz",
                isToday && "_syaz1ldt _k48p1igg _1ywu1ule _1qdgyh40 _18postnw _1hfk1r31 _aetrb3bt _1gufv77o _1czdv77o _g0nfv77o",
                isPreviouslySelected && "_bfhk29zg _syazc8hx _30l3c8hx",
                isSelected && "_bfhk1p4p _syazqueg _irr3quvt _30l31uqy",
                isDisabled && "_syaz7dlb _80om13gf _irr318uv _30l37dlb"
            ]),
            children: day
        })
    });
}));
$d70b02566a310b79$var$Date.displayName = 'Date';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d70b02566a310b79$export$2e2bcd8739ae039 = $d70b02566a310b79$var$Date;

});
parcelRegister("joKkQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $975a473d4552aaa0$export$2e2bcd8739ae039);
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $975a473d4552aaa0$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $975a473d4552aaa0$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $975a473d4552aaa0$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $975a473d4552aaa0$var$alignContentMap = {
    start: "_ae4vv2br",
    center: "_ae4v1h6o",
    end: "_ae4vh9n0",
    'space-between': "_ae4v1yb4",
    'space-around': "_ae4v1b1v",
    'space-evenly': "_ae4vitcz",
    stretch: "_ae4v1fhb"
};
const $975a473d4552aaa0$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $975a473d4552aaa0$var$baseStyles = {
    root: "_1e0c11p5 _vchhusvi"
};
const $975a473d4552aaa0$var$gridAutoFlowMap = {
    row: "_wij2vrvc",
    column: "_wij21bp4",
    dense: "_wij218l3",
    'row dense': "_wij2j5tq",
    'column dense': "_wij2adhi"
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const $975a473d4552aaa0$var$Grid = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        id: id,
        role: role,
        className: (0, $bwpsq.default)([
            $975a473d4552aaa0$var$baseStyles.root,
            gap && $975a473d4552aaa0$var$columnGapMap[gap],
            columnGap && $975a473d4552aaa0$var$columnGapMap[columnGap],
            gap && $975a473d4552aaa0$var$rowGapMap[gap],
            rowGap && $975a473d4552aaa0$var$rowGapMap[rowGap],
            alignItems && $975a473d4552aaa0$var$alignItemsMap[alignItems],
            alignContent && $975a473d4552aaa0$var$alignContentMap[alignContent],
            justifyContent && $975a473d4552aaa0$var$justifyContentMap[justifyContent],
            autoFlow && $975a473d4552aaa0$var$gridAutoFlowMap[autoFlow],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$975a473d4552aaa0$var$Grid.displayName = 'Grid';
var $975a473d4552aaa0$export$2e2bcd8739ae039 = $975a473d4552aaa0$var$Grid;

});


parcelRegister("h581D", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c8aba25f4ae00ff$export$2e2bcd8739ae039);
/* week-day-grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $joKkQ = parcelRequire("joKkQ");
const $5c8aba25f4ae00ff$var$styles = {
    templateColumns: "_yv0eloeq"
};
/**
 * __Week day grid__
 *
 * A week day grid aligns elements in a 7 wide grid layout.
 *
 */ const $5c8aba25f4ae00ff$var$WeekDayGrid = ({ testId: testId, children: children, isHidden: isHidden })=>{
    const row = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $joKkQ.default), {
        testId: testId,
        xcss: $5c8aba25f4ae00ff$var$styles.templateColumns,
        role: "row",
        children: children
    });
    return isHidden ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "aria-hidden": "true",
        children: row
    }) : row;
};
var $5c8aba25f4ae00ff$export$2e2bcd8739ae039 = $5c8aba25f4ae00ff$var$WeekDayGrid;

});


parcelRegister("avO9B", function(module, exports) {

$parcel$export(module.exports, "default", () => $f29b1b1295ce3a84$export$2e2bcd8739ae039);
/* week-header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
var $dS3PR = parcelRequire("dS3PR");

var $h581D = parcelRequire("h581D");
const $f29b1b1295ce3a84$var$styles = {
    columnHeader: "_1ul98pqr _o5721q9c _1e0c1txw _1bah1h6o"
};
const $f29b1b1295ce3a84$var$WeekHeader = /*#__PURE__*/ (0, $5uXOq.memo)(function WeekHeader({ daysShort: daysShort, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $h581D.default), {
        isHidden: true,
        testId: testId && `${testId}--column-headers`,
        children: daysShort.map((shortDay)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                padding: "space.100",
                xcss: $f29b1b1295ce3a84$var$styles.columnHeader,
                role: "columnheader",
                testId: testId && `${testId}--column-header`,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                    weight: "bold",
                    size: "UNSAFE_small",
                    align: "center",
                    color: "color.text.subtle",
                    children: shortDay
                })
            }, shortDay))
    });
});
$f29b1b1295ce3a84$var$WeekHeader.displayName = 'WeekHeader';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f29b1b1295ce3a84$export$2e2bcd8739ae039 = $f29b1b1295ce3a84$var$WeekHeader;

});

parcelRegister("iioJV", function(module, exports) {

$parcel$export(module.exports, "arrowKeys", () => $85c2ac8e9452c4bf$export$8b15eca9c6d5c48a);
$parcel$export(module.exports, "daysPerWeek", () => $85c2ac8e9452c4bf$export$3ae905d9742bef55);
$parcel$export(module.exports, "monthsPerYear", () => $85c2ac8e9452c4bf$export$c9b7c010035d60c6);
$parcel$export(module.exports, "blankStringArray", () => $85c2ac8e9452c4bf$export$8fa20d70624f8b9d);
const $85c2ac8e9452c4bf$export$8b15eca9c6d5c48a = {
    ArrowDown: 'down',
    ArrowLeft: 'left',
    ArrowRight: 'right',
    ArrowUp: 'up'
};
const $85c2ac8e9452c4bf$export$3ae905d9742bef55 = 7;
const $85c2ac8e9452c4bf$export$c9b7c010035d60c6 = 12;
const $85c2ac8e9452c4bf$export$8fa20d70624f8b9d = [];

});

parcelRegister("jihAA", function(module, exports) {

$parcel$export(module.exports, "default", () => $654a69afe715a212$export$2e2bcd8739ae039);

var $33etG = parcelRequire("33etG");

var $f8qry = parcelRequire("f8qry");

var $3EtUb = parcelRequire("3EtUb");
function $654a69afe715a212$export$2e2bcd8739ae039({ day: day, defaultDay: defaultDay, month: month, defaultMonth: defaultMonth, year: year, defaultYear: defaultYear, today: today, selected: selected, defaultSelected: defaultSelected, previouslySelected: previouslySelected, defaultPreviouslySelected: defaultPreviouslySelected }) {
    const { current: { thisDay: thisDay, thisMonth: thisMonth, thisYear: thisYear } } = (0, $f8qry.default)(()=>{
        const now = new Date();
        const thisDay = now.getDate();
        const thisMonth = now.getMonth() + 1;
        const thisYear = now.getFullYear();
        return {
            thisDay: thisDay,
            thisMonth: thisMonth,
            thisYear: thisYear
        };
    });
    const [dayValue, setDayValue] = (0, $33etG.default)(day, ()=>defaultDay || thisDay);
    const [monthValue, setMonthValue] = (0, $33etG.default)(month, ()=>defaultMonth || thisMonth);
    const [yearValue, setYearValue] = (0, $33etG.default)(year, ()=>defaultYear || thisYear);
    const [todayValue] = (0, $33etG.default)(today, ()=>today || `${thisYear}-${(0, $3EtUb.default)(thisMonth)}-${(0, $3EtUb.default)(thisDay)}`);
    const [selectedValue, setSelectedValue] = (0, $33etG.default)(selected, ()=>defaultSelected);
    const [previouslySelectedValue, setPreviouslySelectedValue] = (0, $33etG.default)(previouslySelected, ()=>defaultPreviouslySelected);
    return {
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        today: [
            todayValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            previouslySelectedValue,
            setPreviouslySelectedValue
        ]
    };
}

});
parcelRegister("3EtUb", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd804e1790f6d755$export$2e2bcd8739ae039);
function $cd804e1790f6d755$export$2e2bcd8739ae039(num) {
    return num < 10 ? `0${num}` : `${num}`;
}

});


parcelRegister("bbnGB", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ccb38b64bb63461$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $8ccb38b64bb63461$export$2e2bcd8739ae039({ onBlur: onBlur, onFocus: onFocus }) {
    const handleContainerBlur = (0, $5uXOq.useCallback)((event)=>{
        onBlur(event);
    }, [
        onBlur
    ]);
    const handleContainerFocus = (0, $5uXOq.useCallback)((event)=>{
        onFocus(event);
    }, [
        onFocus
    ]);
    return {
        handleContainerBlur: handleContainerBlur,
        handleContainerFocus: handleContainerFocus
    };
}

});

parcelRegister("hbcve", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fe53b5f3382c02e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eZDAP = parcelRequire("eZDAP");

var $iioJV = parcelRequire("iioJV");

var $6ASl9 = parcelRequire("6ASl9");

var $5wbTt = parcelRequire("5wbTt");
function $0fe53b5f3382c02e$var$useGetCalendarWithSixthWeek(calendar, { month: month, year: year, weekStartDay: weekStartDay }) {
    const shouldDisplaySixthWeek = calendar.length % 6;
    const calendarLastValue = calendar[calendar.length - 1];
    return (0, $5uXOq.useMemo)(()=>{
        // Some months jump between 5 and 6 weeks to display. In some cases 4 (Feb
        // with the 1st on a Monday etc). This ensures the UI doesn't jump around by
        // catering to always showing 6 weeks.
        if (shouldDisplaySixthWeek) {
            const lastDayIsSibling = calendarLastValue.siblingMonth;
            const sliceStart = lastDayIsSibling ? (0, $iioJV.daysPerWeek) : 0;
            return (0, $5wbTt.default)(year, month, {
                weekStartDay: weekStartDay
            }).slice(sliceStart, sliceStart + (0, $iioJV.daysPerWeek)).map((date)=>({
                    ...date,
                    siblingMonth: true
                }));
        }
    }, [
        calendarLastValue,
        month,
        shouldDisplaySixthWeek,
        weekStartDay,
        year
    ]);
}
function $0fe53b5f3382c02e$export$2e2bcd8739ae039({ day: day, daysLong: daysLong, month: month, year: year, today: today, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDateString, maxDate: maxDateString, selected: selected, previouslySelected: previouslySelected, weekStartDay: weekStartDay }) {
    const calendar = (0, $5uXOq.useMemo)(()=>(0, $5wbTt.default)(year, month - 1, {
            weekStartDay: weekStartDay
        }), [
        month,
        weekStartDay,
        year
    ]);
    const calendarWithSixthWeek = $0fe53b5f3382c02e$var$useGetCalendarWithSixthWeek(calendar, {
        month: month,
        year: year,
        weekStartDay: weekStartDay
    });
    if (calendarWithSixthWeek) calendar.push(...calendarWithSixthWeek);
    const minDate = minDateString ? (0, $eZDAP.default)(minDateString) : undefined;
    const maxDate = maxDateString ? (0, $eZDAP.default)(maxDateString) : undefined;
    const needJsDate = minDateString || maxDateString;
    return (0, $5uXOq.useMemo)(()=>{
        const weeks = [];
        calendar.forEach((date)=>{
            const dateAsString = (0, $6ASl9.default)(date, {
                fixMonth: true
            });
            const JSDate = needJsDate ? (0, $eZDAP.default)(dateAsString) : undefined;
            let week;
            if (date.weekDay === weekStartDay) {
                week = {
                    id: dateAsString,
                    values: []
                };
                weeks.push(week);
            } else week = weeks[weeks.length - 1];
            const weekDayOffset = (date.weekDay - weekStartDay) % 7;
            // Define a bunch of `const`s
            const weekDayName = daysLong[weekDayOffset];
            const isDisabledByArray = disabled ? disabled.indexOf(dateAsString) > -1 : false;
            const isDisabledByFilter = disabledDateFilter ? disabledDateFilter(dateAsString) : false;
            const isDisabledByMin = minDate && JSDate ? JSDate < minDate : false;
            const isDisabledByMax = maxDate && JSDate ? JSDate > maxDate : false;
            const isDisabled = isDisabledByArray || isDisabledByFilter || isDisabledByMin || isDisabledByMax;
            const isFocused = day === date.day && !date.siblingMonth;
            const isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
            const isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
            const isSiblingMonth = !!date.siblingMonth;
            const isToday = today === dateAsString;
            week.values.push({
                id: dateAsString,
                isDisabled: isDisabled,
                isFocused: isFocused,
                isToday: isToday,
                month: date.month + 1,
                isPreviouslySelected: isPreviouslySelected,
                isSelected: isSelected,
                isSiblingMonth: isSiblingMonth,
                year: date.year,
                day: date.day,
                weekDayName: weekDayName
            });
        });
        return weeks;
    }, [
        calendar,
        day,
        disabled,
        disabledDateFilter,
        minDate,
        maxDate,
        needJsDate,
        previouslySelected,
        selected,
        today,
        weekStartDay,
        daysLong
    ]);
}

});
parcelRegister("6ASl9", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6ae62fd51c4538f$export$2e2bcd8739ae039);

var $3EtUb = parcelRequire("3EtUb");
function $b6ae62fd51c4538f$export$2e2bcd8739ae039(date, options) {
    return `${date.year}-${(0, $3EtUb.default)(date.month + (options && options.fixMonth ? 1 : 0))}-${(0, $3EtUb.default)(date.day)}`;
}

});

parcelRegister("5wbTt", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dff1ed1384abe91$export$2e2bcd8739ae039);
/**
 * Logic taken from https://github.com/WesSouza/calendar-base which is not maintained for quite sometime.
 * This will help us fixing any issue we might get or any new functionality we might want to support.
 * Not changing much code below. Just removed those parts which we don't need.
 */ 
var $iioJV = parcelRequire("iioJV");

var $9Zmg7 = parcelRequire("9Zmg7");
function $3dff1ed1384abe91$export$2e2bcd8739ae039(year, month, { weekStartDay: weekStartDay = 0 } = {
    weekStartDay: 0
}) {
    const date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
    const utcYear = date.getUTCFullYear();
    const utcMonth = date.getUTCMonth();
    const calendar = [];
    const firstDay = date.getUTCDay();
    const firstDate = -(((0, $iioJV.daysPerWeek) - weekStartDay + firstDay) % (0, $iioJV.daysPerWeek));
    const lastDate = (0, $9Zmg7.default)(utcYear, utcMonth);
    const lastDay = (lastDate - firstDate) % (0, $iioJV.daysPerWeek);
    const lastDateOfPreviousMonth = (0, $9Zmg7.default)(utcYear, utcMonth - 1);
    let dateCounter = firstDate;
    let currentDay;
    let currentDate;
    let currentDateObject = null;
    let calculatedMonth;
    let calculatedYear;
    const maxDateCount = lastDate - dateCounter + (lastDay !== 0 ? (0, $iioJV.daysPerWeek) - lastDay : 0) + firstDate;
    while(dateCounter < maxDateCount){
        currentDate = dateCounter + 1;
        currentDay = ((dateCounter < 1 ? (0, $iioJV.daysPerWeek) + dateCounter : dateCounter) + firstDay) % (0, $iioJV.daysPerWeek);
        if (currentDate < 1 || currentDate > lastDate) {
            if (currentDate < 1) {
                calculatedMonth = utcMonth - 1;
                calculatedYear = utcYear;
                if (calculatedMonth < 0) {
                    calculatedMonth = (0, $iioJV.monthsPerYear) - 1;
                    calculatedYear--;
                }
                currentDate = lastDateOfPreviousMonth + currentDate;
            } else if (currentDate > lastDate) {
                calculatedMonth = utcMonth + 1;
                calculatedYear = utcYear;
                if (calculatedMonth > (0, $iioJV.monthsPerYear) - 1) {
                    calculatedMonth = 0;
                    calculatedYear++;
                }
                currentDate = dateCounter - lastDate + 1;
            }
            if (calculatedMonth !== undefined && calculatedYear !== undefined) currentDateObject = {
                day: currentDate,
                weekDay: currentDay,
                month: calculatedMonth,
                year: calculatedYear,
                siblingMonth: true
            };
        } else currentDateObject = {
            day: currentDate,
            weekDay: currentDay,
            month: utcMonth,
            year: utcYear
        };
        calendar.push(currentDateObject);
        dateCounter++;
    }
    return calendar;
}

});
parcelRegister("9Zmg7", function(module, exports) {

$parcel$export(module.exports, "default", () => $878800070b837d93$export$2e2bcd8739ae039);
function $878800070b837d93$export$2e2bcd8739ae039(year, month) {
    return new Date(year, month + 1, 0).getDate();
}

});



parcelRegister("2TGJ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $caae4eff24f6e8d0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iioJV = parcelRequire("iioJV");

var $6ASl9 = parcelRequire("6ASl9");

var $9Zmg7 = parcelRequire("9Zmg7");
const $caae4eff24f6e8d0$var$getNextMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === (0, $iioJV.monthsPerYear)) {
        month = 1;
        year += 1;
    } else month += 1;
    return {
        month: month,
        year: year
    };
};
const $caae4eff24f6e8d0$var$getPrevMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === 1) {
        month = (0, $iioJV.monthsPerYear);
        year -= 1;
    } else month -= 1;
    return {
        month: month,
        year: year
    };
};
function $caae4eff24f6e8d0$export$2e2bcd8739ae039({ day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], shouldSetFocus: [_shouldSetFocus, setShouldSetFocus], onChange: onChange }) {
    const dateRef = (0, $5uXOq.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $5uXOq.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnChange = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day, type: type })=>{
        const iso = (0, $6ASl9.default)({
            year: year,
            month: month,
            day: day
        });
        const isFocusableType = [
            'up',
            'down',
            'left',
            'right'
        ].includes(type);
        onChange({
            day: day,
            month: month,
            year: year,
            iso: iso,
            type: type
        });
        setDayValue(day);
        setMonthValue(month);
        setYearValue(year);
        setShouldSetFocus(isFocusableType);
    }, [
        onChange,
        setDayValue,
        setMonthValue,
        setYearValue,
        setShouldSetFocus
    ]);
    const navigate = (0, $5uXOq.useCallback)((type)=>{
        const { day: day, month: month, year: year } = dateRef.current;
        if (type === 'down') {
            const next = day + (0, $iioJV.daysPerWeek);
            const daysInMonth = (0, $9Zmg7.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $caae4eff24f6e8d0$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: next - daysInMonth,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'left') {
            const prev = day - 1;
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $caae4eff24f6e8d0$var$getPrevMonth(month, year);
                const prevDay = (0, $9Zmg7.default)(prevYear, prevMonth - 1);
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        } else if (type === 'right') {
            const next = day + 1;
            const daysInMonth = (0, $9Zmg7.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $caae4eff24f6e8d0$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: 1,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'up') {
            const prev = day - (0, $iioJV.daysPerWeek);
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $caae4eff24f6e8d0$var$getPrevMonth(month, year);
                const prevDay = (0, $9Zmg7.default)(prevYear, prevMonth - 1) + prev;
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        }
    }, [
        triggerOnChange
    ]);
    const handleClickNextMonth = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$caae4eff24f6e8d0$var$getNextMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'nextMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickNextYear = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = dateRef.current;
        triggerOnChange({
            day: day,
            month: month,
            year: year + 1,
            type: 'nextYear'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevMonth = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$caae4eff24f6e8d0$var$getPrevMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'prevMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevYear = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = dateRef.current;
        triggerOnChange({
            day: day,
            month: month,
            year: year - 1,
            type: 'prevYear'
        });
    }, [
        triggerOnChange
    ]);
    return {
        navigate: navigate,
        handleClickNextMonth: handleClickNextMonth,
        handleClickNextYear: handleClickNextYear,
        handleClickPrevMonth: handleClickPrevMonth,
        handleClickPrevYear: handleClickPrevYear
    };
}

});

parcelRegister("f9D1v", function(module, exports) {

$parcel$export(module.exports, "default", () => $42ec54640e7b9de4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iioJV = parcelRequire("iioJV");

var $6ASl9 = parcelRequire("6ASl9");
function $42ec54640e7b9de4$export$2e2bcd8739ae039({ day: [dayValue], month: [monthValue], year: [yearValue], selected: [selectedValue, setSelectedValue], previous: [, setPreviouslySelectedValue], onSelect: onSelect, navigate: navigate }) {
    const dateRef = (0, $5uXOq.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $5uXOq.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnSelect = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day })=>{
        const iso = (0, $6ASl9.default)({
            year: year,
            month: month,
            day: day
        });
        onSelect({
            day: day,
            month: month,
            year: year,
            iso: iso
        });
        setPreviouslySelectedValue(selectedValue);
        setSelectedValue([
            iso
        ]);
    }, [
        onSelect,
        selectedValue,
        setPreviouslySelectedValue,
        setSelectedValue
    ]);
    const handleClickDay = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day })=>{
        triggerOnSelect({
            year: year,
            month: month,
            day: day
        });
    }, [
        triggerOnSelect
    ]);
    const handleContainerKeyDown = (0, $5uXOq.useCallback)((e)=>{
        const { key: key } = e;
        const arrowKey = (0, $iioJV.arrowKeys)[key];
        if (key === 'Enter' || key === ' ') {
            e.preventDefault();
            triggerOnSelect(dateRef.current);
        } else if (arrowKey) {
            e.preventDefault();
            navigate(arrowKey);
        }
    }, [
        triggerOnSelect,
        navigate
    ]);
    return {
        handleClickDay: handleClickDay,
        handleContainerKeyDown: handleContainerKeyDown
    };
}

});

parcelRegister("9efze", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbd6f430b06675a1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7qZ1x = parcelRequire("7qZ1x");
function $fbd6f430b06675a1$export$2e2bcd8739ae039({ locale: locale, weekStartDay: weekStartDay }) {
    const l10n = (0, $5uXOq.useMemo)(()=>(0, $7qZ1x.createLocalizationProvider)(locale), [
        locale
    ]);
    const monthsLong = (0, $5uXOq.useMemo)(()=>l10n.getMonthsLong(), [
        l10n
    ]);
    const daysShort = (0, $5uXOq.useMemo)(()=>l10n.getDaysShort(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    const daysLong = (0, $5uXOq.useMemo)(()=>l10n.getDaysLong(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    return {
        monthsLong: monthsLong,
        daysShort: daysShort,
        daysLong: daysLong
    };
}

});


parcelRegister("avHVh", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac07968b7cb494a9$export$2e2bcd8739ae039);
/* fixed-layer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");

var $5owSH = parcelRequire("5owSH");

var $gkD4s = parcelRequire("gkD4s");
var $4oNEb = parcelRequire("4oNEb");
var $1V7PR = parcelRequire("1V7PR");
const $ac07968b7cb494a9$var$styles = {
    root: "_bfhk18uv _kqswstnw _154ize3t",
    popperStyles: "_1pbyowjs"
};
class $ac07968b7cb494a9$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.inputValue !== this.props.inputValue) this.update();
    }
    render() {
        const { containerRef: containerRef, content: content, testId: testId } = this.props;
        // Wait for containerRef callback to cause a re-render
        if (!containerRef) return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {});
        const divStyles = {
            height: containerRef.getBoundingClientRect().height,
            // Don't block the clear button
            width: containerRef.getBoundingClientRect().width - parseInt((0, $5owSH.sizes).small.slice(0, -2)) - 8
        };
        return(/* Need to wrap layer in a fixed position div so that it will render its content as fixed
       * We need to set the intial top value to where the container is and zIndex so that it still
       * applies since we're creating a new stacking context. */ /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gkD4s.Manager), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1V7PR.Reference), {
                    children: ({ ref: ref })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            ref: ref,
                            "data-layer-child": true,
                            style: divStyles,
                            className: (0, $bwpsq.default)([
                                $ac07968b7cb494a9$var$styles.root
                            ])
                        })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4oNEb.Popper), {
                    children: ({ ref: ref, style: style, update: update })=>{
                        this.update = update;
                        return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            ref: ref,
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            style: style,
                            "data-testid": testId && `${testId}--popper--container`,
                            className: (0, $bwpsq.default)([
                                $ac07968b7cb494a9$var$styles.popperStyles
                            ]),
                            children: content
                        });
                    }
                })
            ]
        }));
    }
    constructor(...args){
        super(...args), this.update = (0, $eGmKJ.default);
    }
}

});
parcelRegister("5owSH", function(module, exports) {

$parcel$export(module.exports, "sizes", () => $7ad0abb26ad673d7$export$c647cb0ee6e282fe);
const $7ad0abb26ad673d7$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
const $7ad0abb26ad673d7$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
const $7ad0abb26ad673d7$export$62ad7b0c781000e9 = {
    small: {
        width: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.small,
        height: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.medium,
        height: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.large,
        height: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.xlarge,
        height: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.xlarge
    }
};

});



parcelRegister("6AqCE", function(module, exports) {

$parcel$export(module.exports, "getShortISOString", () => $caee16c105163c22$export$77d5bc49fed7ef14);
$parcel$export(module.exports, "getSafeCalendarValue", () => $caee16c105163c22$export$ff525416014fb67d);

var $k7m40 = parcelRequire("k7m40");

var $2ucUe = parcelRequire("2ucUe");
function $caee16c105163c22$export$77d5bc49fed7ef14(date) {
    return (0, $k7m40.default)(date, (0, $2ucUe.convertTokens)('YYYY-MM-DD'));
}
function $caee16c105163c22$export$ff525416014fb67d(calendarValue) {
    // If `calendarValue` has a year that is greater than 9999, default to
    // today's date
    const yearIsOverLimit = calendarValue.match(/^\d{5,}/);
    if (yearIsOverLimit) return $caee16c105163c22$export$77d5bc49fed7ef14(new Date());
    return calendarValue;
}

});

parcelRegister("dBs4v", function(module, exports) {

$parcel$export(module.exports, "makeSingleValue", () => $9661917c82165ad2$export$6e30bf8cb1347b56);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");
const $9661917c82165ad2$export$6e30bf8cb1347b56 = ({ lang: lang })=>({ children: children, className: className, clearValue: clearValue, cx: cx, data: data, getStyles: getStyles, getValue: getValue, hasValue: hasValue, isDisabled: isDisabled, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, ...rest })=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).SingleValue, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            data: data,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: {
                lang: lang
            },
            isDisabled: isDisabled,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue,
            children: children
        });
    };

});


parcelRegister("jcbUF", function(module, exports) {

$parcel$export(module.exports, "default", () => $48f5b21daaca02ab$export$2e2bcd8739ae039);
/* date-picker-fc.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $6QvkM = parcelRequire("6QvkM");

var $42CjB = parcelRequire("42CjB");

var $3JT92 = parcelRequire("3JT92");

var $9KnKW = parcelRequire("9KnKW");

var $acknU = parcelRequire("acknU");

var $7qZ1x = parcelRequire("7qZ1x");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $7K5PP = parcelRequire("7K5PP");
var $7VXAu = parcelRequire("7VXAu");

var $jHBnA = parcelRequire("jHBnA");

var $5RLF6 = parcelRequire("5RLF6");

var $iaQLg = parcelRequire("iaQLg");

var $gtijU = parcelRequire("gtijU");

var $6AqCE = parcelRequire("6AqCE");

var $dBs4v = parcelRequire("dBs4v");
const $48f5b21daaca02ab$var$packageName = "platform-pkg";
const $48f5b21daaca02ab$var$packageVersion = "0.0.0-use.local";
const $48f5b21daaca02ab$var$styles = {
    pickerContainerStyle: "_kqswh2mm",
    dropdownIndicatorStyles: "_1ul91k8s _1tke1k8s _1e0c1txw _4cvr1h6o _1bah1h6o",
    iconContainerStyles: "_v564vrg3 _1e0c1txw _4t3i1osq _kqswstnw _4cvr1h6o _i0dl1kw7 _syaz131l _152tze3t _rjxpze3t _30l31gjq",
    iconSpacingWithClearButtonStyles: "_12l2xy5q",
    iconSpacingWithoutClearButtonStyles: "_12l21b66"
};
const $48f5b21daaca02ab$var$analyticsAttributes = {
    componentName: 'datePicker',
    packageName: $48f5b21daaca02ab$var$packageName,
    packageVersion: $48f5b21daaca02ab$var$packageVersion
}; /**
    * __Date picker__
    *
    * A date picker allows the user to select a particular date.
    *
    * - [Examples](https://atlassian.design/components/datetime-picker/date-picker/examples)
    * - [Code](https://atlassian.design/components/datetime-picker/date-picker/code)
    * - [Usage](https://atlassian.design/components/datetime-picker/date-picker/usage)
    */ 
const $48f5b21daaca02ab$var$DatePicker = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, forwardedRef)=>{
    const containerRef = (0, $5uXOq.useRef)(null);
    const calendarRef = (0, $5uXOq.useRef)(null);
    const calendarButtonRef = (0, $5uXOq.useRef)(null);
    const { appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', disabled: disabled = [], disabledDateFilter: disabledDateFilter = (_)=>false, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($acknU))), id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', name: name = '', onBlur: // eslint-disable-next-line @repo/internal/react/use-noop
    onBlur = (_event)=>{}, // eslint-disable-next-line @repo/internal/react/use-noop
    onChange: onChangeProp = (_value)=>{}, onFocus: // eslint-disable-next-line @repo/internal/react/use-noop
    onFocus = (_event)=>{}, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', locale: propLocale = 'en-US', value: propValue, isOpen: isOpenProp, maxDate: maxDate, minDate: minDate, weekStartDay: weekStartDay, formatDisplayLabel: formatDisplayLabel, testId: testId, 'aria-describedby': ariaDescribedBy, placeholder: placeholder, nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, ...rest } = props;
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(defaultIsOpen);
    const [_, setIsFocused] = (0, $5uXOq.useState)(false);
    const [clearingFromIcon, setClearingFromIcon] = (0, $5uXOq.useState)(false);
    const [selectInputValue, setSelectInputValue] = (0, $5uXOq.useState)(selectProps.inputValue);
    const [value, setValue] = (0, $5uXOq.useState)(propValue || defaultValue);
    const [calendarValue, setCalendarValue] = (0, $5uXOq.useState)(propValue || defaultValue || (0, $6AqCE.getShortISOString)(new Date()));
    const [l10n, setL10n] = (0, $5uXOq.useState)((0, $7qZ1x.createLocalizationProvider)(propLocale));
    const [locale, setLocale] = (0, $5uXOq.useState)(propLocale);
    const [shouldSetFocusOnCurrentDay, setShouldSetFocusOnCurrentDay] = (0, $5uXOq.useState)(false);
    const [isKeyDown, setIsKeyDown] = (0, $5uXOq.useState)(false);
    const [wasOpenedFromCalendarButton, setWasOpenedFromCalendarButton] = (0, $5uXOq.useState)(false); // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = (0, $5uXOq.useReducer)((x)=>!x, true);
    const onChangePropWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChangeProp,
        action: 'selectedDate',
        actionSubject: 'datePicker',
        ...$48f5b21daaca02ab$var$analyticsAttributes
    });
    if (propLocale !== locale) {
        setL10n((0, $7qZ1x.createLocalizationProvider)(propLocale));
        setLocale(propLocale);
    }
    (0, $5uXOq.useEffect)(()=>{
        // We don't want the focus to move if this is a click event
        if (!isKeyDown) return;
        if (isOpen && wasOpenedFromCalendarButton) {
            setIsKeyDown(false); // Focus on the first button within the calendar
            calendarRef?.current?.querySelector('button')?.focus();
        }
    }, [
        isKeyDown,
        calendarRef,
        isOpen,
        wasOpenedFromCalendarButton
    ]);
    const getValue = ()=>propValue ?? value;
    const getIsOpen = ()=>isOpenProp ?? isOpen;
    const onCalendarChange = ({ iso: iso })=>{
        setCalendarValue((0, $5RLF6.getParsedISO)({
            iso: iso
        }));
    };
    const onCalendarSelect = ({ iso: iso })=>{
        setSelectInputValue('');
        setIsOpen(false);
        setCalendarValue(iso);
        setValue(iso);
        setWasOpenedFromCalendarButton(false);
        onChangePropWithAnalytics(iso); // Yes, this is not ideal. The alternative is to be able to place a ref
        // on the inner input of Select itself, which would require a lot of
        // extra stuff in the Select component for only this one thing. While
        // this would be more "React-y", it doesn't seem to pose any other
        // benefits. Performance-wise, we are only searching within the
        // container, so it's quick.
        if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
        else {
            const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
            innerCombobox?.focus();
        }
        setIsOpen(false);
    };
    const onInputClick = ()=>{
        if (!isDisabled && !getIsOpen()) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onContainerBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        if (!containerRef?.current?.contains(newlyFocusedElement)) {
            setIsOpen(false);
            setShouldSetFocusOnCurrentDay(false);
            setWasOpenedFromCalendarButton(false);
            onBlur(event);
        }
    };
    const onContainerFocus = ()=>{
        setShouldSetFocusOnCurrentDay(false);
    };
    const onSelectBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        if (clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
        setClearingFromIcon(false);
        else if (!containerRef?.current?.contains(newlyFocusedElement)) {
            // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            setIsOpen(false);
            setIsFocused(false);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onSelectFocus = (event)=>{
        const value = getValue();
        if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
        setClearingFromIcon(false);
        else {
            // Don't open when focused into via keyboard if the calendar button is present
            setIsOpen(!shouldShowCalendarButton);
            setCalendarValue(value);
            setIsFocused(true);
            setWasOpenedFromCalendarButton(false);
        }
        onFocus(event);
    };
    const onTextInput = (event)=>{
        const inputValue = event.target.value;
        if (inputValue) {
            const parsed = (0, $5RLF6.parseDate)(inputValue, {
                parseInputValue: rest?.parseInputValue,
                dateFormat: rest?.dateFormat,
                l10n: l10n
            }); // Only try to set the date if we have month & day
            if (parsed && (0, $jovBr.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
            // this is the format expected by the @atlaskit/calendar component
            setCalendarValue((0, $6AqCE.getShortISOString)(parsed));
        }
        setIsOpen(true);
        setWasOpenedFromCalendarButton(false);
    };
    const onInputKeyDown = (event)=>{
        const value = getValue();
        const keyPressed = event.key.toLowerCase(); // If the input is focused and the calendar is not visible, handle space and enter clicks
        if (!isOpen && (keyPressed === 'enter' || keyPressed === ' ')) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
        switch(keyPressed){
            case 'escape':
                // Yes, this is not ideal. The alternative is to be able to place a ref
                // on the inner input of Select itself, which would require a lot of
                // extra stuff in the Select component for only this one thing. While
                // this would be more "React-y", it doesn't seem to pose any other
                // benefits. Performance-wise, we are only searching within the
                // container, so it's quick.
                if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
                else {
                    const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
                    innerCombobox?.focus();
                }
                setIsOpen(false);
                setShouldSetFocusOnCurrentDay(false);
                setWasOpenedFromCalendarButton(false);
                break;
            case 'backspace':
            case 'delete':
                {
                    const inputCount = 0;
                    if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) {
                        // If being cleared from keyboard, don't change behaviour
                        setClearingFromIcon(false);
                        setValue('');
                    }
                    break;
                }
            case 'enter':
                if (!isOpen) return;
                 // Prevent form submission when a date is selected
                // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                // for more details.
                event.preventDefault();
                if (!(0, $5RLF6.isDateDisabled)(calendarValue, {
                    disabled: disabled
                })) {
                    // Get a safe `calendarValue` in case the value exceeds the maximum
                    // allowed by ISO 8601
                    const safeCalendarValue = (0, $6AqCE.getSafeCalendarValue)(calendarValue);
                    const valueChanged = safeCalendarValue !== value;
                    setSelectInputValue('');
                    setIsOpen(false);
                    setValue(safeCalendarValue);
                    setCalendarValue(safeCalendarValue);
                    setWasOpenedFromCalendarButton(wasOpenedFromCalendarButton);
                    if (valueChanged) onChangePropWithAnalytics(safeCalendarValue);
                }
                break;
            case 'arrowdown':
            case 'arrowup':
                if (!shouldSetFocusOnCurrentDay) {
                    setIsOpen(true);
                    setShouldSetFocusOnCurrentDay(true);
                }
                break;
            default:
                break;
        }
    };
    const onCalendarButtonKeyDown = (e)=>{
        // Don't allow an arrow up or down to open the menu, since the input key
        // down handler is actually on the parent.
        if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
         // We want to stop this from triggering other keydown events, particularly
        // for space and enter presses. Otherwise, it opens and then closes
        // immediately.
        if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
            e.stopPropagation();
            setIsKeyDown(true);
            setWasOpenedFromCalendarButton(true);
        }
    }; // This event handler is triggered from both keydown and click. It's weird.
    const onCalendarButtonClick = (e)=>{
        setIsOpen(!isOpen);
        setWasOpenedFromCalendarButton(true);
        e.stopPropagation();
    };
    const onClear = ()=>{
        setValue('');
        setCalendarValue(defaultValue || (0, $6AqCE.getShortISOString)(new Date()));
        if (!hideIcon) setClearingFromIcon(true);
        onChangePropWithAnalytics('');
    }; // `unknown` is used because `value` is unused so it does not matter.
    const onSelectChange = (_value, action)=>{
        // Used for native clear event in React Select
        // Triggered when clicking ClearIndicator or backspace with no value
        if (action.action === 'clear') onClear();
    };
    const handleSelectInputChange = (selectInputValue, actionMeta)=>{
        if (selectProps.onInputChange) selectProps.onInputChange(selectInputValue, actionMeta);
        setSelectInputValue(selectInputValue);
    };
    const getContainerRef = (0, $5uXOq.useCallback)((ref)=>{
        const oldRef = containerRef.current;
        containerRef.current = ref; // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef == null && ref != null) forceUpdate();
    }, [
        containerRef
    ]);
    const getterValue = getValue();
    let actualSelectInputValue;
    actualSelectInputValue = selectInputValue;
    const menuIsOpen = getIsOpen() && !isDisabled;
    const showClearIndicator = Boolean((getterValue || selectInputValue) && !hideIcon);
    let clearIndicator = Icon; // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $VSDnB.fg)('platform-visual-refresh-icons')) clearIndicator = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            xcss: $48f5b21daaca02ab$var$styles.dropdownIndicatorStyles,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                ...props
            })
        });
    const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
    const SingleValue = (0, $dBs4v.makeSingleValue)({
        lang: propLocale
    });
    const selectComponents = {
        ...selectProps.components,
        DropdownIndicator: shouldShowCalendarButton ? (0, $jHBnA.EmptyComponent) : dropDownIcon,
        // Only use this new container component if the calendar button is shown.
        // Otherwise, it throws errors downstream for some reason
        ...shouldShowCalendarButton ? {
            IndicatorsContainer: (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $iaQLg.IndicatorsContainer), {
                    ...props,
                    showClearIndicator: showClearIndicator
                })
        } : {},
        Menu: $gtijU.Menu,
        SingleValue: SingleValue,
        ...!showClearIndicator && {
            ClearIndicator: (0, $jHBnA.EmptyComponent)
        }
    };
    const { styles: selectStyles = {} } = selectProps;
    const disabledStyle = isDisabled ? {
        pointerEvents: 'none',
        color: "var(--ds-icon-disabled, inherit)"
    } : {};
    const calendarProps = {
        calendarContainerRef: containerRef.current,
        calendarDisabled: disabled,
        calendarDisabledDateFilter: disabledDateFilter,
        calendarMaxDate: maxDate,
        calendarMinDate: minDate,
        calendarRef: calendarRef,
        calendarValue: getterValue && (0, $6AqCE.getShortISOString)((0, $eZDAP.default)(getterValue)),
        calendarView: calendarValue,
        onCalendarChange: onCalendarChange,
        onCalendarSelect: onCalendarSelect,
        calendarLocale: locale,
        calendarWeekStartDay: weekStartDay,
        shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay,
        /**
     * This overrides the inner wrapper the Calendar.
     * @private Please use this with extreme caution, this API may be changed in the future.
     */ menuInnerWrapper: props?.menuInnerWrapper
    }; // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
    const mergedStyles = (0, $7VXAu.mergeStyles)(selectStyles, {
        control: (base)=>({
                ...base,
                ...disabledStyle
            }),
        indicatorsContainer: (base)=>({
                ...base,
                paddingLeft: "var(--ds-space-025, 2px)",
                // ICON_PADDING = 2
                paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
            })
    });
    const initialValue = getterValue ? {
        label: (0, $5RLF6.formatDate)(getterValue, {
            formatDisplayLabel: formatDisplayLabel,
            dateFormat: rest?.dateFormat,
            l10n: l10n
        }),
        value: getterValue
    } : null; // `label` takes precedence of the `inputLabel`
    const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel}, ${openCalendarLabel}` : openCalendarLabel;
    const openCalendarLabelId = `open-calendar-label--${(0, $9KnKW.useId)()}`;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        ...innerProps,
        "data-testid": testId && `${testId}--container`,
        onBlur: onContainerBlur,
        onFocus: onContainerFocus,
        onClick: onInputClick,
        onInput: onTextInput,
        onKeyDown: onInputKeyDown,
        ref: getContainerRef,
        role: "presentation",
        className: (0, $bwpsq.default)([
            $48f5b21daaca02ab$var$styles.pickerContainerStyle
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                name: name,
                type: "hidden",
                value: getterValue,
                "data-testid": testId && `${testId}--input`
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7K5PP.default), {
                appearance: appearance,
                "aria-describedby": ariaDescribedBy,
                label: label || undefined,
                autoFocus: autoFocus,
                clearControlLabel: clearControlLabel,
                closeMenuOnSelect: true,
                enableAnimation: false,
                inputId: id,
                inputValue: actualSelectInputValue,
                isDisabled: isDisabled,
                isRequired: isRequired,
                menuIsOpen: menuIsOpen,
                onBlur: onSelectBlur,
                onChange: onSelectChange,
                onFocus: onSelectFocus,
                onInputChange: handleSelectInputChange,
                placeholder: (0, $5RLF6.getPlaceholder)({
                    placeholder: placeholder,
                    l10n: l10n
                }),
                // @ts-ignore -- Type 'OptionType' is not assignable to type '{ label: string; value: string; }'
                styles: mergedStyles,
                value: initialValue,
                ...selectProps,
                // up when you alter some of the properties in the `selectComponents`
                // object. These errors are still present, and I suspect have always
                // been present, without changing the unrelated code. Ignoring as the
                // component still works as expected despite this error. And also
                // because the select refresh team may solve it later.
                components: selectComponents,
                // selectProps or not and what wil be overwritten
                isClearable: true,
                isInvalid: isInvalid,
                spacing: spacing,
                testId: testId,
                // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
                calendarContainerRef: calendarProps.calendarContainerRef,
                calendarDisabled: calendarProps.calendarDisabled,
                calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
                calendarLocale: calendarProps.calendarLocale,
                calendarMaxDate: calendarProps.calendarMaxDate,
                calendarMinDate: calendarProps.calendarMinDate,
                calendarRef: calendarProps.calendarRef,
                calendarValue: calendarProps.calendarValue,
                calendarView: calendarProps.calendarView,
                calendarWeekStartDay: calendarProps.calendarWeekStartDay,
                nextMonthLabel: nextMonthLabel,
                onCalendarChange: calendarProps.onCalendarChange,
                onCalendarSelect: calendarProps.onCalendarSelect,
                previousMonthLabel: previousMonthLabel,
                shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay,
                menuInnerWrapper: calendarProps.menuInnerWrapper
            }),
            shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                xcss: (0, $3JT92.cx)($48f5b21daaca02ab$var$styles.iconContainerStyles, value && !hideIcon ? $48f5b21daaca02ab$var$styles.iconSpacingWithClearButtonStyles : $48f5b21daaca02ab$var$styles.iconSpacingWithoutClearButtonStyles),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                    appearance: "subtle",
                    label: !inputLabelId ? fullopenCalendarLabel : openCalendarLabel,
                    "aria-labelledby": inputLabelId ? `${inputLabelId} ${openCalendarLabelId}` : undefined,
                    id: openCalendarLabelId,
                    icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acknU))), {
                            ...iconProps,
                            color: "var(--ds-icon, #44546F)"
                        }),
                    onClick: onCalendarButtonClick,
                    onKeyDown: onCalendarButtonKeyDown,
                    ref: calendarButtonRef,
                    testId: testId && `${testId}--open-calendar-button`
                })
            }) : null
        ]
    });
});
var $48f5b21daaca02ab$export$2e2bcd8739ae039 = $48f5b21daaca02ab$var$DatePicker;

});


parcelRegister("jdTq6", function(module, exports) {

$parcel$export(module.exports, "default", () => $420c0ce16dc216b4$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $k7m40 = parcelRequire("k7m40");
var $jovBr = parcelRequire("jovBr");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $7qZ1x = parcelRequire("7qZ1x");

var $iOwNT = parcelRequire("iOwNT");
var $7K5PP = parcelRequire("7K5PP");
var $7VXAu = parcelRequire("7VXAu");

var $jHBnA = parcelRequire("jHBnA");

var $imOgG = parcelRequire("imOgG");

var $j537G = parcelRequire("j537G");

var $2ucUe = parcelRequire("2ucUe");

var $dBs4v = parcelRequire("dBs4v");
const $420c0ce16dc216b4$var$packageName = "platform-pkg";
const $420c0ce16dc216b4$var$packageVersion = "0.0.0-use.local";
const $420c0ce16dc216b4$var$menuStyles = {
    /* Need to remove default absolute positioning as that causes issues with position fixed */ position: 'static',
    /* Need to add overflow to the element with max-height, otherwise causes overflow issues in IE11 */ overflowY: 'auto',
    /* React-Popper has already offset the menu so we need to reset the margin, otherwise the offset value is doubled */ margin: 0
};
const $420c0ce16dc216b4$var$analyticsAttributes = {
    componentName: 'timePicker',
    packageName: $420c0ce16dc216b4$var$packageName,
    packageVersion: $420c0ce16dc216b4$var$packageVersion
};
/**
 * __Time picker__
 *
 * A time picker allows the user to select a specific time.
 *
 * - [Examples](https://atlassian.design/components/datetime-picker/time-picker/examples)
 * - [Code](https://atlassian.design/components/datetime-picker/time-picker/code)
 * - [Usage](https://atlassian.design/components/datetime-picker/time-picker/usage)
 */ const $420c0ce16dc216b4$var$TimePicker = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ 'aria-describedby': ariaDescribedBy, appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'clear timepicker', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', formatDisplayLabel: formatDisplayLabel, hideIcon: hideIcon = false, id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, isOpen: providedIsOpen, label: label = '', locale: locale = 'en-US', name: name = '', onBlur: providedOnBlur = (0, $eGmKJ.default), onChange: providedOnChange = (0, $eGmKJ.default), onFocus: providedOnFocus = (0, $eGmKJ.default), parseInputValue: parseInputValue = (time, _timeFormat)=>(0, $j537G.default)(time), placeholder: placeholder, selectProps: selectProps = {}, spacing: spacing = 'default', testId: testId, timeFormat: timeFormat, timeIsEditable: timeIsEditable = false, times: times = (0, $jHBnA.defaultTimes), value: providedValue }, ref)=>{
    const [containerRef, setContainerRef] = (0, $5uXOq.useState)(null);
    /**
   * When being cleared from the icon the TimePicker is blurred.
   * This variable defines whether the default onMenuOpen or onMenuClose
   * events should behave as normal
   */ const [clearingFromIcon, setClearingFromIcon] = (0, $5uXOq.useState)(false);
    // TODO: Remove isFocused? Does it do anything?
    const [_, setIsFocused] = (0, $5uXOq.useState)(false);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(defaultIsOpen);
    const [value, setValue] = (0, $5uXOq.useState)(defaultValue);
    // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = (0, $5uXOq.useReducer)((x)=>x + 1, 0);
    const providedOnChangeWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: providedOnChange,
        action: 'selectedTime',
        ...$420c0ce16dc216b4$var$analyticsAttributes
    });
    (0, $5uXOq.useEffect)(()=>{
        if (providedValue) setValue(providedValue);
    }, [
        providedValue
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (providedIsOpen) setIsOpen(providedIsOpen);
    }, [
        providedIsOpen
    ]);
    const onChange = (0, $5uXOq.useCallback)((newValue, action)=>{
        const rawValue = newValue ? newValue.value || newValue : '';
        const finalValue = rawValue.toString();
        setValue(finalValue);
        if (action && action.action === 'clear') setClearingFromIcon(true);
        providedOnChangeWithAnalytics(finalValue);
    }, [
        providedOnChangeWithAnalytics
    ]);
    /**
   * Only allow custom times if timeIsEditable prop is true
   */ const onCreateOption = (inputValue)=>{
        if (timeIsEditable) {
            let sanitizedInput;
            try {
                sanitizedInput = parseInputValue(inputValue, timeFormat || (0, $jHBnA.defaultTimeFormat));
            } catch (e) {
                return; // do nothing, the main validation should happen in the form
            }
            const includesSeconds = !!(timeFormat && /[:.]?(s|ss)/.test(timeFormat));
            const formatFormat = includesSeconds ? 'HH:mm:ss' : 'HH:mm';
            const formattedValue = (0, $k7m40.default)(sanitizedInput, formatFormat) || '';
            setValue(formattedValue);
            providedOnChangeWithAnalytics(formattedValue);
        } else providedOnChangeWithAnalytics(inputValue);
    };
    const onMenuOpen = ()=>{
        // Don't open menu after the user has clicked clear
        if (clearingFromIcon) setClearingFromIcon(false);
        else setIsOpen(true);
    };
    const onMenuClose = ()=>{
        // Don't close menu after the user has clicked clear
        if (clearingFromIcon) setClearingFromIcon(false);
        else setIsOpen(false);
    };
    const setInternalContainerRef = (ref)=>{
        const oldRef = containerRef;
        setContainerRef(ref);
        // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef === null && ref !== null) forceUpdate();
    };
    const onBlur = (event)=>{
        setIsFocused(false);
        providedOnBlur(event);
    };
    const onFocus = (event)=>{
        setIsFocused(true);
        providedOnFocus(event);
    };
    const onSelectKeyDown = (event)=>{
        const { key: key } = event;
        const keyPressed = key.toLowerCase();
        if (clearingFromIcon && (keyPressed === 'backspace' || keyPressed === 'delete')) // If being cleared from keyboard, don't change behaviour
        setClearingFromIcon(false);
    };
    const ICON_PADDING = 2;
    const GRID_SIZE = 8;
    const l10n = (0, $7qZ1x.createLocalizationProvider)(locale);
    const { styles: selectStyles = {}, ...otherSelectProps } = selectProps;
    const SelectComponent = timeIsEditable ? (0, $iOwNT.default) : (0, $7K5PP.default);
    /**
   * There are multiple props that can change how the time is formatted.
   * The priority of props used is:
   *   1. formatDisplayLabel
   *   2. timeFormat
   *   3. locale
   */ const formatTime = (time)=>{
        if (formatDisplayLabel) return formatDisplayLabel(time, timeFormat || (0, $jHBnA.defaultTimeFormat));
        const date = (0, $j537G.default)(time);
        if (!(date instanceof Date)) return '';
        if (!(0, $jovBr.default)(date)) return time;
        if (timeFormat) return (0, $k7m40.default)(date, (0, $2ucUe.convertTokens)(timeFormat));
        return l10n.formatTime(date);
    };
    const options = times.map((time)=>{
        return {
            label: formatTime(time),
            value: time
        };
    });
    let initialValue;
    if (providedValue !== null && providedValue !== undefined && providedValue !== '') initialValue = {
        label: formatTime(providedValue),
        value: providedValue
    };
    else if (providedValue !== '' && value) initialValue = {
        label: formatTime(value),
        value: value
    };
    else initialValue = null;
    const SingleValue = (0, $dBs4v.makeSingleValue)({
        lang: locale
    });
    const selectComponents = {
        DropdownIndicator: (0, $jHBnA.EmptyComponent),
        Menu: (0, $imOgG.FixedLayerMenu),
        SingleValue: SingleValue,
        ...hideIcon && {
            ClearIndicator: (0, $jHBnA.EmptyComponent)
        }
    };
    const renderIconContainer = Boolean(!hideIcon && value);
    // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
    const mergedStyles = (0, $7VXAu.mergeStyles)(selectStyles, {
        control: (base)=>({
                ...base
            }),
        menu: (base)=>({
                ...base,
                ...$420c0ce16dc216b4$var$menuStyles,
                // Fixed positioned elements no longer inherit width from their parent, so we must explicitly set the
                // menu width to the width of our container
                width: containerRef ? containerRef.getBoundingClientRect().width : 'auto'
            }),
        indicatorsContainer: (base)=>({
                ...base,
                paddingLeft: renderIconContainer ? ICON_PADDING : 0,
                paddingRight: renderIconContainer ? GRID_SIZE - ICON_PADDING : 0
            })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        ...innerProps,
        ref: setInternalContainerRef,
        "data-testid": testId && `${testId}--container`,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                name: name,
                type: "hidden",
                value: value,
                "data-testid": testId && `${testId}--input`,
                onKeyDown: onSelectKeyDown
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)(SelectComponent, {
                "aria-describedby": ariaDescribedBy,
                "aria-label": label || undefined,
                appearance: appearance,
                autoFocus: autoFocus,
                clearControlLabel: clearControlLabel,
                components: selectComponents,
                inputId: id,
                isClearable: true,
                isDisabled: isDisabled,
                isRequired: isRequired,
                menuIsOpen: isOpen && !isDisabled,
                menuPlacement: "auto",
                openMenuOnFocus: true,
                onBlur: onBlur,
                onCreateOption: onCreateOption,
                onChange: onChange,
                options: options,
                onFocus: onFocus,
                onMenuOpen: onMenuOpen,
                onMenuClose: onMenuClose,
                placeholder: placeholder || l10n.formatTime((0, $jHBnA.placeholderDatetime)),
                styles: mergedStyles,
                value: initialValue,
                spacing: spacing,
                // We need this to get things to work, even though it's not supported.
                // @ts-ignore
                fixedLayerRef: containerRef,
                isInvalid: isInvalid,
                testId: testId,
                ...otherSelectProps
            })
        ]
    });
});
var $420c0ce16dc216b4$export$2e2bcd8739ae039 = $420c0ce16dc216b4$var$TimePicker;

});
parcelRegister("iOwNT", function(module, exports) {

$parcel$export(module.exports, "default", () => $59b6485f0cb008dd$export$2e2bcd8739ae039);

var $9OU1i = parcelRequire("9OU1i");

var $3c98u = parcelRequire("3c98u");
const $59b6485f0cb008dd$var$CreatableSelect = (0, $3c98u.default)((0, $9OU1i.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$59b6485f0cb008dd$export$2e2bcd8739ae039 = $59b6485f0cb008dd$var$CreatableSelect;

});
parcelRegister("9OU1i", function(module, exports) {

$parcel$export(module.exports, "default", () => $b29f1caecd9c7d5a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useCreatable", () => (parcelRequire("2HH7Y")).default);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2QhWf = parcelRequire("2QhWf");

var $2HH7Y = parcelRequire("2HH7Y");

var $9uJ4X = parcelRequire("9uJ4X");
const $b29f1caecd9c7d5a$var$CreatableSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const creatableProps = (0, $9uJ4X.default)(props);
    const selectProps = (0, $2HH7Y.default)(creatableProps);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2QhWf.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b29f1caecd9c7d5a$export$2e2bcd8739ae039 = $b29f1caecd9c7d5a$var$CreatableSelect;

});
parcelRegister("2HH7Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $994aeb783b6f955a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eEtcC = parcelRequire("eEtcC");

var $gyjU7 = parcelRequire("gyjU7");
const $994aeb783b6f955a$var$compareOption = (inputValue = '', option, accessors)=>{
    const candidate = String(inputValue).toLowerCase();
    const optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    const optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
const $994aeb783b6f955a$var$builtins = {
    formatCreateLabel: (inputValue)=>`Create "${inputValue}"`,
    isValidNewOption: (inputValue, selectValue, selectOptions, accessors)=>!(!inputValue || selectValue.some((option)=>$994aeb783b6f955a$var$compareOption(inputValue, option, accessors)) || selectOptions.some((option)=>$994aeb783b6f955a$var$compareOption(inputValue, option, accessors))),
    getNewOptionData: (inputValue, optionLabel)=>({
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        })
};
function $994aeb783b6f955a$export$2e2bcd8739ae039({ allowCreateWhileLoading: allowCreateWhileLoading = false, createOptionPosition: createOptionPosition = 'last', formatCreateLabel: formatCreateLabel = $994aeb783b6f955a$var$builtins.formatCreateLabel, isValidNewOption: isValidNewOption = $994aeb783b6f955a$var$builtins.isValidNewOption, getNewOptionData: //@ts-ignore
getNewOptionData = $994aeb783b6f955a$var$builtins.getNewOptionData, onCreateOption: onCreateOption, options: propsOptions = [], onChange: propsOnChange, ...restSelectProps }) {
    const { getOptionValue: getOptionValue = (0, $eEtcC.getOptionValue), getOptionLabel: getOptionLabel = (0, $eEtcC.getOptionLabel), inputValue: inputValue, isLoading: isLoading, isMulti: isMulti, value: value, name: name } = restSelectProps;
    const newOption = (0, $5uXOq.useMemo)(()=>isValidNewOption(inputValue, (0, $gyjU7.cleanValue)(value), propsOptions, {
            getOptionValue: getOptionValue,
            getOptionLabel: getOptionLabel
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel,
        getOptionValue,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    const options = (0, $5uXOq.useMemo)(()=>(allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
            newOption,
            ...propsOptions
        ] : [
            ...propsOptions,
            newOption
        ] : propsOptions, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    const onChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
        if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
        const valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                const newOptionData = getNewOptionData(inputValue, inputValue);
                const newActionMeta = {
                    action: 'create-option',
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, $gyjU7.valueTernary)(isMulti, [
                    ...(0, $gyjU7.cleanValue)(value),
                    newOptionData
                ], newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return {
        ...restSelectProps,
        options: options,
        onChange: onChange
    };
}

});



parcelRegister("imOgG", function(module, exports) {

$parcel$export(module.exports, "FixedLayerMenu", () => $cf860f703ecf4b3d$export$982ad994195b4356);
/* fixed-layer-menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");

var $avHVh = parcelRequire("avHVh");
const $cf860f703ecf4b3d$export$982ad994195b4356 = ({ className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getValue: getValue, hasValue: hasValue, innerProps: innerProps, innerRef: innerRef, isLoading: isLoading, isMulti: isMulti, isRtl: isRtl, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, minMenuHeight: minMenuHeight, options: options, placement: placement, selectOption: selectOption, selectProps: selectProps, setValue: setValue, children: children, ...rest })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $avHVh.default), {
        inputValue: selectProps.inputValue,
        //@ts-ignore react-select unsupported props
        containerRef: selectProps.fixedLayerRef,
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).Menu, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: innerProps,
            innerRef: innerRef,
            isLoading: isLoading,
            isMulti: isMulti,
            isRtl: isRtl,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView,
            minMenuHeight: minMenuHeight,
            options: options,
            placement: placement,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue,
            children: children
        }),
        //@ts-ignore react-select unsupported props
        testId: selectProps.testId
    });

});

parcelRegister("j537G", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5e493719c30ce57$export$2e2bcd8739ae039);
const $b5e493719c30ce57$var$map24 = {
    '12': '12',
    '01': '13',
    '02': '14',
    '03': '15',
    '04': '16',
    '05': '17',
    '06': '18',
    '07': '19',
    '08': '20',
    '09': '21',
    '10': '22',
    '11': '23'
};
function $b5e493719c30ce57$export$1ea939691cdc45b8(timeString) {
    /**
	 * Regex match for `12:34`, `12:34:56`, `1:23:56 p`, `1:23:56PM`, and a bit more…
	 */ const time = timeString.trim().match(/([012]?[\d])(?::([0-5][\d]))?(?::([0-5][\d]))?\s*([ap]m?)?/i);
    /**
	 * Regex match for `1234`, `12:34`, `12.34`, `123456`, `12:34:56`, `12.34.56`
	 */ const time24hr = timeString.trim().match(/([012][\d])[:.]?([0-5][\d])([:.]?([0-5][\d]))?/);
    /**
	 * Convert `2:34:56 pm` down to `23456`
	 */ const num = timeString.replace(/[^0-9]/g, '');
    const includesSeconds = time && time[1] !== undefined && time[2] !== undefined && time[3] !== undefined || time24hr && time24hr[1] !== undefined && time24hr[2] !== undefined && time24hr[4] !== undefined;
    if (!time && !time24hr) return false;
    if (time && !time[1]) return false;
    if (num.length > 6) return false;
    if (num.length > 4 && !includesSeconds) return false;
    if (num.length === 2 && parseInt(num, 10) > 12) return false;
    return true;
}
function $b5e493719c30ce57$export$49c81d9f91c512ce(time) {
    return time.replace(/[:.]/g, '');
}
function $b5e493719c30ce57$var$formatSemi24(time) {
    if (time.length === 1) return `0${time}00`;
    if (time.length === 2) return `${time}00`;
    if (time.length === 3 || time.length === 5) return `0${time}`;
    return time;
}
function $b5e493719c30ce57$var$checkHour(hour, meridiem) {
    if (hour > '24') return null;
    if (hour === '12' && meridiem === 'a') return '00';
    if (hour < '12' && meridiem === 'p') return $b5e493719c30ce57$var$map24[hour];
    return hour;
}
function $b5e493719c30ce57$var$checkMinuteSecond(value) {
    if (value > '59') return null;
    return value;
}
function $b5e493719c30ce57$export$6137ce2c9c5166bb(time) {
    const timeArray = time.toLowerCase().split(/(p|a)/i);
    const meridiem = timeArray[1];
    const semi24 = $b5e493719c30ce57$var$formatSemi24(timeArray[0].trim());
    const hour = $b5e493719c30ce57$var$checkHour(semi24.substring(0, 2), meridiem);
    const minute = $b5e493719c30ce57$var$checkMinuteSecond(semi24.substring(2, 4));
    const seconds = semi24.length === 6 && $b5e493719c30ce57$var$checkMinuteSecond(semi24.substring(4, 6));
    if (!hour || !minute) return null;
    return {
        hour: parseInt(hour, 10),
        minute: parseInt(minute, 10),
        seconds: parseInt(seconds || '0', 10) || 0
    };
}
function $b5e493719c30ce57$var$assignToDate(time) {
    const dateTime = new Date();
    dateTime.setHours(time.hour);
    dateTime.setMinutes(time.minute);
    // milliseconds is not supported
    dateTime.setSeconds(time.seconds || 0, 0);
    return dateTime;
}
function $b5e493719c30ce57$export$2e2bcd8739ae039(time) {
    const trimmedTime = time.toString().trim();
    if (!$b5e493719c30ce57$export$1ea939691cdc45b8(trimmedTime)) throw RangeError('invalid time format');
    const time1 = $b5e493719c30ce57$export$49c81d9f91c512ce(trimmedTime);
    const time2 = $b5e493719c30ce57$export$6137ce2c9c5166bb(time1);
    if (!time2) throw RangeError('invalid time format');
    return $b5e493719c30ce57$var$assignToDate(time2);
}

});


parcelRegister("8C78M", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8375c0a150abd1f$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $f8375c0a150abd1f$export$2e2bcd8739ae039 = [
    '00:00',
    '00:30',
    '01:00',
    '01:30',
    '02:00',
    '02:30',
    '03:00',
    '03:30',
    '04:00',
    '04:30',
    '05:00',
    '05:30',
    '06:00',
    '06:30',
    '07:00',
    '07:30',
    '08:00',
    '08:30',
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00',
    '18:30',
    '19:00',
    '19:30',
    '20:00',
    '20:30',
    '21:00',
    '21:30',
    '22:00',
    '22:30',
    '23:00',
    '23:30'
];

});

parcelRegister("jy5cU", function(module, exports) {

$parcel$export(module.exports, "parseDateTimeToISO", () => $8c7b898430ca91bf$export$c3b7bf9ddc221a4f);
$parcel$export(module.exports, "parseDateValue", () => $8c7b898430ca91bf$export$220ff045e4b830ec);
$parcel$export(module.exports, "parseTimeValue", () => $8c7b898430ca91bf$export$beddb17599b4a110);
$parcel$export(module.exports, "getTimePlaceholder", () => $8c7b898430ca91bf$export$c7659888e054d16a);

var $k7m40 = parcelRequire("k7m40");

var $jj52j = parcelRequire("jj52j");

var $jovBr = parcelRequire("jovBr");

var $2753q = parcelRequire("2753q");

var $eZDAP = parcelRequire("eZDAP");

var $7qZ1x = parcelRequire("7qZ1x");
/**
 * Format used by atlaskit datepicker
 */ const $8c7b898430ca91bf$var$DATE_FORMAT = 'yyyy-MM-dd';
const $8c7b898430ca91bf$export$c4e1e4e065ff5bd8 = 'HH:mm';
const $8c7b898430ca91bf$export$c3b7bf9ddc221a4f = (date, time)=>{
    const parsedDate = (0, $2753q.default)(`${date} ${time}`, `${$8c7b898430ca91bf$var$DATE_FORMAT} ${$8c7b898430ca91bf$export$c4e1e4e065ff5bd8}`, new Date());
    if (!(0, $jovBr.default)(parsedDate)) return '';
    return (0, $jj52j.default)(parsedDate);
};
const $8c7b898430ca91bf$export$220ff045e4b830ec = (date)=>{
    if (!(0, $jovBr.default)((0, $eZDAP.default)(date))) return '';
    return (0, $k7m40.default)(new Date(date), $8c7b898430ca91bf$var$DATE_FORMAT);
};
const $8c7b898430ca91bf$export$beddb17599b4a110 = (date)=>{
    if (!(0, $jovBr.default)((0, $eZDAP.default)(date))) return '';
    return (0, $k7m40.default)(new Date(date), $8c7b898430ca91bf$export$c4e1e4e065ff5bd8);
};
const $8c7b898430ca91bf$export$c7659888e054d16a = (time, locale)=>{
    const { formatTime: formatTime } = (0, $7qZ1x.createLocalizationProvider)(locale);
    const parsedDate = (0, $2753q.default)(time, `${$8c7b898430ca91bf$export$c4e1e4e065ff5bd8}`, new Date());
    if (!(0, $jovBr.default)(parsedDate)) return time;
    return formatTime(parsedDate);
};

});


parcelRegister("caKWk", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ada671edc4e7ec1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1ada671edc4e7ec1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    and: {
        "id": "jql-builder-basic-datetime.between-date-time.and",
        "defaultMessage": "and"
    },
    startDateLabel: {
        "id": "jql-builder-basic-datetime.between-date-time.start-date-label",
        "defaultMessage": "Choose a start date"
    },
    endDateLabel: {
        "id": "jql-builder-basic-datetime.between-date-time.end-date-label",
        "defaultMessage": "Choose an end date"
    },
    startTimeLabel: {
        "id": "jql-builder-basic-datetime.between-date-time.start-time-label",
        "defaultMessage": "Choose a start time"
    },
    endTimeLabel: {
        "id": "jql-builder-basic-datetime.between-date-time.end-time-label",
        "defaultMessage": "Choose an end time"
    }
});

});


parcelRegister("k1RQ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $8906bb8f5b1e8491$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jovBr = parcelRequire("jovBr");

var $eZDAP = parcelRequire("eZDAP");

var $cHapz = parcelRequire("cHapz");

var $7qZ1x = parcelRequire("7qZ1x");

var $koVbs = parcelRequire("koVbs");

var $6yeNV = parcelRequire("6yeNV");

var $DVljb = parcelRequire("DVljb");

var $jaMj2 = parcelRequire("jaMj2");

var $80yAD = parcelRequire("80yAD");
const $8906bb8f5b1e8491$var$ONE_DAY_IN_MILLISECONDS = 86400000;
const $8906bb8f5b1e8491$var$isDateValueInvalid = (value)=>!(0, $jovBr.default)((0, $eZDAP.default)(value)) && value !== '';
const $8906bb8f5b1e8491$var$BetweenDates = ({ value: { value1: value1, value2: value2 }, onChange: onChange })=>{
    const locale = (0, $DVljb.useLocale)();
    const standardizedLocale = (0, $6yeNV.standardizeLocale)(locale);
    const [localizationProvider] = (0, $5uXOq.useState)((0, $7qZ1x.createLocalizationProvider)(standardizedLocale));
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onChangeValue1Date = (0, $5uXOq.useCallback)((value)=>{
        onChange({
            value1: value,
            value2: value2
        });
    }, [
        onChange,
        value2
    ]);
    const onChangeValue2Date = (0, $5uXOq.useCallback)((value)=>{
        onChange({
            value1: value1,
            value2: value
        });
    }, [
        onChange,
        value1
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jaMj2.StyledRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jaMj2.ChildWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cHapz.default), {
        id: "value1",
        locale: standardizedLocale,
        onChange: onChangeValue1Date,
        isInvalid: $8906bb8f5b1e8491$var$isDateValueInvalid(value1),
        value: !$8906bb8f5b1e8491$var$isDateValueInvalid(value1) ? value1 : '',
        spacing: "compact",
        testId: "jql-builder-basic-datetime.ui.between-dates.value-1",
        label: formatMessage((0, $80yAD.default).startDateLabel),
        placeholder: localizationProvider.formatDate(new Date(new Date().getTime() - $8906bb8f5b1e8491$var$ONE_DAY_IN_MILLISECONDS)),
        shouldShowCalendarButton: true,
        inputLabel: formatMessage((0, $80yAD.default).startDateLabel)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jaMj2.FixedChildWrapper), null, formatMessage((0, $80yAD.default).and)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jaMj2.ChildWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cHapz.default), {
        id: "value2",
        locale: standardizedLocale,
        isInvalid: $8906bb8f5b1e8491$var$isDateValueInvalid(value2),
        onChange: onChangeValue2Date,
        value: !$8906bb8f5b1e8491$var$isDateValueInvalid(value2) ? value2 : '',
        spacing: "compact",
        testId: "jql-builder-basic-datetime.ui.between-dates.value-2",
        label: formatMessage((0, $80yAD.default).endDateLabel),
        placeholder: localizationProvider.formatDate(new Date(new Date().getTime() + $8906bb8f5b1e8491$var$ONE_DAY_IN_MILLISECONDS)),
        shouldShowCalendarButton: true,
        inputLabel: formatMessage((0, $80yAD.default).endDateLabel)
    })));
};
var $8906bb8f5b1e8491$export$2e2bcd8739ae039 = $8906bb8f5b1e8491$var$BetweenDates;

});
parcelRegister("jaMj2", function(module, exports) {

$parcel$export(module.exports, "StyledRow", () => $71ae847b0deb634c$export$81761b52b04ea573);
$parcel$export(module.exports, "ChildWrapper", () => $71ae847b0deb634c$export$87c2de9f2249ec47);
$parcel$export(module.exports, "FixedChildWrapper", () => $71ae847b0deb634c$export$c11f358d1515ce8d);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $71ae847b0deb634c$export$81761b52b04ea573 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1b66 _1e0c1txw _18u01ejb _19pk12x7 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $71ae847b0deb634c$export$87c2de9f2249ec47 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});
const $71ae847b0deb634c$export$c11f358d1515ce8d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});

});

parcelRegister("80yAD", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ad6be19252adbe5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2ad6be19252adbe5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    and: {
        "id": "jql-builder-basic-datetime.between-dates.and",
        "defaultMessage": "and"
    },
    startDateLabel: {
        "id": "jql-builder-basic-datetime.between-dates.start-date-label",
        "defaultMessage": "Choose a start date"
    },
    endDateLabel: {
        "id": "jql-builder-basic-datetime.between-dates.end-date-label",
        "defaultMessage": "Choose an end date"
    }
});

});


parcelRegister("5v4cH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a10381ef5e7b13b2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kY99m = parcelRequire("kY99m");

var $koVbs = parcelRequire("koVbs");

var $jaMj2 = parcelRequire("jaMj2");

var $8gYLY = parcelRequire("8gYLY");
const $a10381ef5e7b13b2$var$InRangeOf = ({ value: { value1: value1 = '', value2: value2 = '' }, onChange: onChange, isInvalid: isInvalid })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onChangeValue1Date = (0, $5uXOq.useCallback)((event)=>{
        onChange({
            value1: event.currentTarget.value,
            value2: value2
        });
    }, [
        onChange,
        value2
    ]);
    const onChangeValue2Date = (0, $5uXOq.useCallback)((event)=>{
        onChange({
            value1: value1,
            value2: event.currentTarget.value
        });
    }, [
        onChange,
        value1
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jaMj2.StyledRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jaMj2.ChildWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
        isInvalid: isInvalid,
        name: "value1",
        onChange: onChangeValue1Date,
        value: value1,
        placeholder: "-3w 4d 12h 30m",
        isCompact: true,
        autoComplete: "off",
        testId: "jql-builder-basic-datetime.ui.in-range-of-time.input-1",
        "aria-label": formatMessage((0, $8gYLY.default).startTimeRangeLabel)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jaMj2.FixedChildWrapper), null, formatMessage((0, $8gYLY.default).to)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jaMj2.ChildWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
        isInvalid: isInvalid,
        name: "value2",
        onChange: onChangeValue2Date,
        value: value2,
        placeholder: "3w 4d 12h 30m",
        isCompact: true,
        autoComplete: "off",
        testId: "jql-builder-basic-datetime.ui.in-range-of-time.input-2",
        "aria-label": formatMessage((0, $8gYLY.default).endTimeRangeLabel)
    })));
};
var $a10381ef5e7b13b2$export$2e2bcd8739ae039 = $a10381ef5e7b13b2$var$InRangeOf;

});
parcelRegister("8gYLY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b61835f7c09eb153$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b61835f7c09eb153$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    to: {
        "id": "jql-builder-basic-datetime.in-range-of-time.to",
        "defaultMessage": "to"
    },
    startTimeRangeLabel: {
        "id": "jql-builder-basic-datetime.in-range-of-time.start-time-range-label",
        "defaultMessage": "Enter start of the time range e.g weeks, days, hours and/or minutes"
    },
    endTimeRangeLabel: {
        "id": "jql-builder-basic-datetime.in-range-of-time.end-time-range-label",
        "defaultMessage": "Enter end of the time range"
    }
});

});


parcelRegister("6IpN3", function(module, exports) {

$parcel$export(module.exports, "Radio", () => $6695b1b0efddbe1a$export$d7b12c4107be0d61);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $6695b1b0efddbe1a$var$Label = ({ htmlFor: htmlFor, children: children, testId: testId, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6695b1b0efddbe1a$export$eea83358d9434634, {
        htmlFor: htmlFor,
        "data-testid": testId,
        ...props
    }, children);
let $6695b1b0efddbe1a$var$controlId = 0;
const $6695b1b0efddbe1a$export$d7b12c4107be0d61 = ({ children: children, testId: testId, ...props })=>{
    $6695b1b0efddbe1a$var$controlId += 1;
    const id = `jql-builder-basic-datetime-dialog-radio-${$6695b1b0efddbe1a$var$controlId}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6695b1b0efddbe1a$var$Label, {
        htmlFor: id,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6695b1b0efddbe1a$export$a195049fd73b3fe2, {
        type: "radio",
        id: id,
        ...props
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, children));
};
const $6695b1b0efddbe1a$export$eea83358d9434634 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4cvr1h6o _1e0c1txw _24rc1b66",
            __cmplp.className
        ])
    });
});
const $6695b1b0efddbe1a$export$a195049fd73b3fe2 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "input", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkze3t _2hwx1b66 _otyrze3t _18u01b66",
            __cmplp.className
        ])
    });
});

});

parcelRegister("b6HWX", function(module, exports) {

$parcel$export(module.exports, "default", () => $11bac68aeccd6278$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7K5PP = parcelRequire("7K5PP");

var $kY99m = parcelRequire("kY99m");

var $koVbs = parcelRequire("koVbs");

var $cv9D1 = parcelRequire("cv9D1");

var $f2Bil = parcelRequire("f2Bil");

var $jaMj2 = parcelRequire("jaMj2");

var $iNRIY = parcelRequire("iNRIY");
const $11bac68aeccd6278$var$TimeInput = ({ value: { value1: value1, value2: value2, excludeOverdue: excludeOverdue }, onChange: onChange, typeConfig: { endLabel: endLabel, overduePicker: overduePicker }, isInvalid: isInvalid })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [overdueOptions] = (0, $5uXOq.useState)([
        {
            label: formatMessage((0, $iNRIY.default).labelOrIs),
            value: 'or-is'
        },
        {
            label: formatMessage((0, $iNRIY.default).labelAndNot),
            value: 'and-not'
        }
    ]);
    const [options] = (0, $5uXOq.useState)(Object.entries((0, $cv9D1.TimeUnits)).map(([value, timeUnit])=>{
        const messageDescriptor = (0, $iNRIY.messageLookup)[`${timeUnit}${endLabel || ''}`];
        return {
            label: messageDescriptor ? formatMessage(messageDescriptor) : '',
            value: value
        };
    }));
    (0, $5uXOq.useEffect)(()=>{
        if (value2 === '') {
            const value = {
                value1: value1,
                value2: Object.keys((0, $cv9D1.TimeUnits))[0]
            };
            if (overduePicker !== undefined && overduePicker === true) value.excludeOverdue = excludeOverdue;
            onChange(value);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onChangeValue1 = (0, $5uXOq.useCallback)((event)=>{
        const value = {
            value1: event.currentTarget.value,
            value2: value2
        };
        if (overduePicker !== undefined && overduePicker === true) value.excludeOverdue = excludeOverdue;
        onChange(value);
    }, [
        value2,
        overduePicker,
        onChange,
        excludeOverdue
    ]);
    const onChangeValue2 = (0, $5uXOq.useCallback)((optionValue)=>{
        if (!optionValue) return;
        const value = {
            value1: value1,
            value2: optionValue.value
        };
        if (overduePicker !== undefined && overduePicker === true) value.excludeOverdue = excludeOverdue;
        onChange(value);
    }, [
        excludeOverdue,
        onChange,
        overduePicker,
        value1
    ]);
    const onChangeExcludeOverdue = (0, $5uXOq.useCallback)((value)=>{
        if (!value) return;
        onChange({
            value1: value1,
            value2: value2,
            excludeOverdue: value.value === overdueOptions[1].value
        });
    }, [
        onChange,
        overdueOptions,
        value1,
        value2
    ]);
    const optionValue2 = options.find((o)=>o.value === value2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jaMj2.StyledRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($11bac68aeccd6278$var$InputWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
        isInvalid: isInvalid,
        name: "value1",
        onChange: onChangeValue1,
        value: value1,
        isCompact: true,
        autoComplete: "off",
        testId: "jql-builder-basic-datetime.ui.time-input.input",
        "aria-label": formatMessage((0, $iNRIY.default).timeInputLabel, {
            timeUnit: optionValue2?.label
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($11bac68aeccd6278$var$ChildWrapper, {
        overduePicker: overduePicker
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        value: optionValue2,
        "aria-label": formatMessage((0, $iNRIY.default).labelTimeUnit),
        onChange: onChangeValue2,
        name: "value2",
        options: options,
        spacing: "compact",
        components: (0, $f2Bil.default),
        styles: {
            singleValue: (base)=>({
                    ...base,
                    minWidth: 'fit-content'
                })
        },
        testId: "jql-builder-basic-datetime.ui.time-input.time-units-select"
    })), overduePicker !== undefined && overduePicker === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($11bac68aeccd6278$var$ChildWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        value: excludeOverdue === true ? overdueOptions[1] : overdueOptions[0],
        onChange: onChangeExcludeOverdue,
        name: "excludeOverdue",
        options: overdueOptions,
        spacing: "compact",
        components: (0, $f2Bil.default),
        styles: {
            singleValue: (base)=>({
                    ...base,
                    minWidth: 'fit-content'
                })
        },
        testId: "jql-builder-basic-datetime.ui.time-input.overdue-select",
        "aria-label": formatMessage((0, $iNRIY.default).labelTimeStatus)
    })));
};
var $11bac68aeccd6278$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
 = $11bac68aeccd6278$var$TimeInput;
const $11bac68aeccd6278$var$InputWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zkb7n _i0dlf1ug _1ul9t9kd",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $11bac68aeccd6278$var$ChildWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { overduePicker: overduePicker, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zkb7n _i0dlf1ug",
            __cmplp.overduePicker ? "_1ul916xz" : "_1ul91llu",
            __cmplp.className
        ])
    });
});

});
parcelRegister("f2Bil", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1223566a9b0d447$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");
const $d1223566a9b0d447$var$Control = ({ children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": `${rest.selectProps.testId}--control`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Control, rest, children));
const $d1223566a9b0d447$var$Option = ({ children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": `${rest.selectProps.testId}--option`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, rest, children));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d1223566a9b0d447$export$2e2bcd8739ae039 = {
    Control: $d1223566a9b0d447$var$Control,
    Option: $d1223566a9b0d447$var$Option
};

});

parcelRegister("iNRIY", function(module, exports) {

$parcel$export(module.exports, "default", () => $62e7a7c62c2e3672$export$2e2bcd8739ae039);
$parcel$export(module.exports, "messageLookup", () => $62e7a7c62c2e3672$export$3a16bd55b6aaaf91);

var $7VHMR = parcelRequire("7VHMR");
const $62e7a7c62c2e3672$var$messages = (0, $7VHMR.defineMessages)({
    minutes: {
        "id": "jql-builder-basic-datetime.time-input.minutes",
        "defaultMessage": "minutes"
    },
    hours: {
        "id": "jql-builder-basic-datetime.time-input.hours",
        "defaultMessage": "hours"
    },
    days: {
        "id": "jql-builder-basic-datetime.time-input.days",
        "defaultMessage": "days"
    },
    weeks: {
        "id": "jql-builder-basic-datetime.time-input.weeks",
        "defaultMessage": "weeks"
    },
    months: {
        "id": "jql-builder-basic-datetime.time-input.months",
        "defaultMessage": "months"
    },
    years: {
        "id": "jql-builder-basic-datetime.time-input.years",
        "defaultMessage": "years"
    },
    minutesAgo: {
        "id": "jql-builder-basic-datetime.time-input.minutes-ago",
        "defaultMessage": "minutes ago"
    },
    hoursAgo: {
        "id": "jql-builder-basic-datetime.time-input.hours-ago",
        "defaultMessage": "hours ago"
    },
    daysAgo: {
        "id": "jql-builder-basic-datetime.time-input.days-ago",
        "defaultMessage": "days ago"
    },
    weeksAgo: {
        "id": "jql-builder-basic-datetime.time-input.weeks-ago",
        "defaultMessage": "weeks ago"
    },
    monthsAgo: {
        "id": "jql-builder-basic-datetime.time-input.months-ago",
        "defaultMessage": "months ago"
    },
    yearsAgo: {
        "id": "jql-builder-basic-datetime.time-input.years-ago",
        "defaultMessage": "years ago"
    },
    minutesOverdue: {
        "id": "jql-builder-basic-datetime.time-input.minutes-overdue",
        "defaultMessage": "minutes overdue"
    },
    hoursOverdue: {
        "id": "jql-builder-basic-datetime.time-input.hours-overdue",
        "defaultMessage": "hours overdue"
    },
    daysOverdue: {
        "id": "jql-builder-basic-datetime.time-input.days-overdue",
        "defaultMessage": "days overdue"
    },
    weeksOverdue: {
        "id": "jql-builder-basic-datetime.time-input.weeks-overdue",
        "defaultMessage": "weeks overdue"
    },
    monthsOverdue: {
        "id": "jql-builder-basic-datetime.time-input.months-overdue",
        "defaultMessage": "months overdue"
    },
    yearsOverdue: {
        "id": "jql-builder-basic-datetime.time-input.years-overdue",
        "defaultMessage": "years overdue"
    },
    labelOrIs: {
        "id": "jql-builder-basic-datetime.time-input.label-or-is",
        "defaultMessage": "or is overdue"
    },
    labelAndNot: {
        "id": "jql-builder-basic-datetime.time-input.label-and-not",
        "defaultMessage": "and not overdue"
    },
    labelTimeUnit: {
        "id": "jql-builder-basic-datetime.time-input.label-time-unit",
        "defaultMessage": "Select unit of time"
    },
    labelTimeStatus: {
        "id": "jql-builder-basic-datetime.time-input.label-time-status",
        "defaultMessage": "Select status"
    },
    timeInputLabel: {
        "id": "jql-builder-basic-datetime.time-input.time-input-label",
        "defaultMessage": "Enter a number of {timeUnit}"
    }
});
var $62e7a7c62c2e3672$export$2e2bcd8739ae039 = $62e7a7c62c2e3672$var$messages;
const $62e7a7c62c2e3672$export$3a16bd55b6aaaf91 = $62e7a7c62c2e3672$var$messages;

});


parcelRegister("dJttO", function(module, exports) {

$parcel$export(module.exports, "DueDateTypeConfig", () => $2682fba2ac97e4ed$export$e089c311056e8386);
$parcel$export(module.exports, "DateTypeConfig", () => $2682fba2ac97e4ed$export$6643317b16cfbee9);
$parcel$export(module.exports, "DateTimeTypeConfig", () => $2682fba2ac97e4ed$export$5ff2b2d5b16ed369);

var $ctEDs = parcelRequire("ctEDs");

var $a3exZ = parcelRequire("a3exZ");

var $dG6Ze = parcelRequire("dG6Ze");

var $jOFhu = parcelRequire("jOFhu");

var $8uhcn = parcelRequire("8uhcn");

var $5FZbC = parcelRequire("5FZbC");

var $2O68y = parcelRequire("2O68y");
const $2682fba2ac97e4ed$export$e089c311056e8386 = [
    (0, $5FZbC.NOW_OVERDUE_CONFIG),
    (0, $8uhcn.MORE_THAN_CONFIG),
    (0, $dG6Ze.DUE_IN_NEXT_CONFIG),
    (0, $ctEDs.BETWEEN_CONFIG),
    (0, $jOFhu.IN_RANGE_CONFIG)
];
const $2682fba2ac97e4ed$export$6643317b16cfbee9 = [
    (0, $2O68y.WITHIN_THE_LAST_CONFIG),
    (0, $8uhcn.CONFIG_DATE_MORE_THAN),
    (0, $ctEDs.BETWEEN_CONFIG),
    (0, $jOFhu.IN_RANGE_CONFIG)
];
const $2682fba2ac97e4ed$export$5ff2b2d5b16ed369 = [
    (0, $2O68y.WITHIN_THE_LAST_CONFIG),
    (0, $8uhcn.CONFIG_DATE_MORE_THAN),
    (0, $a3exZ.BETWEEN_DATE_TIME_CONFIG),
    (0, $jOFhu.IN_RANGE_CONFIG)
];

});
parcelRegister("ctEDs", function(module, exports) {

$parcel$export(module.exports, "BETWEEN_CONFIG", () => $a122ecf6e5236d3f$export$76f00c4fd9a48d7b);

var $jovBr = parcelRequire("jovBr");

var $bzbto = parcelRequire("bzbto");

var $e5geY = parcelRequire("e5geY");

var $4M9H7 = parcelRequire("4M9H7");
const $a122ecf6e5236d3f$export$76f00c4fd9a48d7b = {
    type: 'between',
    componentType: 'between',
    label: 'labelBetween',
    hasInput: true,
    getErrorMessage: (intl, value)=>{
        if (value?.value1 && value?.value2 && new Date(value?.value1) > new Date(value?.value2)) return intl.formatMessage((0, $e5geY.default).validationMessageBeforeGreaterThanAfter);
        if (value && (value?.value1 !== '' && !(0, $jovBr.default)(new Date(value?.value1)) || value?.value2 !== '' && !(0, $jovBr.default)(new Date(value?.value2)))) return intl.formatMessage((0, $e5geY.default).validationMessageInvalidDateFormat);
        return undefined;
    },
    getFormattedValue: (intl, value)=>{
        // Format Date based on 'UTC' because `new Date()` uses UTC when no timezone present, and JQL dates never have a timezone
        // JRACLOUD-79698: Without this, users west of UTC will see the dates off-by-one in the UI
        const formatOptions = {
            timeZone: 'UTC'
        };
        if (value) {
            if (value.value1 && value.value2) {
                if ((0, $jovBr.default)(new Date(value.value1)) && (0, $jovBr.default)(new Date(value.value2))) return `${intl.formatDate(new Date(value.value1), formatOptions)} - ${intl.formatDate(new Date(value.value2), formatOptions)}`;
            } else if (value.value1 && (0, $jovBr.default)(new Date(value.value1)) || value.value2 && (0, $jovBr.default)(new Date(value.value2))) {
                const valueToformat = value.value1 || value.value2;
                return intl.formatDate(new Date(valueToformat), formatOptions);
            }
        }
        return '';
    },
    getJqlData: ({ value1: value1, value2: value2 } = {})=>({
            primaryClause: value1 ? {
                operator: (0, $bzbto.OPERATOR_GT_EQUALS),
                operand: `${value1}`
            } : undefined,
            secondaryClause: value2 ? {
                operator: (0, $bzbto.OPERATOR_LT_EQUALS),
                operand: `${value2}`
            } : undefined
        }),
    getValueFromJqlData: (jqlData)=>{
        if (jqlData !== undefined) {
            const { primaryClause: primaryClause, secondaryClause: secondaryClause } = jqlData;
            if (primaryClause === undefined && secondaryClause === undefined) // Do not match type if both clauses are not present
            return undefined;
            if (primaryClause !== undefined || secondaryClause !== undefined) {
                const returnValue = {
                    value1: '',
                    value2: ''
                };
                [
                    primaryClause,
                    secondaryClause
                ].forEach((clause)=>{
                    if (clause) {
                        const operatorValue = clause.operator ? clause.operator : '';
                        const value = clause.operand !== undefined ? clause.operand : '';
                        switch(operatorValue){
                            case 0, $bzbto.OPERATOR_GT_EQUALS:
                                if (value.match((0, $4M9H7.IS_YYYY_MM_DD_REGEX))) returnValue.value1 = value;
                                break;
                            case 0, $bzbto.OPERATOR_LT_EQUALS:
                                if (value.match((0, $4M9H7.IS_YYYY_MM_DD_REGEX))) returnValue.value2 = value;
                                break;
                            default:
                                break;
                        }
                    }
                });
                if (returnValue.value1 || returnValue.value2) return returnValue;
            }
            return undefined;
        }
        return undefined;
    }
};

});
parcelRegister("e5geY", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8d74a939a673910$export$2e2bcd8739ae039);
$parcel$export(module.exports, "messageLookup", () => $e8d74a939a673910$export$3a16bd55b6aaaf91);

var $7VHMR = parcelRequire("7VHMR");
const $e8d74a939a673910$var$messages = (0, $7VHMR.defineMessages)({
    updateButtonText: {
        "id": "jql-builder-basic-datetime.utils.update-button-text",
        "defaultMessage": "Update"
    },
    legendText: {
        "id": "jql-builder-basic-datetime.utils.legend-text",
        "defaultMessage": "{fieldLabel} issues by date and time"
    },
    labelNowOverdue: {
        "id": "jql-builder-basic-datetime.utils.label-now-overdue",
        "defaultMessage": "Now overdue"
    },
    valueNowOverdue: {
        "id": "jql-builder-basic-datetime.utils.value-now-overdue",
        "defaultMessage": "Now overdue"
    },
    labelMoreThan: {
        "id": "jql-builder-basic-datetime.utils.label-more-than",
        "defaultMessage": "More than"
    },
    valueMoreThanMinutes: {
        "id": "jql-builder-basic-datetime.utils.value-more-than-minutes",
        "defaultMessage": "More than {dateNumber, plural, =0 {now} one {# minute ago} other {# minutes ago}}"
    },
    valueMoreThanHours: {
        "id": "jql-builder-basic-datetime.utils.value-more-than-hours",
        "defaultMessage": "More than {dateNumber, plural, =0 {now} one {# hour ago} other {# hours ago}}"
    },
    valueMoreThanDays: {
        "id": "jql-builder-basic-datetime.utils.value-more-than-days",
        "defaultMessage": "More than {dateNumber, plural, =0 {now} one {# day ago} other {# days ago}}"
    },
    valueMoreThanWeeks: {
        "id": "jql-builder-basic-datetime.utils.value-more-than-weeks",
        "defaultMessage": "More than {dateNumber, plural, =0 {now} one {# week ago} other {# weeks ago}}"
    },
    labelDueInNext: {
        "id": "jql-builder-basic-datetime.utils.label-due-in-next",
        "defaultMessage": "Due in next"
    },
    valueDueInNextExcludeOverdueMinutes: {
        "id": "jql-builder-basic-datetime.utils.value-due-in-next-exclude-overdue-minutes",
        "defaultMessage": "Due in next {dateNumber, plural, =0 {0 minutes} one {# minute} other {# minutes}}"
    },
    valueDueInNextExcludeOverdueHours: {
        "id": "jql-builder-basic-datetime.utils.value-due-in-next-exclude-overdue-hours",
        "defaultMessage": "Due in next {dateNumber, plural, =0 {0 hours} one {# hour} other {# hours}}"
    },
    valueDueInNextExcludeOverdueDays: {
        "id": "jql-builder-basic-datetime.utils.value-due-in-next-exclude-overdue-days",
        "defaultMessage": "Due in next {dateNumber, plural, =0 {0 days} one {# day} other {# days}}"
    },
    valueDueInNextExcludeOverdueWeeks: {
        "id": "jql-builder-basic-datetime.utils.value-due-in-next-exclude-overdue-weeks",
        "defaultMessage": "Due in next {dateNumber, plural, =0 {0 weeks} one {# week} other {# weeks}}"
    },
    valueDueInNextMinutes: {
        "id": "jql-builder-basic-datetime.utils.value-due-in-next-minutes",
        "defaultMessage": "Due in next {dateNumber, plural, =0 {0 minutes} one {# minute} other {# minutes}} or is overdue"
    },
    valueDueInNextHours: {
        "id": "jql-builder-basic-datetime.utils.value-due-in-next-hours",
        "defaultMessage": "Due in next {dateNumber, plural, =0 {0 hours} one {# hour} other {# hours}} or is overdue"
    },
    valueDueInNextDays: {
        "id": "jql-builder-basic-datetime.utils.value-due-in-next-days",
        "defaultMessage": "Due in next {dateNumber, plural, =0 {0 days} one {# day} other {# days}} or is overdue"
    },
    valueDueInNextWeeks: {
        "id": "jql-builder-basic-datetime.utils.value-due-in-next-weeks",
        "defaultMessage": "Due in next {dateNumber, plural, =0 {0 weeks} one {# week} other {# weeks}} or is overdue"
    },
    labelBetween: {
        "id": "jql-builder-basic-datetime.utils.label-between",
        "defaultMessage": "Between"
    },
    labelInRange: {
        "id": "jql-builder-basic-datetime.utils.label-in-range",
        "defaultMessage": "In the range"
    },
    valueInRange: {
        "id": "jql-builder-basic-datetime.utils.value-in-range",
        "defaultMessage": "From {start} to {end}"
    },
    valueInRangeBeforeNowToAfterNow: {
        "id": "jql-builder-basic-datetime.utils.value-in-range-before-now-to-after-now",
        "defaultMessage": "From {beforeTime} ago to {afterTime} from now"
    },
    valueInRangeBeforeNowToBeforeNow: {
        "id": "jql-builder-basic-datetime.utils.value-in-range-before-now-to-before-now",
        "defaultMessage": "From {beforeTime} ago to {afterTime} ago"
    },
    valueInRangeAfterNowToAfterNow: {
        "id": "jql-builder-basic-datetime.utils.value-in-range-after-now-to-after-now",
        "defaultMessage": "From {beforeTime} from now to {afterTime} from now"
    },
    valueInRangeBeforeNowToBlank: {
        "id": "jql-builder-basic-datetime.utils.value-in-range-before-now-to-blank",
        "defaultMessage": "From {beforeTime} ago"
    },
    valueInRangeAfterNowToBlank: {
        "id": "jql-builder-basic-datetime.utils.value-in-range-after-now-to-blank",
        "defaultMessage": "From {beforeTime} from now"
    },
    valueInRangeBlankToBeforeNow: {
        "id": "jql-builder-basic-datetime.utils.value-in-range-blank-to-before-now",
        "defaultMessage": "Up to {afterTime} ago"
    },
    valueInRangeBlankToAfterNow: {
        "id": "jql-builder-basic-datetime.utils.value-in-range-blank-to-after-now",
        "defaultMessage": "Up to {afterTime} from now"
    },
    labelIsNotSet: {
        "id": "jql-builder-basic-datetime.utils.label-is-not-set",
        "defaultMessage": "is empty"
    },
    labelWithinTheLast: {
        "id": "jql-builder-basic-datetime.utils.label-within-the-last",
        "defaultMessage": "Within the last"
    },
    valueWithinTheLastMinutes: {
        "id": "jql-builder-basic-datetime.utils.value-within-the-last-minutes",
        "defaultMessage": "Within the last {dateNumber, plural, =0 {0 minutes} one {# minute} other {# minutes}}"
    },
    valueWithinTheLastHours: {
        "id": "jql-builder-basic-datetime.utils.value-within-the-last-hours",
        "defaultMessage": "Within the last {dateNumber, plural, =0 {0 hours} one {# hour} other {# hours}}"
    },
    valueWithinTheLastDays: {
        "id": "jql-builder-basic-datetime.utils.value-within-the-last-days",
        "defaultMessage": "Within the last {dateNumber, plural, =0 {0 days} one {# day} other {# days}}"
    },
    valueWithinTheLastWeeks: {
        "id": "jql-builder-basic-datetime.utils.value-within-the-last-weeks",
        "defaultMessage": "Within the last {dateNumber, plural, =0 {0 weeks} one {# week} other {# weeks}}"
    },
    valueTimeInWeeks: {
        "id": "jql-builder-basic-datetime.utils.value-time-in-weeks",
        "defaultMessage": "{timeNumber, plural, =0 {0 weeks} one {# week} other {# weeks}}"
    },
    valueTimeInDays: {
        "id": "jql-builder-basic-datetime.utils.value-time-in-days",
        "defaultMessage": "{timeNumber, plural, =0 {0 days} one {# day} other {# days}}"
    },
    valueTimeInHours: {
        "id": "jql-builder-basic-datetime.utils.value-time-in-hours",
        "defaultMessage": "{timeNumber, plural, =0 {0 hours} one {# hour} other {# hours}}"
    },
    valueTimeInMinutes: {
        "id": "jql-builder-basic-datetime.utils.value-time-in-minutes",
        "defaultMessage": "{timeNumber, plural, =0 {0 minutes} one {# minute} other {# minutes}}"
    },
    validationMessageInvalidPeriodFormat: {
        "id": "jql-builder-basic-datetime.utils.validation-message-invalid-period-format",
        "defaultMessage": "Enter a valid number"
    },
    validationMessageBeforeGreaterThanAfter: {
        "id": "jql-builder-basic-datetime.utils.validation-message-before-greater-than-after",
        "defaultMessage": "'Before' field cannot be later than 'After' field."
    },
    validationMessageFromGreaterThanTo: {
        "id": "jql-builder-basic-datetime.utils.validation-message-from-greater-than-to",
        "defaultMessage": "'From' field cannot be later than 'To' field."
    },
    validationMessageInvalidDateFormat: {
        "id": "jql-builder-basic-datetime.utils.validation-message-invalid-date-format",
        "defaultMessage": "Invalid date format."
    },
    validationMessageInvalidPeriodFormatValue: {
        "id": "jql-builder-basic-datetime.utils.validation-message-invalid-period-format-value",
        "defaultMessage": "Invalid period format. Please enter the period in the format \"3w 4d 5h 6m\"."
    }
});
var $e8d74a939a673910$export$2e2bcd8739ae039 = $e8d74a939a673910$var$messages;
const $e8d74a939a673910$export$3a16bd55b6aaaf91 = $e8d74a939a673910$var$messages;

});

parcelRegister("4M9H7", function(module, exports) {

$parcel$export(module.exports, "IS_YYYY_MM_DD_REGEX", () => $9edf72b6e867fbac$export$f1b1463eb20d9130);
$parcel$export(module.exports, "getTimeInfo", () => $9edf72b6e867fbac$export$5c5047d260d2b2e4);
$parcel$export(module.exports, "getTimeString", () => $9edf72b6e867fbac$export$da876ebe5870f49a);
$parcel$export(module.exports, "getTimeInMinutes", () => $9edf72b6e867fbac$export$99ba9a356555dbdf);
$parcel$export(module.exports, "isValidTimePeriodFormat", () => $9edf72b6e867fbac$export$2214112898027187);

var $e5geY = parcelRequire("e5geY");
const $9edf72b6e867fbac$var$periodRegexp = /^(?!$)(?<sign>(^-))?((?<weeks>\d+)w)? ?((?<days>\d+)d)? ?((?<hours>\d+)h)? ?((?<minutes>\d+)m)*$/;
const $9edf72b6e867fbac$export$f1b1463eb20d9130 = /[1-9][0-9]{3}([-][0-9]{2}){2}/;
const $9edf72b6e867fbac$export$412dc06c06fbf003 = (timeString)=>{
    const weeksIndex = timeString.indexOf('w');
    const daysIndex = timeString.indexOf('d');
    const hoursIndex = timeString.indexOf('h');
    const minutesIndex = timeString.indexOf('m');
    if (weeksIndex > -1 && weeksIndex < timeString.length - 1 && timeString[weeksIndex + 1] !== ' ') return false;
    if (daysIndex > -1 && daysIndex < timeString.length - 1 && timeString[daysIndex + 1] !== ' ') return false;
    if (hoursIndex > -1 && hoursIndex < timeString.length - 1 && timeString[hoursIndex + 1] !== ' ') return false;
    if (minutesIndex > -1 && minutesIndex < timeString.length - 1 && timeString[minutesIndex + 1] !== ' ') return false;
    return true;
};
const $9edf72b6e867fbac$export$5c5047d260d2b2e4 = (timeData)=>{
    if (timeData !== undefined) {
        const matches = timeData.match($9edf72b6e867fbac$var$periodRegexp);
        if ($9edf72b6e867fbac$var$periodRegexp.test(timeData) && $9edf72b6e867fbac$export$412dc06c06fbf003(timeData) && matches && matches.groups) {
            const { sign: sign = '', weeks: weeks = '', days: days = '', hours: hours = '', minutes: minutes = '' } = matches.groups;
            const parsedWeeks = parseInt(weeks, 10);
            const parsedDays = parseInt(days, 10);
            const parsedHours = parseInt(hours, 10);
            const parsedMinute = parseInt(minutes, 10);
            return {
                isBeforeNow: sign === '-',
                minutes: Number.isNaN(parsedMinute) ? undefined : +parsedMinute,
                hours: Number.isNaN(parsedHours) ? undefined : +parsedHours,
                days: Number.isNaN(parsedDays) ? undefined : +parsedDays,
                weeks: Number.isNaN(parsedWeeks) ? undefined : +parsedWeeks,
                isValid: true
            };
        }
    }
    return {
        isBeforeNow: false,
        minutes: undefined,
        hours: undefined,
        days: undefined,
        weeks: undefined,
        isValid: false
    };
};
const $9edf72b6e867fbac$export$da876ebe5870f49a = (intl, timeInfo)=>[
        timeInfo.weeks !== undefined ? intl.formatMessage((0, $e5geY.default).valueTimeInWeeks, {
            timeNumber: timeInfo.weeks
        }) : false,
        timeInfo.days !== undefined ? intl.formatMessage((0, $e5geY.default).valueTimeInDays, {
            timeNumber: timeInfo.days
        }) : false,
        timeInfo.hours !== undefined ? intl.formatMessage((0, $e5geY.default).valueTimeInHours, {
            timeNumber: timeInfo.hours
        }) : false,
        timeInfo.minutes !== undefined ? intl.formatMessage((0, $e5geY.default).valueTimeInMinutes, {
            timeNumber: timeInfo.minutes
        }) : false
    ].filter(Boolean).join(', ');
const $9edf72b6e867fbac$export$99ba9a356555dbdf = (timeInfo)=>{
    if (timeInfo.isValid) return (timeInfo.isBeforeNow ? -1 : 1) * ((timeInfo.minutes !== undefined ? timeInfo.minutes : 0) + (timeInfo.hours !== undefined ? timeInfo.hours * 60 : 0) + (timeInfo.days !== undefined ? timeInfo.days * 1440 : 0) + (timeInfo.weeks !== undefined ? timeInfo.weeks * 10080 : 0));
    return 0;
};
const $9edf72b6e867fbac$var$isNumeric = (value)=>/^\d+$/.test(value);
const $9edf72b6e867fbac$export$2214112898027187 = (timeDigits, timeUnit)=>timeDigits === '' || timeDigits !== undefined && $9edf72b6e867fbac$var$isNumeric(timeDigits) && parseInt(timeDigits, 10) > -1 && [
        'm',
        'h',
        'd',
        'w'
    ].includes(timeUnit ?? '');

});


parcelRegister("a3exZ", function(module, exports) {

$parcel$export(module.exports, "BETWEEN_DATE_TIME_CONFIG", () => $6c84cf6e03b5cb02$export$a553aad7ea821394);

var $k7m40 = parcelRequire("k7m40");

var $jovBr = parcelRequire("jovBr");

var $eZDAP = parcelRequire("eZDAP");

var $bzbto = parcelRequire("bzbto");

var $e5geY = parcelRequire("e5geY");

var $4M9H7 = parcelRequire("4M9H7");
const $6c84cf6e03b5cb02$export$a553aad7ea821394 = {
    type: 'between_date_time',
    componentType: 'between_date_time',
    label: 'labelBetween',
    hasInput: true,
    getErrorMessage: (intl, value)=>{
        if (value?.value1 && value?.value2 && (0, $eZDAP.default)(value?.value1) > (0, $eZDAP.default)(value?.value2)) return intl.formatMessage((0, $e5geY.default).validationMessageBeforeGreaterThanAfter);
        if (value && (value?.value1 !== '' && !(0, $jovBr.default)((0, $eZDAP.default)(value?.value1)) || value?.value2 !== '' && !(0, $jovBr.default)((0, $eZDAP.default)(value?.value2)))) return intl.formatMessage((0, $e5geY.default).validationMessageInvalidDateFormat);
        return undefined;
    },
    getFormattedValue: (intl, value)=>{
        if (value) {
            if (value.value1 && value.value2) {
                const parsedValue1 = (0, $eZDAP.default)(value.value1);
                const parsedValue2 = (0, $eZDAP.default)(value.value2);
                if ((0, $jovBr.default)(parsedValue1) && (0, $jovBr.default)(parsedValue2)) return `${intl.formatDate(parsedValue1, {
                    dateStyle: 'short',
                    timeStyle: 'short'
                })} - ${intl.formatDate(parsedValue2, {
                    dateStyle: 'short',
                    timeStyle: 'short'
                })}`;
            } else if (value.value1 && (0, $jovBr.default)((0, $eZDAP.default)(value.value1)) || value.value2 && (0, $jovBr.default)((0, $eZDAP.default)(value.value2))) {
                const valueToformat = value.value1 || value.value2;
                return intl.formatDate((0, $eZDAP.default)(valueToformat), {
                    dateStyle: 'short',
                    timeStyle: 'short'
                });
            }
        }
        return '';
    },
    getJqlData: ({ value1: value1, value2: value2 } = {})=>{
        const formatValue = (value)=>{
            const parsedValue = (0, $eZDAP.default)(value);
            return (0, $jovBr.default)(parsedValue) ? (0, $k7m40.default)(parsedValue, 'yyyy-MM-dd HH:mm') : value;
        };
        return {
            primaryClause: value1 ? {
                operator: (0, $bzbto.OPERATOR_GT_EQUALS),
                operand: formatValue(value1)
            } : undefined,
            secondaryClause: value2 ? {
                operator: (0, $bzbto.OPERATOR_LT_EQUALS),
                operand: formatValue(value2)
            } : undefined
        };
    },
    getValueFromJqlData: (jqlData)=>{
        if (jqlData !== undefined) {
            const { primaryClause: primaryClause, secondaryClause: secondaryClause } = jqlData;
            if (primaryClause === undefined && secondaryClause === undefined) // Do not match type if both clauses are not present
            return undefined;
            if (primaryClause !== undefined || secondaryClause !== undefined) {
                const returnValue = {
                    value1: '',
                    value2: ''
                };
                [
                    primaryClause,
                    secondaryClause
                ].forEach((clause)=>{
                    if (clause) {
                        const operatorValue = clause.operator ? clause.operator : '';
                        const value = clause.operand !== undefined ? clause.operand : '';
                        switch(operatorValue){
                            case 0, $bzbto.OPERATOR_GT_EQUALS:
                                if (value.match((0, $4M9H7.IS_YYYY_MM_DD_REGEX))) returnValue.value1 = value;
                                break;
                            case 0, $bzbto.OPERATOR_LT_EQUALS:
                                if (value.match((0, $4M9H7.IS_YYYY_MM_DD_REGEX))) returnValue.value2 = value;
                                break;
                            default:
                                break;
                        }
                    }
                });
                if (returnValue.value1 || returnValue.value2) return returnValue;
            }
            return undefined;
        }
        return undefined;
    }
};

});

parcelRegister("dG6Ze", function(module, exports) {

$parcel$export(module.exports, "DUE_IN_NEXT_CONFIG", () => $88b1c0a50804a6db$export$f0be3f9139a88bf5);

var $bzbto = parcelRequire("bzbto");

var $e5geY = parcelRequire("e5geY");

var $4M9H7 = parcelRequire("4M9H7");
const $88b1c0a50804a6db$export$f0be3f9139a88bf5 = {
    type: 'due_in_next',
    componentType: 'time_input',
    label: 'labelDueInNext',
    hasInput: true,
    getErrorMessage: (intl, value)=>(0, $4M9H7.isValidTimePeriodFormat)(value?.value1, value?.value2) ? undefined : intl.formatMessage((0, $e5geY.default).validationMessageInvalidPeriodFormat),
    getFormattedValue: (intl, value)=>{
        if (value !== undefined) {
            const { excludeOverdue: excludeOverdue = false } = value;
            switch(value.value2.toLowerCase()){
                case 'm':
                    return excludeOverdue ? intl.formatMessage((0, $e5geY.default).valueDueInNextExcludeOverdueMinutes, {
                        dateNumber: value.value1
                    }) : intl.formatMessage((0, $e5geY.default).valueDueInNextMinutes, {
                        dateNumber: value.value1
                    });
                case 'h':
                    return excludeOverdue ? intl.formatMessage((0, $e5geY.default).valueDueInNextExcludeOverdueHours, {
                        dateNumber: value.value1
                    }) : intl.formatMessage((0, $e5geY.default).valueDueInNextHours, {
                        dateNumber: value.value1
                    });
                case 'd':
                    return excludeOverdue ? intl.formatMessage((0, $e5geY.default).valueDueInNextExcludeOverdueDays, {
                        dateNumber: value.value1
                    }) : intl.formatMessage((0, $e5geY.default).valueDueInNextDays, {
                        dateNumber: value.value1
                    });
                case 'w':
                    return excludeOverdue ? intl.formatMessage((0, $e5geY.default).valueDueInNextExcludeOverdueWeeks, {
                        dateNumber: value.value1
                    }) : intl.formatMessage((0, $e5geY.default).valueDueInNextWeeks, {
                        dateNumber: value.value1
                    });
                default:
                    return value.value2;
            }
        }
        return '';
    },
    getJqlData: (dateTimeValue)=>{
        if (!dateTimeValue) return undefined;
        const { value1: value1, value2: value2, excludeOverdue: excludeOverdue } = dateTimeValue;
        return excludeOverdue === true ? {
            primaryClause: {
                operator: (0, $bzbto.OPERATOR_GT_EQUALS),
                operand: '0'
            },
            secondaryClause: {
                operator: (0, $bzbto.OPERATOR_LT_EQUALS),
                operand: `${value1}${value2}`
            }
        } : {
            primaryClause: {
                operator: (0, $bzbto.OPERATOR_LT_EQUALS),
                operand: `${value1}${value2}`
            }
        };
    },
    getValueFromJqlData: (jqlData)=>{
        if (jqlData !== undefined) {
            const { primaryClause: primaryClause, secondaryClause: secondaryClause } = jqlData;
            // if both clauses are present check value of operand if it's '0'
            if (primaryClause === undefined && secondaryClause === undefined) // Does not match type if more than one clause is present
            return undefined;
            if (primaryClause !== undefined && secondaryClause !== undefined) {
                const returnValue = {
                    value1: '',
                    value2: '',
                    excludeOverdue: false
                };
                [
                    primaryClause,
                    secondaryClause
                ].forEach((clause)=>{
                    const operatorValue = clause.operator ? clause.operator : '';
                    const value = clause.operand !== undefined ? clause.operand : '';
                    switch(operatorValue){
                        case 0, $bzbto.OPERATOR_GT_EQUALS:
                            if (value === '0' || value === '"0"') returnValue.excludeOverdue = true;
                            break;
                        case 0, $bzbto.OPERATOR_LT_EQUALS:
                            if (value) {
                                const matches = value.match(/^([0-9]*)([mhdw])$/);
                                if (matches?.length === 3) {
                                    const [, value1, value2] = matches;
                                    returnValue.value1 = value1;
                                    returnValue.value2 = value2;
                                }
                            }
                            break;
                        default:
                            break;
                    }
                });
                if (returnValue.value1 && returnValue.value2 && returnValue.excludeOverdue) return returnValue;
            }
            if (primaryClause === undefined && secondaryClause !== undefined || primaryClause !== undefined && secondaryClause === undefined) {
                const clause = primaryClause || secondaryClause;
                if (clause && clause.operator === (0, $bzbto.OPERATOR_LT_EQUALS)) {
                    const value = clause.operand !== undefined ? clause.operand : '';
                    if (value !== undefined) {
                        const matches = value.match(/^([0-9]*)([mhdw])$/);
                        if (matches?.length === 3) return {
                            value1: matches[1],
                            value2: matches[2]
                        };
                    }
                }
            }
            return undefined;
        }
        return undefined;
    },
    overduePicker: true
};

});

parcelRegister("jOFhu", function(module, exports) {

$parcel$export(module.exports, "IN_RANGE_CONFIG", () => $ca29d17899fcbb9f$export$824796e3ed16a4e0);

var $bzbto = parcelRequire("bzbto");

var $e5geY = parcelRequire("e5geY");

var $4M9H7 = parcelRequire("4M9H7");
const $ca29d17899fcbb9f$export$824796e3ed16a4e0 = {
    type: 'in_range',
    componentType: 'in_range',
    label: 'labelInRange',
    hasInput: true,
    getErrorMessage: (intl, value)=>{
        if (value?.value1 && value.value2 && (0, $4M9H7.getTimeInMinutes)((0, $4M9H7.getTimeInfo)(value.value1)) > (0, $4M9H7.getTimeInMinutes)((0, $4M9H7.getTimeInfo)(value.value2))) return intl.formatMessage((0, $e5geY.default).validationMessageFromGreaterThanTo);
        if (value && (value.value1 !== '' && !(0, $4M9H7.getTimeInfo)(value.value1).isValid || value.value2 !== '' && !(0, $4M9H7.getTimeInfo)(value.value2).isValid)) return intl.formatMessage((0, $e5geY.default).validationMessageInvalidPeriodFormatValue);
        return undefined;
    },
    getTooltip: (intl, value)=>{
        const fromTimeInfo = (0, $4M9H7.getTimeInfo)(value?.value1);
        const toTimeInfo = (0, $4M9H7.getTimeInfo)(value?.value2);
        if (fromTimeInfo.isValid && toTimeInfo.isValid) {
            if (fromTimeInfo.isBeforeNow && toTimeInfo.isBeforeNow) return intl.formatMessage((0, $e5geY.default).valueInRangeBeforeNowToBeforeNow, {
                beforeTime: (0, $4M9H7.getTimeString)(intl, fromTimeInfo),
                afterTime: (0, $4M9H7.getTimeString)(intl, toTimeInfo)
            });
            if (fromTimeInfo.isBeforeNow && !toTimeInfo.isBeforeNow) return intl.formatMessage((0, $e5geY.default).valueInRangeBeforeNowToAfterNow, {
                beforeTime: (0, $4M9H7.getTimeString)(intl, fromTimeInfo),
                afterTime: (0, $4M9H7.getTimeString)(intl, toTimeInfo)
            });
            if (!fromTimeInfo.isBeforeNow && !toTimeInfo.isBeforeNow) return intl.formatMessage((0, $e5geY.default).valueInRangeAfterNowToAfterNow, {
                beforeTime: (0, $4M9H7.getTimeString)(intl, fromTimeInfo),
                afterTime: (0, $4M9H7.getTimeString)(intl, toTimeInfo)
            });
        }
        return undefined;
    },
    getFormattedValue: (intl, value)=>{
        const fromTimeInfo = (0, $4M9H7.getTimeInfo)(value?.value1);
        const toTimeInfo = (0, $4M9H7.getTimeInfo)(value?.value2);
        if (fromTimeInfo.isValid && toTimeInfo.isValid) return intl.formatMessage((0, $e5geY.default).valueInRange, {
            start: value?.value1,
            end: value?.value2
        });
        if (fromTimeInfo.isValid && value && value.value2 === '') return fromTimeInfo.isBeforeNow ? intl.formatMessage((0, $e5geY.default).valueInRangeBeforeNowToBlank, {
            beforeTime: (0, $4M9H7.getTimeString)(intl, fromTimeInfo)
        }) : intl.formatMessage((0, $e5geY.default).valueInRangeAfterNowToBlank, {
            beforeTime: (0, $4M9H7.getTimeString)(intl, fromTimeInfo)
        });
        if (toTimeInfo.isValid && value && value.value1 === '') return toTimeInfo.isBeforeNow ? intl.formatMessage((0, $e5geY.default).valueInRangeBlankToBeforeNow, {
            afterTime: (0, $4M9H7.getTimeString)(intl, toTimeInfo)
        }) : intl.formatMessage((0, $e5geY.default).valueInRangeBlankToAfterNow, {
            afterTime: (0, $4M9H7.getTimeString)(intl, toTimeInfo)
        });
        // TODO : This scenario shouldn't happen, retain this till invalid scenarios are handled
        return value ? intl.formatMessage((0, $e5geY.default).valueInRangeBeforeNowToAfterNow, {
            beforeTime: value.value1,
            afterTime: value.value2
        }) : '';
    },
    getJqlData: (dateTimeValue)=>{
        if (!dateTimeValue) return undefined;
        const { value1: value1, value2: value2 } = dateTimeValue;
        return {
            primaryClause: value1 ? {
                operator: (0, $bzbto.OPERATOR_GT_EQUALS),
                operand: `${value1}`
            } : undefined,
            secondaryClause: value2 ? {
                operator: (0, $bzbto.OPERATOR_LT_EQUALS),
                operand: `${value2}`
            } : undefined
        };
    },
    getValueFromJqlData: (jqlData)=>{
        if (jqlData !== undefined) {
            const { primaryClause: primaryClause, secondaryClause: secondaryClause } = jqlData;
            if (primaryClause === undefined && secondaryClause === undefined) // Do not match type if both clauses are not present
            return undefined;
            if (primaryClause !== undefined || secondaryClause !== undefined) {
                const returnValue = {
                    value1: '',
                    value2: ''
                };
                [
                    primaryClause,
                    secondaryClause
                ].forEach((clause)=>{
                    const operatorValue = clause && clause.operator ? clause.operator : '';
                    const value = clause && clause.operand !== undefined ? clause.operand : '';
                    switch(operatorValue){
                        case 0, $bzbto.OPERATOR_GT_EQUALS:
                            if (value.match((0, $4M9H7.IS_YYYY_MM_DD_REGEX)) == null) returnValue.value1 = value;
                            break;
                        case 0, $bzbto.OPERATOR_LT_EQUALS:
                            if (value.match((0, $4M9H7.IS_YYYY_MM_DD_REGEX)) == null) returnValue.value2 = value;
                            break;
                        default:
                            break;
                    }
                });
                if (returnValue.value1 || returnValue.value2) return returnValue;
            }
            return undefined;
        }
        return undefined;
    }
};

});

parcelRegister("8uhcn", function(module, exports) {

$parcel$export(module.exports, "MORE_THAN_CONFIG", () => $eec157b907d8cff2$export$d840a05dccc1ad98);
$parcel$export(module.exports, "CONFIG_DATE_MORE_THAN", () => $eec157b907d8cff2$export$3381ab6a0f70cfec);

var $bzbto = parcelRequire("bzbto");

var $e5geY = parcelRequire("e5geY");

var $4M9H7 = parcelRequire("4M9H7");
const $eec157b907d8cff2$export$d840a05dccc1ad98 = {
    type: 'more_than',
    componentType: 'time_input',
    label: 'labelMoreThan',
    hasInput: true,
    getErrorMessage: (intl, value)=>(0, $4M9H7.isValidTimePeriodFormat)(value?.value1, value?.value2) ? undefined : intl.formatMessage((0, $e5geY.default).validationMessageInvalidPeriodFormat),
    getFormattedValue: (intl, value)=>{
        if (value !== undefined) switch(value.value2.toLowerCase()){
            case 'm':
                return intl.formatMessage((0, $e5geY.default).valueMoreThanMinutes, {
                    dateNumber: value.value1
                });
            case 'h':
                return intl.formatMessage((0, $e5geY.default).valueMoreThanHours, {
                    dateNumber: value.value1
                });
            case 'd':
                return intl.formatMessage((0, $e5geY.default).valueMoreThanDays, {
                    dateNumber: value.value1
                });
            case 'w':
                return intl.formatMessage((0, $e5geY.default).valueMoreThanWeeks, {
                    dateNumber: value.value1
                });
            default:
                return value.value2;
        }
        return '';
    },
    getJqlData: (dateTimeValue)=>{
        if (!dateTimeValue) return undefined;
        const { value1: value1, value2: value2 } = dateTimeValue;
        return {
            primaryClause: {
                operator: (0, $bzbto.OPERATOR_LT_EQUALS),
                operand: `-${value1}${value2}`
            }
        };
    },
    getValueFromJqlData: (jqlData)=>{
        if (jqlData !== undefined) {
            const { primaryClause: primaryClause, secondaryClause: secondaryClause } = jqlData;
            if (primaryClause !== undefined && secondaryClause !== undefined) // Does not match type if more than one clause is present
            return undefined;
            const clause = primaryClause || secondaryClause;
            if (clause && clause.operator === (0, $bzbto.OPERATOR_LT_EQUALS)) {
                const value = clause.operand !== undefined ? clause.operand : '';
                if (value) {
                    const matches = value.match(/^[-]([0-9]*)([mhdw])$/);
                    if (matches?.length === 3) return {
                        value1: matches[1],
                        value2: matches[2]
                    };
                }
            }
            return undefined;
        }
        return undefined;
    },
    endLabel: 'Overdue'
};
const $eec157b907d8cff2$export$3381ab6a0f70cfec = {
    ...$eec157b907d8cff2$export$d840a05dccc1ad98,
    endLabel: 'Ago'
};

});

parcelRegister("5FZbC", function(module, exports) {

$parcel$export(module.exports, "NOW_OVERDUE_CONFIG", () => $65485fe607c2956e$export$10b9f2fe105831bd);

var $bzbto = parcelRequire("bzbto");

var $e5geY = parcelRequire("e5geY");
const $65485fe607c2956e$export$10b9f2fe105831bd = {
    type: 'now_overdue',
    componentType: 'is_not_set',
    label: 'labelNowOverdue',
    hasInput: false,
    getFormattedValue: (intl, value)=>value ? intl.formatMessage((0, $e5geY.default).valueNowOverdue) : '',
    getJqlData: ()=>({
            primaryClause: {
                operator: (0, $bzbto.OPERATOR_LT_EQUALS),
                operand: '0'
            }
        }),
    getValueFromJqlData: (jqlData)=>{
        if (jqlData !== undefined) {
            const { primaryClause: primaryClause, secondaryClause: secondaryClause } = jqlData;
            if (primaryClause !== undefined && secondaryClause !== undefined) // Does not match type if more than one clause is present
            return undefined;
            const clause = primaryClause || secondaryClause;
            if (clause && clause.operator === (0, $bzbto.OPERATOR_LT_EQUALS)) {
                const value = clause.operand;
                if (value && (value === '0' || value === '"0"')) return {
                    value1: '',
                    value2: ''
                };
            }
        }
        return undefined;
    }
};

});

parcelRegister("2O68y", function(module, exports) {

$parcel$export(module.exports, "WITHIN_THE_LAST_CONFIG", () => $083060e9cf4e29a3$export$8095f803ac0c0718);

var $bzbto = parcelRequire("bzbto");

var $e5geY = parcelRequire("e5geY");

var $4M9H7 = parcelRequire("4M9H7");
const $083060e9cf4e29a3$export$8095f803ac0c0718 = {
    type: 'within_the_last',
    componentType: 'time_input',
    label: 'labelWithinTheLast',
    hasInput: true,
    getErrorMessage: (intl, value)=>(0, $4M9H7.isValidTimePeriodFormat)(value?.value1, value?.value2) ? undefined : intl.formatMessage((0, $e5geY.default).validationMessageInvalidPeriodFormat),
    getFormattedValue: (intl, value)=>{
        if (value !== undefined) switch(value.value2.toLowerCase()){
            case 'm':
                return intl.formatMessage((0, $e5geY.default).valueWithinTheLastMinutes, {
                    dateNumber: value.value1
                });
            case 'h':
                return intl.formatMessage((0, $e5geY.default).valueWithinTheLastHours, {
                    dateNumber: value.value1
                });
            case 'd':
                return intl.formatMessage((0, $e5geY.default).valueWithinTheLastDays, {
                    dateNumber: value.value1
                });
            case 'w':
                return intl.formatMessage((0, $e5geY.default).valueWithinTheLastWeeks, {
                    dateNumber: value.value1
                });
            default:
                return value.value2;
        }
        return '';
    },
    getJqlData: (dateTimeValue)=>{
        if (!dateTimeValue) return undefined;
        const { value1: value1, value2: value2 } = dateTimeValue;
        return {
            primaryClause: {
                operator: (0, $bzbto.OPERATOR_GT_EQUALS),
                operand: `-${value1}${value2}`
            }
        };
    },
    getValueFromJqlData: (jqlData)=>{
        if (jqlData !== undefined) {
            const { primaryClause: primaryClause, secondaryClause: secondaryClause } = jqlData;
            if (primaryClause !== undefined && secondaryClause !== undefined) // Does not match type if more than one clause is present
            return undefined;
            const clause = primaryClause || secondaryClause;
            if (clause && clause.operator === (0, $bzbto.OPERATOR_GT_EQUALS)) {
                const value = clause.operand !== undefined ? clause.operand : '';
                if (value) {
                    const matches = value.match(/^[-]([0-9]*)([mhdw])$/);
                    if (matches?.length === 3) return {
                        value1: matches[1],
                        value2: matches[2]
                    };
                }
            }
            return undefined;
        }
        return undefined;
    }
};

});



parcelRegister("aUQOl", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca4d78dd6cba9e08$export$2e2bcd8739ae039);

var $iEIQF = parcelRequire("iEIQF");
var $l0V05 = parcelRequire("l0V05");
const $ca4d78dd6cba9e08$var$singleDatePattern = /^(-)?[0-9]+(m|minute|minutes|h|hour|hours|d|day|days|w|week|weeks){1}$/;
const $ca4d78dd6cba9e08$var$isSingleDateValue = (str)=>$ca4d78dd6cba9e08$var$singleDatePattern.test(str.toLowerCase());
const $ca4d78dd6cba9e08$var$wrapWithQuotesIfNeeded = (text)=>$ca4d78dd6cba9e08$var$isSingleDateValue(text) ? text : `"${text.replace(/"/g, '\\"')}"`;
const $ca4d78dd6cba9e08$var$getClauses = (ast, fieldIdentifier)=>{
    const fieldsToReturn = [];
    const where = ast.query?.where;
    if (where) {
        if (where.clauseType === (0, $e9a0ef16a223cbc7$export$7a58b23488ea076b) && where.clauses) where.clauses.forEach((clause)=>{
            if (clause.clauseType === (0, $e9a0ef16a223cbc7$export$ae56b4ef248a2b6a)) {
                const fieldId = clause.field.value.toLowerCase();
                if (fieldIdentifier.toLowerCase() === fieldId) fieldsToReturn.push(clause);
            }
        });
        else if (where.clauseType === (0, $e9a0ef16a223cbc7$export$ae56b4ef248a2b6a)) {
            const fieldId = where.field.value.toLowerCase();
            if (fieldIdentifier.toLowerCase() === fieldId) fieldsToReturn.push(where);
        }
    }
    return fieldsToReturn;
};
const $ca4d78dd6cba9e08$var$createTerminalClause = ({ fieldId: fieldId, operator: operator, value: value })=>(0, $iEIQF.default).terminalClause((0, $iEIQF.default).field(fieldId), (0, $iEIQF.default).operator(operator), (0, $iEIQF.default).byText.valueOperand($ca4d78dd6cba9e08$var$wrapWithQuotesIfNeeded(value)));
const $ca4d78dd6cba9e08$var$appendOrReplaceClause = ({ fieldId: fieldId, newClauseData: newClauseData, clauseToReplace: clauseToReplace, query: query })=>{
    const { operator: operator, operand: value } = newClauseData;
    if (clauseToReplace) clauseToReplace.replace($ca4d78dd6cba9e08$var$createTerminalClause({
        fieldId: fieldId,
        operator: operator,
        value: value
    }));
    else query.appendClause($ca4d78dd6cba9e08$var$createTerminalClause({
        fieldId: fieldId,
        operator: operator,
        value: value
    }), (0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97));
};
const $ca4d78dd6cba9e08$var$appendOrReplaceClauses = ({ fieldId: fieldId, jqlData: jqlData, fieldToRenderClause: fieldToRenderClause, fieldToRenderSecondaryClause: fieldToRenderSecondaryClause, query: query })=>{
    const { primaryClause: primaryClauseData, secondaryClause: secondaryClauseData } = jqlData;
    if (primaryClauseData) $ca4d78dd6cba9e08$var$appendOrReplaceClause({
        fieldId: fieldId,
        newClauseData: primaryClauseData,
        clauseToReplace: fieldToRenderClause || fieldToRenderSecondaryClause,
        query: query
    });
    if (secondaryClauseData) $ca4d78dd6cba9e08$var$appendOrReplaceClause({
        fieldId: fieldId,
        newClauseData: secondaryClauseData,
        clauseToReplace: primaryClauseData ? fieldToRenderSecondaryClause : fieldToRenderClause || fieldToRenderSecondaryClause,
        query: query
    });
};
const $ca4d78dd6cba9e08$var$deleteUnnecessaryClauses = ({ jqlData: jqlData, fieldToRenderClause: fieldToRenderClause, fieldToRenderSecondaryClause: fieldToRenderSecondaryClause })=>{
    if (!jqlData || !jqlData.primaryClause && !jqlData.secondaryClause) {
        fieldToRenderClause && fieldToRenderClause.remove();
        fieldToRenderSecondaryClause && fieldToRenderSecondaryClause.remove();
    }
    if (jqlData && (!jqlData.primaryClause || !jqlData.secondaryClause)) fieldToRenderSecondaryClause && fieldToRenderSecondaryClause.remove();
};
const $ca4d78dd6cba9e08$var$getNewJqlFromDoubleClausePickerJqlData = (fieldId, ast, jqlData)=>{
    if (!ast.query) return ast.represents;
    const [fieldToRenderClause, fieldToRenderSecondaryClause] = $ca4d78dd6cba9e08$var$getClauses(ast, fieldId);
    if (jqlData !== undefined) $ca4d78dd6cba9e08$var$appendOrReplaceClauses({
        fieldId: fieldId,
        jqlData: jqlData,
        fieldToRenderClause: fieldToRenderClause,
        fieldToRenderSecondaryClause: fieldToRenderSecondaryClause,
        query: ast.query
    });
    $ca4d78dd6cba9e08$var$deleteUnnecessaryClauses({
        jqlData: jqlData,
        fieldToRenderClause: fieldToRenderClause,
        fieldToRenderSecondaryClause: fieldToRenderSecondaryClause
    });
    return (0, $l0V05.print)(ast, {
        operatorCase: 'upper'
    });
};
var $ca4d78dd6cba9e08$export$2e2bcd8739ae039 = $ca4d78dd6cba9e08$var$getNewJqlFromDoubleClausePickerJqlData;

});


parcelRegister("kxBJw", function(module, exports) {

$parcel$export(module.exports, "LastUserCommentedPickerWrapper", () => $759da141d141502c$export$d03064b9074933a8);

var $5uXOq = parcelRequire("5uXOq");

var $kkJfY = parcelRequire("kkJfY");

var $2x3Cb = parcelRequire("2x3Cb");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $4yuwq = parcelRequire("4yuwq");

var $eWn4R = parcelRequire("eWn4R");

var $jgJNO = parcelRequire("jgJNO");


var $4Hz9T = parcelRequire("4Hz9T");

var $kG16F = parcelRequire("kG16F");

var $qsHp4 = parcelRequire("qsHp4");

var $kupLM = parcelRequire("kupLM");
const $759da141d141502c$export$d03064b9074933a8 = ({ activePopupKey: activePopupKey, clause: clause, fieldId: fieldId, fieldLabel: fieldLabel, fieldDescription: fieldDescription, onClear: onClear, onClose: onClose, onOpen: onOpen, onSearchWrapper: onSearchWrapper, isIrremovable: isIrremovable })=>{
    const [isChecked, setIsChecked] = (0, $5uXOq.useState)((0, $kupLM.getInitialState)(clause));
    const isOpen = activePopupKey === fieldId;
    const handleOnTriggerClick = (0, $5uXOq.useCallback)(()=>isOpen ? onClose() : onOpen(), [
        isOpen,
        onClose,
        onOpen
    ]);
    const [ast] = (0, $kG16F.useAST)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        key: fieldId,
        placement: "bottom-start",
        isOpen: isOpen,
        onClose: onClose,
        popupComponent: (0, $4yuwq.FixedWidthPopupComponent),
        shouldRenderToParent: true,
        messageId: "jql-builder-basic.ui.jql-editor.field.last-user-commented-picker-wrapper.popup",
        messageType: "transactional",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Hz9T.default), {
                ...triggerProps,
                isInvalid: false,
                isSelected: isOpen,
                hasValues: !!clause,
                onClick: handleOnTriggerClick,
                onClear: ()=>onClear(clause ? (0, $eWn4R.default)(ast, clause) : undefined),
                testId: `jql-builder-basic.ui.jql-editor.picker.filter-button.${fieldId}`,
                fieldDescription: fieldDescription,
                isIrremovable: isIrremovable
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                color: "inherit",
                weight: "medium",
                testId: (0, $227fa8a1aa91f085$export$743be55d5cf4a20d)
            }, clause ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                as: "strong"
            }, `${fieldLabel}: `), isChecked ? formatMessage((0, $qsHp4.default).trueMessage) : formatMessage((0, $qsHp4.default).all)) : fieldLabel)),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $759da141d141502c$var$boxStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
                id: "last-user-commented-checkbox",
                onChange: (e)=>{
                    setIsChecked(e.target.checked);
                    onSearchWrapper && onSearchWrapper((0, $kupLM.getUpdatedJql)(ast, clause, fieldId, e.target.checked));
                    onClose();
                },
                isChecked: isChecked,
                testId: "jql-builder-basic.ui.jql-editor.field.last-user-commented-picker-wrapper.checkbox"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2x3Cb.Label), {
                htmlFor: "last-user-commented-checkbox"
            }, formatMessage((0, $qsHp4.default).checkBoxLabel)))
    });
};
var $759da141d141502c$export$2e2bcd8739ae039 = $759da141d141502c$export$d03064b9074933a8;
const $759da141d141502c$var$boxStyles = (0, $8CUq3.xcss)({
    padding: 'space.150'
});

});
parcelRegister("kkJfY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3106eb14f9b0a593$export$2e2bcd8739ae039);
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6QvkM = parcelRequire("6QvkM");

var $5JjdN = parcelRequire("5JjdN");

var $kag1C = parcelRequire("kag1C");
var $7xteU = parcelRequire("7xteU");
var $hsLv2 = parcelRequire("hsLv2");
var $e62YQ = parcelRequire("e62YQ");
const $3106eb14f9b0a593$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf _r050fibj _9bg71mn3 _19op11so _a30fhteq _1610e4h9 _13wo93zu _q5a61gyf _8gq114p8 _wje2mov0 _1fo21cni _eyedglyw _1ef7js4s _1h6rjs4s _smzgj3jf _1dk7j3jf _l71j1i6y _t34a1i6y _y32gkivo _1ah9199y _1frj180l _h78e1g3k _dwvb1ps2 _1bok170n _1mhr17cl _fx2i3rva _10oaq2ws _w12s155b _15y61vek _e6ww155b _sg1j1vek _rphw18jz _y9y9mz2b _141bmz2b _255gmz2b _jj67mz2b _swhgmz2b _axq81diq _1jiz1diq _s9051diq _1efy1diq _1oav1diq _10y313gf _1wt913gf _qq8613gf _1adw13gf _12sr13gf _16jiglyw _693jglyw _1niqglyw _cl9tglyw _1jbnglyw _j1ta1hou _18qu1ps2 _1g52170n _1log17cl _32hzmz2b _1vv91diq _yjhd1hou _w1cowc43 _jdqn1onz _4y4t1onz _lvfrwc43 _g68dwc43 _13dk1onz _w1el1onz _a9yw1onz _1l3g1onz _dcdpgir2 _wobcgir2 _rp9wgir2 _9ebfwc43 _e43iwc43 _1tkuwc43 _1lehwc43 _b9q3wc43 _tu2918qt _1uxv18qt _1ufw18qt _opo918qt _1e8318qt _1k3d18qt _25yv18qt _1igz18qt _c7cc18qt _1swg18qt"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $3106eb14f9b0a593$var$Checkbox = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $5uXOq.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $5uXOq.useRef)(null);
    const mergedRefs = (0, $5JjdN.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $5uXOq.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $7xteU.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $bwpsq.default)([
                    $3106eb14f9b0a593$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kag1C.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $hsLv2.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e62YQ.default), {})
                ]
            })
        ]
    });
}));
$3106eb14f9b0a593$var$Checkbox.displayName = 'Checkbox';
var $3106eb14f9b0a593$export$2e2bcd8739ae039 = $3106eb14f9b0a593$var$Checkbox;

});
parcelRegister("kag1C", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0746a27410bc168$export$2e2bcd8739ae039);
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dV6Te = parcelRequire("dV6Te");

var $VSDnB = parcelRequire("VSDnB");
function $a0746a27410bc168$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
    }
    if (isChecked) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
    }
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $a0746a27410bc168$var$CheckboxIcon = /*#__PURE__*/ (0, $5uXOq.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $5uXOq.useMemo)(()=>$a0746a27410bc168$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dV6Te.default), {
        label: "",
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                (0, $VSDnB.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5"
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    fill: "currentColor",
                    x: "6",
                    y: "6",
                    width: "12",
                    height: "12",
                    rx: "2"
                }),
                icon
            ]
        })
    });
});
var $a0746a27410bc168$export$2e2bcd8739ae039 = $a0746a27410bc168$var$CheckboxIcon;

});

parcelRegister("7xteU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b368d644c230660$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $7b368d644c230660$var$baseStyles = null;
const $7b368d644c230660$var$textLabelLayoutStyles = null;
const $7b368d644c230660$var$disabledStyles = null;
const $7b368d644c230660$var$labelStyles = null;
function $7b368d644c230660$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("label", {
        className: (0, $bwpsq.default)([
            "_11c82smr _1e0c11p5 _1ejihkll _umai184x _syazj3m3 _80om73ad",
            label && "_zulp1nu5 _yv0ey09t",
            isDisabled && "_syaz1tvo _80om13gf",
            "_h5e3mag2 _1nzs11d3 _1eszzyvw _yp0jhh5a _ay2w1y1w _d51u10ko _phft1fmg _1g1funzk _l6wkzyvw _1dikhh5a _1sfg1q3k _fpdj1y1w _1yjc194a _oaj11fmg _1j3h1q3k _eawb1dzn _1rda1qbb _18q015t7 _13hr3acm",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("hsLv2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce636d67b4ff1120$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $ce636d67b4ff1120$var$labelTextStyles = null;
function $ce636d67b4ff1120$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("e62YQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2156c28a3894cac$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $d2156c28a3894cac$var$requiredIndicatorStyles = null;
function $d2156c28a3894cac$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "aria-hidden": true,
        className: (0, $bwpsq.default)([
            "_syaz1gtz _bozgv77o"
        ]),
        children: "*"
    });
}

});


const $227fa8a1aa91f085$export$743be55d5cf4a20d = 'jql-builder-basic.common.ui.format-label.label-container';
const $227fa8a1aa91f085$export$fca2db27fe6c1305 = 'jql-builder-basic.common.ui.format-label.badge';

parcelRegister("qsHp4", function(module, exports) {

$parcel$export(module.exports, "default", () => $d784bc7e79273d6f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d784bc7e79273d6f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    checkBoxLabel: {
        "id": "jql-builder-basic.jql-editor.field.last-user-commented-picker-wrapper.check-box-label",
        "defaultMessage": "Restrict to last commented by non-developers"
    },
    all: {
        "id": "jql-builder-basic.jql-editor.field.last-user-commented-picker-wrapper.all",
        "defaultMessage": "All"
    },
    trueMessage: {
        "id": "jql-builder-basic.jql-editor.field.last-user-commented-picker-wrapper.true-message",
        "defaultMessage": "true"
    }
});

});

parcelRegister("kupLM", function(module, exports) {

$parcel$export(module.exports, "getUpdatedJql", () => $1ed0603258c57a15$export$1625bb7ada97d007);
$parcel$export(module.exports, "getInitialState", () => $1ed0603258c57a15$export$53ac33307b5acee9);

var $iEIQF = parcelRequire("iEIQF");
var $bzbto = parcelRequire("bzbto");
var $l0V05 = parcelRequire("l0V05");

var $eWn4R = parcelRequire("eWn4R");

var $1dTaH = parcelRequire("1dTaH");
const $1ed0603258c57a15$var$createTerminalClause = (fieldId, value)=>(0, $iEIQF.default).terminalClause((0, $iEIQF.default).field((0, $1dTaH.escapeBackslashes)(fieldId)), (0, $iEIQF.default).operator((0, $bzbto.OPERATOR_EQUALS)), (0, $iEIQF.default).byText.valueOperand(value ? '"true"' : '""'));
const $1ed0603258c57a15$export$1625bb7ada97d007 = (ast, clause, fieldId, value)=>{
    const hasValue = Boolean(value);
    if (!clause) {
        if (!ast.query || !hasValue) return ast.represents;
        if (value) ast.query.appendClause($1ed0603258c57a15$var$createTerminalClause(fieldId, value), (0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97));
    } else if (value) clause.replace($1ed0603258c57a15$var$createTerminalClause(fieldId, value));
    else return (0, $eWn4R.default)(ast, clause);
    return (0, $l0V05.print)(ast, {
        operatorCase: 'upper'
    });
};
const $1ed0603258c57a15$export$53ac33307b5acee9 = (clause)=>(clause && clause.clauseType === (0, $e9a0ef16a223cbc7$export$ae56b4ef248a2b6a) && clause.operand && clause.operand.operandType === (0, $49b29ef7baa2a152$export$38accfc5a5d1c113) && clause.operand.value) === 'true';

});


parcelRegister("169o0", function(module, exports) {

$parcel$export(module.exports, "NumberRangePicker", () => $4dc7082d324fbf08$export$1ad8a36b54765fad);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $aUQOl = parcelRequire("aUQOl");

var $4Hz9T = parcelRequire("4Hz9T");

var $kG16F = parcelRequire("kG16F");

var $8rQ7L = parcelRequire("8rQ7L");

var $6QnoO = parcelRequire("6QnoO");
const $4dc7082d324fbf08$export$1ad8a36b54765fad = ({ fieldId: fieldId, fieldLabel: fieldLabel, activePopupKey: activePopupKey, clause: clause, secondaryClause: secondaryClause, onSearchWrapper: onSearchWrapper, onSendOptionAnalytics: onSendOptionAnalytics, onClear: onClear, onOpen: onOpen, onClose: onClose, fieldDescription: fieldDescription, isIrremovable: isIrremovable })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [ast] = (0, $kG16F.useAST)();
    /**
   * fieldLabel comes from field displayName from the hydration data.
   * It is defined in the fragment `jqlEditor_jqlBuilderBasic_JQLEditorUI` in
   * `src/packages/jql-builder/basic/src/ui/jql-editor/index.tsx`
   * we never expect it to be undefined but since we are not using the @required
   * directive in the fragment, this check is required.
   */ const safeFieldLabel = fieldLabel ?? '';
    const numberRangeValue = (0, $5uXOq.useMemo)(()=>(0, $6QnoO.mapJqlDataToNumberRangeValue)((0, $6QnoO.getJqlDataFromClauses)(clause, secondaryClause)), [
        clause,
        secondaryClause
    ]);
    const triggerValueMessageDescriptor = (0, $5uXOq.useMemo)(()=>(0, $6QnoO.getTriggerValueMessageDescriptor)(numberRangeValue), [
        numberRangeValue
    ]);
    const isOpen = activePopupKey === fieldId;
    const handleOnChange = (0, $5uXOq.useCallback)((newValue)=>{
        onSearchWrapper && onSearchWrapper((0, $aUQOl.default)(fieldId, ast, (0, $6QnoO.mapNumberRangeValueToJqlData)(newValue)));
        onClose();
        onSendOptionAnalytics && onSendOptionAnalytics({
            hasMinValue: newValue.min.length > 0,
            hasMaxValue: newValue.max.length > 0
        });
    }, [
        ast,
        fieldId,
        onClose,
        onSearchWrapper,
        onSendOptionAnalytics
    ]);
    const onTriggerClick = (0, $5uXOq.useCallback)(()=>isOpen ? onClose() : onOpen(), [
        isOpen,
        onClose,
        onOpen
    ]);
    const onTriggerClear = (0, $5uXOq.useCallback)(()=>onClear(clause ? (0, $aUQOl.default)(fieldId, ast, undefined) : undefined), [
        ast,
        clause,
        fieldId,
        onClear
    ]);
    const triggerRenderer = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Hz9T.default), {
            ...triggerProps,
            isInvalid: false,
            isSelected: isOpen,
            isLoading: false,
            hasValues: !(0, $6QnoO.isNumberRangeValueEmpty)(numberRangeValue),
            onClear: onTriggerClear,
            onClick: onTriggerClick,
            testId: "jql-builder-basic.ui.jql-editor.field.number-range-picker.picker-trigger",
            fieldDescription: fieldDescription,
            isIrremovable: isIrremovable
        }, triggerValueMessageDescriptor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            as: "span",
            alignItems: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            as: "strong",
            color: "inherit"
        }, safeFieldLabel, ":\xa0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $4dc7082d324fbf08$var$valueContainerStyles,
            as: "span"
        }, formatMessage(triggerValueMessageDescriptor, numberRangeValue))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            as: "span"
        }, safeFieldLabel)), [
        isOpen,
        numberRangeValue,
        onTriggerClear,
        onTriggerClick,
        fieldDescription,
        isIrremovable,
        triggerValueMessageDescriptor,
        safeFieldLabel,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8rQ7L.NumberRangePickerPopup), {
        isOpen: isOpen,
        onClose: onClose,
        onChange: handleOnChange,
        value: numberRangeValue,
        renderTrigger: triggerRenderer
    });
};
const $4dc7082d324fbf08$var$valueContainerStyles = (0, $8CUq3.xcss)({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '200px'
});

});
parcelRegister("8rQ7L", function(module, exports) {

$parcel$export(module.exports, "NumberRangePickerPopup", () => $c7bc787225e58574$export$7e88ff560d51764b);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $2x3Cb = parcelRequire("2x3Cb");

var $qfj8c = parcelRequire("qfj8c");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $kY99m = parcelRequire("kY99m");

var $koVbs = parcelRequire("koVbs");

var $4yuwq = parcelRequire("4yuwq");

var $jgJNO = parcelRequire("jgJNO");


var $6zg4A = parcelRequire("6zg4A");

var $6QnoO = parcelRequire("6QnoO");
const $c7bc787225e58574$export$7e88ff560d51764b = ({ isOpen: isOpen, onClose: onClose, renderTrigger: renderTrigger, value: value, onChange: onChange })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [unsubmittedValue, setUnsubmittedValue] = (0, $5uXOq.useState)(value);
    const [errorStateMessages, setErrorStateMessages] = (0, $5uXOq.useState)(()=>(0, $6QnoO.getNumberRangePickerErrorMessages)(value));
    const hasError = (0, $5uXOq.useMemo)(()=>(0, $6QnoO.hasNumberRangeValueError)(errorStateMessages), [
        errorStateMessages
    ]);
    const handleOnChange = (0, $5uXOq.useCallback)((index)=>({ currentTarget: { value: targetValue } })=>{
            const newUnsubmittedValue = {
                ...unsubmittedValue,
                [index]: targetValue
            };
            setUnsubmittedValue(newUnsubmittedValue);
            setErrorStateMessages((0, $6QnoO.getNumberRangePickerErrorMessages)(newUnsubmittedValue, index));
        }, [
        unsubmittedValue
    ]);
    const handleOnSubmit = (0, $5uXOq.useCallback)((e)=>{
        e.preventDefault();
        onChange(unsubmittedValue);
    }, [
        onChange,
        unsubmittedValue
    ]);
    const showErrorMessage = (0, $5uXOq.useCallback)((messageDescriptor)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $c7bc787225e58574$var$errorMessageContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, messageDescriptor === (0, $6zg4A.default).numberSizeLimitErrorMessage ? formatMessage(messageDescriptor, {
            maxSize: (0, $ae4efb9f19844b8c$export$3aefefab9ae0beef).toLocaleString()
        }) : formatMessage(messageDescriptor))), [
        formatMessage
    ]);
    const renderContent = (0, $5uXOq.useCallback)(({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $c7bc787225e58574$var$textFieldGroupContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $c7bc787225e58574$var$clauseDropdownContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2x3Cb.Label), {
            htmlFor: "lower-clause-number-range-field"
        }, formatMessage((0, $6zg4A.default).minimumClauseLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
            ref: setInitialFocusRef,
            id: "lower-clause-number-range-field",
            onChange: handleOnChange('min'),
            value: unsubmittedValue.min,
            placeholder: formatMessage((0, $6zg4A.default).numberRangePlaceholderMessage),
            isInvalid: hasError && errorStateMessages.min !== undefined,
            testId: "jql-builder-basic.ui.jql-editor.field.number-range-picker.lower-clause-text-field"
        }), hasError && errorStateMessages.min !== undefined && showErrorMessage(errorStateMessages.min)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $c7bc787225e58574$var$clauseDropdownContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2x3Cb.Label), {
            htmlFor: "upper-clause-number-range-field"
        }, formatMessage((0, $6zg4A.default).maximumClauseLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
            id: "upper-clause-number-range-field",
            onChange: handleOnChange('max'),
            value: unsubmittedValue.max,
            placeholder: formatMessage((0, $6zg4A.default).numberRangePlaceholderMessage),
            isInvalid: hasError && errorStateMessages.max !== undefined,
            testId: "jql-builder-basic.ui.jql-editor.field.number-range-picker.upper-clause-text-field"
        }), hasError && errorStateMessages.max !== undefined && showErrorMessage(errorStateMessages.max))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $c7bc787225e58574$var$buttonContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "primary",
            onClick: handleOnSubmit,
            type: "submit",
            isDisabled: hasError,
            testId: "jql-builder-basic.ui.jql-editor.field.number-range-picker.update-button"
        }, formatMessage((0, $6zg4A.default).updateButtonText)))), [
        errorStateMessages,
        formatMessage,
        handleOnChange,
        handleOnSubmit,
        hasError,
        showErrorMessage,
        unsubmittedValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        content: renderContent,
        isOpen: isOpen,
        onClose: onClose,
        placement: "bottom-start",
        popupComponent: (0, $4yuwq.FixedWidthPopupComponent),
        shouldRenderToParent: true,
        messageId: "jql-builder-basic.ui.jql-editor.field.number-range-picker.popup",
        messageType: "transactional",
        trigger: renderTrigger
    });
};
const $c7bc787225e58574$var$textFieldGroupContainerStyles = (0, $8CUq3.xcss)({
    paddingLeft: 'space.150',
    paddingRight: 'space.150'
});
const $c7bc787225e58574$var$clauseDropdownContainerStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.100',
    marginBottom: 'space.100'
});
const $c7bc787225e58574$var$buttonContainerStyles = (0, $8CUq3.xcss)({
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderWidth: 'border.width.0',
    borderTopWidth: 'border.width',
    paddingInline: 'space.150',
    paddingBlock: 'space.075'
});
const $c7bc787225e58574$var$errorMessageContainerStyles = (0, $8CUq3.xcss)({
    margin: 'space.050'
});

});
const $ae4efb9f19844b8c$export$3aefefab9ae0beef = 100000000000000;

parcelRegister("6zg4A", function(module, exports) {

$parcel$export(module.exports, "default", () => $65ce3a21e3e8c53a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $65ce3a21e3e8c53a$var$messages = (0, $7VHMR.defineMessages)({
    numberRangePlaceholderMessage: {
        "id": "jql-builder-basic.jql-editor.field.number-range-picker.number-range-placeholder-message",
        "defaultMessage": "Enter a number"
    },
    minimumClauseLabel: {
        "id": "jql-builder-basic.jql-editor.field.number-range-picker.minimum-clause-label",
        "defaultMessage": "Minimum"
    },
    maximumClauseLabel: {
        "id": "jql-builder-basic.jql-editor.field.number-range-picker.maximum-clause-label",
        "defaultMessage": "Maximum"
    },
    triggerValueBothClauses: {
        "id": "jql-builder-basic.jql-editor.field.number-range-picker.trigger-value-both-clauses",
        "defaultMessage": "From {min} to {max}"
    },
    triggerValueMinimumClause: {
        "id": "jql-builder-basic.jql-editor.field.number-range-picker.trigger-value-minimum-clause",
        "defaultMessage": "From {min}"
    },
    triggerValueMaximumClause: {
        "id": "jql-builder-basic.jql-editor.field.number-range-picker.trigger-value-maximum-clause",
        "defaultMessage": "Up to {max}"
    },
    validNumberErrorMessage: {
        "id": "jql-builder-basic.jql-editor.field.number-range-picker.valid-number-error-message",
        "defaultMessage": "Please enter a valid number"
    },
    numberSizeLimitErrorMessage: {
        "id": "jql-builder-basic.jql-editor.field.number-range-picker.number-size-limit-error-message",
        "defaultMessage": "Specify a number for the custom field (below {maxSize})"
    },
    numberRangeErrorMinimumClauseMessage: {
        "id": "jql-builder-basic.jql-editor.field.number-range-picker.number-range-error-minimum-clause-message",
        "defaultMessage": "The minimum must be less than the maximum"
    },
    numberRangeErrorMaximumClauseMessage: {
        "id": "jql-builder-basic.jql-editor.field.number-range-picker.number-range-error-maximum-clause-message",
        "defaultMessage": "The maximum must be greater than the minimum"
    },
    updateButtonText: {
        "id": "jql-builder-basic.jql-editor.field.number-range-picker.update-button-text",
        "defaultMessage": "Update"
    }
});
var $65ce3a21e3e8c53a$export$2e2bcd8739ae039 = $65ce3a21e3e8c53a$var$messages;

});

parcelRegister("6QnoO", function(module, exports) {

$parcel$export(module.exports, "isNumberRangeValueEmpty", () => $d2bbe11e1cb65ef2$export$edfac072ec483f79);
$parcel$export(module.exports, "hasNumberRangeValueError", () => $d2bbe11e1cb65ef2$export$dacc285ab5e4c500);
$parcel$export(module.exports, "getJqlDataFromClauses", () => $d2bbe11e1cb65ef2$export$6e2488cf7796259d);
$parcel$export(module.exports, "mapJqlDataToNumberRangeValue", () => $d2bbe11e1cb65ef2$export$37604c455ea22dda);
$parcel$export(module.exports, "mapNumberRangeValueToJqlData", () => $d2bbe11e1cb65ef2$export$d2843f73b1f2a602);
$parcel$export(module.exports, "getTriggerValueMessageDescriptor", () => $d2bbe11e1cb65ef2$export$9454d66b829ec1fe);
$parcel$export(module.exports, "getNumberRangePickerErrorMessages", () => $d2bbe11e1cb65ef2$export$d22fc14cae6c7a09);

var $1sXeC = parcelRequire("1sXeC");

var $bzbto = parcelRequire("bzbto");

var $1QYvD = parcelRequire("1QYvD");

var $ibQjx = parcelRequire("ibQjx");

var $6zg4A = parcelRequire("6zg4A");
const $d2bbe11e1cb65ef2$export$edfac072ec483f79 = (numberRangeValue)=>numberRangeValue.min === '' && numberRangeValue.max === '';
const $d2bbe11e1cb65ef2$export$dacc285ab5e4c500 = (errorStateMessages)=>errorStateMessages.min !== undefined || errorStateMessages.max !== undefined;
const $d2bbe11e1cb65ef2$export$6e2488cf7796259d = (primaryClause, secondaryClause)=>({
        ...primaryClause !== undefined && primaryClause.operator && primaryClause.operand && primaryClause.operand.operandType === (0, $49b29ef7baa2a152$export$38accfc5a5d1c113) && {
            primaryClause: {
                operator: primaryClause.operator.value,
                operand: (0, $ibQjx.removeSurroundingQuotes)(primaryClause.operand.text)
            }
        },
        ...secondaryClause !== undefined && secondaryClause.operator && secondaryClause.operand && secondaryClause.operand.operandType === (0, $49b29ef7baa2a152$export$38accfc5a5d1c113) && {
            secondaryClause: {
                operator: secondaryClause.operator.value,
                operand: (0, $ibQjx.removeSurroundingQuotes)(secondaryClause.operand.text)
            }
        }
    });
const $d2bbe11e1cb65ef2$export$37604c455ea22dda = (jqlData)=>{
    const { primaryClause: primaryClause, secondaryClause: secondaryClause } = jqlData;
    const numberRangeValue = {
        min: '',
        max: ''
    };
    [
        primaryClause,
        secondaryClause
    ].forEach((clause)=>{
        switch(clause?.operator){
            case 0, $bzbto.OPERATOR_GT_EQUALS:
                numberRangeValue.min = clause.operand;
                break;
            case 0, $bzbto.OPERATOR_LT_EQUALS:
                numberRangeValue.max = clause.operand;
                break;
            default:
                break;
        }
    });
    return numberRangeValue;
};
const $d2bbe11e1cb65ef2$export$d2843f73b1f2a602 = (numberRangeValue)=>({
        ...numberRangeValue.min !== '' && {
            primaryClause: {
                operator: (0, $bzbto.OPERATOR_GT_EQUALS),
                operand: numberRangeValue.min
            }
        },
        ...numberRangeValue.max !== '' && {
            secondaryClause: {
                operator: (0, $bzbto.OPERATOR_LT_EQUALS),
                operand: numberRangeValue.max
            }
        }
    });
const $d2bbe11e1cb65ef2$export$9454d66b829ec1fe = (numberRangeValue)=>{
    const { min: min, max: max } = numberRangeValue;
    if (min !== '' && max !== '') return (0, $6zg4A.default).triggerValueBothClauses;
    if (min !== '') return (0, $6zg4A.default).triggerValueMinimumClause;
    if (max !== '') return (0, $6zg4A.default).triggerValueMaximumClause;
};
const $d2bbe11e1cb65ef2$export$e51ed4980accfbd3 = (inputValue, focusedIndex)=>{
    if (inputValue.min !== '' && inputValue.max !== '') {
        if (focusedIndex === 'min' && (0, (/*@__PURE__*/$parcel$interopDefault($1sXeC)))(inputValue.min) > (inputValue.max !== '' ? (0, (/*@__PURE__*/$parcel$interopDefault($1sXeC)))(inputValue.max) : Number.POSITIVE_INFINITY)) return true;
        if (focusedIndex === 'max' && (0, (/*@__PURE__*/$parcel$interopDefault($1sXeC)))(inputValue.max) < (inputValue.min !== '' ? (0, (/*@__PURE__*/$parcel$interopDefault($1sXeC)))(inputValue.min) : Number.NEGATIVE_INFINITY)) return true;
    }
    return false;
};
const $d2bbe11e1cb65ef2$export$d22fc14cae6c7a09 = (inputValue, // default is used here to account for initial state, where focusedIndex is not provided
focusedIndex = 'max')=>{
    const errorMessages = {};
    if ($d2bbe11e1cb65ef2$export$edfac072ec483f79(inputValue)) return errorMessages;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    for (const index of [
        'min',
        'max'
    ]){
        if (focusedIndex === index && $d2bbe11e1cb65ef2$export$e51ed4980accfbd3(inputValue, index)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        errorMessages[index] = focusedIndex === 'min' ? (0, $6zg4A.default).numberRangeErrorMinimumClauseMessage : (0, $6zg4A.default).numberRangeErrorMaximumClauseMessage;
        if ((0, $1QYvD.isUnsubmittedValueNotANumber)(inputValue[index])) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        errorMessages[index] = (0, $6zg4A.default).validNumberErrorMessage;
        // this assumes that value is a valid number
        if ((0, $1QYvD.isUnsubmittedNumberTooLarge)((0, (/*@__PURE__*/$parcel$interopDefault($1sXeC)))(inputValue[index]))) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        errorMessages[index] = (0, $6zg4A.default).numberSizeLimitErrorMessage;
    }
    return errorMessages;
};

});
parcelRegister("1QYvD", function(module, exports) {

$parcel$export(module.exports, "isUnsubmittedValueNotANumber", () => $b5eac8519327a868$export$dc9f326e882569dd);
$parcel$export(module.exports, "isUnsubmittedNumberTooLarge", () => $b5eac8519327a868$export$8716b9bb318bd57c);

var $1sXeC = parcelRequire("1sXeC");

const $b5eac8519327a868$export$4e785eb5f6d441 = (value)=>/^-?(\d+(\.\d*)?|\.\d+)$|^$/.test(`${value}`);
const $b5eac8519327a868$export$dc9f326e882569dd = (unsubmittedValue)=>!$b5eac8519327a868$export$4e785eb5f6d441(unsubmittedValue);
const $b5eac8519327a868$export$8716b9bb318bd57c = (unsubmittedValue)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, (/*@__PURE__*/$parcel$interopDefault($1sXeC)))(unsubmittedValue) > (0, $ae4efb9f19844b8c$export$3aefefab9ae0beef);

});




parcelRegister("2eN5z", function(module, exports) {

$parcel$export(module.exports, "PickerWrapper", () => $2f9c9b261d352cde$export$9d776b739e5a282a);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $koVbs = parcelRequire("koVbs");

var $7pFAn = parcelRequire("7pFAn");

var $jG2IE = parcelRequire("jG2IE");

var $eWn4R = parcelRequire("eWn4R");

var $9OXo1 = parcelRequire("9OXo1");

var $8OILN = parcelRequire("8OILN");

var $kG16F = parcelRequire("kG16F");

var $6sVgC = parcelRequire("6sVgC");

var $2LuCx = parcelRequire("2LuCx");

var $fzsvi = parcelRequire("fzsvi");

var $5AAnk = parcelRequire("5AAnk");

var $cy95Y = parcelRequire("cy95Y");

var $dvxPs = parcelRequire("dvxPs");

var $fHJ6B = parcelRequire("fHJ6B");
const $2f9c9b261d352cde$export$9d776b739e5a282a = ({ fieldId: fieldId, fieldLabel: fieldDisplayName, terminalClause: terminalClause, activePopupKey: activePopupKey, onOpen: onOpen, onClose: onClose, onSearchWrapper: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onSearchWrapper = ()=>{}, onSendOptionAnalytics: onSendOptionAnalytics, hydratedData: hydratedData, loading: isLoading, onClear: onClear, picker: picker, projectOptions: projectOptions, isMulti: isMulti, fieldDescription: fieldDescription, onOpenOperatorPicker: onOpenOperatorPicker, hideOperatorDropdown: hideOperatorDropdown, isIrremovable: isIrremovable, contextJql: contextJql, viewContext: viewContext, scope: scope, suggestedUsersCount: suggestedUsersCount })=>{
    const isOpen = activePopupKey === fieldId;
    const isEmpty = !terminalClause;
    const intl = (0, $koVbs.default)();
    const [ast] = (0, $kG16F.useAST)();
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const { searchTemplate: searchTemplate } = picker;
    const { loadOptions: loadOptionsCallback, enableFullList: enableFullList, operandDisplayValues: operandDisplayValues, showOperandDisplayValuesInFullList: showOperandDisplayValuesInFullList } = (0, $cy95Y.getPickerProps)({
        fieldId: fieldId,
        propType: picker.propType || (0, $8OILN.GenericPropTypes).NoProp,
        searchTemplate: searchTemplate,
        jql: contextJql,
        formatMessage: intl.formatMessage,
        environment: environment,
        cloudId: cloudId,
        projectOptions: projectOptions,
        viewContext: viewContext,
        scope: scope,
        suggestedUsersCount: suggestedUsersCount
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const loadOptions = (0, $5uXOq.useCallback)((0, $7pFAn.createGenericDebouncableDataLoader)(loadOptionsCallback), [
        loadOptionsCallback
    ]);
    const [selectedValues, setSelectedValues] = (0, $fHJ6B.useSelectedValues)(terminalClause, hydratedData, fieldId, operandDisplayValues, searchTemplate);
    const { selectedOperator: selectedOperator, setSelectedOperator: setSelectedOperator, allowedOperators: allowedOperators, setDefaultOperator: setDefaultOperator } = (0, $dvxPs.useSelectedOperator)({
        fieldDisplayName: fieldDisplayName ?? fieldId,
        terminalClause: terminalClause,
        allowedOperators: picker.allowedOperators
    });
    const onChangeOperator = (0, $5uXOq.useCallback)((operator)=>{
        if (!hideOperatorDropdown && operator !== null && operator.value !== selectedOperator?.value) {
            setSelectedOperator && setSelectedOperator(operator);
            if (terminalClause) onSearchWrapper((0, $6sVgC.changeOperator)(ast, terminalClause, operator.value));
        }
    }, [
        hideOperatorDropdown,
        selectedOperator?.value,
        setSelectedOperator,
        terminalClause,
        onSearchWrapper,
        ast
    ]);
    const isInvalid = (0, $5uXOq.useMemo)(()=>!isEmpty && selectedValues.length > 0 && selectedValues.some((selectedValue)=>selectedValue.optionType === 'error' || selectedValue.optionType !== 'group' && selectedValue.invalid), [
        selectedValues,
        isEmpty
    ]);
    const onChangeCallback = (0, $5uXOq.useCallback)((optionOrOptions, meta, selectData)=>{
        const options = Array.isArray(optionOrOptions) ? optionOrOptions : [
            optionOrOptions
        ];
        // Optimistically make the UI change, so we don't have to wait for hydration
        setSelectedValues(options);
        onSearchWrapper?.((0, $2LuCx.updateSelectedValue)({
            ast: ast,
            fieldId: fieldId,
            options: options,
            terminalClause: terminalClause,
            operator: !hideOperatorDropdown ? selectedOperator : undefined
        }));
        if (!Array.isArray(optionOrOptions)) onClose?.();
        if (meta.option && (0, $jG2IE.isSingleValueOption)(meta.option)) onSendOptionAnalytics?.({
            selectedItemsCount: options.length,
            selectedItemIndex: selectData?.selectedIndex,
            selectedItemType: 'option' in meta ? meta.option?.itemType : undefined,
            isFullList: 'option' in meta ? meta.option?.fullList : undefined
        });
    }, [
        setSelectedValues,
        onSearchWrapper,
        ast,
        fieldId,
        terminalClause,
        hideOperatorDropdown,
        selectedOperator,
        onClose,
        onSendOptionAnalytics
    ]);
    const onClearValues = (0, $5uXOq.useCallback)(()=>{
        // Optimistically make the UI change so we don't have to wait for hydration
        setSelectedValues([]);
        terminalClause && onSearchWrapper && onSearchWrapper((0, $eWn4R.default)(ast, terminalClause));
        if (!hideOperatorDropdown) setDefaultOperator();
    }, [
        setSelectedValues,
        terminalClause,
        onSearchWrapper,
        ast,
        hideOperatorDropdown,
        setDefaultOperator
    ]);
    const handleOnClear = (0, $5uXOq.useCallback)(()=>{
        onClear && onClear(terminalClause ? (0, $eWn4R.default)(ast, terminalClause) : undefined);
    }, [
        ast,
        onClear,
        terminalClause
    ]);
    const refinement = fieldDisplayName?.toLowerCase() || fieldId;
    const invalidMessage = refinement === 'project' ? intl.formatMessage((0, $fzsvi.default).refinementInvalidProjectOptionMessage) : intl.formatMessage((0, $fzsvi.default).refinementInvalidOptionMessage, {
        refinement: refinement
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5AAnk.PickerLoader), {
        isOpen: isOpen,
        onOpen: onOpen,
        onClose: onClose,
        value: selectedValues,
        isLoading: isLoading,
        fieldId: fieldId,
        searchTemplate: searchTemplate,
        fieldInvalidLabel: isInvalid ? invalidMessage : undefined,
        onChange: onChangeCallback,
        onClearValues: terminalClause ? onClearValues : undefined,
        onLoadOptions: loadOptions,
        enableFullList: enableFullList,
        operandDisplayValues: operandDisplayValues,
        showOperandDisplayValuesInFullList: showOperandDisplayValuesInFullList,
        clause: terminalClause,
        fieldDisplayName: fieldDisplayName,
        isInvalid: isInvalid,
        isEmpty: isEmpty,
        onClearPicker: handleOnClear,
        onChangeOperator: onChangeOperator,
        allowedOperators: allowedOperators,
        selectedOperator: selectedOperator,
        hideOperatorDropdown: hideOperatorDropdown,
        isMulti: isMulti,
        fieldDescription: fieldDescription,
        onOpenOperatorPicker: onOpenOperatorPicker,
        isIrremovable: isIrremovable
    });
};

});
parcelRegister("6sVgC", function(module, exports) {

$parcel$export(module.exports, "changeOperator", () => $c8c431b20f2e520b$export$108a5188e4c8d65);

var $iEIQF = parcelRequire("iEIQF");
var $l0V05 = parcelRequire("l0V05");

var $5JlPO = parcelRequire("5JlPO");

var $8k7M1 = parcelRequire("8k7M1");
const $c8c431b20f2e520b$export$108a5188e4c8d65 = (ast, clause, operatorValue)=>{
    let correctOperator = operatorValue;
    if (clause.operand) {
        correctOperator = (0, $8k7M1.resolveOperator)({
            operatorValue: operatorValue,
            isList: (0, $5JlPO.isListOperand)(clause.operand)
        });
        if (clause.operand.operandType === (0, $49b29ef7baa2a152$export$fabec4aebba3f4df) && clause.operand.values.length === 1) clause.setOperand(clause.operand.values[0]);
    }
    clause.setOperator((0, $iEIQF.default).operator(correctOperator));
    return (0, $l0V05.print)(ast, {
        operatorCase: 'upper'
    });
};

});
parcelRegister("5JlPO", function(module, exports) {

$parcel$export(module.exports, "isListOperand", () => $d1d481b19f153eff$export$1ad46a26ef4c01b7);


var $5Dsab = parcelRequire("5Dsab");
const $d1d481b19f153eff$export$1ad46a26ef4c01b7 = (operand)=>{
    if (operand.operandType === (0, $49b29ef7baa2a152$export$fabec4aebba3f4df)) {
        if (operand.values.length === 1) {
            if (operand.values[0].operandType === (0, $49b29ef7baa2a152$export$19c7c729db381f9d)) return Boolean((0, $5Dsab.OperandValues)[operand.values[0].function.value]?.isList);
            return false;
        }
        return true;
    }
    if (operand.operandType === (0, $49b29ef7baa2a152$export$19c7c729db381f9d)) return Boolean((0, $5Dsab.OperandValues)[operand.function.value]?.isList);
    return false;
};

});

parcelRegister("8k7M1", function(module, exports) {

$parcel$export(module.exports, "resolveOperator", () => $2de8e3425e1de792$export$1ba71b2d6ac9610b);

var $bzbto = parcelRequire("bzbto");
const $2de8e3425e1de792$export$1ba71b2d6ac9610b = ({ operatorValue: operatorValue, isList: isList })=>{
    switch(operatorValue){
        case 0, $bzbto.OPERATOR_EQUALS:
        case 0, $bzbto.OPERATOR_IN:
        case 0, $bzbto.OPERATOR_IS:
            return isList ? (0, $bzbto.OPERATOR_IN) : (0, $bzbto.OPERATOR_EQUALS);
        case 0, $bzbto.OPERATOR_NOT_EQUALS:
        case 0, $bzbto.OPERATOR_NOT_IN:
        case 0, $bzbto.OPERATOR_IS_NOT:
            return isList ? (0, $bzbto.OPERATOR_NOT_IN) : (0, $bzbto.OPERATOR_NOT_EQUALS);
        case 0, $bzbto.OPERATOR_WAS_NOT_IN:
        case 0, $bzbto.OPERATOR_WAS_NOT:
            return isList ? (0, $bzbto.OPERATOR_WAS_NOT_IN) : (0, $bzbto.OPERATOR_WAS_NOT);
        case 0, $bzbto.OPERATOR_WAS:
        case 0, $bzbto.OPERATOR_WAS_IN:
            return isList ? (0, $bzbto.OPERATOR_WAS_IN) : (0, $bzbto.OPERATOR_WAS);
        default:
            return operatorValue;
    }
};

});


parcelRegister("2LuCx", function(module, exports) {

$parcel$export(module.exports, "updateSelectedValue", () => $9b3a5296a5f7ceb2$export$e4207420b53e5463);

var $iEIQF = parcelRequire("iEIQF");
var $bzbto = parcelRequire("bzbto");
var $l0V05 = parcelRequire("l0V05");

var $5Dsab = parcelRequire("5Dsab");

var $1dTaH = parcelRequire("1dTaH");

var $8k7M1 = parcelRequire("8k7M1");
const $9b3a5296a5f7ceb2$var$parseFunction = (func)=>{
    const [, functionName, args] = func.match(/(\w+)\((.*)\)/) ?? [];
    return functionName ? {
        functionName: functionName,
        arguments: args.split(',').map((arg)=>(0, $iEIQF.default).byText.argument(arg.trim()))
    } : {
        functionName: func,
        arguments: []
    };
};
const $9b3a5296a5f7ceb2$var$getOperandValue = (option)=>{
    switch(option.itemType){
        case 0, $49b29ef7baa2a152$export$19c7c729db381f9d:
            {
                const parsedFunctionText = $9b3a5296a5f7ceb2$var$parseFunction(option.value);
                return (0, $iEIQF.default).functionOperand((0, $iEIQF.default).functionString(parsedFunctionText.functionName), parsedFunctionText.arguments);
            }
        case 0, $49b29ef7baa2a152$export$f6049126fd97001f:
            return (0, $iEIQF.default).keywordOperand();
        default:
            return (0, $iEIQF.default).byText.valueOperand(option.value);
    }
};
const $9b3a5296a5f7ceb2$var$getOperandValues = (options)=>{
    const operandValues = options.map((option)=>$9b3a5296a5f7ceb2$var$getOperandValue(option));
    return operandValues;
};
const $9b3a5296a5f7ceb2$var$isListOperator = (options)=>{
    if (options.length === 1) {
        const [option] = options;
        const keyword = Object.values((0, $5Dsab.OperandValues)).find((kw)=>kw.value === option.value || kw.hasArgs && option.value.startsWith(kw.value));
        return Boolean(keyword?.isList);
    }
    return true;
};
const $9b3a5296a5f7ceb2$var$createTerminalClause = ({ fieldId: fieldId, options: options, terminalClause: terminalClause, operator: operator = terminalClause?.operator || (0, $iEIQF.default).operator((0, $bzbto.OPERATOR_EQUALS)) })=>(0, $iEIQF.default).terminalClause((0, $iEIQF.default).field((0, $1dTaH.escapeBackslashes)(fieldId)), (0, $iEIQF.default).operator((0, $8k7M1.resolveOperator)({
        operatorValue: operator.value,
        isList: $9b3a5296a5f7ceb2$var$isListOperator(options)
    })), options.length > 1 ? (0, $iEIQF.default).listOperand($9b3a5296a5f7ceb2$var$getOperandValues(options)) : $9b3a5296a5f7ceb2$var$getOperandValue(options[0]));
const $9b3a5296a5f7ceb2$export$e4207420b53e5463 = ({ ast: ast, fieldId: fieldId, options: options, terminalClause: terminalClause, operator: operator })=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const filteredOptions = options.filter((option)=>'value' in option);
    if (!terminalClause && filteredOptions.length) {
        const newClause = $9b3a5296a5f7ceb2$var$createTerminalClause({
            fieldId: fieldId,
            options: filteredOptions,
            terminalClause: terminalClause,
            operator: operator
        });
        ast.query?.appendClause(newClause, (0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97));
    }
    if (terminalClause && !filteredOptions.length) terminalClause.remove();
    else terminalClause?.replace($9b3a5296a5f7ceb2$var$createTerminalClause({
        fieldId: fieldId,
        options: filteredOptions,
        terminalClause: terminalClause,
        operator: operator
    }));
    return (0, $l0V05.print)(ast, {
        operatorCase: 'upper'
    });
};

});

parcelRegister("fzsvi", function(module, exports) {

$parcel$export(module.exports, "default", () => $e459d64a49b478ed$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e459d64a49b478ed$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    refinementInvalidOptionMessage: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.refinement-invalid-option-message",
        "defaultMessage": "Your project and {refinement} selection is invalid."
    },
    refinementInvalidProjectOptionMessage: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.refinement-invalid-project-option-message",
        "defaultMessage": "Your project selection is invalid."
    }
});

});

parcelRegister("5AAnk", function(module, exports) {

$parcel$export(module.exports, "PickerLoader", () => $6be3f785f9ab71c1$export$4b415d703a601d69);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $7mPT9 = parcelRequire("7mPT9");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $cSD7y = parcelRequire("cSD7y");

var $b1ym7 = parcelRequire("b1ym7");

var $4Hz9T = parcelRequire("4Hz9T");

var $3AuGJ = parcelRequire("3AuGJ");

var $jiutS = parcelRequire("jiutS");

var $crFz4 = parcelRequire("crFz4");

var $6qlmC = parcelRequire("6qlmC");

const $6be3f785f9ab71c1$export$ba25329847403e11 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("hDEjR")), {
    ssr: false,
    moduleId: "./src/packages/jql-builder/basic-picker/src/index.tsx"
});
const $6be3f785f9ab71c1$var$isKeyboardEvent = (event)=>Object.hasOwn(event, 'key');
const $6be3f785f9ab71c1$var$TriggerButtonWrapper = ({ children: children, popupRef: popupRef, triggerRef: triggerRef, ...props })=>{
    const ref = (0, $7mPT9.default)(popupRef, triggerRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Hz9T.default), {
        ref: ref,
        ...props
    }, children);
};
const $6be3f785f9ab71c1$export$f931278d7da4334c = ({ clause: clause, fieldId: fieldId, fieldDisplayName: fieldDisplayName, isLoading: isLoading, isOpen: isOpen, onOpen: onOpen, onClose: onClose, fieldInvalidLabel: fieldInvalidLabel, onChange: onChange, onClearValues: onClearValues, onLoadOptions: onLoadOptions, enableFullList: enableFullList, operandDisplayValues: operandDisplayValues, showOperandDisplayValuesInFullList: showOperandDisplayValuesInFullList, isInvalid: isInvalid, isEmpty: isEmpty, onClearPicker: onClearPicker, value: value, onChangeOperator: onChangeOperator, allowedOperators: allowedOperators, selectedOperator: selectedOperator, isMulti: isMulti, searchTemplate: searchTemplate, fieldDescription: fieldDescription, onOpenOperatorPicker: onOpenOperatorPicker, hideOperatorDropdown: hideOperatorDropdown, isIrremovable: isIrremovable })=>{
    const buttonRef = (0, $5uXOq.useRef)(null);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onTrigger = (0, $5uXOq.useCallback)(({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6be3f785f9ab71c1$var$TriggerButtonWrapper, {
            isInvalid: isInvalid,
            isSelected: isOpen,
            hasValues: !isEmpty,
            onClick: (event)=>{
                isOpen ? onClose(event) : onOpen();
            },
            onClear: onClearPicker,
            popupRef: ref,
            triggerRef: buttonRef,
            testId: `jql-builder-basic.ui.jql-editor.picker.filter-button.${fieldId}`,
            fieldDescription: fieldDescription,
            /**
   * We need to show loading state when:
   * 1) clause is defined (values are selected) and
   * 2) we are waiting for hydrtation to finish (isLoading === true)
   * 3) Picker is closed
   * 4) There are no hydrated values (new or old) for current clause
   */ isLoading: clause && isLoading && !isOpen && value.length === 0,
            searchTemplate: searchTemplate,
            isIrremovable: isIrremovable
        }, !hideOperatorDropdown ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jiutS.default), {
            label: fieldDisplayName,
            value: value,
            isInvalid: isInvalid,
            onChangeOperator: onChangeOperator,
            selectedOperator: selectedOperator,
            allowedOperators: allowedOperators,
            isParentPickerOpen: isOpen,
            onOpenOperatorPicker: onOpenOperatorPicker,
            ...(0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-headers-buttons') && {
                isSelected: isOpen
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3AuGJ.TriggerComponentNoOperator), {
            label: fieldDisplayName,
            value: value,
            isInvalid: isInvalid,
            ...(0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-headers-buttons') && {
                isSelected: isOpen
            }
        })), [
        isInvalid,
        isOpen,
        isEmpty,
        fieldId,
        onClearPicker,
        fieldDescription,
        clause,
        isLoading,
        value,
        searchTemplate,
        isIrremovable,
        hideOperatorDropdown,
        allowedOperators,
        onOpenOperatorPicker,
        fieldDisplayName,
        onChangeOperator,
        selectedOperator,
        onClose,
        onOpen
    ]);
    const experienceAnalyticsAttributes = (0, $5uXOq.useMemo)(()=>searchTemplate ? {
            searchTemplate: searchTemplate
        } : {}, [
        searchTemplate
    ]);
    const handleClose = (0, $5uXOq.useCallback)((event)=>{
        onClose(event);
        if ($6be3f785f9ab71c1$var$isKeyboardEvent(event) && event.key === 'Escape') buttonRef.current?.focus();
    }, [
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "picker-loader-picker",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b1ym7.default), {
            clause: clause,
            fieldId: fieldId,
            fieldDisplayName: fieldDisplayName,
            fieldDescription: fieldDescription,
            isIrremovable: isIrremovable
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6be3f785f9ab71c1$export$ba25329847403e11, {
        isOpen: isOpen,
        onClose: handleClose,
        value: value,
        id: fieldId,
        searchInputPlaceholder: formatMessage((0, $6qlmC.default).searchPlaceholder, {
            fieldName: fieldDisplayName
        }),
        invalidLabel: fieldInvalidLabel,
        onChange: onChange,
        onClearValues: onClearValues,
        onLoadOptions: onLoadOptions,
        enableFullList: enableFullList,
        operandDisplayValues: operandDisplayValues,
        showOperandDisplayValuesInFullList: showOperandDisplayValuesInFullList,
        onTrigger: onTrigger,
        shouldRenderToParent: true,
        showOperatorSelect: !hideOperatorDropdown,
        onChangeOperator: onChangeOperator,
        allowedOperators: allowedOperators,
        selectedOperator: selectedOperator,
        isMulti: isMulti,
        experienceAnalyticsAttributes: experienceAnalyticsAttributes
    }));
};
const $6be3f785f9ab71c1$export$4b415d703a601d69 = (0, $cSD7y.componentWithFG)('jql_builder_lazy_picker_to_entrypoint', (0, $crFz4.PickerLoader), $6be3f785f9ab71c1$export$f931278d7da4334c);
var $6be3f785f9ab71c1$export$2e2bcd8739ae039 = $6be3f785f9ab71c1$export$4b415d703a601d69;

});
parcelRegister("jiutS", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d0085d78826c993$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $16T6Y = parcelRequire("16T6Y");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $gwIPs = parcelRequire("gwIPs");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");


var $l0BLU = parcelRequire("l0BLU");
const $6d0085d78826c993$var$hasValue = (value)=>Array.isArray(value) ? value.length > 0 : typeof value === 'object' && value !== null;
const $6d0085d78826c993$var$TriggerComponent = ({ isInvalid: isInvalid = false, label: label = '', value: value, allowedOperators: allowedOperators, onChangeOperator: onChangeOperator, selectedOperator: selectedOperator, isParentPickerOpen: isParentPickerOpen, onOpenOperatorPicker: onOpenOperatorPicker, isSelected: isSelected })=>{
    if (!value || !$6d0085d78826c993$var$hasValue(value)) return (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-headers-buttons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $6d0085d78826c993$var$triggerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $6d0085d78826c993$var$triggerStyles,
        testId: (0, $227fa8a1aa91f085$export$743be55d5cf4a20d)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        weight: "medium",
        color: !isSelected ? 'color.text.subtle' : 'inherit'
    }, label))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6d0085d78826c993$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6d0085d78826c993$var$LabelContainer, {
        "data-testid": (0, $227fa8a1aa91f085$export$743be55d5cf4a20d)
    }, label));
    const valueMap = value.map((v)=>v.optionType !== 'error' && v.label !== undefined ? v.label : '');
    const valueLength = valueMap.length;
    const [firstValue, ...rest] = valueMap;
    const badgeAppearance = isInvalid ? 'important' : 'primary';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6d0085d78826c993$var$Container, {
        "aria-label": `${selectedOperator?.ariaLabel} ${firstValue}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6d0085d78826c993$var$LabelContainer, {
        "data-testid": (0, $227fa8a1aa91f085$export$743be55d5cf4a20d)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6d0085d78826c993$var$StyledLabel, null, label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l0BLU.default), {
        isInvalid: isInvalid,
        allowedOperators: allowedOperators,
        selectedOperator: selectedOperator,
        onChangeOperator: onChangeOperator,
        isParentPickerOpen: isParentPickerOpen,
        onOpenOperatorPicker: onOpenOperatorPicker
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6d0085d78826c993$var$ValueContainer, null, firstValue), valueLength > 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6d0085d78826c993$var$StyledBadge, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16T6Y.default), {
        testId: (0, $227fa8a1aa91f085$export$fca2db27fe6c1305),
        appearance: badgeAppearance
    }, `+${rest.length}`)) : null);
};
const $6d0085d78826c993$var$triggerContainerStyles = (0, $8CUq3.xcss)({
    display: 'inline-flex',
    alignItems: 'center'
});
const $6d0085d78826c993$var$triggerStyles = (0, $8CUq3.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${24 * (0, $gwIPs.gridSize)}px`,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6d0085d78826c993$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $6d0085d78826c993$var$LabelContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _p12fd36x _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $6d0085d78826c993$var$ValueContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _p12fd36x _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $6d0085d78826c993$var$StyledLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_k48pmoej _2hwx1b66",
            __cmplp.className
        ])
    });
});
const $6d0085d78826c993$var$StyledBadge = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o _18u01b66",
            __cmplp.className
        ])
    });
});
var $6d0085d78826c993$export$2e2bcd8739ae039 = $6d0085d78826c993$var$TriggerComponent;

});
parcelRegister("l0BLU", function(module, exports) {

$parcel$export(module.exports, "default", () => $b519843ab37cbc7b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ 
var $5uXOq = parcelRequire("5uXOq");

var $c8Oei = parcelRequire("c8Oei");

var $dC5iT = parcelRequire("dC5iT");

var $bChGW = parcelRequire("bChGW");
var $7K5PP = parcelRequire("7K5PP");

var $gwIPs = parcelRequire("gwIPs");

var $7XYc4 = parcelRequire("7XYc4");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dCm1o = parcelRequire("dCm1o");

var $6Hlgz = parcelRequire("6Hlgz");
const $b519843ab37cbc7b$var$baseStyle = {
    alignSelf: 'center',
    margin: 0,
    padding: 0
};
const $b519843ab37cbc7b$var$indicatorsContainerStyle = {
    root: "_3lltze3t _1onpze3t _k4bfze3t _1vxpze3t"
};
const $b519843ab37cbc7b$var$getAdditionalStyles = (isInvalid)=>({
        control: (css, props)=>({
                ...css,
                height: `${"var(--ds-space-300, 24px)"}`,
                textAlign: 'left',
                // need to overwrite existing minHeight
                minHeight: 0,
                // substracting 5 so it's never on top of main dropdown
                zIndex: (0, $gwIPs.layers).navigation - 5,
                backgroundColor: "var(--ds-background-input, #FFFFFF)",
                ...props.isDisabled ? {
                    backgroundColor: 'none',
                    borderColor: "var(--ds-text-inverse, #FFFFFF)"
                } : {}
            }),
        input: (css)=>({
                ...css,
                ...$b519843ab37cbc7b$var$baseStyle,
                height: 'inherit'
            }),
        singleValue: (css)=>({
                ...css,
                ...$b519843ab37cbc7b$var$baseStyle,
                color: "var(--ds-text-selected, #0C66E4)",
                textAlign: 'left',
                ...isInvalid ? {
                    color: "var(--ds-text-danger, #AE2E24)"
                } : {}
            }),
        valueContainer: (css)=>({
                ...css,
                ...$b519843ab37cbc7b$var$baseStyle,
                // to align horizontally
                height: '100%',
                paddingLeft: `${"var(--ds-space-050, 4px)"}`,
                paddingRight: 0
            }),
        indicatorsContainer: (css)=>({
                ...css,
                ...$b519843ab37cbc7b$var$baseStyle,
                '> div': {
                    padding: '0'
                },
                // to align horizontally
                height: '100%'
            }),
        container: (css)=>({
                ...css,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                lineHeight: '20px',
                textAlign: 'left'
            }),
        menu: (css)=>({
                ...css,
                // no space between dropdown and trigger button
                marginTop: 0,
                width: 'fit-content',
                // substracting 4 so it's never on top of main dropdown but if on top of the picker trigger of other operator dropdowns
                zIndex: (0, $gwIPs.layers).navigation - 4
            })
    });
const $b519843ab37cbc7b$var$TEST_ID_DROPDOWN = 'jql-builder-basic.common.ui.picker-trigger.dropdown-operator.dropdown-operator';
const $b519843ab37cbc7b$var$getOptionLabel = (option)=>option.ariaLabel;
const $b519843ab37cbc7b$var$formatOptionLabel = (option)=>option.shortLabel;
const $b519843ab37cbc7b$var$DropdownOperator = ({ allowedOperators: allowedOperators, selectedOperator: selectedOperator = allowedOperators[0], onChangeOperator: onChangeOperator, isParentPickerOpen: isParentPickerOpen, onOpenOperatorPicker: onOpenOperatorPicker, isInvalid: isInvalid })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onChangeOperatorWithAnalytics = (0, $5uXOq.useCallback)((option)=>{
        onChangeOperator && onChangeOperator(option);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        });
        option && (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'operatorSelect', {
            option: option.value,
            selectType: 'inline'
        });
    }, [
        createAnalyticsEvent,
        onChangeOperator
    ]);
    const SingleValue = (0, $5uXOq.useCallback)(({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).SingleValue, props, selectedOperator?.valueLabel), [
        selectedOperator?.valueLabel
    ]);
    const DropdownIndicator = (0, $5uXOq.useCallback)((props)=>{
        let primaryColor = "var(--ds-text-selected, #0C66E4)";
        if (props.isDisabled) primaryColor = "var(--ds-text-inverse, #FFFFFF)";
        else if (isInvalid) primaryColor = "var(--ds-text-danger, #AE2E24)";
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).DropdownIndicator, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b519843ab37cbc7b$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
            testId: "jql-builder-basic.common.ui.picker-trigger.dropdown-operator.chevron-down-icon",
            label: "",
            color: primaryColor,
            LEGACY_primaryColor: primaryColor
        })));
    }, [
        isInvalid
    ]);
    const onMenuOpenAnalytics = (0, $5uXOq.useCallback)(()=>{
        onOpenOperatorPicker();
        const analyticsEvent = createAnalyticsEvent({
            action: 'opened',
            actionSubject: 'dropdown'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'operatorSelect', {
            selectType: 'inline'
        });
    }, [
        createAnalyticsEvent,
        onOpenOperatorPicker
    ]);
    const dropdownOperatorComponents = (0, $5uXOq.useMemo)(()=>({
            DropdownIndicator: DropdownIndicator,
            SingleValue: SingleValue,
            IndicatorsContainer: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).IndicatorsContainer, {
                    ...props,
                    xcss: $b519843ab37cbc7b$var$indicatorsContainerStyle.root
                })
        }), [
        DropdownIndicator,
        SingleValue
    ]);
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingInlineStart: "space.025",
        paddingInlineEnd: "space.050",
        onClick: (event)=>{
            !isParentPickerOpen && event.stopPropagation();
        },
        role: "presentation",
        onKeyDown: (event)=>{
            // Prevent issue list from capturing arrow up and down keys, prevent closing a modal on escape key
            if (event.key === 'ArrowDown' || event.key === 'ArrowUp' || event.key === 'Escape') event.stopPropagation();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        "aria-label": formatMessage((0, $6Hlgz.default).operatorLabel),
        testId: $b519843ab37cbc7b$var$TEST_ID_DROPDOWN,
        components: dropdownOperatorComponents,
        spacing: "compact",
        appearance: "subtle",
        styles: $b519843ab37cbc7b$var$getAdditionalStyles(isInvalid),
        value: selectedOperator,
        options: allowedOperators,
        onChange: onChangeOperatorWithAnalytics,
        getOptionLabel: $b519843ab37cbc7b$var$getOptionLabel,
        formatOptionLabel: $b519843ab37cbc7b$var$formatOptionLabel,
        isDisabled: isParentPickerOpen,
        isInvalid: isInvalid,
        isSearchable: false,
        onMenuOpen: onMenuOpenAnalytics
    })));
};
var $b519843ab37cbc7b$export$2e2bcd8739ae039 = $b519843ab37cbc7b$var$DropdownOperator;
const $b519843ab37cbc7b$var$IconContainer = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingInline: "space.075"
    }, children), (0, $5uXOq.Fragment));

});
parcelRegister("6Hlgz", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c8a35407d878b4d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $4c8a35407d878b4d$var$messages = (0, $7VHMR.defineMessages)({
    operatorLabel: {
        "id": "jql-builder-basic.common.picker-trigger.dropdown-operator.operator-label",
        "defaultMessage": "Operator dropdown"
    }
});
var $4c8a35407d878b4d$export$2e2bcd8739ae039 = $4c8a35407d878b4d$var$messages;

});



parcelRegister("crFz4", function(module, exports) {

$parcel$export(module.exports, "PickerLoader", () => $395b10c6e4bedc7f$export$4b415d703a601d69);

var $5uXOq = parcelRequire("5uXOq");

var $F7vyc = parcelRequire("F7vyc");

var $7mPT9 = parcelRequire("7mPT9");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $4Hz9T = parcelRequire("4Hz9T");

var $3AuGJ = parcelRequire("3AuGJ");

var $jiutS = parcelRequire("jiutS");
const $395b10c6e4bedc7f$var$isKeyboardEvent = (event)=>Object.hasOwn(event, 'key');
const $395b10c6e4bedc7f$var$TriggerButtonWrapper = ({ children: children, popupRef: popupRef, triggerRef: triggerRef, buttonRef: buttonRef, ...props })=>{
    const ref = (0, $7mPT9.default)(popupRef, triggerRef, buttonRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Hz9T.default), {
        ref: ref,
        ...props
    }, children);
};
const $395b10c6e4bedc7f$export$4b415d703a601d69 = ({ clause: clause, fieldId: fieldId, fieldDisplayName: fieldDisplayName, isLoading: isLoading, isOpen: isOpen, onOpen: onOpen, onClose: onClose, fieldInvalidLabel: fieldInvalidLabel, onChange: onChange, onClearValues: onClearValues, onLoadOptions: onLoadOptions, enableFullList: enableFullList, operandDisplayValues: operandDisplayValues, showOperandDisplayValuesInFullList: showOperandDisplayValuesInFullList, isInvalid: isInvalid, isEmpty: isEmpty, onClearPicker: onClearPicker, value: value, onChangeOperator: onChangeOperator, allowedOperators: allowedOperators, selectedOperator: selectedOperator, isMulti: isMulti, searchTemplate: searchTemplate, fieldDescription: fieldDescription, onOpenOperatorPicker: onOpenOperatorPicker, hideOperatorDropdown: hideOperatorDropdown, isIrremovable: isIrremovable })=>{
    const buttonRef = (0, $5uXOq.useRef)(null);
    const onTrigger = (0, $5uXOq.useCallback)((triggerProps, triggerRef)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($395b10c6e4bedc7f$var$TriggerButtonWrapper, {
            isInvalid: isInvalid,
            isSelected: isOpen,
            hasValues: !isEmpty,
            onClick: (event)=>{
                isOpen ? onClose(event) : onOpen();
            },
            onClear: onClearPicker,
            popupRef: triggerProps.ref,
            triggerRef: triggerRef,
            buttonRef: buttonRef,
            testId: `jql-builder-basic.ui.jql-editor.picker.filter-button.${fieldId}`,
            fieldDescription: fieldDescription,
            /**
					 * We need to show loading state when:
					 * 1) clause is defined (values are selected) and
					 * 2) we are waiting for hydrtation to finish (isLoading === true)
					 * 3) Picker is closed
					 * 4) There are no hydrated values (new or old) for current clause
					 */ isLoading: clause && isLoading && !isOpen && value.length === 0,
            searchTemplate: searchTemplate,
            isIrremovable: isIrremovable
        }, !hideOperatorDropdown ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jiutS.default), {
            label: fieldDisplayName,
            value: value,
            isInvalid: isInvalid,
            onChangeOperator: onChangeOperator,
            selectedOperator: selectedOperator,
            allowedOperators: allowedOperators,
            isParentPickerOpen: isOpen,
            onOpenOperatorPicker: onOpenOperatorPicker,
            ...(0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-headers-buttons') && {
                isSelected: isOpen
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3AuGJ.TriggerComponentNoOperator), {
            label: fieldDisplayName,
            value: value,
            isInvalid: isInvalid,
            ...(0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-headers-buttons') && {
                isSelected: isOpen
            }
        }));
    }, [
        isInvalid,
        isOpen,
        isEmpty,
        fieldId,
        onClearPicker,
        fieldDescription,
        clause,
        isLoading,
        value,
        searchTemplate,
        isIrremovable,
        hideOperatorDropdown,
        allowedOperators,
        onOpenOperatorPicker,
        fieldDisplayName,
        onChangeOperator,
        selectedOperator,
        onClose,
        onOpen
    ]);
    const experienceAnalyticsAttributes = (0, $5uXOq.useMemo)(()=>searchTemplate ? {
            searchTemplate: searchTemplate
        } : {}, [
        searchTemplate
    ]);
    const handleClose = (0, $5uXOq.useCallback)((event)=>{
        onClose(event);
        if ($395b10c6e4bedc7f$var$isKeyboardEvent(event) && event.key === 'Escape') buttonRef.current?.focus();
    }, [
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $F7vyc.PickerEntryPoint), {
        isOpen: isOpen,
        onClose: handleClose,
        value: value,
        id: fieldId,
        invalidLabel: fieldInvalidLabel,
        onChange: onChange,
        onClearValues: onClearValues,
        onLoadOptions: onLoadOptions,
        enableFullList: enableFullList,
        operandDisplayValues: operandDisplayValues,
        showOperandDisplayValuesInFullList: showOperandDisplayValuesInFullList,
        onTrigger: onTrigger,
        shouldRenderToParent: true,
        showOperatorSelect: !hideOperatorDropdown,
        onChangeOperator: onChangeOperator,
        allowedOperators: allowedOperators,
        selectedOperator: selectedOperator,
        isMulti: isMulti,
        experienceAnalyticsAttributes: experienceAnalyticsAttributes
    });
};
var $395b10c6e4bedc7f$export$2e2bcd8739ae039 = $395b10c6e4bedc7f$export$4b415d703a601d69;

});

parcelRegister("6qlmC", function(module, exports) {

$parcel$export(module.exports, "default", () => $840927bd5aaee88f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $840927bd5aaee88f$var$messages = (0, $7VHMR.defineMessages)({
    searchPlaceholder: {
        "id": "jql-builder-basic.picker-loader.search-placeholder",
        "defaultMessage": "Search {fieldName}"
    }
});
var $840927bd5aaee88f$export$2e2bcd8739ae039 = $840927bd5aaee88f$var$messages;

});


parcelRegister("cy95Y", function(module, exports) {

$parcel$export(module.exports, "getPickerProps", () => $2dc86d2bafc2f9ec$export$3dc4888d75a40889);

var $8OILN = parcelRequire("8OILN");

var $1dTaH = parcelRequire("1dTaH");

var $6YDT8 = parcelRequire("6YDT8");

var $i8D8h = parcelRequire("i8D8h");

var $9l3yI = parcelRequire("9l3yI");

var $14an2 = parcelRequire("14an2");

var $f9Gva = parcelRequire("f9Gva");

var $fxPX8 = parcelRequire("fxPX8");

var $acs6u = parcelRequire("acs6u");
const $2dc86d2bafc2f9ec$export$3dc4888d75a40889 = ({ fieldId: fieldId, propType: propType, searchTemplate: searchTemplate, formatMessage: formatMessage, jql: jql, environment: environment, cloudId: cloudId, projectOptions: projectOptions, viewContext: viewContext, scope: scope, suggestedUsersCount: suggestedUsersCount })=>{
    const commonProps = {
        fieldId: fieldId,
        searchTemplate: searchTemplate,
        propType: propType,
        formatMessage: formatMessage,
        jql: jql,
        environment: environment,
        cloudId: cloudId,
        operandDisplayValues: (0, $6YDT8.getValidOperandDisplayValues)(propType),
        viewContext: viewContext,
        scope: scope,
        suggestedUsersCount: suggestedUsersCount
    };
    if (!(0, $1dTaH.isPickerPropType)(propType)) throw new Error(`Unsupported PickerPropType: ${propType}`);
    switch(propType){
        case (0, $8OILN.PickerPropTypes).IssueType:
            return (0, $14an2.getIssueTypeProps)(commonProps);
        case (0, $8OILN.PickerPropTypes).User:
            return (0, $f9Gva.getPeopleProps)(commonProps);
        case (0, $8OILN.PickerPropTypes).Sprint:
            return (0, $acs6u.getSprintProps)(commonProps);
        case (0, $8OILN.PickerPropTypes).Common:
            return (0, $i8D8h.getCommonProps)(commonProps);
        case (0, $8OILN.PickerPropTypes).CommonWithEmpty:
        case (0, $8OILN.PickerPropTypes).Version:
            return (0, $i8D8h.getCommonProps)({
                ...commonProps,
                showOperandDisplayValuesInFullList: true
            });
        case (0, $8OILN.PickerPropTypes).Project:
            return (0, $fxPX8.getProjectProps)({
                ...commonProps,
                projectOptions: projectOptions
            });
        case (0, $8OILN.PickerPropTypes).Group:
            return (0, $9l3yI.getGroupProps)(commonProps);
        default:
            throw new Error(`Unsupported PickerPropType: ${propType}`);
    }
};

});
parcelRegister("6YDT8", function(module, exports) {

$parcel$export(module.exports, "getValidOperandNames", () => $e0d5d649a1f09daf$export$1917025b3a772e5);
$parcel$export(module.exports, "getValidOperandDisplayValues", () => $e0d5d649a1f09daf$export$7b0867b4bdc21cd8);

var $gJBT6 = parcelRequire("gJBT6");

var $5Dsab = parcelRequire("5Dsab");

var $8OILN = parcelRequire("8OILN");
const $e0d5d649a1f09daf$export$1917025b3a772e5 = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((propType)=>{
    switch(propType){
        case (0, $8OILN.PickerPropTypes).IssueType:
            return [
                (0, $5Dsab.FunctionName).standardIssueTypes,
                (0, $5Dsab.FunctionName).subTaskIssueTypes
            ];
        case (0, $8OILN.PickerPropTypes).User:
            return [
                (0, $5Dsab.FunctionName).currentUser,
                (0, $5Dsab.KeywordName).empty,
                (0, $5Dsab.FunctionName).membersOf
            ];
        case (0, $8OILN.PickerPropTypes).CommonWithEmpty:
        case (0, $8OILN.PickerPropTypes).Sprint:
            return [
                (0, $5Dsab.KeywordName).empty
            ];
        case (0, $8OILN.PickerPropTypes).Version:
            return [
                (0, $5Dsab.KeywordName).empty,
                (0, $5Dsab.FunctionName).releasedVersions,
                (0, $5Dsab.FunctionName).unreleasedVersions
            ];
        default:
    }
    return undefined;
});
const $e0d5d649a1f09daf$export$7b0867b4bdc21cd8 = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((propType)=>$e0d5d649a1f09daf$export$1917025b3a772e5(propType)?.map((name)=>(0, $5Dsab.OperandValues)[name].value));

});

parcelRegister("i8D8h", function(module, exports) {

$parcel$export(module.exports, "getOption", () => $1e0e6f48b48f1f2a$export$6df0712d20d2cc08);
$parcel$export(module.exports, "getCommonProps", () => $1e0e6f48b48f1f2a$export$fa723cfebd5684f9);

var $2cItf = parcelRequire("2cItf");

var $8Uumt = parcelRequire("8Uumt");


var $5Dsab = parcelRequire("5Dsab");

var $1dTaH = parcelRequire("1dTaH");

var $gCOs7 = parcelRequire("gCOs7");

var $djaDD = parcelRequire("djaDD");

var $6YDT8 = parcelRequire("6YDT8");

var $cPTCQ = parcelRequire("cPTCQ");
const $1e0e6f48b48f1f2a$export$6df0712d20d2cc08 = (node, itemType)=>{
    const { displayName: displayName, jqlTerm: jqlTerm, __typename: __typename } = node;
    const option = {
        label: displayName,
        value: jqlTerm,
        optionType: 'option',
        itemType: itemType
    };
    if (__typename === 'JiraJqlPriorityFieldValue' && node.priority && node.priority.iconUrl) return {
        ...option,
        icon: node.priority.iconUrl
    };
    if ((__typename === 'JiraJqlStatusFieldValue' || __typename === 'JiraJqlStatusCategoryFieldValue') && node.statusCategory) {
        const { colorName: colorName } = node.statusCategory;
        return {
            ...option,
            optionType: 'lozenge',
            appearance: (0, $cPTCQ.getLozengeAppearance)(colorName)
        };
    }
    if (__typename === 'JiraJqlIssueFieldValue' && node.issue && node.issue.fields && node.issue.fields.edges && node.issue.fields.edges[0] && node.issue.fields.edges[0].node && node.issue.fields.edges[0].node.text !== undefined && node.issue.fields.edges[0].node.text !== null) return {
        ...option,
        label: node.issue.fields.edges[0].node.text,
        secondaryLabel: option.label
    };
    return option;
};
const $1e0e6f48b48f1f2a$export$fa723cfebd5684f9 = ({ fieldId: fieldId, propType: propType, showOperandDisplayValuesInFullList: showOperandDisplayValuesInFullList, formatMessage: formatMessage, jql: jql, environment: environment, cloudId: cloudId, operandDisplayValues: operandDisplayValues, searchTemplate: searchTemplate, viewContext: viewContext })=>({
        enableFullList: false,
        operandDisplayValues: operandDisplayValues,
        showOperandDisplayValuesInFullList: showOperandDisplayValuesInFullList || undefined,
        loadOptions: async (search, renderInitialValues, endCursor)=>{
            const after = endCursor;
            try {
                const data = await (0, $8Uumt.fetchQuery)(environment, (0, $2cItf.default), {
                    cloudId: cloudId,
                    first: 10,
                    jqlTerm: fieldId.toLowerCase(),
                    jql: jql || '',
                    searchString: search,
                    after: after,
                    viewContext: viewContext
                }, {
                    fetchPolicy: 'store-or-network'
                }).toPromise();
                const operandOptions = showOperandDisplayValuesInFullList ? ((0, $6YDT8.getValidOperandNames)(propType) ?? []).map((name)=>({
                        label: (0, $5Dsab.OperandValues)[name].type === (0, $49b29ef7baa2a152$export$f6049126fd97001f) ? (0, $gCOs7.getEmptyLabel)(searchTemplate ?? null, formatMessage) : (0, $djaDD.getFunctionLabel)(name, formatMessage),
                        value: (0, $5Dsab.OperandValues)[name].value,
                        optionType: 'option',
                        itemType: (0, $5Dsab.OperandValues)[name].type
                    })) : [];
                if (!data?.jira?.jqlBuilder?.fieldValues?.edges) return (0, $1dTaH.generateOptions)([
                    ...operandOptions
                ]);
                const { edges: fieldValues, totalCount: totalCount, pageInfo: pageInfo } = data.jira.jqlBuilder.fieldValues;
                return (0, $1dTaH.generateOptions)([
                    ...search.length === 0 && !endCursor ? operandOptions : [],
                    ...fieldValues.reduce((options, edges)=>{
                        if (!edges || !edges.node) return options;
                        const { node: node } = edges;
                        options.push($1e0e6f48b48f1f2a$export$6df0712d20d2cc08(node, (0, $49b29ef7baa2a152$export$38accfc5a5d1c113)));
                        return options;
                    }, [])
                ], totalCount, pageInfo?.endCursor || undefined);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $1dTaH.fireJqlBuilderBasicErrorAnalytics)('commonJqlBuilderBasicFieldValues', searchTemplate, error);
                return (0, $1dTaH.generateErrorOptions)(error);
            }
        }
    });

});
parcelRegister("2cItf", function(module, exports) {

$parcel$export(module.exports, "default", () => $1960dff69d7660bd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<67496997b94ad558a73aa816f0c74f85>>
 * @relayHash 8640e63348e5d925f93816e53f6c5b01
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e831c84bdd8946040c19eb688135440ba952ad04b564b51cc4edbcd136cd7b02
const $1960dff69d7660bd$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jqlTerm"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchString"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewContext"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v8 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "jqlContext",
            "variableName": "jql"
        },
        {
            "kind": "Variable",
            "name": "jqlTerm",
            "variableName": "jqlTerm"
        },
        {
            "kind": "Variable",
            "name": "searchString",
            "variableName": "searchString"
        },
        {
            "kind": "Variable",
            "name": "viewContext",
            "variableName": "viewContext"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v10 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v12 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v13 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v14 = {
        "kind": "ScalarField",
        "name": "colorName"
    }, v15 = [
        {
            "concreteType": "JiraStatusCategory",
            "kind": "LinkedField",
            "name": "statusCategory",
            "plural": false,
            "selections": [
                v14 /*: any*/ 
            ]
        }
    ], v16 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "text"
            }
        ],
        "type": "JiraSingleLineTextField"
    }, v18 = {
        "kind": "ScalarField",
        "name": "id"
    }, v19 = [
        {
            "concreteType": "JiraStatusCategory",
            "kind": "LinkedField",
            "name": "statusCategory",
            "plural": false,
            "selections": [
                v14 /*: any*/ ,
                v18 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "commonJqlBuilderBasicFieldValuesQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v7 /*: any*/ ,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v8 /*: any*/ ,
                                        "concreteType": "JiraJqlFieldValueConnection",
                                        "kind": "LinkedField",
                                        "name": "fieldValues",
                                        "plural": false,
                                        "selections": [
                                            v9 /*: any*/ ,
                                            v10 /*: any*/ ,
                                            {
                                                "concreteType": "JiraJqlFieldValueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v11 /*: any*/ ,
                                                            v12 /*: any*/ ,
                                                            v13 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v15 /*: any*/ ,
                                                                "type": "JiraJqlStatusFieldValue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraPriority",
                                                                        "kind": "LinkedField",
                                                                        "name": "priority",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v16 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlPriorityFieldValue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v15 /*: any*/ ,
                                                                "type": "JiraJqlStatusCategoryFieldValue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraIssue",
                                                                        "kind": "LinkedField",
                                                                        "name": "issue",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraIssueFieldConnection",
                                                                                "kind": "LinkedField",
                                                                                "name": "fields",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraIssueFieldEdge",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "edges",
                                                                                        "plural": true,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "LinkedField",
                                                                                                "name": "node",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    v17 /*: any*/ 
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlIssueFieldValue"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v0 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "commonJqlBuilderBasicFieldValuesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v8 /*: any*/ ,
                                    "concreteType": "JiraJqlFieldValueConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldValues",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "concreteType": "JiraJqlFieldValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        v12 /*: any*/ ,
                                                        v13 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v19 /*: any*/ ,
                                                            "type": "JiraJqlStatusFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraPriority",
                                                                    "kind": "LinkedField",
                                                                    "name": "priority",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v16 /*: any*/ ,
                                                                        v18 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlPriorityFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v19 /*: any*/ ,
                                                            "type": "JiraJqlStatusCategoryFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "issue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v13 /*: any*/ ,
                                                                                                v17 /*: any*/ ,
                                                                                                v18 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v18 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlIssueFieldValue"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e831c84bdd8946040c19eb688135440ba952ad04b564b51cc4edbcd136cd7b02",
            "metadata": {},
            "name": "commonJqlBuilderBasicFieldValuesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1960dff69d7660bd$var$node.hash = "287a2bf3ddbdda31cd84a0d1afbcfa31";
var $1960dff69d7660bd$export$2e2bcd8739ae039 = $1960dff69d7660bd$var$node;

});

parcelRegister("gCOs7", function(module, exports) {

$parcel$export(module.exports, "getEmptyLabel", () => $eafa41d402728f65$export$b77f75d3ab7bfc24);

var $bBtjK = parcelRequire("bBtjK");
const $eafa41d402728f65$export$b77f75d3ab7bfc24 = (searchTemplate, formatMessage)=>{
    const message = (0, $bBtjK.messageLookup)[searchTemplate];
    if (message) return formatMessage(message);
    return formatMessage((0, $bBtjK.messages).genericEmpty);
};

});
parcelRegister("bBtjK", function(module, exports) {

$parcel$export(module.exports, "messages", () => $107f821a96b5bc5a$export$defe85febe8b728c);
$parcel$export(module.exports, "messageLookup", () => $107f821a96b5bc5a$export$3a16bd55b6aaaf91);

var $7VHMR = parcelRequire("7VHMR");

var $5Dsab = parcelRequire("5Dsab");
const $107f821a96b5bc5a$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    // eslint-disable-next-line jira/i18n/id-named-by-package
    [(0, $5Dsab.ASSIGNEE).searchTemplate]: {
        "id": "jql-builder-basic.utils.get-empty-label.assignee",
        "defaultMessage": "Unassigned"
    },
    // eslint-disable-next-line jira/i18n/id-named-by-package
    [(0, $5Dsab.REPORTER).searchTemplate]: {
        "id": "jql-builder-basic.utils.get-empty-label.reporter-new",
        "defaultMessage": "Anonymous"
    },
    // eslint-disable-next-line jira/i18n/id-named-by-package
    [(0, $5Dsab.CREATOR).searchTemplate]: {
        "id": "jql-builder-basic.utils.get-empty-label.creator",
        "defaultMessage": "Anonymous"
    },
    // eslint-disable-next-line jira/i18n/id-named-by-package
    [(0, $5Dsab.COMPONENT).searchTemplate]: {
        "id": "jql-builder-basic.utils.get-empty-label.components",
        "defaultMessage": "No component"
    },
    // eslint-disable-next-line jira/i18n/id-named-by-package
    [(0, $5Dsab.PARENT).searchTemplate]: {
        "id": "jql-builder-basic.utils.get-empty-label.parent",
        "defaultMessage": "No parent"
    },
    // eslint-disable-next-line jira/i18n/id-named-by-package
    [(0, $5Dsab.FIX_VERSION).searchTemplate]: {
        "id": "jql-builder-basic.utils.get-empty-label.fix-versions",
        "defaultMessage": "No version"
    },
    // eslint-disable-next-line jira/i18n/id-named-by-package
    [(0, $5Dsab.AFFECTED_VERSION).searchTemplate]: {
        "id": "jql-builder-basic.utils.get-empty-label.versions",
        "defaultMessage": "No version"
    },
    // eslint-disable-next-line jira/i18n/id-named-by-package
    'com.atlassian.jira.plugin.system.customfieldtypes:versionsearcher': {
        "id": "jql-builder-basic.utils.get-empty-label.custom-versions",
        "defaultMessage": "No version"
    },
    // eslint-disable-next-line jira/i18n/id-named-by-package
    [(0, $5Dsab.EPIC_LINK).searchTemplate]: {
        "id": "jql-builder-basic.utils.get-empty-label.epic-link-new",
        "defaultMessage": "No epic link"
    },
    // eslint-disable-next-line jira/i18n/id-named-by-package
    [(0, $5Dsab.SPRINT).searchTemplate]: {
        "id": "jql-builder-basic.utils.get-empty-label.sprint-new",
        "defaultMessage": "No sprint"
    },
    genericEmpty: {
        "id": "jql-builder-basic.utils.get-empty-label.generic-empty",
        "defaultMessage": "Empty"
    },
    // eslint-disable-next-line jira/i18n/id-named-by-package
    'epic link': {
        "id": "jql-builder-basic.utils.get-empty-label.epic-link",
        "defaultMessage": "No epic link"
    },
    sprint: {
        "id": "jql-builder-basic.utils.get-empty-label.sprint",
        "defaultMessage": "No sprint"
    }
});
const $107f821a96b5bc5a$export$3a16bd55b6aaaf91 = $107f821a96b5bc5a$export$defe85febe8b728c;

});


parcelRegister("djaDD", function(module, exports) {

$parcel$export(module.exports, "getFunctionLabel", () => $b3dfd87bf97483ab$export$2d3d5a019b7ffccf);

var $6s1PB = parcelRequire("6s1PB");

var $96xdC = parcelRequire("96xdC");
const $b3dfd87bf97483ab$export$2d3d5a019b7ffccf = (name, formatMessage)=>{
    let messageKey = name.toLowerCase();
    if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) {
        const refreshedMessageKey = `${messageKey}IssueTermRefresh`;
        if (refreshedMessageKey in (0, $96xdC.default)) messageKey = refreshedMessageKey;
    }
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ subtaskissuetypes: MessageDescriptorV2; standardissuetypes: MessageDescriptorV2; currentuser: MessageDescriptorV2; }'.
    const message = (0, $96xdC.default)[messageKey];
    if (message) return formatMessage(message);
    return name;
};

});
parcelRegister("96xdC", function(module, exports) {

$parcel$export(module.exports, "default", () => $89312b3a967198e6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $89312b3a967198e6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    currentuser: {
        "id": "jql-builder-basic.utils.get-function-label.currentuser",
        "defaultMessage": "Current User"
    },
    standardissuetypes: {
        "id": "jql-builder-basic.utils.get-function-label.standardissuetypes",
        "defaultMessage": "All standard issue types"
    },
    subtaskissuetypes: {
        "id": "jql-builder-basic.utils.get-function-label.subtaskissuetypes",
        "defaultMessage": "All sub-task issue types"
    },
    releasedversions: {
        "id": "jql-builder-basic.utils.get-function-label.releasedversions",
        "defaultMessage": "All Released Versions"
    },
    unreleasedversions: {
        "id": "jql-builder-basic.utils.get-function-label.unreleasedversions",
        "defaultMessage": "All Unreleased Versions"
    },
    standardissuetypesIssueTermRefresh: {
        "id": "jql-builder-basic.utils.get-function-label.standardissuetypes-issue-term-refresh",
        "defaultMessage": "All standard work types"
    },
    subtaskissuetypesIssueTermRefresh: {
        "id": "jql-builder-basic.utils.get-function-label.subtaskissuetypes-issue-term-refresh",
        "defaultMessage": "All sub-tasks"
    }
});

});


parcelRegister("cPTCQ", function(module, exports) {

$parcel$export(module.exports, "getLozengeAppearance", () => $2399897afeb4fe59$export$4d9e331cafeacb9d);

var $5Dsab = parcelRequire("5Dsab");
const $2399897afeb4fe59$export$4d9e331cafeacb9d = (colorName)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    if (colorName && Object.keys((0, $5Dsab.appearanceMap)).includes(colorName)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $5Dsab.appearanceMap)[colorName];
    return undefined;
};

});


parcelRegister("9l3yI", function(module, exports) {

$parcel$export(module.exports, "getGroupProps", () => $7786cdf255555d1c$export$acaa9db88ea2a755);

var $2E0CA = parcelRequire("2E0CA");

var $aq1fm = parcelRequire("aq1fm");

var $8Uumt = parcelRequire("8Uumt");


var $1dTaH = parcelRequire("1dTaH");

var $gljDV = parcelRequire("gljDV");
const $7786cdf255555d1c$var$getSuggestedOptions = async ({ environment: environment, cloudId: cloudId, formatMessage: formatMessage })=>{
    const data = await (0, $8Uumt.fetchQuery)(environment, (0, $aq1fm.default), {
        cloudId: cloudId
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    if (!data?.jira?.jqlBuilder?.suggestedGroups?.edges) return (0, $1dTaH.generateOptions)([]);
    const groups = data?.jira?.jqlBuilder?.suggestedGroups?.edges?.reduce((options, edge)=>{
        if (!edge || !edge.node) return options;
        const { node: node } = edge;
        options.push({
            label: node.displayName,
            value: node.jqlTerm,
            optionType: 'avatar',
            isGroup: true,
            itemType: (0, $49b29ef7baa2a152$export$38accfc5a5d1c113)
        });
        return options;
    }, []) || [];
    const options = [
        {
            label: formatMessage((0, $gljDV.default).refinementOptionSuggestedGroups),
            optionType: 'group',
            options: groups
        }
    ];
    return (0, $1dTaH.generateOptions)(options);
};
const $7786cdf255555d1c$var$getFieldValueOptions = async ({ environment: environment, cloudId: cloudId, lowerCaseFieldId: lowerCaseFieldId, jql: jql, search: search, endCursor: endCursor, viewContext: viewContext })=>{
    const after = endCursor;
    const data = await (0, $8Uumt.fetchQuery)(environment, (0, $2E0CA.default), {
        cloudId: cloudId,
        first: 10,
        jqlTerm: lowerCaseFieldId,
        jql: jql || '',
        searchString: search,
        after: after,
        viewContext: viewContext
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    if (!data?.jira?.jqlBuilder?.fieldValues?.edges) return (0, $1dTaH.generateOptions)([]);
    const { edges: fieldValues, totalCount: totalCount, pageInfo: pageInfo } = data.jira.jqlBuilder.fieldValues;
    return (0, $1dTaH.generateOptions)(fieldValues.reduce((options, edge)=>{
        if (!edge || !edge.node) return options;
        const { node: node } = edge;
        options.push({
            label: node.displayName,
            value: node.jqlTerm,
            optionType: 'avatar',
            isGroup: true,
            itemType: (0, $49b29ef7baa2a152$export$38accfc5a5d1c113)
        });
        return options;
    }, []), totalCount, pageInfo?.endCursor || undefined);
};
const $7786cdf255555d1c$export$acaa9db88ea2a755 = ({ fieldId: fieldId, operandDisplayValues: operandDisplayValues, formatMessage: formatMessage, jql: jql, environment: environment, cloudId: cloudId, searchTemplate: searchTemplate, viewContext: viewContext })=>({
        enableFullList: true,
        operandDisplayValues: operandDisplayValues,
        loadOptions: async (search, renderInitialValues, endCursor)=>{
            try {
                if (search.length === 0 && renderInitialValues) return await $7786cdf255555d1c$var$getSuggestedOptions({
                    environment: environment,
                    cloudId: cloudId,
                    formatMessage: formatMessage
                });
                return await $7786cdf255555d1c$var$getFieldValueOptions({
                    environment: environment,
                    cloudId: cloudId,
                    lowerCaseFieldId: fieldId.toLowerCase(),
                    jql: jql,
                    search: search,
                    endCursor: endCursor,
                    viewContext: viewContext
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $1dTaH.fireJqlBuilderBasicErrorAnalytics)('groupJqlBuilderBasicFieldValues', searchTemplate, error);
                return (0, $1dTaH.generateErrorOptions)(error);
            }
        }
    });

});
parcelRegister("2E0CA", function(module, exports) {

$parcel$export(module.exports, "default", () => $42c6c08690e85857$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<991ba5ac800b257d21b1047f43404185>>
 * @relayHash 06c4d66e23835ebc572846a0efd865a5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d4982c6eb0de3a1f0d61be5e83b4457823ceed6631a0abe4509a993a35a9c371
const $42c6c08690e85857$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jqlTerm"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchString"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewContext"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v8 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "jqlContext",
            "variableName": "jql"
        },
        {
            "kind": "Variable",
            "name": "jqlTerm",
            "variableName": "jqlTerm"
        },
        {
            "kind": "Variable",
            "name": "searchString",
            "variableName": "searchString"
        },
        {
            "kind": "Variable",
            "name": "viewContext",
            "variableName": "viewContext"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v10 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v12 = {
        "kind": "ScalarField",
        "name": "displayName"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "groupJqlBuilderBasicFieldValuesQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v7 /*: any*/ ,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v8 /*: any*/ ,
                                        "concreteType": "JiraJqlFieldValueConnection",
                                        "kind": "LinkedField",
                                        "name": "fieldValues",
                                        "plural": false,
                                        "selections": [
                                            v9 /*: any*/ ,
                                            v10 /*: any*/ ,
                                            {
                                                "concreteType": "JiraJqlFieldValueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v11 /*: any*/ ,
                                                            v12 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v0 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "groupJqlBuilderBasicFieldValuesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v8 /*: any*/ ,
                                    "concreteType": "JiraJqlFieldValueConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldValues",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "concreteType": "JiraJqlFieldValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v11 /*: any*/ ,
                                                        v12 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d4982c6eb0de3a1f0d61be5e83b4457823ceed6631a0abe4509a993a35a9c371",
            "metadata": {},
            "name": "groupJqlBuilderBasicFieldValuesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$42c6c08690e85857$var$node.hash = "3750697c009021fb29b02b6b38567062";
var $42c6c08690e85857$export$2e2bcd8739ae039 = $42c6c08690e85857$var$node;

});

parcelRegister("aq1fm", function(module, exports) {

$parcel$export(module.exports, "default", () => $a802de8d056a0d5c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2cf28df69801d2e8d4ca1f516b897779>>
 * @relayHash 4242efb1e1867c214b21bde3f239c032
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5d6bf7b889b129263d1bfecb23143f0126ab23fbd7882e0ce40044a8c0c3293d
const $a802de8d056a0d5c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "cloudId",
                        "variableName": "cloudId"
                    }
                ],
                "concreteType": "JiraJqlBuilder",
                "kind": "LinkedField",
                "name": "jqlBuilder",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "context",
                                "value": "GROUP"
                            },
                            {
                                "kind": "Literal",
                                "name": "first",
                                "value": 10
                            }
                        ],
                        "concreteType": "JiraJqlGroupFieldValueConnection",
                        "kind": "LinkedField",
                        "name": "suggestedGroups",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraJqlGroupFieldValueEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraJqlGroupFieldValue",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "jqlTerm"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "displayName"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "storageKey": "suggestedGroups(context:\"GROUP\",first:10)"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "groupJqlBuilderBasicInitQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": v1 /*: any*/ ,
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "groupJqlBuilderBasicInitQuery",
            "selections": [
                v1 /*: any*/ 
            ]
        },
        "params": {
            "id": "5d6bf7b889b129263d1bfecb23143f0126ab23fbd7882e0ce40044a8c0c3293d",
            "metadata": {},
            "name": "groupJqlBuilderBasicInitQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a802de8d056a0d5c$var$node.hash = "89effe1db6e447cbb0e66d80074d1b0b";
var $a802de8d056a0d5c$export$2e2bcd8739ae039 = $a802de8d056a0d5c$var$node;

});

parcelRegister("gljDV", function(module, exports) {

$parcel$export(module.exports, "default", () => $c060de5474296e50$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c060de5474296e50$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    refinementOptionSuggestedGroups: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.group.refinement-option-suggested-groups",
        "defaultMessage": "Suggested Groups"
    }
});

});


parcelRegister("14an2", function(module, exports) {

$parcel$export(module.exports, "getOption", () => $d8fb23ae743cc294$export$6df0712d20d2cc08);
$parcel$export(module.exports, "getIssueTypeProps", () => $d8fb23ae743cc294$export$912584a67029924);

var $7P5JF = parcelRequire("7P5JF");

var $c2zje = parcelRequire("c2zje");

var $8Uumt = parcelRequire("8Uumt");


var $6s1PB = parcelRequire("6s1PB");

var $5Dsab = parcelRequire("5Dsab");

var $1dTaH = parcelRequire("1dTaH");

var $djaDD = parcelRequire("djaDD");

var $5yKAP = parcelRequire("5yKAP");
const $d8fb23ae743cc294$var$getFirstIssueTypeAvatar = (node)=>node.issueTypes?.find((issueType)=>typeof issueType.avatar?.xsmall === 'string' && issueType.avatar.xsmall.length > 0)?.avatar?.xsmall;
const $d8fb23ae743cc294$export$6df0712d20d2cc08 = (node, itemType)=>{
    const { displayName: displayName, jqlTerm: jqlTerm } = node;
    const option = {
        label: displayName,
        value: jqlTerm,
        optionType: 'option',
        itemType: itemType
    };
    if (node.issueTypes) return {
        ...option,
        optionType: 'avatar',
        avatar: $d8fb23ae743cc294$var$getFirstIssueTypeAvatar(node),
        square: true,
        itemType: itemType
    };
    return option;
};
const $d8fb23ae743cc294$var$getInitialOptions = async ({ environment: environment, cloudId: cloudId, jql: jql, formatMessage: formatMessage })=>{
    const data = await (0, $8Uumt.fetchQuery)(environment, (0, $c2zje.default), {
        cloudId: cloudId,
        jql: jql || ''
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    const issueTypes = data?.jira?.jqlBuilder?.issueTypes;
    if (!issueTypes) return (0, $1dTaH.generateOptions)([]);
    const aboveBaseLevelTypes = issueTypes?.aboveBaseLevel?.edges || [];
    const baseLevelTypes = issueTypes?.baseLevel?.edges || [];
    const belowBaseLevelTypes = issueTypes?.belowBaseLevel?.edges || [];
    const standardTypes = aboveBaseLevelTypes.concat(baseLevelTypes).reduce((options, edges)=>{
        if (edges?.node === undefined || edges?.node === null) return options;
        const { node: node } = edges;
        if (node !== undefined && node !== null) options.push($d8fb23ae743cc294$export$6df0712d20d2cc08(node, (0, $49b29ef7baa2a152$export$38accfc5a5d1c113)));
        return options;
    }, []);
    const subtaskTypes = belowBaseLevelTypes.reduce((options, edges)=>{
        if (edges?.node === undefined || edges?.node === null) return options;
        const { node: node } = edges;
        if (node !== undefined && node !== null) options.push($d8fb23ae743cc294$export$6df0712d20d2cc08(node, (0, $49b29ef7baa2a152$export$38accfc5a5d1c113)));
        return options;
    }, []);
    const standardGroupOption = [
        {
            label: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5yKAP.default).refinementSubtitleStandardIssueTypesIssueTermRefresh : (0, $5yKAP.default).refinementSubtitleStandardIssueTypes),
            optionType: 'group',
            options: standardTypes
        }
    ];
    const subtaskGroupOption = [
        {
            label: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5yKAP.default).refinementSubtitleSubTaskIssueTypesIssueTermRefresh : (0, $5yKAP.default).refinementSubtitleSubTaskIssueTypes),
            optionType: 'group',
            options: subtaskTypes
        }
    ];
    return (0, $1dTaH.generateOptions)([
        {
            label: (0, $djaDD.getFunctionLabel)('standardIssueTypes', formatMessage),
            value: (0, $5Dsab.OperandValues).standardIssueTypes.value,
            optionType: 'avatar',
            hideAvatar: true,
            itemType: (0, $49b29ef7baa2a152$export$19c7c729db381f9d)
        },
        {
            label: (0, $djaDD.getFunctionLabel)('subTaskIssueTypes', formatMessage),
            value: (0, $5Dsab.OperandValues).subTaskIssueTypes.value,
            optionType: 'avatar',
            hideAvatar: true,
            itemType: (0, $49b29ef7baa2a152$export$19c7c729db381f9d)
        },
        ...Array.isArray(standardTypes) && standardTypes.length > 0 ? standardGroupOption : [],
        ...Array.isArray(subtaskTypes) && subtaskTypes.length > 0 ? subtaskGroupOption : []
    ]);
};
const $d8fb23ae743cc294$var$getFieldValueOptions = async ({ environment: environment, cloudId: cloudId, lowerCaseFieldId: lowerCaseFieldId, jql: jql, search: search, endCursor: endCursor, viewContext: viewContext, scope: scope = null })=>{
    const after = endCursor;
    const data = await (0, $8Uumt.fetchQuery)(environment, (0, $7P5JF.default), {
        cloudId: cloudId,
        first: 10,
        jqlTerm: lowerCaseFieldId,
        jql: jql || '',
        searchString: search,
        after: after,
        viewContext: viewContext,
        scope: scope
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    if (!data?.jira?.jqlBuilder?.fieldValues?.edges) return (0, $1dTaH.generateOptions)([]);
    const { edges: fieldValues, totalCount: totalCount, pageInfo: pageInfo } = data.jira.jqlBuilder.fieldValues;
    return (0, $1dTaH.generateOptions)(fieldValues.reduce((options, edges)=>{
        if (!edges || !edges.node) return options;
        const { node: node } = edges;
        if (node !== undefined && node !== null) options.push($d8fb23ae743cc294$export$6df0712d20d2cc08(node, (0, $49b29ef7baa2a152$export$38accfc5a5d1c113)));
        return options;
    }, []), totalCount, pageInfo.endCursor || undefined);
};
const $d8fb23ae743cc294$export$912584a67029924 = ({ fieldId: fieldId, formatMessage: formatMessage, jql: jql, environment: environment, cloudId: cloudId, operandDisplayValues: operandDisplayValues, searchTemplate: searchTemplate, viewContext: viewContext })=>({
        enableFullList: true,
        operandDisplayValues: operandDisplayValues,
        loadOptions: async (search, renderInitialValues, endCursor)=>{
            try {
                if (search.length === 0 && renderInitialValues) return await $d8fb23ae743cc294$var$getInitialOptions({
                    environment: environment,
                    cloudId: cloudId,
                    jql: jql,
                    formatMessage: formatMessage
                });
                return await $d8fb23ae743cc294$var$getFieldValueOptions({
                    environment: environment,
                    cloudId: cloudId,
                    lowerCaseFieldId: fieldId.toLowerCase(),
                    jql: jql,
                    search: search,
                    endCursor: endCursor,
                    viewContext: viewContext
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $1dTaH.fireJqlBuilderBasicErrorAnalytics)('issueTypeJqlBuilderBasicFieldValues', searchTemplate, error);
                return (0, $1dTaH.generateErrorOptions)(error);
            }
        }
    });

});
parcelRegister("7P5JF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b1d7c8b37bd17e7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b62ab1792ba8ec9be40508d0c1b428f2>>
 * @relayHash 30538de95cec3c3cdff68eadc99f2abd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 656a65d09fbea171572af0068266d364b84a8e0e6face2f36475662ed790295c
const $4b1d7c8b37bd17e7$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jqlTerm"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchString"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewContext"
    }, v8 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v9 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "jqlContext",
            "variableName": "jql"
        },
        {
            "kind": "Variable",
            "name": "jqlTerm",
            "variableName": "jqlTerm"
        },
        {
            "kind": "Variable",
            "name": "scope",
            "variableName": "scope"
        },
        {
            "kind": "Variable",
            "name": "searchString",
            "variableName": "searchString"
        },
        {
            "kind": "Variable",
            "name": "viewContext",
            "variableName": "viewContext"
        }
    ], v10 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v11 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v13 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v14 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "issueTypeJqlBuilderBasicFieldValuesQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v8 /*: any*/ ,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v9 /*: any*/ ,
                                        "concreteType": "JiraJqlFieldValueConnection",
                                        "kind": "LinkedField",
                                        "name": "fieldValues",
                                        "plural": false,
                                        "selections": [
                                            v10 /*: any*/ ,
                                            v11 /*: any*/ ,
                                            {
                                                "concreteType": "JiraJqlFieldValueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v12 /*: any*/ ,
                                                            v13 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraIssueType",
                                                                        "kind": "LinkedField",
                                                                        "name": "issueTypes",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            v14 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlIssueTypeFieldValue"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v6 /*: any*/ ,
                v0 /*: any*/ ,
                v7 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "issueTypeJqlBuilderBasicFieldValuesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v9 /*: any*/ ,
                                    "concreteType": "JiraJqlFieldValueConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldValues",
                                    "plural": false,
                                    "selections": [
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        {
                                            "concreteType": "JiraJqlFieldValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v12 /*: any*/ ,
                                                        v13 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v14 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "id"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlIssueTypeFieldValue"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "656a65d09fbea171572af0068266d364b84a8e0e6face2f36475662ed790295c",
            "metadata": {},
            "name": "issueTypeJqlBuilderBasicFieldValuesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4b1d7c8b37bd17e7$var$node.hash = "8a0afa1c6c431e628b55f9e4f56ffde8";
var $4b1d7c8b37bd17e7$export$2e2bcd8739ae039 = $4b1d7c8b37bd17e7$var$node;

});

parcelRegister("c2zje", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e15285e6a527a2c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6074d0f3e024b0012bb1972fe1478635>>
 * @relayHash acb29e4100939579dcd3416df9471194
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7a787d89ed618a815e9879150e4bc32d1810382544bfced47ff3503e5a3ee9d3
const $7e15285e6a527a2c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jql"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "jqlContext",
            "variableName": "jql"
        }
    ], v3 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 2
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v6 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v7 = [
        {
            "concreteType": "JiraJqlIssueTypeFieldValueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraJqlIssueTypeFieldValue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "issueTypes",
                            "plural": true,
                            "selections": [
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ], v8 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 3
        }
    ], v9 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 5
        }
    ], v10 = [
        {
            "concreteType": "JiraJqlIssueTypeFieldValueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraJqlIssueTypeFieldValue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "issueTypes",
                            "plural": true,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "issueTypeJqlBuilderBasicInitQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1 /*: any*/ ,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v2 /*: any*/ ,
                                        "concreteType": "JiraJqlIssueTypes",
                                        "kind": "LinkedField",
                                        "name": "issueTypes",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "args": v3 /*: any*/ ,
                                                "concreteType": "JiraJqlIssueTypeFieldValueConnection",
                                                "kind": "LinkedField",
                                                "name": "aboveBaseLevel",
                                                "plural": false,
                                                "selections": v7 /*: any*/ ,
                                                "storageKey": "aboveBaseLevel(first:2)"
                                            },
                                            {
                                                "args": v8 /*: any*/ ,
                                                "concreteType": "JiraJqlIssueTypeFieldValueConnection",
                                                "kind": "LinkedField",
                                                "name": "baseLevel",
                                                "plural": false,
                                                "selections": v7 /*: any*/ ,
                                                "storageKey": "baseLevel(first:3)"
                                            },
                                            {
                                                "args": v9 /*: any*/ ,
                                                "concreteType": "JiraJqlIssueTypeFieldValueConnection",
                                                "kind": "LinkedField",
                                                "name": "belowBaseLevel",
                                                "plural": false,
                                                "selections": v7 /*: any*/ ,
                                                "storageKey": "belowBaseLevel(first:5)"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "issueTypeJqlBuilderBasicInitQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraJqlIssueTypes",
                                    "kind": "LinkedField",
                                    "name": "issueTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v3 /*: any*/ ,
                                            "concreteType": "JiraJqlIssueTypeFieldValueConnection",
                                            "kind": "LinkedField",
                                            "name": "aboveBaseLevel",
                                            "plural": false,
                                            "selections": v10 /*: any*/ ,
                                            "storageKey": "aboveBaseLevel(first:2)"
                                        },
                                        {
                                            "args": v8 /*: any*/ ,
                                            "concreteType": "JiraJqlIssueTypeFieldValueConnection",
                                            "kind": "LinkedField",
                                            "name": "baseLevel",
                                            "plural": false,
                                            "selections": v10 /*: any*/ ,
                                            "storageKey": "baseLevel(first:3)"
                                        },
                                        {
                                            "args": v9 /*: any*/ ,
                                            "concreteType": "JiraJqlIssueTypeFieldValueConnection",
                                            "kind": "LinkedField",
                                            "name": "belowBaseLevel",
                                            "plural": false,
                                            "selections": v10 /*: any*/ ,
                                            "storageKey": "belowBaseLevel(first:5)"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7a787d89ed618a815e9879150e4bc32d1810382544bfced47ff3503e5a3ee9d3",
            "metadata": {},
            "name": "issueTypeJqlBuilderBasicInitQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$7e15285e6a527a2c$var$node.hash = "b67b86d33998fb54b3dd5cfc1247f7e1";
var $7e15285e6a527a2c$export$2e2bcd8739ae039 = $7e15285e6a527a2c$var$node;

});

parcelRegister("5yKAP", function(module, exports) {

$parcel$export(module.exports, "default", () => $14e7c780a8ac604d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $14e7c780a8ac604d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    refinementOptionAllStandardIssues: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.issue-type.refinement-option-all-standard-issues",
        "defaultMessage": "All standard issue types"
    },
    refinementOptionAllSubTaskIssues: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.issue-type.refinement-option-all-sub-task-issues",
        "defaultMessage": "All sub-task issue types"
    },
    refinementSubtitleStandardIssueTypes: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.issue-type.refinement-subtitle-standard-issue-types",
        "defaultMessage": "Standard issue types"
    },
    refinementSubtitleSubTaskIssueTypes: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.issue-type.refinement-subtitle-sub-task-issue-types",
        "defaultMessage": "Sub-task issue types"
    },
    refinementOptionAllStandardIssuesIssueTermRefresh: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.issue-type.refinement-option-all-standard-issues-issue-term-refresh",
        "defaultMessage": "All standard work types"
    },
    refinementOptionAllSubTaskIssuesIssueTermRefresh: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.issue-type.refinement-option-all-sub-task-issues-issue-term-refresh",
        "defaultMessage": "All sub-tasks"
    },
    refinementSubtitleStandardIssueTypesIssueTermRefresh: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.issue-type.refinement-subtitle-standard-issue-types-issue-term-refresh",
        "defaultMessage": "Standard work types"
    },
    refinementSubtitleSubTaskIssueTypesIssueTermRefresh: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.issue-type.refinement-subtitle-sub-task-issue-types-issue-term-refresh",
        "defaultMessage": "Subtasks"
    }
});

});


parcelRegister("f9Gva", function(module, exports) {

$parcel$export(module.exports, "getPeopleProps", () => $92bcd38a9fa80e10$export$c4faa1f798289cbf);

var $gLMSR = parcelRequire("gLMSR");

var $ddXs9 = parcelRequire("ddXs9");

var $8Uumt = parcelRequire("8Uumt");


var $5Dsab = parcelRequire("5Dsab");

var $1dTaH = parcelRequire("1dTaH");

var $gCOs7 = parcelRequire("gCOs7");

var $djaDD = parcelRequire("djaDD");

var $4GdlB = parcelRequire("4GdlB");
const $92bcd38a9fa80e10$var$getSuggestedOptions = async ({ environment: environment, cloudId: cloudId, searchTemplate: searchTemplate, formatMessage: formatMessage, suggestedUsersCount: suggestedUsersCount = 5 })=>{
    const data = await (0, $8Uumt.fetchQuery)(environment, (0, $ddXs9.default), {
        cloudId: cloudId,
        suggestedUsersCount: suggestedUsersCount
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    if (!data?.jira?.jqlBuilder?.recentlyUsedUsers?.edges) return (0, $1dTaH.generateOptions)([]);
    const users = data?.jira?.jqlBuilder?.recentlyUsedUsers?.edges.reduce((options, edges)=>{
        if (!edges || !edges.node) return options;
        const { node: node } = edges;
        options.push({
            label: node.displayName,
            value: node.jqlTerm,
            optionType: 'avatar',
            avatar: node.user?.picture,
            itemType: (0, $49b29ef7baa2a152$export$38accfc5a5d1c113)
        });
        return options;
    }, []);
    const groups = data?.jira?.jqlBuilder?.suggestedGroups?.edges?.reduce((options, edges)=>{
        if (!edges || !edges.node) return options;
        const { node: node } = edges;
        options.push({
            label: node.displayName,
            value: node.jqlTerm,
            optionType: 'avatar',
            isGroup: true,
            itemType: (0, $49b29ef7baa2a152$export$19c7c729db381f9d)
        });
        return options;
    }, []) || [];
    const emptyLabel = (0, $gCOs7.getEmptyLabel)(searchTemplate ?? null, formatMessage);
    const options = [
        {
            label: (0, $djaDD.getFunctionLabel)('currentUser', formatMessage),
            value: (0, $5Dsab.OperandValues).currentUser.value,
            optionType: 'avatar',
            avatar: data?.me?.user?.picture,
            itemType: (0, $49b29ef7baa2a152$export$19c7c729db381f9d)
        },
        {
            label: emptyLabel,
            optionType: 'avatar',
            value: (0, $5Dsab.OperandValues).empty.value,
            itemType: (0, $49b29ef7baa2a152$export$f6049126fd97001f)
        },
        {
            label: formatMessage((0, $4GdlB.default).refinementOptionSuggestedUsers),
            optionType: 'group',
            options: users
        }
    ];
    options.push({
        label: formatMessage((0, $4GdlB.default).refinementOptionSuggestedGroups),
        optionType: 'group',
        options: groups
    });
    return (0, $1dTaH.generateOptions)(options);
};
const $92bcd38a9fa80e10$var$getFieldValueOptions = async ({ environment: environment, cloudId: cloudId, lowerCaseFieldId: lowerCaseFieldId, jql: jql, search: search, endCursor: endCursor, viewContext: viewContext })=>{
    const after = endCursor;
    const data = await (0, $8Uumt.fetchQuery)(environment, (0, $gLMSR.default), {
        cloudId: cloudId,
        first: 10,
        jqlTerm: lowerCaseFieldId,
        jql: jql || '',
        searchString: search,
        after: after,
        viewContext: viewContext
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    if (!data?.jira?.jqlBuilder?.fieldValues?.edges) return (0, $1dTaH.generateOptions)([]);
    const { edges: fieldValues, totalCount: totalCount, pageInfo: pageInfo } = data.jira.jqlBuilder.fieldValues;
    return (0, $1dTaH.generateOptions)(fieldValues.reduce((options, edges)=>{
        if (!edges || !edges.node) return options;
        const { node: node } = edges;
        options.push({
            label: node.displayName,
            value: node.jqlTerm,
            optionType: 'avatar',
            avatar: node.user?.picture,
            ...node.__typename === 'JiraJqlGroupFieldValue' ? {
                isGroup: true,
                itemType: (0, $49b29ef7baa2a152$export$19c7c729db381f9d)
            } : {
                itemType: (0, $49b29ef7baa2a152$export$38accfc5a5d1c113)
            }
        });
        return options;
    }, []), totalCount, pageInfo?.endCursor || undefined);
};
const $92bcd38a9fa80e10$export$c4faa1f798289cbf = ({ fieldId: fieldId, formatMessage: formatMessage, jql: jql, environment: environment, cloudId: cloudId, operandDisplayValues: operandDisplayValues, searchTemplate: searchTemplate, viewContext: viewContext, suggestedUsersCount: suggestedUsersCount })=>({
        enableFullList: true,
        operandDisplayValues: operandDisplayValues,
        loadOptions: async (search, renderInitialValues, endCursor)=>{
            try {
                if (search.length === 0 && renderInitialValues) return await $92bcd38a9fa80e10$var$getSuggestedOptions({
                    environment: environment,
                    cloudId: cloudId,
                    fieldId: fieldId,
                    searchTemplate: searchTemplate,
                    formatMessage: formatMessage,
                    suggestedUsersCount: suggestedUsersCount
                });
                return await $92bcd38a9fa80e10$var$getFieldValueOptions({
                    environment: environment,
                    cloudId: cloudId,
                    lowerCaseFieldId: fieldId.toLowerCase(),
                    jql: jql,
                    search: search,
                    endCursor: endCursor,
                    viewContext: viewContext
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $1dTaH.fireJqlBuilderBasicErrorAnalytics)('peopleJqlBuilderBasicFieldValues', searchTemplate, error);
                return (0, $1dTaH.generateErrorOptions)(error);
            }
        }
    });

});
parcelRegister("gLMSR", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c9b0ca4900b479b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cdecb30eba4bd1c6c0327c8498a32df0>>
 * @relayHash 12d33ba0d4f7005558a90b51b7f8972a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9a16b4ab65b19abc2908fd11e6e008e1ae9a5d76096455dab5aea9cc79f7f3fe
const $6c9b0ca4900b479b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jqlTerm"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchString"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewContext"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v8 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "jqlContext",
            "variableName": "jql"
        },
        {
            "kind": "Variable",
            "name": "jqlTerm",
            "variableName": "jqlTerm"
        },
        {
            "kind": "Variable",
            "name": "searchString",
            "variableName": "searchString"
        },
        {
            "kind": "Variable",
            "name": "viewContext",
            "variableName": "viewContext"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v10 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v12 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v13 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v14 = {
        "kind": "ScalarField",
        "name": "picture"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "peopleJqlBuilderBasicFieldValuesQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v7 /*: any*/ ,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v8 /*: any*/ ,
                                        "concreteType": "JiraJqlFieldValueConnection",
                                        "kind": "LinkedField",
                                        "name": "fieldValues",
                                        "plural": false,
                                        "selections": [
                                            v9 /*: any*/ ,
                                            v10 /*: any*/ ,
                                            {
                                                "concreteType": "JiraJqlFieldValueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v11 /*: any*/ ,
                                                            v12 /*: any*/ ,
                                                            v13 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "user",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v14 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlUserFieldValue"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v0 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "peopleJqlBuilderBasicFieldValuesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v8 /*: any*/ ,
                                    "concreteType": "JiraJqlFieldValueConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldValues",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "concreteType": "JiraJqlFieldValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        v12 /*: any*/ ,
                                                        v13 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v11 /*: any*/ ,
                                                                        v14 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "id"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlUserFieldValue"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9a16b4ab65b19abc2908fd11e6e008e1ae9a5d76096455dab5aea9cc79f7f3fe",
            "metadata": {},
            "name": "peopleJqlBuilderBasicFieldValuesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6c9b0ca4900b479b$var$node.hash = "58da705b88c7cc909a92b46593be279d";
var $6c9b0ca4900b479b$export$2e2bcd8739ae039 = $6c9b0ca4900b479b$var$node;

});

parcelRegister("ddXs9", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0771960058e1ffc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c5b2b2d7f16455667801cc7af16014d7>>
 * @relayHash 60854f32bffe29af2901e4add654f964
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f3dcddb111bd3a875a7fe72854ff370624a9ff146bf6085aa9856c22d9b59710
const $b0771960058e1ffc$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "suggestedUsersCount"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v2 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
            v1 /*: any*/ 
        ]
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "suggestedUsersCount"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v6 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v7 = {
        "args": [
            {
                "kind": "Literal",
                "name": "first",
                "value": 5
            }
        ],
        "concreteType": "JiraJqlGroupFieldValueConnection",
        "kind": "LinkedField",
        "name": "suggestedGroups",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraJqlGroupFieldValueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraJqlGroupFieldValue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v5 /*: any*/ ,
                            v6 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "storageKey": "suggestedGroups(first:5)"
    }, v8 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            v1 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "peopleJqlBuilderBasicInitQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ 
                    ]
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v3 /*: any*/ ,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v4 /*: any*/ ,
                                        "concreteType": "JiraJqlUserFieldValueConnection",
                                        "kind": "LinkedField",
                                        "name": "recentlyUsedUsers",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraJqlUserFieldValueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraJqlUserFieldValue",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v5 /*: any*/ ,
                                                            v6 /*: any*/ ,
                                                            v2 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    v7 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "peopleJqlBuilderBasicInitQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        v8 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "JiraJqlUserFieldValueConnection",
                                    "kind": "LinkedField",
                                    "name": "recentlyUsedUsers",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraJqlUserFieldValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraJqlUserFieldValue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v7 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f3dcddb111bd3a875a7fe72854ff370624a9ff146bf6085aa9856c22d9b59710",
            "metadata": {},
            "name": "peopleJqlBuilderBasicInitQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b0771960058e1ffc$var$node.hash = "05b44957144740bb12a1e2842916fbf5";
var $b0771960058e1ffc$export$2e2bcd8739ae039 = $b0771960058e1ffc$var$node;

});

parcelRegister("4GdlB", function(module, exports) {

$parcel$export(module.exports, "default", () => $05a97cd30aae0814$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $05a97cd30aae0814$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    refinementOptionCurrentUser: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.people.refinement-option-current-user",
        "defaultMessage": "Current User"
    },
    refinementOptionUnassigned: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.people.refinement-option-unassigned",
        "defaultMessage": "Unassigned"
    },
    refinementOptionSuggestedUsers: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.people.refinement-option-suggested-users",
        "defaultMessage": "Suggested Users"
    },
    refinementOptionSuggestedGroups: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.people.refinement-option-suggested-groups",
        "defaultMessage": "Suggested Groups"
    }
});

});


parcelRegister("fxPX8", function(module, exports) {

$parcel$export(module.exports, "getOption", () => $0e217ae5e3998877$export$6df0712d20d2cc08);
$parcel$export(module.exports, "getProjectProps", () => $0e217ae5e3998877$export$2ba60b1cee4e2df8);

var $ikPf6 = parcelRequire("ikPf6");

var $gCNZq = parcelRequire("gCNZq");

var $8Uumt = parcelRequire("8Uumt");


var $1dTaH = parcelRequire("1dTaH");

var $fzXGy = parcelRequire("fzXGy");
const $0e217ae5e3998877$export$6df0712d20d2cc08 = (node, itemType)=>({
        label: node.displayName,
        value: node.jqlTerm,
        optionType: 'avatar',
        avatar: node.project?.avatar?.small,
        square: true,
        itemType: itemType
    });
const $0e217ae5e3998877$var$getSuggestedOptions = async ({ environment: environment, cloudId: cloudId, formatMessage: formatMessage, projectOptions: projectOptions })=>{
    const data = await (0, $8Uumt.fetchQuery)(environment, (0, $gCNZq.default), {
        cloudId: cloudId,
        ...projectOptions && {
            projectOptions: projectOptions
        }
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    if (!data?.jira.jqlBuilder?.recentlyUsedProjects || !data?.jira.jqlBuilder?.recentlyUsedProjects.edges) return (0, $1dTaH.generateOptions)([]);
    const { edges: projectEdges } = data?.jira.jqlBuilder?.recentlyUsedProjects;
    return (0, $1dTaH.generateOptions)([
        {
            label: formatMessage((0, $fzXGy.default).refinementOptionRecentProjects),
            optionType: 'group',
            options: projectEdges.reduce((options, edges)=>{
                if (!edges || !edges.node) return options;
                const { node: node } = edges;
                options.push($0e217ae5e3998877$export$6df0712d20d2cc08(node, (0, $49b29ef7baa2a152$export$38accfc5a5d1c113)));
                return options;
            }, [])
        }
    ]);
};
const $0e217ae5e3998877$var$getFieldValueOptions = async ({ environment: environment, cloudId: cloudId, lowerCaseFieldId: lowerCaseFieldId, jql: jql, search: search, endCursor: endCursor, projectOptions: projectOptions, viewContext: viewContext })=>{
    const after = endCursor;
    const data = await (0, $8Uumt.fetchQuery)(environment, (0, $ikPf6.default), {
        cloudId: cloudId,
        first: 10,
        jqlTerm: lowerCaseFieldId,
        jql: jql || '',
        searchString: search,
        after: after,
        ...projectOptions && {
            projectOptions: projectOptions
        },
        viewContext: viewContext
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    if (!data?.jira?.jqlBuilder?.fieldValues?.edges) return (0, $1dTaH.generateOptions)([]);
    const { edges: fieldValues, totalCount: totalCount, pageInfo: pageInfo } = data.jira.jqlBuilder.fieldValues;
    return (0, $1dTaH.generateOptions)(fieldValues.reduce((options, edges)=>{
        if (!edges || !edges.node) return options;
        const { node: node } = edges;
        options.push($0e217ae5e3998877$export$6df0712d20d2cc08(node, (0, $49b29ef7baa2a152$export$38accfc5a5d1c113)));
        return options;
    }, []), totalCount, pageInfo.endCursor || undefined);
};
const $0e217ae5e3998877$export$2ba60b1cee4e2df8 = ({ fieldId: fieldId, formatMessage: formatMessage, jql: jql, environment: environment, cloudId: cloudId, projectOptions: projectOptions, operandDisplayValues: operandDisplayValues, searchTemplate: searchTemplate, viewContext: viewContext })=>({
        enableFullList: true,
        operandDisplayValues: operandDisplayValues,
        loadOptions: async (search, renderInitialValues, endCursor)=>{
            try {
                if (search.length === 0 && renderInitialValues) return await $0e217ae5e3998877$var$getSuggestedOptions({
                    environment: environment,
                    cloudId: cloudId,
                    formatMessage: formatMessage,
                    projectOptions: projectOptions
                });
                return await $0e217ae5e3998877$var$getFieldValueOptions({
                    environment: environment,
                    cloudId: cloudId,
                    lowerCaseFieldId: fieldId.toLowerCase(),
                    jql: jql,
                    search: search,
                    endCursor: endCursor,
                    projectOptions: projectOptions,
                    viewContext: viewContext
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $1dTaH.fireJqlBuilderBasicErrorAnalytics)('projectJqlBuilderBasicFieldValues', searchTemplate, error);
                return (0, $1dTaH.generateErrorOptions)(error);
            }
        }
    });

});
parcelRegister("ikPf6", function(module, exports) {

$parcel$export(module.exports, "default", () => $2aca7f1216d8a698$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<940b19f06aa01e262cfdbe28f434a695>>
 * @relayHash 3192fa5b6aa6a6075a38be5eb5f2aecb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 08d5f8ea6bbd314a0327191f720e0d7feda67a0f80b02f2c0149ab63f075c6ca
const $2aca7f1216d8a698$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jqlTerm"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectOptions"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchString"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewContext"
    }, v8 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v9 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "jqlContext",
            "variableName": "jql"
        },
        {
            "kind": "Variable",
            "name": "jqlTerm",
            "variableName": "jqlTerm"
        },
        {
            "kind": "Variable",
            "name": "projectOptions",
            "variableName": "projectOptions"
        },
        {
            "kind": "Variable",
            "name": "searchString",
            "variableName": "searchString"
        },
        {
            "kind": "Variable",
            "name": "viewContext",
            "variableName": "viewContext"
        }
    ], v10 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v11 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v13 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v14 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "projectJqlBuilderBasicFieldValuesQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v8 /*: any*/ ,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v9 /*: any*/ ,
                                        "concreteType": "JiraJqlFieldValueConnection",
                                        "kind": "LinkedField",
                                        "name": "fieldValues",
                                        "plural": false,
                                        "selections": [
                                            v10 /*: any*/ ,
                                            v11 /*: any*/ ,
                                            {
                                                "concreteType": "JiraJqlFieldValueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v12 /*: any*/ ,
                                                            v13 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraProject",
                                                                        "kind": "LinkedField",
                                                                        "name": "project",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v14 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlProjectFieldValue"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v6 /*: any*/ ,
                v0 /*: any*/ ,
                v5 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "projectJqlBuilderBasicFieldValuesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v9 /*: any*/ ,
                                    "concreteType": "JiraJqlFieldValueConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldValues",
                                    "plural": false,
                                    "selections": [
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        {
                                            "concreteType": "JiraJqlFieldValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v12 /*: any*/ ,
                                                        v13 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraProject",
                                                                    "kind": "LinkedField",
                                                                    "name": "project",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v14 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "id"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlProjectFieldValue"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "08d5f8ea6bbd314a0327191f720e0d7feda67a0f80b02f2c0149ab63f075c6ca",
            "metadata": {},
            "name": "projectJqlBuilderBasicFieldValuesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$2aca7f1216d8a698$var$node.hash = "7ae3b3a2998a3aacd96d184e4fa73d96";
var $2aca7f1216d8a698$export$2e2bcd8739ae039 = $2aca7f1216d8a698$var$node;

});

parcelRegister("gCNZq", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf93eca93ef5177c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fd0ea0833b7ca298c76608f11bb00cb1>>
 * @relayHash 18fa54e2ca28ad2622498bf24b076364
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ece22d797eb7f498f6481931bc3a47afb02775056d1512d271738b91c214c2ad
const $bf93eca93ef5177c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectOptions"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "projectOptions",
            "variableName": "projectOptions"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v4 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v5 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "projectJqlBuilderBasicInitQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1 /*: any*/ ,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v2 /*: any*/ ,
                                        "concreteType": "JiraJqlProjectFieldValueConnection",
                                        "kind": "LinkedField",
                                        "name": "recentlyUsedProjects",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraJqlProjectFieldValueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraJqlProjectFieldValue",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v3 /*: any*/ ,
                                                            v4 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraProject",
                                                                "kind": "LinkedField",
                                                                "name": "project",
                                                                "plural": false,
                                                                "selections": [
                                                                    v5 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "projectJqlBuilderBasicInitQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraJqlProjectFieldValueConnection",
                                    "kind": "LinkedField",
                                    "name": "recentlyUsedProjects",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraJqlProjectFieldValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraJqlProjectFieldValue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraProject",
                                                            "kind": "LinkedField",
                                                            "name": "project",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "id"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ece22d797eb7f498f6481931bc3a47afb02775056d1512d271738b91c214c2ad",
            "metadata": {},
            "name": "projectJqlBuilderBasicInitQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$bf93eca93ef5177c$var$node.hash = "fe20d750eadef8bafda1d590956fca21";
var $bf93eca93ef5177c$export$2e2bcd8739ae039 = $bf93eca93ef5177c$var$node;

});

parcelRegister("fzXGy", function(module, exports) {

$parcel$export(module.exports, "default", () => $70b6bc55c65759cd$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $70b6bc55c65759cd$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    refinementOptionRecentProjects: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.project.refinement-option-recent-projects",
        "defaultMessage": "Recent projects"
    }
});

});


parcelRegister("acs6u", function(module, exports) {

$parcel$export(module.exports, "getOption", () => $64dbef751dc6759c$export$6df0712d20d2cc08);
$parcel$export(module.exports, "getSprintProps", () => $64dbef751dc6759c$export$85662d0553c985b4);

var $jDC4u = parcelRequire("jDC4u");

var $hHwAI = parcelRequire("hHwAI");

var $8Uumt = parcelRequire("8Uumt");


var $5Dsab = parcelRequire("5Dsab");

var $1dTaH = parcelRequire("1dTaH");

var $gCOs7 = parcelRequire("gCOs7");

var $fkMdc = parcelRequire("fkMdc");

var $dn84m = parcelRequire("dn84m");
const $64dbef751dc6759c$export$6df0712d20d2cc08 = (node, formatMessage, itemType)=>{
    const { displayName: displayName, jqlTerm: jqlTerm } = node;
    const option = {
        label: displayName,
        value: jqlTerm,
        optionType: 'option',
        itemType: itemType
    };
    if (node.sprint) {
        const { state: state, boardName: boardName } = node.sprint;
        const i18nState = state ? (0, $dn84m.getSprintState)(state, formatMessage) : undefined;
        const secondaryLabel = [
            i18nState,
            boardName
        ].filter((0, $dn84m.hasValue)).join(" \u22C5 ");
        if (secondaryLabel !== '') return {
            ...option,
            secondaryLabel: secondaryLabel
        };
    }
    return option;
};
const $64dbef751dc6759c$var$getSuggestedOptions = async ({ environment: environment, cloudId: cloudId, searchTemplate: searchTemplate, endCursor: endCursor, formatMessage: formatMessage })=>{
    const data = await (0, $8Uumt.fetchQuery)(environment, (0, $hHwAI.default), {
        cloudId: cloudId
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    const emptyOption = [
        {
            label: (0, $gCOs7.getEmptyLabel)(searchTemplate ?? null, formatMessage),
            value: (0, $5Dsab.OperandValues).empty.value,
            optionType: 'option',
            itemType: (0, $49b29ef7baa2a152$export$f6049126fd97001f)
        }
    ];
    if (!data?.jira?.jqlBuilder?.recentlyUsedSprints?.edges) return (0, $1dTaH.generateOptions)(emptyOption);
    const { edges: fieldValues } = data.jira.jqlBuilder.recentlyUsedSprints;
    const sprints = fieldValues.reduce((options, edges)=>{
        if (!edges || !edges.node) return options;
        const { node: node } = edges;
        options.push($64dbef751dc6759c$export$6df0712d20d2cc08(node, formatMessage, (0, $49b29ef7baa2a152$export$38accfc5a5d1c113)));
        return options;
    }, []);
    return (0, $1dTaH.generateOptions)([
        ...!endCursor ? emptyOption : [],
        {
            label: formatMessage((0, $fkMdc.default).refinementOptionSuggestedSprints),
            optionType: 'group',
            options: sprints
        }
    ]);
};
const $64dbef751dc6759c$var$getFieldValueOptions = async ({ environment: environment, cloudId: cloudId, fieldId: fieldId, searchTemplate: searchTemplate, jql: jql, search: search, endCursor: endCursor, formatMessage: formatMessage, viewContext: viewContext })=>{
    const after = endCursor;
    const data = await (0, $8Uumt.fetchQuery)(environment, (0, $jDC4u.default), {
        cloudId: cloudId,
        first: 10,
        jqlTerm: fieldId.toLowerCase(),
        jql: jql || '',
        searchString: search,
        after: after,
        viewContext: viewContext
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise();
    const emptyOption = {
        label: (0, $gCOs7.getEmptyLabel)(searchTemplate ?? null, formatMessage),
        value: (0, $5Dsab.OperandValues).empty.value,
        optionType: 'option',
        itemType: (0, $49b29ef7baa2a152$export$f6049126fd97001f)
    };
    if (!data?.jira?.jqlBuilder?.fieldValues?.edges) return (0, $1dTaH.generateOptions)([
        emptyOption
    ]);
    const { edges: fieldValues, totalCount: totalCount, pageInfo: pageInfo } = data.jira.jqlBuilder.fieldValues;
    const sprints = fieldValues.reduce((options, edges)=>{
        if (!edges || !edges.node) return options;
        const { node: node } = edges;
        options.push($64dbef751dc6759c$export$6df0712d20d2cc08(node, formatMessage, (0, $49b29ef7baa2a152$export$38accfc5a5d1c113)));
        return options;
    }, []);
    return (0, $1dTaH.generateOptions)([
        ...search.length === 0 && !endCursor ? [
            emptyOption
        ] : [],
        ...sprints
    ], totalCount, pageInfo?.endCursor || undefined);
};
const $64dbef751dc6759c$export$85662d0553c985b4 = ({ fieldId: fieldId, formatMessage: formatMessage, jql: jql, environment: environment, cloudId: cloudId, operandDisplayValues: operandDisplayValues, searchTemplate: searchTemplate, viewContext: viewContext })=>({
        enableFullList: true,
        operandDisplayValues: operandDisplayValues,
        showOperandDisplayValuesInFullList: true,
        loadOptions: async (search, renderInitialValues, endCursor)=>{
            try {
                if (search.length === 0 && renderInitialValues) return await $64dbef751dc6759c$var$getSuggestedOptions({
                    environment: environment,
                    cloudId: cloudId,
                    fieldId: fieldId,
                    searchTemplate: searchTemplate,
                    endCursor: endCursor,
                    formatMessage: formatMessage
                });
                return await $64dbef751dc6759c$var$getFieldValueOptions({
                    environment: environment,
                    cloudId: cloudId,
                    fieldId: fieldId,
                    searchTemplate: searchTemplate,
                    jql: jql,
                    search: search,
                    endCursor: endCursor,
                    formatMessage: formatMessage,
                    viewContext: viewContext
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $1dTaH.fireJqlBuilderBasicErrorAnalytics)('sprintJqlBuilderBasicFieldValues', searchTemplate, error);
                return (0, $1dTaH.generateErrorOptions)(error);
            }
        }
    });

});
parcelRegister("jDC4u", function(module, exports) {

$parcel$export(module.exports, "default", () => $af4cad9ade64408b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<03ca7c4ab2d8aa6d7329b75757463944>>
 * @relayHash a753d2378b8a0e85d368b587cef149cb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f49a61064524e802bb475f20e360b1e395edcd2bd05d487b7817a174f90c52df
const $af4cad9ade64408b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": 10,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jql"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jqlTerm"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchString"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewContext"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v8 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "jqlContext",
            "variableName": "jql"
        },
        {
            "kind": "Variable",
            "name": "jqlTerm",
            "variableName": "jqlTerm"
        },
        {
            "kind": "Variable",
            "name": "searchString",
            "variableName": "searchString"
        },
        {
            "kind": "Variable",
            "name": "viewContext",
            "variableName": "viewContext"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v10 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v12 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v13 = {
        "kind": "ScalarField",
        "name": "state"
    }, v14 = {
        "kind": "ScalarField",
        "name": "boardName"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "sprintJqlBuilderBasicFieldValuesQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v7 /*: any*/ ,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v8 /*: any*/ ,
                                        "concreteType": "JiraJqlFieldValueConnection",
                                        "kind": "LinkedField",
                                        "name": "fieldValues",
                                        "plural": false,
                                        "selections": [
                                            v9 /*: any*/ ,
                                            v10 /*: any*/ ,
                                            {
                                                "concreteType": "JiraJqlFieldValueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v11 /*: any*/ ,
                                                            v12 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraSprint",
                                                                        "kind": "LinkedField",
                                                                        "name": "sprint",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v13 /*: any*/ ,
                                                                            v14 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlSprintFieldValue"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v0 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "sprintJqlBuilderBasicFieldValuesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v8 /*: any*/ ,
                                    "concreteType": "JiraJqlFieldValueConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldValues",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "concreteType": "JiraJqlFieldValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v11 /*: any*/ ,
                                                        v12 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSprint",
                                                                    "kind": "LinkedField",
                                                                    "name": "sprint",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v13 /*: any*/ ,
                                                                        v14 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "id"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlSprintFieldValue"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f49a61064524e802bb475f20e360b1e395edcd2bd05d487b7817a174f90c52df",
            "metadata": {},
            "name": "sprintJqlBuilderBasicFieldValuesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$af4cad9ade64408b$var$node.hash = "2fca268b01a9949b7d6a9c7abb665ff1";
var $af4cad9ade64408b$export$2e2bcd8739ae039 = $af4cad9ade64408b$var$node;

});

parcelRegister("hHwAI", function(module, exports) {

$parcel$export(module.exports, "default", () => $77cdb6000500e566$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b82b9b38c96bf6b763bd8f21ed441feb>>
 * @relayHash 0f4f3c0dc3fbfd461b30b2edce7ff480
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bd147d7ddd3fe153f2faac37da072abad63284dd1e60a1ad50037b7db7059d8d
const $77cdb6000500e566$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 5
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v4 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v5 = {
        "kind": "ScalarField",
        "name": "state"
    }, v6 = {
        "kind": "ScalarField",
        "name": "boardName"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "sprintJqlBuilderBasicInitQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1 /*: any*/ ,
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v2 /*: any*/ ,
                                        "concreteType": "JiraJqlSprintFieldValueConnection",
                                        "kind": "LinkedField",
                                        "name": "recentlyUsedSprints",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraJqlSprintFieldValueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraJqlSprintFieldValue",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v3 /*: any*/ ,
                                                            v4 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraSprint",
                                                                "kind": "LinkedField",
                                                                "name": "sprint",
                                                                "plural": false,
                                                                "selections": [
                                                                    v5 /*: any*/ ,
                                                                    v6 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ],
                                        "storageKey": "recentlyUsedSprints(first:5)"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "sprintJqlBuilderBasicInitQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraJqlSprintFieldValueConnection",
                                    "kind": "LinkedField",
                                    "name": "recentlyUsedSprints",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraJqlSprintFieldValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraJqlSprintFieldValue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraSprint",
                                                            "kind": "LinkedField",
                                                            "name": "sprint",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "id"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "recentlyUsedSprints(first:5)"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "bd147d7ddd3fe153f2faac37da072abad63284dd1e60a1ad50037b7db7059d8d",
            "metadata": {},
            "name": "sprintJqlBuilderBasicInitQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$77cdb6000500e566$var$node.hash = "ea6849d517e657548891da01c0336d4f";
var $77cdb6000500e566$export$2e2bcd8739ae039 = $77cdb6000500e566$var$node;

});

parcelRegister("fkMdc", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b4f5ad1e6875e7b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8b4f5ad1e6875e7b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    active: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.sprint.active",
        "defaultMessage": "Active"
    },
    future: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.sprint.future",
        "defaultMessage": "Future"
    },
    closed: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.sprint.closed",
        "defaultMessage": "Closed"
    },
    refinementOptionSuggestedSprints: {
        "id": "jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.sprint.refinement-option-suggested-sprints",
        "defaultMessage": "Suggested Sprints"
    }
});

});

parcelRegister("dn84m", function(module, exports) {

$parcel$export(module.exports, "hasValue", () => $b337ebb65a66e2d8$export$96bdbc84526f3739);
$parcel$export(module.exports, "getSprintState", () => $b337ebb65a66e2d8$export$9cbf48c04feaac07);

var $fkMdc = parcelRequire("fkMdc");
const $b337ebb65a66e2d8$export$96bdbc84526f3739 = (text)=>typeof text === 'string' && text.length > 0;
const $b337ebb65a66e2d8$export$9cbf48c04feaac07 = (state, formatMessage)=>{
    switch(state){
        case 'ACTIVE':
            return formatMessage((0, $fkMdc.default).active);
        case 'FUTURE':
            return formatMessage((0, $fkMdc.default).future);
        case 'CLOSED':
            return formatMessage((0, $fkMdc.default).closed);
        default:
            return undefined;
    }
};

});



parcelRegister("dvxPs", function(module, exports) {

$parcel$export(module.exports, "useSelectedOperator", () => $513b83fc745b60b5$export$7efa7e0a027633a3);

var $5uXOq = parcelRequire("5uXOq");

var $iEIQF = parcelRequire("iEIQF");
var $dI0u8 = parcelRequire("dI0u8");
var $bzbto = parcelRequire("bzbto");

var $koVbs = parcelRequire("koVbs");

var $5JlPO = parcelRequire("5JlPO");

var $yqpCH = parcelRequire("yqpCH");

var $8k7M1 = parcelRequire("8k7M1");
const $513b83fc745b60b5$var$DEFAULT_OPERATOR = (0, $iEIQF.default).operator((0, $bzbto.OPERATOR_EQUALS));
const $513b83fc745b60b5$export$7efa7e0a027633a3 = ({ fieldDisplayName: fieldDisplayName, terminalClause: terminalClause, allowedOperators: allowedOperators = [] })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    /**
   * List of operators allowed for the field
   * We need to keep the object references to allow react select to know which is selected for screen readers
   * It uses the reference for this, not the value (https://github.com/JedWatson/react-select/blob/master/packages/react-select/src/components/LiveRegion.tsx#L118)
   */ const allowedOperatorsOptions = (0, $5uXOq.useMemo)(()=>({
            singleOperators: [
                ...new Set(allowedOperators.map((operator)=>(0, $8k7M1.resolveOperator)({
                        operatorValue: operator.value,
                        isList: false
                    })))
            ].map((operatorValue)=>(0, $yqpCH.createOperatorOption)({
                    fieldDisplayName: fieldDisplayName,
                    operator: (0, $iEIQF.default).operator(operatorValue),
                    formatMessage: formatMessage
                })),
            listOperators: [
                ...new Set(allowedOperators.map((o)=>(0, $8k7M1.resolveOperator)({
                        operatorValue: o.value,
                        isList: true
                    })))
            ].map((operatorValue)=>(0, $yqpCH.createOperatorOption)({
                    fieldDisplayName: fieldDisplayName,
                    operator: (0, $iEIQF.default).operator(operatorValue),
                    formatMessage: formatMessage
                }))
        }), // Operator don't change after bootup
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Select if we need to show list or single operators
    const allowedOperatorsOptionsFiltered = (0, $5uXOq.useMemo)(()=>allowedOperatorsOptions[terminalClause?.operand && (0, $5JlPO.isListOperand)(terminalClause.operand) ? 'listOperators' : 'singleOperators'], [
        allowedOperatorsOptions,
        terminalClause?.operand
    ]);
    // Selected operator for the field
    const [selectedOperator, setSelectedOperator] = (0, $5uXOq.useState)(()=>{
        let resolvedOperator = allowedOperatorsOptionsFiltered.find((operator)=>terminalClause?.operator?.value && operator.value === terminalClause.operator.value);
        if (!resolvedOperator) resolvedOperator = allowedOperatorsOptionsFiltered.find((operator)=>operator.value === $513b83fc745b60b5$var$DEFAULT_OPERATOR.value);
        return resolvedOperator !== undefined ? resolvedOperator : (0, $yqpCH.createOperatorOption)({
            fieldDisplayName: fieldDisplayName,
            operator: $513b83fc745b60b5$var$DEFAULT_OPERATOR,
            formatMessage: formatMessage
        });
    });
    const setDefaultOperator = (0, $5uXOq.useCallback)(()=>{
        setSelectedOperator(()=>{
            const resolvedOperator = allowedOperatorsOptionsFiltered.find((operator)=>operator.value === $513b83fc745b60b5$var$DEFAULT_OPERATOR.value);
            return resolvedOperator !== undefined ? resolvedOperator : (0, $yqpCH.createOperatorOption)({
                fieldDisplayName: fieldDisplayName,
                operator: $513b83fc745b60b5$var$DEFAULT_OPERATOR,
                formatMessage: formatMessage
            });
        });
    }, [
        allowedOperatorsOptionsFiltered,
        fieldDisplayName,
        formatMessage
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (terminalClause && terminalClause.operator?.value && (0, $dI0u8.isOperator)(terminalClause.operator.value) && terminalClause.operator.value !== selectedOperator?.value) {
            const terminalOperator = terminalClause.operator;
            const resolvedOperator = allowedOperatorsOptionsFiltered.find((operator)=>operator.value === terminalOperator.value);
            setSelectedOperator(resolvedOperator !== undefined ? resolvedOperator : (0, $yqpCH.createOperatorOption)({
                fieldDisplayName: fieldDisplayName,
                operator: terminalOperator,
                formatMessage: formatMessage
            }));
        }
    // Only update when change come from outside of the hook (terminalClause)
    // We already manage selectedOperator changes internally
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        formatMessage,
        terminalClause
    ]);
    return {
        allowedOperators: allowedOperatorsOptionsFiltered,
        selectedOperator: selectedOperator,
        setSelectedOperator: setSelectedOperator,
        setDefaultOperator: setDefaultOperator
    };
};

});
parcelRegister("yqpCH", function(module, exports) {

$parcel$export(module.exports, "createOperatorOption", () => $969a261700ce5d46$export$ed5b7e9422ae3ae4);

var $bzbto = parcelRequire("bzbto");

var $7xOL0 = parcelRequire("7xOL0");
const $969a261700ce5d46$var$getOperatorLabels = ({ operatorValue: operatorValue, fieldDisplayName: fieldDisplayName, formatMessage: formatMessage })=>{
    let messageKey;
    let resolvedOperatorValue;
    switch(operatorValue){
        case 0, $bzbto.OPERATOR_EQUALS:
        case 0, $bzbto.OPERATOR_IS:
        case 0, $bzbto.OPERATOR_IN:
            messageKey = 'operatorEquals';
            resolvedOperatorValue = (0, $bzbto.OPERATOR_EQUALS);
            break;
        case 0, $bzbto.OPERATOR_NOT_EQUALS:
        case 0, $bzbto.OPERATOR_IS_NOT:
        case 0, $bzbto.OPERATOR_NOT_IN:
            messageKey = 'operatorNotEquals';
            resolvedOperatorValue = (0, $bzbto.OPERATOR_NOT_EQUALS);
            break;
        case 0, $bzbto.OPERATOR_WAS:
        case 0, $bzbto.OPERATOR_WAS_IN:
            messageKey = 'operatorWas';
            resolvedOperatorValue = (0, $bzbto.OPERATOR_WAS);
            break;
        case 0, $bzbto.OPERATOR_WAS_NOT:
        case 0, $bzbto.OPERATOR_WAS_NOT_IN:
            messageKey = 'operatorWasNot';
            resolvedOperatorValue = (0, $bzbto.OPERATOR_WAS_NOT);
            break;
        case 0, $bzbto.OPERATOR_CHANGED:
            messageKey = 'operatorChanged';
            resolvedOperatorValue = (0, $bzbto.OPERATOR_CHANGED);
            break;
        case 0, $bzbto.OPERATOR_LIKE:
            messageKey = 'operatorLike';
            resolvedOperatorValue = (0, $bzbto.OPERATOR_LIKE);
            break;
        case 0, $bzbto.OPERATOR_NOT_LIKE:
            messageKey = 'operatorNotLike';
            resolvedOperatorValue = (0, $bzbto.OPERATOR_NOT_LIKE);
            break;
        case 0, $bzbto.OPERATOR_GT:
            messageKey = 'operatorGt';
            resolvedOperatorValue = (0, $bzbto.OPERATOR_GT);
            break;
        case 0, $bzbto.OPERATOR_GT_EQUALS:
            messageKey = 'operatorGtEquals';
            resolvedOperatorValue = (0, $bzbto.OPERATOR_GT_EQUALS);
            break;
        case 0, $bzbto.OPERATOR_LT:
            messageKey = 'operatorLt';
            resolvedOperatorValue = (0, $bzbto.OPERATOR_LT);
            break;
        case 0, $bzbto.OPERATOR_LT_EQUALS:
            messageKey = 'operatorLtEquals';
            resolvedOperatorValue = (0, $bzbto.OPERATOR_LT_EQUALS);
            break;
        default:
            throw new Error(`Operator value: ${operatorValue} not supported`);
    }
    return {
        label: formatMessage((0, $7xOL0.default)[messageKey], {
            fieldDisplayName: fieldDisplayName,
            operator: resolvedOperatorValue
        }),
        shortLabel: formatMessage((0, $7xOL0.default)[`${messageKey}Short`], {
            operator: resolvedOperatorValue
        }),
        ariaLabel: formatMessage((0, $7xOL0.default)[`${messageKey}AriaLabel`], {
            fieldDisplayName: fieldDisplayName
        }),
        valueLabel: resolvedOperatorValue
    };
};
const $969a261700ce5d46$export$ed5b7e9422ae3ae4 = ({ fieldDisplayName: fieldDisplayName, operator: operator, formatMessage: formatMessage })=>({
        ...operator,
        ...$969a261700ce5d46$var$getOperatorLabels({
            operatorValue: operator.value,
            fieldDisplayName: fieldDisplayName,
            formatMessage: formatMessage
        })
    });

});
parcelRegister("7xOL0", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f26e7cae49ee455$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $3f26e7cae49ee455$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    operatorEquals: {
        "id": "jql-builder-basic.utils.operators.operator-equals",
        "defaultMessage": "{fieldDisplayName} {operator} (equals)"
    },
    operatorNotEquals: {
        "id": "jql-builder-basic.utils.operators.operator-not-equals",
        "defaultMessage": "{fieldDisplayName} {operator} (not equals)"
    },
    operatorWas: {
        "id": "jql-builder-basic.utils.operators.operator-was",
        "defaultMessage": "{fieldDisplayName} {operator}"
    },
    operatorWasNot: {
        "id": "jql-builder-basic.utils.operators.operator-was-not",
        "defaultMessage": "{fieldDisplayName} {operator}"
    },
    operatorChanged: {
        "id": "jql-builder-basic.utils.operators.operator-changed",
        "defaultMessage": "{fieldDisplayName} {operator}"
    },
    operatorLike: {
        "id": "jql-builder-basic.utils.operators.operator-like",
        "defaultMessage": "{fieldDisplayName} {operator} (like)"
    },
    operatorNotLike: {
        "id": "jql-builder-basic.utils.operators.operator-not-like",
        "defaultMessage": "{fieldDisplayName} {operator} (not like)"
    },
    operatorGt: {
        "id": "jql-builder-basic.utils.operators.operator-gt",
        "defaultMessage": "{fieldDisplayName} {operator} (greater than)"
    },
    operatorGtEquals: {
        "id": "jql-builder-basic.utils.operators.operator-gt-equals",
        "defaultMessage": "{fieldDisplayName} {operator} (greater than or equals)"
    },
    operatorLt: {
        "id": "jql-builder-basic.utils.operators.operator-lt",
        "defaultMessage": "{fieldDisplayName} {operator} (less than)"
    },
    operatorLtEquals: {
        "id": "jql-builder-basic.utils.operators.operator-lt-equals",
        "defaultMessage": "{fieldDisplayName} {operator} (less than or equals)"
    },
    operatorEqualsShort: {
        "id": "jql-builder-basic.utils.operators.operator-equals-short",
        "defaultMessage": "{operator} (equals)"
    },
    operatorNotEqualsShort: {
        "id": "jql-builder-basic.utils.operators.operator-not-equals-short",
        "defaultMessage": "{operator} (not equals)"
    },
    operatorWasShort: {
        "id": "jql-builder-basic.utils.operators.operator-was-short",
        "defaultMessage": "{operator}"
    },
    operatorWasNotShort: {
        "id": "jql-builder-basic.utils.operators.operator-was-not-short",
        "defaultMessage": "{operator}"
    },
    operatorChangedShort: {
        "id": "jql-builder-basic.utils.operators.operator-changed-short",
        "defaultMessage": "{operator}"
    },
    operatorLikeShort: {
        "id": "jql-builder-basic.utils.operators.operator-like-short",
        "defaultMessage": "{operator} (like)"
    },
    operatorNotLikeShort: {
        "id": "jql-builder-basic.utils.operators.operator-not-like-short",
        "defaultMessage": "{operator} (not like)"
    },
    operatorGtShort: {
        "id": "jql-builder-basic.utils.operators.operator-gt-short",
        "defaultMessage": "{operator} (greater than)"
    },
    operatorGtEqualsShort: {
        "id": "jql-builder-basic.utils.operators.operator-gt-equals-short",
        "defaultMessage": "{operator} (greater than or equals)"
    },
    operatorLtShort: {
        "id": "jql-builder-basic.utils.operators.operator-lt-short",
        "defaultMessage": "{operator} (less than)"
    },
    operatorLtEqualsShort: {
        "id": "jql-builder-basic.utils.operators.operator-lt-equals-short",
        "defaultMessage": "{operator} (less than or equals)"
    },
    operatorEqualsAriaLabel: {
        "id": "jql-builder-basic.utils.operators.operator-equals-aria-label",
        "defaultMessage": "{fieldDisplayName} equals"
    },
    operatorNotEqualsAriaLabel: {
        "id": "jql-builder-basic.utils.operators.operator-not-equals-aria-label",
        "defaultMessage": "{fieldDisplayName} not equals"
    },
    operatorWasAriaLabel: {
        "id": "jql-builder-basic.utils.operators.operator-was-aria-label",
        "defaultMessage": "{fieldDisplayName} was"
    },
    operatorWasNotAriaLabel: {
        "id": "jql-builder-basic.utils.operators.operator-was-not-aria-label",
        "defaultMessage": "{fieldDisplayName} was not"
    },
    operatorChangedAriaLabel: {
        "id": "jql-builder-basic.utils.operators.operator-changed-aria-label",
        "defaultMessage": "{fieldDisplayName} changed"
    },
    operatorLikeAriaLabel: {
        "id": "jql-builder-basic.utils.operators.operator-like-aria-label",
        "defaultMessage": "{fieldDisplayName} like"
    },
    operatorNotLikeAriaLabel: {
        "id": "jql-builder-basic.utils.operators.operator-not-like-aria-label",
        "defaultMessage": "{fieldDisplayName} not like"
    },
    operatorGtAriaLabel: {
        "id": "jql-builder-basic.utils.operators.operator-gt-aria-label",
        "defaultMessage": "{fieldDisplayName} greater than"
    },
    operatorGtEqualsAriaLabel: {
        "id": "jql-builder-basic.utils.operators.operator-gt-equals-aria-label",
        "defaultMessage": "{fieldDisplayName} greater than or equals"
    },
    operatorLtAriaLabel: {
        "id": "jql-builder-basic.utils.operators.operator-lt-aria-label",
        "defaultMessage": "{fieldDisplayName} less than"
    },
    operatorLtEqualsAriaLabel: {
        "id": "jql-builder-basic.utils.operators.operator-lt-equals-aria-label",
        "defaultMessage": "{fieldDisplayName} less than or equals"
    }
});
var $3f26e7cae49ee455$export$2e2bcd8739ae039 = $3f26e7cae49ee455$export$defe85febe8b728c;

});



parcelRegister("fHJ6B", function(module, exports) {

$parcel$export(module.exports, "useSelectedValues", () => $2a0726ec256d64e2$export$e10928cdf9450649);

var $5uXOq = parcelRequire("5uXOq");

var $5Dsab = parcelRequire("5Dsab");

var $5jdnK = parcelRequire("5jdnK");
const $2a0726ec256d64e2$var$isEmptyOption = (option)=>option.optionType === 'option' && option.value === (0, $5Dsab.OperandValues).empty.value;
const $2a0726ec256d64e2$export$e10928cdf9450649 = (terminalClause, hydratedData, fieldId, operandDisplayValues, searchTemplate)=>{
    // Allow optimistic updates when a value is selected while hydration is taking place
    const [optimisticValues, setOptimisticValues] = (0, $5uXOq.useState)([]);
    const [hydrated, setHydrated] = (0, $5uXOq.useState)(false);
    const prevHydratedData = (0, $5uXOq.useRef)();
    const hydratedValues = (0, $5jdnK.useHydratedValues)(fieldId, hydratedData, searchTemplate, terminalClause, operandDisplayValues);
    // Only flag values as hydrated after a data change
    (0, $5uXOq.useEffect)(()=>{
        if (!hydrated && hydratedData !== prevHydratedData.current) setHydrated(true);
        prevHydratedData.current = hydratedData;
    }, [
        hydrated,
        hydratedData
    ]);
    const selectedValues = (0, $5uXOq.useMemo)(()=>{
        const values = hydrated ? hydratedValues : optimisticValues;
        const emptyIndex = values.findIndex($2a0726ec256d64e2$var$isEmptyOption);
        if (emptyIndex !== -1) {
            const orderedValues = [
                ...values
            ];
            // Rearrange selected values to keep EMPTY at the end
            orderedValues.push(orderedValues.splice(emptyIndex, 1)[0]);
            return orderedValues;
        }
        return values;
    }, [
        hydrated,
        hydratedValues,
        optimisticValues
    ]);
    const setSelectedValues = (0, $5uXOq.useCallback)((values)=>{
        setHydrated(false);
        setOptimisticValues(values);
    }, []);
    return [
        selectedValues,
        setSelectedValues
    ];
};

});
parcelRegister("5jdnK", function(module, exports) {

$parcel$export(module.exports, "useHydratedValues", () => $5462d2b26db71025$export$dc23a21ad032e5fa);

var $jlXxy = parcelRequire("jlXxy");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $koVbs = parcelRequire("koVbs");

var $d2y5h = parcelRequire("d2y5h");
const $5462d2b26db71025$export$dc23a21ad032e5fa = (fieldId, hydratedData, searchTemplate, terminalClause, operandDisplayValues)=>{
    const intl = (0, $koVbs.default)();
    /* eslint-disable @atlassian/relay/graphql-naming, @atlassian/relay/unused-fields */ const data = (0, $8Uumt.useFragment)((0, $jlXxy.default), hydratedData);
    /* eslint-enable @atlassian/relay/graphql-naming, @atlassian/relay/unused-fields */ return (0, $5uXOq.useMemo)(()=>{
        if (terminalClause && data) {
            const hydratedValuesFromClause = (0, $d2y5h.getValuesFromClause)(terminalClause, data, fieldId, operandDisplayValues, intl, searchTemplate);
            if (hydratedValuesFromClause !== undefined) return Array.isArray(hydratedValuesFromClause) ? hydratedValuesFromClause : [
                hydratedValuesFromClause
            ];
        }
        return [];
    }, [
        terminalClause,
        data,
        fieldId,
        intl,
        operandDisplayValues,
        searchTemplate
    ]);
};

});
parcelRegister("jlXxy", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e27d2ec17927240$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5aa1f9f496fb483e2dd16633d7de899e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6e27d2ec17927240$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "picture"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "scope"
    }, v2 = {
        "kind": "Variable",
        "name": "viewContext",
        "variableName": "viewContext"
    }, v3 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v4 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v5 = {
        "kind": "ScalarField",
        "name": "key"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = [
        {
            "concreteType": "JiraStatusCategory",
            "kind": "LinkedField",
            "name": "statusCategory",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "colorName"
                }
            ]
        }
    ], v8 = [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "jql"
                },
                {
                    "kind": "LinkedField",
                    "name": "fields",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraJqlField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "concreteType": "JiraJqlSearchTemplate",
                                            "kind": "LinkedField",
                                            "name": "searchTemplate",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "shouldShowInContext"
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "values",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "values",
                                                    "plural": true,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraProject",
                                                                    "kind": "LinkedField",
                                                                    "name": "project",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraAvatar",
                                                                            "kind": "LinkedField",
                                                                            "name": "avatar",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "small"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlProjectFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v7 /*: any*/ ,
                                                            "type": "JiraJqlStatusFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v7 /*: any*/ ,
                                                            "type": "JiraJqlStatusCategoryFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraAvatar",
                                                                            "kind": "LinkedField",
                                                                            "name": "avatar",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "xsmall"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlIssueTypeFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": v0 /*: any*/ 
                                                                }
                                                            ],
                                                            "type": "JiraJqlUserFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraPriority",
                                                                    "kind": "LinkedField",
                                                                    "name": "priority",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "iconUrl"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlPriorityFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "issue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "text"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlIssueFieldValue"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSprint",
                                                                    "kind": "LinkedField",
                                                                    "name": "sprint",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "state"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "boardName"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlSprintFieldValue"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlQueryHydratedValue"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "error",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlQueryHydratedError"
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraJqlQueryHydratedField"
                        }
                    ]
                }
            ],
            "type": "JiraJqlHydratedQuery"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ],
            "type": "QueryError"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "accountId"
            },
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "filterAri"
            },
            {
                "kind": "RootArgument",
                "name": "includeJira"
            },
            {
                "kind": "RootArgument",
                "name": "includeUser"
            },
            {
                "kind": "RootArgument",
                "name": "isFilter"
            },
            {
                "kind": "RootArgument",
                "name": "jql"
            },
            {
                "kind": "RootArgument",
                "name": "scope"
            },
            {
                "kind": "RootArgument",
                "name": "viewContext"
            }
        ],
        "kind": "Fragment",
        "name": "useHydratedValues",
        "selections": [
            {
                "condition": "includeUser",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "accountId",
                                "variableName": "accountId"
                            }
                        ],
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ]
            },
            {
                "condition": "includeJira",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudId",
                                        "variableName": "cloudId"
                                    }
                                ],
                                "concreteType": "JiraJqlBuilder",
                                "kind": "LinkedField",
                                "name": "jqlBuilder",
                                "plural": false,
                                "selections": [
                                    {
                                        "condition": "isFilter",
                                        "kind": "Condition",
                                        "passingValue": false,
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "query",
                                                        "variableName": "jql"
                                                    },
                                                    v1 /*: any*/ ,
                                                    v2 /*: any*/ 
                                                ],
                                                "kind": "LinkedField",
                                                "name": "hydrateJqlQuery",
                                                "plural": false,
                                                "selections": v8 /*: any*/ 
                                            }
                                        ]
                                    },
                                    {
                                        "condition": "isFilter",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "id",
                                                        "variableName": "filterAri"
                                                    },
                                                    v1 /*: any*/ ,
                                                    v2 /*: any*/ 
                                                ],
                                                "kind": "LinkedField",
                                                "name": "hydrateJqlQueryForFilter",
                                                "plural": false,
                                                "selections": v8 /*: any*/ 
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$6e27d2ec17927240$var$node.hash = "ca3de7c8645b6f4d9524497f325707e2";
var $6e27d2ec17927240$export$2e2bcd8739ae039 = $6e27d2ec17927240$var$node;

});

parcelRegister("d2y5h", function(module, exports) {

$parcel$export(module.exports, "getValuesFromClause", () => $3c74efb6567221af$export$703572bd21b6316);


var $2YZCu = parcelRequire("2YZCu");

var $7l1QQ = parcelRequire("7l1QQ");

var $lmP9s = parcelRequire("lmP9s");

var $aw7SJ = parcelRequire("aw7SJ");

var $4tEMy = parcelRequire("4tEMy");
const $3c74efb6567221af$export$703572bd21b6316 = (terminalClause, data, fieldJqlTerm, validOperandDisplayValues, intl, searchTemplate)=>{
    if (terminalClause.operand) switch(terminalClause.operand.operandType){
        case 0, $49b29ef7baa2a152$export$f6049126fd97001f:
            return (0, $lmP9s.getKeywordValue)(terminalClause.operand.value, validOperandDisplayValues, intl, searchTemplate);
        case 0, $49b29ef7baa2a152$export$38accfc5a5d1c113:
            return (0, $4tEMy.getValue)(data, fieldJqlTerm, terminalClause.operand.value, intl);
        case 0, $49b29ef7baa2a152$export$19c7c729db381f9d:
            return (0, $7l1QQ.getFunctionValue)(data, terminalClause.operand.function.value, validOperandDisplayValues, intl, terminalClause.operand.arguments, fieldJqlTerm);
        case 0, $49b29ef7baa2a152$export$fabec4aebba3f4df:
            return (0, $aw7SJ.getListValue)({
                listOperand: terminalClause.operand,
                data: data,
                fieldJqlTerm: fieldJqlTerm,
                validOperandDisplayValues: validOperandDisplayValues,
                intl: intl,
                searchTemplate: searchTemplate
            });
        default:
            throw new Error('Operand Type is not valid');
    }
    (0, $2YZCu.default).unsafeErrorWithCustomerData('jiraJqlBuilderBasic.getValuesFromClause', 'Terminal clause operand is undefined', {
        jql: (data?.jira?.jqlBuilder?.hydrateJqlQuery ?? data?.jira?.jqlBuilder?.hydrateJqlQueryForFilter)?.jql,
        fieldJqlTerm: fieldJqlTerm,
        operator: terminalClause.operator?.value,
        searchTemplate: searchTemplate
    });
    throw new Error('Terminal clause operand is undefined');
};

});
parcelRegister("7l1QQ", function(module, exports) {

$parcel$export(module.exports, "getFunctionValue", () => $86b370d46074d470$export$f1c78020f9d2362b);


var $5Dsab = parcelRequire("5Dsab");

var $djaDD = parcelRequire("djaDD");
const $86b370d46074d470$export$f1c78020f9d2362b = (data, value, validOperandDisplayValues, intl, args, fieldJqlTerm)=>{
    const invalid = Boolean(!validOperandDisplayValues || !validOperandDisplayValues.includes((0, $5Dsab.OperandValues)[value]?.value || value));
    if (value === 'membersOf') {
        const matchingField = (data?.jira?.jqlBuilder?.hydrateJqlQuery ?? data?.jira?.jqlBuilder?.hydrateJqlQueryForFilter)?.fields?.find((field)=>field.jqlTerm && field.jqlTerm.toLowerCase() === fieldJqlTerm.toLowerCase());
        const fieldData = matchingField?.values?.find((v)=>v?.jqlTerm && v.jqlTerm === args[0].value);
        if (fieldData?.values?.length) {
            const [hydratedFieldValue] = fieldData.values;
            if (hydratedFieldValue) return {
                label: hydratedFieldValue.displayName,
                value: hydratedFieldValue.jqlTerm,
                itemType: (0, $49b29ef7baa2a152$export$19c7c729db381f9d),
                optionType: 'avatar',
                isGroup: true,
                invalid: invalid
            };
        }
        return undefined;
    }
    const fieldValue = {
        label: (0, $djaDD.getFunctionLabel)(value, intl.formatMessage),
        value: (0, $5Dsab.OperandValues)[value]?.value || value,
        itemType: (0, $49b29ef7baa2a152$export$19c7c729db381f9d)
    };
    if (fieldValue.value === (0, $5Dsab.OperandValues).currentUser.value && !invalid) return {
        ...fieldValue,
        optionType: 'avatar',
        avatar: data?.user?.picture ?? '',
        invalid: invalid
    };
    return {
        ...fieldValue,
        optionType: 'avatar',
        hideAvatar: true,
        invalid: invalid
    };
};

});

parcelRegister("lmP9s", function(module, exports) {

$parcel$export(module.exports, "getKeywordValue", () => $42bf65d5837d058e$export$2b5362d270091b71);


var $5Dsab = parcelRequire("5Dsab");

var $gCOs7 = parcelRequire("gCOs7");
const $42bf65d5837d058e$export$2b5362d270091b71 = (value, validOperandDisplayValues, intl, searchTemplate)=>{
    // EMPTY is the only supported RHS keyword in JQL (AST returns EMPTY for both EMPTY and NULL)
    const label = (0, $gCOs7.getEmptyLabel)(searchTemplate ?? null, intl.formatMessage);
    const selectOptionValue = (0, $5Dsab.OperandValues).empty.value;
    const invalid = !validOperandDisplayValues || !validOperandDisplayValues.some((keyword)=>keyword.toLowerCase() === value.toLowerCase());
    if (searchTemplate && (0, $5Dsab.userFieldSearchTemplates).has(searchTemplate.toLowerCase())) return {
        label: label,
        optionType: 'avatar',
        value: selectOptionValue,
        invalid: invalid,
        itemType: (0, $49b29ef7baa2a152$export$f6049126fd97001f)
    };
    return {
        label: label,
        optionType: 'option',
        value: selectOptionValue,
        invalid: invalid,
        itemType: (0, $49b29ef7baa2a152$export$f6049126fd97001f)
    };
};

});

parcelRegister("aw7SJ", function(module, exports) {

$parcel$export(module.exports, "getListValue", () => $8bb7ccce50619e0a$export$9cc74515108c9544);


var $7l1QQ = parcelRequire("7l1QQ");

var $lmP9s = parcelRequire("lmP9s");

var $4tEMy = parcelRequire("4tEMy");
// Returns a minimal `SelectOption` which contains only the value. This is used
// during creation of `rawSelectedValues` in `./main.js`, and is necessary so
// that we can perform comparisons on the selected values before updated data
// is returned from the server.
const $8bb7ccce50619e0a$var$getRawValue = (value)=>({
        optionType: 'option',
        label: '',
        value: value
    });
const $8bb7ccce50619e0a$export$9cc74515108c9544 = ({ listOperand: listOperand, data: data, fieldJqlTerm: fieldJqlTerm, validOperandDisplayValues: validOperandDisplayValues, intl: intl, searchTemplate: searchTemplate })=>listOperand.values.reduce((acum, value)=>{
        if (value.operandType === (0, $49b29ef7baa2a152$export$38accfc5a5d1c113)) {
            if (!data) {
                const rawValue = $8bb7ccce50619e0a$var$getRawValue(value.value);
                // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                return rawValue ? [
                    ...acum,
                    rawValue
                ] : acum;
            }
            const hydratedValue = (0, $4tEMy.getValue)(data, fieldJqlTerm, value.value, intl);
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            return hydratedValue ? [
                ...acum,
                hydratedValue
            ] : acum;
        }
        if (value.operandType === (0, $49b29ef7baa2a152$export$19c7c729db381f9d)) {
            const hydratedValue = (0, $7l1QQ.getFunctionValue)(data, value.function.value, validOperandDisplayValues, intl, value.arguments, fieldJqlTerm);
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            return hydratedValue ? [
                ...acum,
                hydratedValue
            ] : acum;
        }
        if (value.operandType === (0, $49b29ef7baa2a152$export$f6049126fd97001f)) return [
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...acum,
            (0, $lmP9s.getKeywordValue)(value.value, validOperandDisplayValues, intl, searchTemplate)
        ];
        if (value.operandType === (0, $49b29ef7baa2a152$export$fabec4aebba3f4df)) return [
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...acum,
            ...$8bb7ccce50619e0a$export$9cc74515108c9544({
                listOperand: value,
                data: data,
                fieldJqlTerm: fieldJqlTerm,
                validOperandDisplayValues: validOperandDisplayValues,
                intl: intl,
                searchTemplate: searchTemplate
            })
        ];
        throw new Error('This is unexpected! Check if isQueryTooComplex is missing a check');
    }, []);

});
parcelRegister("4tEMy", function(module, exports) {

$parcel$export(module.exports, "getValue", () => $267efa8f19511e2b$export$bf7199a9ebcb84a9);


var $ibQjx = parcelRequire("ibQjx");

var $i8D8h = parcelRequire("i8D8h");

var $14an2 = parcelRequire("14an2");

var $fxPX8 = parcelRequire("fxPX8");

var $acs6u = parcelRequire("acs6u");
const $267efa8f19511e2b$export$bf7199a9ebcb84a9 = (data, fieldJqlTerm, valueJqlTerm, intl)=>{
    const matchingField = (data?.jira?.jqlBuilder?.hydrateJqlQuery ?? data?.jira?.jqlBuilder?.hydrateJqlQueryForFilter)?.fields?.find((field)=>field.jqlTerm && field.jqlTerm.toLowerCase() === fieldJqlTerm.toLowerCase());
    const fieldData = matchingField?.values?.find((value)=>value?.jqlTerm && (value.jqlTerm === valueJqlTerm || value.jqlTerm.toLowerCase() === (0, $ibQjx.removeSurroundingQuotes)(valueJqlTerm).toLowerCase()));
    if (fieldData?.error) return {
        label: (0, $ibQjx.removeSurroundingQuotes)(valueJqlTerm),
        optionType: 'option',
        value: valueJqlTerm,
        invalid: true,
        itemType: (0, $49b29ef7baa2a152$export$38accfc5a5d1c113)
    };
    if (fieldData?.values?.length) {
        const [hydratedFieldValue] = fieldData.values;
        if (hydratedFieldValue) switch(hydratedFieldValue.__typename){
            case 'JiraJqlUserFieldValue':
                return {
                    label: hydratedFieldValue.displayName,
                    value: hydratedFieldValue.jqlTerm,
                    optionType: 'avatar',
                    avatar: hydratedFieldValue.user?.picture,
                    itemType: (0, $49b29ef7baa2a152$export$38accfc5a5d1c113)
                };
            case 'JiraJqlGroupFieldValue':
                return {
                    label: hydratedFieldValue.displayName,
                    value: hydratedFieldValue.jqlTerm,
                    optionType: 'avatar',
                    itemType: (0, $49b29ef7baa2a152$export$38accfc5a5d1c113),
                    isGroup: true
                };
            case 'JiraJqlIssueTypeFieldValue':
                return (0, $14an2.getOption)(hydratedFieldValue, (0, $49b29ef7baa2a152$export$38accfc5a5d1c113));
            case 'JiraJqlProjectFieldValue':
                return (0, $fxPX8.getOption)(hydratedFieldValue, (0, $49b29ef7baa2a152$export$38accfc5a5d1c113));
            case 'JiraJqlSprintFieldValue':
                return (0, $acs6u.getOption)(hydratedFieldValue, intl.formatMessage, (0, $49b29ef7baa2a152$export$38accfc5a5d1c113));
            default:
                return (0, $i8D8h.getOption)(hydratedFieldValue, (0, $49b29ef7baa2a152$export$38accfc5a5d1c113));
        }
    }
    return undefined;
};

});






parcelRegister("05h2Y", function(module, exports) {

$parcel$export(module.exports, "TextAreaPicker", () => $f5d46deca8243a80$export$2d0fad1d142f2f68);

var $5uXOq = parcelRequire("5uXOq");

var $bzbto = parcelRequire("bzbto");

var $eWn4R = parcelRequire("eWn4R");

var $8OILN = parcelRequire("8OILN");

var $1dTaH = parcelRequire("1dTaH");

var $kG16F = parcelRequire("kG16F");

var $5Sv2f = parcelRequire("5Sv2f");

var $MrkmL = parcelRequire("MrkmL");

var $cGGWn = parcelRequire("cGGWn");

var $i8ykz = parcelRequire("i8ykz");

var $lhV7D = parcelRequire("lhV7D");
const $f5d46deca8243a80$var$isSingleValueOperand = (operand)=>operand.operandType === (0, $49b29ef7baa2a152$export$38accfc5a5d1c113) || operand.operandType === (0, $49b29ef7baa2a152$export$f6049126fd97001f);
const $f5d46deca8243a80$export$2d0fad1d142f2f68 = ({ clause: clause, fieldId: fieldId, fieldLabel: fieldLabel, fieldType: fieldType, activePopupKey: activePopupKey, onSearchWrapper: onSearchWrapper, onClear: onClear, onOpen: onOpen, onClose: onClose, fieldDescription: fieldDescription, propType: propType, isIrremovable: isIrremovable })=>{
    const [ast] = (0, $kG16F.useAST)();
    const sendOptionAnalytics = (0, $5Sv2f.useSendOptionAnalytics)();
    if (!(0, $1dTaH.isTextAreaPropType)(propType)) throw new Error(`Unsupported TextAreaPropType: ${propType}`);
    const handleOnClear = (0, $5uXOq.useCallback)(()=>{
        onClear && onClear(clause ? (0, $eWn4R.default)(ast, clause) : undefined);
    }, [
        onClear,
        clause,
        ast
    ]);
    const commonProps = {
        fieldId: fieldId,
        fieldDisplayName: fieldLabel || '',
        fieldType: fieldType,
        propType: propType,
        isOpen: activePopupKey === fieldId,
        onOpen: onOpen,
        onClose: onClose,
        onClear: handleOnClear,
        value: clause && clause.clauseType === (0, $e9a0ef16a223cbc7$export$ae56b4ef248a2b6a) && clause.operand && $f5d46deca8243a80$var$isSingleValueOperand(clause.operand) && clause.operand.value || '',
        onSendOptionAnalytics: sendOptionAnalytics,
        fieldDescription: fieldDescription,
        isIrremovable: isIrremovable
    };
    switch(propType){
        case (0, $8OILN.TextAreaPropTypes).Number:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cGGWn.default), {
                ...commonProps,
                onChange: (newValue)=>{
                    onSearchWrapper && onSearchWrapper((0, $lhV7D.getUpdatedJql)(ast, clause, fieldId, newValue, (0, $bzbto.OPERATOR_EQUALS)));
                }
            });
        case (0, $8OILN.TextAreaPropTypes).Aql:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MrkmL.default), {
                ...commonProps,
                value: (0, $lhV7D.getAqlFromClause)(clause),
                onChange: (newValue)=>{
                    onSearchWrapper && onSearchWrapper((0, $lhV7D.getUpdatedJqlWithAql)(ast, clause, fieldId, newValue, (0, $bzbto.OPERATOR_IN)));
                }
            });
        case (0, $8OILN.TextAreaPropTypes).Text:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8ykz.default), {
                ...commonProps,
                onChange: (newValue)=>{
                    onSearchWrapper && onSearchWrapper((0, $lhV7D.getUpdatedJql)(ast, clause, fieldId, newValue, (0, $bzbto.OPERATOR_LIKE)));
                }
            });
        case (0, $8OILN.TextAreaPropTypes).ExactText:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8ykz.default), {
                ...commonProps,
                onChange: (newValue)=>{
                    onSearchWrapper && onSearchWrapper((0, $lhV7D.getUpdatedJql)(ast, clause, fieldId, newValue, (0, $bzbto.OPERATOR_EQUALS)));
                }
            });
        default:
            throw new Error(`Unsupported TextAreaPropType: ${propType}`);
    }
};

});
parcelRegister("MrkmL", function(module, exports) {

$parcel$export(module.exports, "default", () => $745ccb1b964efe57$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $krXdA = parcelRequire("krXdA");

var $dg0Fl = parcelRequire("dg0Fl");

var $erAfT = parcelRequire("erAfT");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $f5TWP = parcelRequire("f5TWP");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $jcw0u = parcelRequire("jcw0u");

var $koVbs = parcelRequire("koVbs");

var $4yuwq = parcelRequire("4yuwq");

var $18zMx = parcelRequire("18zMx");

var $jgJNO = parcelRequire("jgJNO");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $ktP1V = parcelRequire("ktP1V");

var $7DxXA = parcelRequire("7DxXA");

var $ahEft = parcelRequire("ahEft");

var $4Scrc = parcelRequire("4Scrc");

var $9OXo1 = parcelRequire("9OXo1");

var $5Dsab = parcelRequire("5Dsab");

var $4Hz9T = parcelRequire("4Hz9T");

var $j36MG = parcelRequire("j36MG");
const $745ccb1b964efe57$var$formatLabel = (label, value)=>{
    if (value === null || value === undefined || !value.length) return label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: "inherit",
        as: "strong"
    }, label), ":\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($745ccb1b964efe57$var$ValueWrapper, null, value));
};
const $745ccb1b964efe57$var$shouldValidateAQL = (tenantContext)=>(0, $ahEft.isLicensedPremiumUser)(tenantContext) && (0, $ktP1V.isCMDBEnabledInEnvironment)(tenantContext.cmdbDisabledInFedRAMP);
const $745ccb1b964efe57$export$3ff8b265431bef98 = ({ fieldId: fieldId, fieldDisplayName: fieldDisplayName, isOpen: isOpen, onOpen: onOpen, onClose: onClose, onClear: onClear, onChange: onChange, onSendOptionAnalytics: onSendOptionAnalytics, value: value, fieldDescription: fieldDescription, isIrremovable: isIrremovable })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { workspaceId: workspaceId, fetchWorkspaceId: fetchWorkspaceId } = (0, $7DxXA.useWorkspaceContext)();
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [{ unvalidatedIql: unvalidatedIql, validationResult: validationResult }, { onChange: onIqlChange }] = (0, $4Scrc.useIqlValidation)({
        workspaceId: workspaceId,
        initialIql: value ?? ''
    });
    let aqlValidationError;
    if (validationResult.type === 'invalid') aqlValidationError = validationResult.error;
    (0, $5uXOq.useEffect)(()=>{
        if (!workspaceId) fetchWorkspaceId();
    }, [
        fetchWorkspaceId,
        workspaceId
    ]);
    const handleOnValueChange = (0, $5uXOq.useCallback)((inputValue = '')=>{
        // Only check AQL if it is a premium user
        if ($745ccb1b964efe57$var$shouldValidateAQL(tenantContext)) onIqlChange(inputValue);
    }, [
        onIqlChange,
        tenantContext
    ]);
    const handleOnUpdate = (0, $5uXOq.useCallback)((inputValue)=>{
        onChange(inputValue);
        onClose();
        onSendOptionAnalytics && onSendOptionAnalytics({
            isAqlValidationEnabled: $745ccb1b964efe57$var$shouldValidateAQL(tenantContext),
            searchStringLength: inputValue.length
        });
    }, [
        onChange,
        onClose,
        onSendOptionAnalytics,
        tenantContext
    ]);
    const handleOnHelpClick = (0, $5uXOq.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        });
        const attributes = {
            actionType: 'close'
        };
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'aqlHelpLink', attributes);
    }, [
        createAnalyticsEvent
    ]);
    const handleOnTriggerClick = (0, $5uXOq.useCallback)(()=>{
        if (isOpen) onClose();
        else {
            onOpen();
            if ($745ccb1b964efe57$var$shouldValidateAQL(tenantContext)) onIqlChange(value || '');
        }
    }, [
        isOpen,
        onClose,
        onIqlChange,
        onOpen,
        tenantContext,
        value
    ]);
    const handleOnAQLValidationRetry = (0, $5uXOq.useCallback)((inputValue)=>()=>onIqlChange(inputValue), [
        onIqlChange
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if ($745ccb1b964efe57$var$shouldValidateAQL(tenantContext) && aqlValidationError) {
            // We skip syntax errors from sentry and sent them to privacy unsafe splunk
            const isInvalidSyntaxError = aqlValidationError.includes('invalid syntax');
            (0, $jcw0u.default)({
                error: new Error(isInvalidSyntaxError ? 'invalid syntax' : 'unable to validate AQL query'),
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: isInvalidSyntaxError,
                meta: {
                    id: 'aql-validation-error',
                    packageName: (0, $5Dsab.PACKAGE_NAME),
                    teamName: (0, $5Dsab.TEAM_NAME)
                }
            });
        }
    }, [
        aqlValidationError,
        tenantContext
    ]);
    const getAqlPickerErrorMessage = (0, $5uXOq.useCallback)((inputValue)=>{
        if (!$745ccb1b964efe57$var$shouldValidateAQL(tenantContext)) return undefined;
        switch(validationResult.type){
            case 'valid':
                return unvalidatedIql !== inputValue ? formatMessage((0, $j36MG.default).aqlValidationInProgressMessage) : undefined;
            case 'invalid':
                return aqlValidationError !== 'Failed to fetch' ? formatMessage((0, $j36MG.default).inValidAqlErrorMessage) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
                    alignInline: "center",
                    xcss: $745ccb1b964efe57$var$retryStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage((0, $j36MG.default).unableToValidateAqlErrorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                    xcss: $745ccb1b964efe57$var$retryIconStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                    content: formatMessage((0, $j36MG.default).retry),
                    position: "top"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                    appearance: "link",
                    spacing: "none",
                    onClick: handleOnAQLValidationRetry(inputValue),
                    testId: "jql-builder-basic.ui.jql-editor.field.text-area-picker.aql-picker-popup.retry-button"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($erAfT))), {
                    LEGACY_size: "small",
                    label: formatMessage((0, $j36MG.default).retry)
                })))));
            case 'loading':
                return formatMessage((0, $j36MG.default).aqlValidationInProgressMessage);
            default:
                return undefined;
        }
    }, [
        tenantContext,
        validationResult.type,
        unvalidatedIql,
        formatMessage,
        aqlValidationError,
        handleOnAQLValidationRetry
    ]);
    const InfoIconComponent = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dg0Fl))), {
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)",
            label: ""
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        key: fieldId,
        placement: "bottom-start",
        isOpen: isOpen,
        onClose: onClose,
        popupComponent: (0, $4yuwq.FixedWidthPopupComponent),
        shouldRenderToParent: true,
        messageId: "jql-builder-basic.ui.jql-editor.field.text-area-picker.aql-picker-popup.popup",
        messageType: "transactional",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Hz9T.default), {
                ...triggerProps,
                isInvalid: false,
                isSelected: isOpen,
                hasValues: !!value,
                onClick: handleOnTriggerClick,
                onClear: onClear,
                testId: `jql-builder-basic.ui.jql-editor.aql.filter-button.${fieldId}`,
                fieldDescription: fieldDescription,
                isIrremovable: isIrremovable
            }, $745ccb1b964efe57$var$formatLabel(fieldDisplayName, value ? formatMessage((0, $j36MG.default).formatLabelMessage) : '')),
        content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $18zMx.default), {
                value: value ?? '',
                getErrorMessage: getAqlPickerErrorMessage,
                onChange: handleOnUpdate,
                onValueChange: handleOnValueChange,
                placeholderText: formatMessage((0, $j36MG.default).textAreaPlaceholder),
                setInitialFocusRef: setInitialFocusRef,
                footerIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                    xcss: $745ccb1b964efe57$var$helpStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                    content: formatMessage((0, $j36MG.default).aqlSyntaxHelpLinkLabel),
                    position: "top"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $krXdA.default), {
                    href: "https://support.atlassian.com/jira-service-management-cloud/docs/use-assets-query-language-aql/",
                    shape: "circle",
                    onClick: handleOnHelpClick,
                    icon: InfoIconComponent,
                    appearance: "subtle",
                    spacing: "compact",
                    label: formatMessage((0, $j36MG.default).aqlSyntaxHelpLinkLabel)
                })))
            })
    });
};
var $745ccb1b964efe57$export$2e2bcd8739ae039 = $745ccb1b964efe57$export$3ff8b265431bef98;
const $745ccb1b964efe57$var$retryStyles = (0, $8CUq3.xcss)({
    height: "var(--ds-space-200, 16px)"
});
const $745ccb1b964efe57$var$helpStyles = (0, $8CUq3.xcss)({
    height: "var(--ds-space-300, 24px)"
});
const $745ccb1b964efe57$var$retryIconStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.050'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $745ccb1b964efe57$var$ValueWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s _p12fuuw1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("erAfT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6523555332355b1d4aa6bddc8955e159>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a83fb5e18ffcf6b2$var$_react = $a83fb5e18ffcf6b2$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a83fb5e18ffcf6b2$var$_retry = $a83fb5e18ffcf6b2$var$_interopRequireDefault((parcelRequire("lzNDe")));

var $a83fb5e18ffcf6b2$var$_retry2 = $a83fb5e18ffcf6b2$var$_interopRequireDefault((parcelRequire("kNGlC")));
function $a83fb5e18ffcf6b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for RetryIcon.
 * This component is RetryIcon, with `UNSAFE_fallbackIcon` set to "RetryIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for retry.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a83fb5e18ffcf6b2$var$RetryIcon = (props)=>/*#__PURE__*/ $a83fb5e18ffcf6b2$var$_react.default.createElement($a83fb5e18ffcf6b2$var$_retry.default, Object.assign({
        LEGACY_fallbackIcon: $a83fb5e18ffcf6b2$var$_retry2.default
    }, props));
$a83fb5e18ffcf6b2$var$RetryIcon.Name = 'RetryIconMigration';
var $a83fb5e18ffcf6b2$var$_default = module.exports.default = $a83fb5e18ffcf6b2$var$RetryIcon;

});
parcelRegister("lzNDe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2b87cc7d74b53f2f9074ecfc04ea4b65>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fb535dae8e778b64$var$_react = $fb535dae8e778b64$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $fb535dae8e778b64$var$_baseNew = $fb535dae8e778b64$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $fb535dae8e778b64$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Retry".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for retry.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fb535dae8e778b64$var$RetryIcon = (props)=>/*#__PURE__*/ $fb535dae8e778b64$var$_react.default.createElement($fb535dae8e778b64$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 8a7 7 0 0 1 12.5-4.33V1H15v5a.75.75 0 0 1-.75.75H9.5v-1.5h3.264a5.5 5.5 0 1 0 .665 3.63l1.482.24A7.002 7.002 0 0 1 1 8" clip-rule="evenodd"/>`
    }, props));
$fb535dae8e778b64$var$RetryIcon.displayName = 'RetryIcon';
var $fb535dae8e778b64$var$_default = module.exports.default = $fb535dae8e778b64$var$RetryIcon;

});

parcelRegister("kNGlC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f2493ba1e2db6b78$var$_react = $f2493ba1e2db6b78$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $f2493ba1e2db6b78$var$_retry = $f2493ba1e2db6b78$var$_interopRequireDefault((parcelRequire("lzNDe")));
function $f2493ba1e2db6b78$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f2493ba1e2db6b78$var$RetryIcon = (props)=>/*#__PURE__*/ $f2493ba1e2db6b78$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 10h2.954a1 1 0 0 1 0 2H5.099A1.1 1.1 0 0 1 4 10.9V7a1 1 0 1 1 2 0z"/><path fill-rule="nonzero" d="M7.39 10.09H5.3a8 8 0 1 1 .818 6H7.84v-1.02a6 6 0 1 0-.45-4.98"/><circle cx="7" cy="15.61" r="1"/></g></svg>`
    }, props, {
        newIcon: $f2493ba1e2db6b78$var$_retry.default
    }));
$f2493ba1e2db6b78$var$RetryIcon.displayName = 'RetryIcon';
var $f2493ba1e2db6b78$var$_default = module.exports.default = $f2493ba1e2db6b78$var$RetryIcon;

});


parcelRegister("18zMx", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca944b423e796f07$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $qfj8c = parcelRequire("qfj8c");

var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $6LCpJ = parcelRequire("6LCpJ");

var $gwIPs = parcelRequire("gwIPs");

var $koVbs = parcelRequire("koVbs");


var $8vXYi = parcelRequire("8vXYi");
const $ca944b423e796f07$export$60ae88ee9ba520c0 = ({ value: value, getErrorMessage: getErrorMessage, onChange: onChange, onValueChange: onValueChange, placeholderText: placeholderText, setInitialFocusRef: setInitialFocusRef, multiline: multiline = true, footerIcon: footerIcon })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [unsubmittedValue, setUnsubmittedValue] = (0, $5uXOq.useState)(value ?? '');
    const textAreaRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (setInitialFocusRef) setInitialFocusRef(textAreaRef.current);
    }, [
        setInitialFocusRef
    ]);
    const handleOnChange = (0, $5uXOq.useCallback)(({ target: { value: targetValue } })=>{
        if (onValueChange) onValueChange(targetValue);
        setUnsubmittedValue(targetValue);
    }, [
        setUnsubmittedValue,
        onValueChange
    ]);
    const handleOnSubmit = (0, $5uXOq.useCallback)((e)=>{
        e.preventDefault();
        onChange(unsubmittedValue);
    }, [
        unsubmittedValue,
        onChange
    ]);
    const hasError = (0, $5uXOq.useMemo)(()=>!!getErrorMessage?.(unsubmittedValue), [
        getErrorMessage,
        unsubmittedValue
    ]);
    const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
        if (!multiline && event.key === 'Enter') event.preventDefault();
    }, [
        multiline
    ]);
    const handleOnPaste = (0, $5uXOq.useCallback)((event)=>{
        if (!multiline) {
            const data = event.clipboardData.getData('text/plain');
            if (textAreaRef.current && data.includes('\n')) {
                // Replace newlines with spaces
                const paste = data.replace(/\n/g, ' ');
                setUnsubmittedValue(unsubmittedValue.slice(0, textAreaRef.current.selectionStart) + paste + unsubmittedValue.slice(textAreaRef.current.selectionEnd));
                event.preventDefault();
            }
        }
    }, [
        multiline,
        unsubmittedValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ca944b423e796f07$var$DialogInner, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ca944b423e796f07$var$TextAreaWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6LCpJ.default), {
        ref: textAreaRef,
        onChange: handleOnChange,
        value: unsubmittedValue,
        onKeyDown: handleKeyDown,
        "aria-multiline": multiline,
        maxHeight: (0, $60c42fd1881b5052$export$5cdf10537498e072),
        onPaste: handleOnPaste,
        appearance: "none",
        minimumRows: 4,
        placeholder: placeholderText ?? formatMessage((0, $8vXYi.default).textAreaPlaceholder),
        testId: "jql-builder-basic-textarea.ui.text-area"
    })), hasError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ca944b423e796f07$var$ErrorMessageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, getErrorMessage?.(unsubmittedValue))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        spread: "space-between",
        alignBlock: "center",
        grow: "fill",
        xcss: $ca944b423e796f07$var$footerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ca944b423e796f07$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "primary",
        onClick: handleOnSubmit,
        type: "submit",
        isDisabled: hasError,
        testId: "jql-builder-basic-textarea.ui.update-button"
    }, formatMessage((0, $8vXYi.default).updateButtonText))), footerIcon));
};
var $ca944b423e796f07$export$2e2bcd8739ae039 = $ca944b423e796f07$export$60ae88ee9ba520c0;
const $ca944b423e796f07$var$footerStyles = (0, $8CUq3.xcss)({
    paddingRight: 'space.150',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderTop: `${"var(--ds-border, #091E4224)"} solid ${(0, $gwIPs.gridSize) / 4}px`,
    paddingTop: 'space.075',
    paddingBottom: 'space.075'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ca944b423e796f07$var$ButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkze3t _2hwxutpp _otyrze3t _18u0utpp _p12f1vmz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ca944b423e796f07$var$TextAreaWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkv77o _otyr12x7 _18u012x7 _2hwx12x7 _c71l4d55",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/design-system/use-primitives, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ca944b423e796f07$var$ErrorMessageWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk1b66 _2hwxutpp _otyr1b66 _18u0utpp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ca944b423e796f07$var$DialogInner = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1mjv",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6LCpJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $934f91ac04cc5aeb$export$2e2bcd8739ae039);
/* text-area.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $VSDnB = parcelRequire("VSDnB");
const $934f91ac04cc5aeb$var$packageName = "platform-pkg";
const $934f91ac04cc5aeb$var$packageVersion = "0.0.0-use.local";
const $934f91ac04cc5aeb$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $934f91ac04cc5aeb$var$packageName,
    packageVersion: $934f91ac04cc5aeb$var$packageVersion
};
const $934f91ac04cc5aeb$var$lineHeightBase = 20;
const $934f91ac04cc5aeb$var$lineHeightCompact = 16;
const $934f91ac04cc5aeb$var$compactVerticalPadding = 2;
const $934f91ac04cc5aeb$var$verticalPadding = 6;
const $934f91ac04cc5aeb$var$transitionDuration = '0.2s';
const $934f91ac04cc5aeb$var$borderWidth = 2;
const $934f91ac04cc5aeb$var$baseStyles = null;
const $934f91ac04cc5aeb$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp821elr _1ltx1j9a _1bqs13gt _z1pvsyzs _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _17km1v6z _wg601v6z _858u1p6i _jomrr01l _7ehiq049 _186j1p6i _qu18syzs",
    subtle: "_1dqonqa1 _kp823acm _1ltx18uv _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _wg601v6z _17km1v6z _858u1p6i _jomrr01l _7ehiq049",
    none: "_1dqoglyw _kp823acm _1ltx18uv _19wt3acm _12ym18uv _19qkv77o _zedr12x7 _1dbiv77o _1etu12x7 _1itd12x7 _wg6012x7 _1a4912x7 _17km12x7 _858u3acm _jomr18uv _7ehinruj"
};
const $934f91ac04cc5aeb$var$fontStyles = {
    default: "_ect41gqc",
    monospace: "_ect41odn _1tn22smr _14mdudxr",
    large: "_11c81ixg _1tn22smr"
};
const $934f91ac04cc5aeb$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
const $934f91ac04cc5aeb$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $934f91ac04cc5aeb$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $934f91ac04cc5aeb$var$InnerTextArea = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const ourRef = (0, $5uXOq.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const borderHeight = (0, $5uXOq.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $934f91ac04cc5aeb$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$934f91ac04cc5aeb$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$934f91ac04cc5aeb$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $5uXOq.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $934f91ac04cc5aeb$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rko1sit _11c82smr _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazj3m3 _slp31hna _153g78r2 _usy4mag2 _1a2sr6rt _vbqb9jg2 _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra78r2 _ibjd10ko _6zpvr6rt _19k01y1w _1idr1wmz _1lep9jg2 _nmhq1fiz _1n388sxn _1luh194a _ndzbr01l _1vj01cu8",
            $934f91ac04cc5aeb$var$appearanceStyles[appearance],
            (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') && $934f91ac04cc5aeb$var$fontStyles['large'],
            $934f91ac04cc5aeb$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $934f91ac04cc5aeb$var$resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $lD23V.default)($934f91ac04cc5aeb$var$lineHeightCompact * minimumRows + $934f91ac04cc5aeb$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $lD23V.default)($934f91ac04cc5aeb$var$lineHeightBase * minimumRows + $934f91ac04cc5aeb$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
}); /**
     * __Text area__
     *
     * A text area lets users enter long form text which spans over multiple lines.
     *
     * - [Examples](https://atlassian.design/components/textarea/examples)
     * - [Code](https://atlassian.design/components/textarea/code)
     * - [Usage](https://atlassian.design/components/textarea/usage)
     */ 
const $934f91ac04cc5aeb$var$TextArea = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)($934f91ac04cc5aeb$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$934f91ac04cc5aeb$var$TextArea.displayName = 'TextArea';
var $934f91ac04cc5aeb$export$2e2bcd8739ae039 = $934f91ac04cc5aeb$var$TextArea;

});

const $60c42fd1881b5052$export$5cdf10537498e072 = '232px';

parcelRegister("8vXYi", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2f6b220a914b344$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d2f6b220a914b344$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    updateButtonText: {
        "id": "jql-builder-basic-textarea.update-button-text",
        "defaultMessage": "Update"
    },
    textAreaPlaceholder: {
        "id": "jql-builder-basic-textarea.text-area-placeholder",
        "defaultMessage": "Begin typing..."
    }
});

});


parcelRegister("7DxXA", function(module, exports) {

$parcel$export(module.exports, "useWorkspaceContext", () => $5d7c6ac21f7af915$export$827d903316fc333c);
$parcel$export(module.exports, "useInsightVisibility", () => $5d7c6ac21f7af915$export$74ebc9a49f60d38a);

var $5uXOq = parcelRequire("5uXOq");

var $ktP1V = parcelRequire("ktP1V");

var $9OXo1 = parcelRequire("9OXo1");

var $2YP9W = parcelRequire("2YP9W");

var $ahEft = parcelRequire("ahEft");

var $gRzZD = parcelRequire("gRzZD");
const $5d7c6ac21f7af915$export$a0002067fa97246a = '/rest/servicedesk/cmdb/latest/workspace';
const $5d7c6ac21f7af915$export$122fccf0bbbc9acc = 30000;
const $5d7c6ac21f7af915$export$827d903316fc333c = ()=>{
    const { data: data, loading: loading, error: error, refresh: fetchWorkspaceId } = (0, $2YP9W.useResource)((0, $gRzZD.workspaceResource));
    const workspaceId = data ?? undefined;
    return {
        loading: loading,
        error: // @ts-expect-error - TS2322 - Type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to type 'Error | null | undefined'.
        error,
        workspaceId: workspaceId,
        fetchWorkspaceId: fetchWorkspaceId
    };
};
// https://overreacted.io/making-setinterval-declarative-with-react-hooks/
const $5d7c6ac21f7af915$var$useInterval = (callback, delay)=>{
    const savedCallback = (0, $5uXOq.useRef)(callback);
    // Remember the latest callback.
    (0, $5uXOq.useEffect)(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    // Set up the interval.
    (0, $5uXOq.useEffect)(()=>{
        const tick = ()=>{
            savedCallback.current();
        };
        if (delay !== null) {
            const id = setInterval(tick, delay);
            return ()=>clearInterval(id);
        }
        return undefined;
    }, [
        delay
    ]);
};
const $5d7c6ac21f7af915$export$74ebc9a49f60d38a = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const { workspaceId: workspaceId, fetchWorkspaceId: fetchWorkspaceId, loading: loading } = $5d7c6ac21f7af915$export$827d903316fc333c();
    // Optimistically set this true if user is premium and CMDB is enabled in environment - which will prevent a flash for the majority of users
    const [isVisible, setIsVisible] = (0, $5uXOq.useState)((0, $ktP1V.isCMDBEnabledInEnvironment)(tenantContext.cmdbDisabledInFedRAMP) && (0, $ahEft.isLicensedPremiumUser)(tenantContext));
    const [shouldPollForWorkspaceId, setShouldPollForWorkspaceId] = (0, $5uXOq.useState)(false);
    const [hasFetchedWorkspaceId, setHasFetchedWorkspaceId] = (0, $5uXOq.useState)(false);
    // Can't test this component without a rerender on each poll — so am just increment a counter with each poll
    const [, setPollCount] = (0, $5uXOq.useState)(0);
    // Run an initial fetch of the workspaceId if the resource wasn't already fetched as
    // part of the route definition (like for the Insight menu in the global nav)
    (0, $5uXOq.useEffect)(()=>{
        if (!hasFetchedWorkspaceId && !workspaceId && (0, $ahEft.isLicensedPremiumUser)(tenantContext) && (0, $ktP1V.isCMDBEnabledInEnvironment)(tenantContext.cmdbDisabledInFedRAMP)) {
            fetchWorkspaceId();
            setHasFetchedWorkspaceId(true);
        }
    }, [
        fetchWorkspaceId,
        hasFetchedWorkspaceId,
        tenantContext,
        workspaceId
    ]);
    // Starts/stops the polling of workspaceId
    $5d7c6ac21f7af915$var$useInterval(()=>{
        fetchWorkspaceId();
        setPollCount((a)=>a + 1);
    }, shouldPollForWorkspaceId ? $5d7c6ac21f7af915$export$122fccf0bbbc9acc : null);
    // Main check to see if insight should be visible
    // If user has premium subscription but no workspace ID, we begin polling for the
    // workspace ID as it means their Insight instance hasn’t completed provisioning yet
    (0, $5uXOq.useEffect)(()=>{
        if (hasFetchedWorkspaceId && !loading) {
            if ((0, $ahEft.isLicensedPremiumUser)(tenantContext)) {
                if (workspaceId !== undefined) {
                    setIsVisible(true);
                    setShouldPollForWorkspaceId(false);
                } else {
                    setIsVisible(false);
                    setShouldPollForWorkspaceId(true);
                }
            } else {
                setIsVisible(false);
                setShouldPollForWorkspaceId(false);
            }
        }
    }, [
        tenantContext,
        workspaceId,
        loading,
        hasFetchedWorkspaceId
    ]);
    return isVisible;
};

});

parcelRegister("4Scrc", function(module, exports) {

$parcel$export(module.exports, "useIqlValidation", () => $ec2b2313cccb811c$export$e39e6ad91e20e4a0);

var $5uXOq = parcelRequire("5uXOq");

var $laWvb = parcelRequire("laWvb");

var $xJtdX = parcelRequire("xJtdX");

var $cRoHr = parcelRequire("cRoHr");

var $gWyXT = parcelRequire("gWyXT");
const $ec2b2313cccb811c$var$IQL_VALIDATE_DELAY = 300;
const $ec2b2313cccb811c$var$getInitialStateForIql = (newUnvalidatedIql)=>({
        unvalidatedIql: newUnvalidatedIql,
        validationResult: newUnvalidatedIql === (0, $cRoHr.EMPTY_VALIDATED_IQL) ? {
            type: 'valid',
            validatedIql: (0, $cRoHr.EMPTY_VALIDATED_IQL)
        } : {
            type: 'loading'
        }
    });
const $ec2b2313cccb811c$export$e39e6ad91e20e4a0 = ({ workspaceId: workspaceId, initialIql: initialIql })=>{
    const [state, setState] = (0, $5uXOq.useState)({
        unvalidatedIql: String(initialIql),
        validationResult: {
            type: 'valid',
            validatedIql: initialIql
        }
    });
    // Debounce calls to prevent validation being requested on every key press
    const [debouncedValidate] = (0, $laWvb.default)(async (newUnvalidatedIql)=>{
        let newValidationResult;
        try {
            if (!workspaceId) return;
            newValidationResult = await (0, $gWyXT.validateQlQuery)({
                workspaceId: workspaceId,
                unvalidatedIql: newUnvalidatedIql
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $xJtdX.fireCmdbErrorAnalytics)({
                error: error,
                meta: {
                    id: 'validateIql',
                    packageName: 'jiraServicedeskInsightIqlValidation',
                    teamName: 'falcons'
                }
            });
            newValidationResult = {
                type: 'invalid',
                error: error.message
            };
        }
        setState((prevState)=>{
            // If unvalidatedIql in the state has changed since this was called, this means the user has changed the IQL
            // making this current request invalid.
            if (prevState.unvalidatedIql !== newUnvalidatedIql) return prevState;
            return {
                unvalidatedIql: newUnvalidatedIql,
                validationResult: newValidationResult
            };
        });
    }, $ec2b2313cccb811c$var$IQL_VALIDATE_DELAY);
    const onChange = (0, $5uXOq.useCallback)((newUnvalidatedIql)=>{
        const newState = $ec2b2313cccb811c$var$getInitialStateForIql(newUnvalidatedIql);
        setState(newState);
        if (newState.validationResult.type === 'valid') return;
        debouncedValidate(newUnvalidatedIql);
    }, [
        debouncedValidate,
        setState
    ]);
    return [
        state,
        {
            onChange: onChange
        }
    ];
};

});
parcelRegister("laWvb", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6a7e96a5e9b4bd2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $f6a7e96a5e9b4bd2$export$2e2bcd8739ae039(callback, delay, options) {
    if (options === void 0) options = {};
    var maxWait = options.maxWait;
    var maxWaitHandler = (0, $5uXOq.useRef)(null);
    var maxWaitArgs = (0, $5uXOq.useRef)([]);
    var leading = options.leading;
    var trailing = options.trailing === undefined ? true : options.trailing;
    var leadingCall = (0, $5uXOq.useRef)(false);
    var functionTimeoutHandler = (0, $5uXOq.useRef)(null);
    var isComponentUnmounted = (0, $5uXOq.useRef)(false);
    var debouncedFunction = (0, $5uXOq.useRef)(callback);
    debouncedFunction.current = callback;
    var cancelDebouncedCallback = (0, $5uXOq.useCallback)(function() {
        clearTimeout(functionTimeoutHandler.current);
        clearTimeout(maxWaitHandler.current);
        maxWaitHandler.current = null;
        maxWaitArgs.current = [];
        functionTimeoutHandler.current = null;
        leadingCall.current = false;
    }, []);
    (0, $5uXOq.useEffect)(function() {
        return function() {
            // we use flag, as we allow to call callPending outside the hook
            isComponentUnmounted.current = true;
        };
    }, []);
    var debouncedCallback = (0, $5uXOq.useCallback)(function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        maxWaitArgs.current = args;
        clearTimeout(functionTimeoutHandler.current);
        if (leadingCall.current) leadingCall.current = false;
        if (!functionTimeoutHandler.current && leading && !leadingCall.current) {
            debouncedFunction.current.apply(debouncedFunction, args);
            leadingCall.current = true;
        }
        functionTimeoutHandler.current = setTimeout(function() {
            var shouldCallFunction = true;
            if (leading && leadingCall.current) shouldCallFunction = false;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current && trailing && shouldCallFunction) debouncedFunction.current.apply(debouncedFunction, args);
        }, delay);
        if (maxWait && !maxWaitHandler.current && trailing) maxWaitHandler.current = setTimeout(function() {
            var args = maxWaitArgs.current;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current) debouncedFunction.current.apply(null, args);
        }, maxWait);
    }, [
        maxWait,
        delay,
        cancelDebouncedCallback,
        leading,
        trailing
    ]);
    var callPending = (0, $5uXOq.useCallback)(function() {
        // Call pending callback only if we have anything in our queue
        if (!functionTimeoutHandler.current) return;
        debouncedFunction.current.apply(null, maxWaitArgs.current);
        cancelDebouncedCallback();
    }, [
        cancelDebouncedCallback
    ]);
    // At the moment, we use 3 args array so that we save backward compatibility
    return [
        debouncedCallback,
        cancelDebouncedCallback,
        callPending
    ];
}

});

parcelRegister("xJtdX", function(module, exports) {

$parcel$export(module.exports, "fireCmdbErrorAnalytics", () => $f8d3fdda5fdae8d1$export$50d4fa14efd248c2);

var $jcw0u = parcelRequire("jcw0u");
const $f8d3fdda5fdae8d1$export$50d4fa14efd248c2 = (payload)=>{
    return (0, $jcw0u.default)(payload);
};

});

parcelRegister("cRoHr", function(module, exports) {

$parcel$export(module.exports, "EMPTY_VALIDATED_IQL", () => $bc2b5e367b7787bf$export$f3e6582beacb59ad);

var $37FS5 = parcelRequire("37FS5");
const $bc2b5e367b7787bf$export$f3e6582beacb59ad = (0, $37FS5.toValidatedIql)('');

});
parcelRegister("37FS5", function(module, exports) {

$parcel$export(module.exports, "toValidatedIql", () => $28f916d7fdaefd86$export$d2a6b8af2abc27c3);
const $28f916d7fdaefd86$export$d2a6b8af2abc27c3 = (value)=>value;

});


parcelRegister("gWyXT", function(module, exports) {

$parcel$export(module.exports, "validateQlQuery", () => $1672ef31ad7dfd39$export$24689a54c49a777b);

var $4VpwK = parcelRequire("4VpwK");

var $edWc4 = parcelRequire("edWc4");

var $37FS5 = parcelRequire("37FS5");
const $1672ef31ad7dfd39$export$24689a54c49a777b = async ({ workspaceId: workspaceId, unvalidatedIql: unvalidatedIql })=>{
    const queryLanguageKey = 'qlQuery';
    const { isValid: isValid, errorMessages: errorMessages } = await (0, $4VpwK.performCmdbPostRequest)((0, $edWc4.getCmdbQueryLanguageValidateUrl)(workspaceId), {
        body: JSON.stringify({
            context: 'ADVANCED_SEARCH',
            [queryLanguageKey]: unvalidatedIql
        })
    });
    if (isValid) return {
        type: 'valid',
        validatedIql: (0, $37FS5.toValidatedIql)(unvalidatedIql)
    };
    return {
        type: 'invalid',
        error: errorMessages.join('')
    };
};

});
parcelRegister("edWc4", function(module, exports) {

$parcel$export(module.exports, "getCmdbQueryLanguageValidateUrl", () => $8f2de452b6803446$export$d8f39b0cf0b8673e);

var $klJ8b = parcelRequire("klJ8b");
const $8f2de452b6803446$var$getCmdbQueryLanguageUrl = (workspaceId)=>`${(0, $klJ8b.getCmdbRestBaseUrl)(workspaceId)}/aql`;
const $8f2de452b6803446$export$d8f39b0cf0b8673e = (workspaceId)=>`${$8f2de452b6803446$var$getCmdbQueryLanguageUrl(workspaceId)}/validate`;

});
parcelRegister("klJ8b", function(module, exports) {

$parcel$export(module.exports, "getCmdbRestBaseUrl", () => $a22cc15ea8014e15$export$28b6c003daedf1c2);
const $a22cc15ea8014e15$export$28b6c003daedf1c2 = (workspaceId)=>`/gateway/api/jsm/assets/workspace/${workspaceId}/v1`;

});




parcelRegister("j36MG", function(module, exports) {

$parcel$export(module.exports, "default", () => $31524c12a79f7726$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $31524c12a79f7726$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    formatLabelMessage: {
        "id": "jql-builder-basic.jql-editor.field.text-area-picker.aql-picker-popup.format-label-message",
        "defaultMessage": "AQL Query"
    },
    textAreaPlaceholder: {
        "id": "jql-builder-basic.jql-editor.field.text-area-picker.aql-picker-popup.text-area-placeholder",
        "defaultMessage": "Enter AQL Search"
    },
    aqlValidationInProgressMessage: {
        "id": "jql-builder-basic.jql-editor.field.text-area-picker.aql-picker-popup.aql-validation-in-progress-message",
        "defaultMessage": "Validating AQL..."
    },
    inValidAqlErrorMessage: {
        "id": "jql-builder-basic.jql-editor.field.text-area-picker.aql-picker-popup.in-valid-aql-error-message",
        "defaultMessage": "Please enter a valid AQL query"
    },
    aqlSyntaxHelpLinkLabel: {
        "id": "jql-builder-basic.jql-editor.field.text-area-picker.aql-picker-popup.aql-syntax-help-link-label",
        "defaultMessage": "Assets Query Language syntax help"
    },
    unableToValidateAqlErrorMessage: {
        "id": "jql-builder-basic.jql-editor.field.text-area-picker.aql-picker-popup.unable-to-validate-aql-error-message",
        "defaultMessage": "Unable to validate AQL query"
    },
    retry: {
        "id": "jql-builder-basic.jql-editor.field.text-area-picker.aql-picker-popup.retry",
        "defaultMessage": "Retry"
    }
});

});


parcelRegister("cGGWn", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4feca315f3fb3c5$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1sXeC = parcelRequire("1sXeC");

var $kgoHi = parcelRequire("kgoHi");
var $cgL5K = parcelRequire("cgL5K");

var $koVbs = parcelRequire("koVbs");

var $4yuwq = parcelRequire("4yuwq");

var $18zMx = parcelRequire("18zMx");

var $jgJNO = parcelRequire("jgJNO");


var $4Hz9T = parcelRequire("4Hz9T");

var $1QYvD = parcelRequire("1QYvD");

var $8FFny = parcelRequire("8FFny");
const $b4feca315f3fb3c5$export$957d7daebd899f12 = (label, value)=>{
    if (value === null || value === undefined || !value.length) return label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: "inherit",
        as: "strong"
    }, label), ":\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b4feca315f3fb3c5$var$ValueWrapper, null, value));
};
const $b4feca315f3fb3c5$export$8ca1a6c3a31e7665 = ({ fieldId: fieldId, fieldDisplayName: fieldDisplayName, isOpen: isOpen, onOpen: onOpen, onClose: onClose, onClear: onClear, onChange: onChange, onSendOptionAnalytics: onSendOptionAnalytics, value: value, fieldDescription: fieldDescription, isIrremovable: isIrremovable })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)(); /**
                  * Note - despite the name, this actually handles the onClick
                  * of the 'Update' button that appears in the footer of the picker content,
                  * it does not get called on a change event
                  */ 
    const handleOnChange = (0, $5uXOq.useCallback)((inputValue)=>{
        onChange(inputValue);
        onClose();
        onSendOptionAnalytics && onSendOptionAnalytics({
            searchStringLength: inputValue.length
        });
    }, [
        onChange,
        onClose,
        onSendOptionAnalytics
    ]);
    const handleOnTriggerClick = (0, $5uXOq.useCallback)(()=>{
        isOpen ? onClose() : onOpen();
    }, [
        isOpen,
        onClose,
        onOpen
    ]);
    const getNumberPickerErrorMessage = (0, $5uXOq.useCallback)((inputValue)=>{
        if ((0, $1QYvD.isUnsubmittedValueNotANumber)(inputValue)) return formatMessage((0, $8FFny.default).validNumberErrorMessage);
         // this assumes that value is a valid number
        if ((0, $1QYvD.isUnsubmittedNumberTooLarge)((0, (/*@__PURE__*/$parcel$interopDefault($1sXeC)))(inputValue))) return formatMessage((0, $8FFny.default).numberSizeLimitErrorMessage, {
            maxSize: (0, $ae4efb9f19844b8c$export$3aefefab9ae0beef).toLocaleString()
        });
    }, [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        key: fieldId,
        placement: "bottom-start",
        isOpen: isOpen,
        onClose: onClose,
        popupComponent: (0, $4yuwq.FixedWidthPopupComponent),
        shouldRenderToParent: true,
        messageId: "jql-builder-basic.ui.jql-editor.field.text-area-picker.number-picker-popup.popup",
        messageType: "transactional",
        trigger: ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Hz9T.default), {
                isInvalid: false,
                isSelected: isOpen,
                hasValues: !!value,
                onClick: handleOnTriggerClick,
                onClear: onClear,
                ref: ref,
                testId: `jql-builder-basic.ui.jql-editor.number.filter-button.${fieldId}`,
                fieldDescription: fieldDescription,
                isIrremovable: isIrremovable
            }, $b4feca315f3fb3c5$export$957d7daebd899f12(fieldDisplayName, value)),
        content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $18zMx.default), {
                value: value || '',
                getErrorMessage: getNumberPickerErrorMessage,
                setInitialFocusRef: setInitialFocusRef,
                multiline: false,
                onChange: handleOnChange,
                placeholderText: formatMessage((0, $8FFny.default).numberPlaceholderMessage)
            })
    });
};
var $b4feca315f3fb3c5$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $b4feca315f3fb3c5$export$8ca1a6c3a31e7665;
const $b4feca315f3fb3c5$var$ValueWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s _p12fuuw1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8FFny", function(module, exports) {

$parcel$export(module.exports, "default", () => $04cfe396908c1f41$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $04cfe396908c1f41$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    numberPlaceholderMessage: {
        "id": "jql-builder-basic.jql-editor.field.text-area-picker.number-picker-popup.number-placeholder-message",
        "defaultMessage": "Enter a number"
    },
    validNumberErrorMessage: {
        "id": "jql-builder-basic.jql-editor.field.text-area-picker.number-picker-popup.valid-number-error-message",
        "defaultMessage": "Please enter a valid number"
    },
    numberSizeLimitErrorMessage: {
        "id": "jql-builder-basic.jql-editor.field.text-area-picker.number-picker-popup.number-size-limit-error-message",
        "defaultMessage": "Specify a number for the custom field (below {maxSize})"
    }
});

});


parcelRegister("i8ykz", function(module, exports) {

$parcel$export(module.exports, "default", () => $64c2bb374629e55e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $kgoHi = parcelRequire("kgoHi");
var $cgL5K = parcelRequire("cgL5K");

var $koVbs = parcelRequire("koVbs");

var $4yuwq = parcelRequire("4yuwq");

var $18zMx = parcelRequire("18zMx");

var $5fc53 = parcelRequire("5fc53");

var $jgJNO = parcelRequire("jgJNO");

var $8OILN = parcelRequire("8OILN");

var $4Hz9T = parcelRequire("4Hz9T");


var $86amz = parcelRequire("86amz");

var $3iHIw = parcelRequire("3iHIw");
const $64c2bb374629e55e$export$957d7daebd899f12 = (label, value)=>{
    if (value === null || value === undefined || !value.length) return label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: "inherit",
        as: "strong"
    }, label), ': "', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($64c2bb374629e55e$var$ValueWrapper, null, value), '"');
};
const $64c2bb374629e55e$export$3f65fe93ad5d48a1 = ({ fieldId: fieldId, fieldDisplayName: fieldDisplayName, propType: propType, fieldType: fieldType, isOpen: isOpen, onOpen: onOpen, onClose: onClose, onClear: onClear, onChange: onChange, onSendOptionAnalytics: onSendOptionAnalytics, value: value, fieldDescription: fieldDescription, isIrremovable: isIrremovable })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)(); /**
                  * Note - despite the name, this actually handles the onClick
                  * of the 'Update' button that appears in the footer of the picker content,
                  * it does not get called on a change event
                  */ 
    const handleOnChange = (0, $5uXOq.useCallback)((inputValue)=>{
        onChange(inputValue);
        onClose();
        onSendOptionAnalytics && onSendOptionAnalytics({
            searchStringLength: inputValue.length
        });
    }, [
        onChange,
        onClose,
        onSendOptionAnalytics
    ]);
    const handleOnTriggerClick = (0, $5uXOq.useCallback)(()=>{
        isOpen ? onClose() : onOpen();
    }, [
        isOpen,
        onClose,
        onOpen
    ]);
    const getTextAreaPickerErrorMessage = (0, $5uXOq.useCallback)((inputValue)=>{
        if ((fieldType === (0, $5fc53.TEXT_READONLY_CF_TYPE) || fieldType === (0, $5fc53.TEXT_CF_TYPE) || propType === (0, $8OILN.TextAreaPropTypes).ExactText) && (0, $3iHIw.isUnsubmittedValueTooLong)(inputValue)) return formatMessage((0, $86amz.default).characterLimitErrorMessage, {
            maxChars: (0, $ca04556aaad67c2f$export$bfd6231f3a02692b)
        });
        if (fieldType === (0, $5fc53.URL_CF_TYPE) && !(0, $3iHIw.isValidUrl)(inputValue)) return formatMessage((0, $86amz.default).invalidUrlErrorMessage);
        return undefined;
    }, [
        fieldType,
        formatMessage,
        propType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        key: fieldId,
        placement: "bottom-start",
        isOpen: isOpen,
        onClose: onClose,
        popupComponent: (0, $4yuwq.FixedWidthPopupComponent),
        shouldRenderToParent: true,
        messageId: "jql-builder-basic.ui.jql-editor.field.text-area-picker.text-area-picker-popup.popup",
        messageType: "transactional",
        trigger: ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Hz9T.default), {
                isInvalid: false,
                isSelected: isOpen,
                hasValues: !!value,
                onClick: handleOnTriggerClick,
                onClear: onClear,
                ref: ref,
                testId: `jql-builder-basic.ui.jql-editor.text-area.filter-button.${fieldId}`,
                fieldDescription: fieldDescription,
                isIrremovable: isIrremovable
            }, $64c2bb374629e55e$export$957d7daebd899f12(fieldDisplayName, value)),
        content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $18zMx.default), {
                setInitialFocusRef: setInitialFocusRef,
                value: value || '',
                getErrorMessage: getTextAreaPickerErrorMessage,
                onChange: handleOnChange,
                multiline: fieldType !== (0, $5fc53.URL_CF_TYPE)
            })
    });
};
var $64c2bb374629e55e$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $64c2bb374629e55e$export$3f65fe93ad5d48a1;
const $64c2bb374629e55e$var$ValueWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s _p12fuuw1",
            __cmplp.className
        ])
    });
});

});
const $ca04556aaad67c2f$export$bfd6231f3a02692b = 255;

parcelRegister("86amz", function(module, exports) {

$parcel$export(module.exports, "default", () => $df1e812e7fe04eff$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $df1e812e7fe04eff$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    characterLimitErrorMessage: {
        "id": "jql-builder-basic.jql-editor.field.text-area-picker.text-area-picker-popup.character-limit-error-message",
        "defaultMessage": "You've reached the character limit ({maxChars})"
    },
    invalidUrlErrorMessage: {
        "id": "jql-builder-basic.jql-editor.field.text-area-picker.text-area-picker-popup.invalid-url-error-message",
        "defaultMessage": "Please enter a valid URL."
    }
});

});

parcelRegister("3iHIw", function(module, exports) {

$parcel$export(module.exports, "isUnsubmittedValueTooLong", () => $2194207fb00f8d27$export$6db449563fc820c1);
$parcel$export(module.exports, "isValidUrl", () => $2194207fb00f8d27$export$bef94a5618bf18bf);

const $2194207fb00f8d27$export$6db449563fc820c1 = (unsubmittedValue)=>unsubmittedValue.length > (0, $ca04556aaad67c2f$export$bfd6231f3a02692b);
const $2194207fb00f8d27$export$bef94a5618bf18bf = (url)=>{
    // empty string is valid
    if (url === '') return true;
    try {
        new URL(url);
        return true;
    } catch (e) {
        return false;
    }
};

});


parcelRegister("lhV7D", function(module, exports) {

$parcel$export(module.exports, "getUpdatedJql", () => $29753dc45ae5b55e$export$1625bb7ada97d007);
$parcel$export(module.exports, "getUpdatedJqlWithAql", () => $29753dc45ae5b55e$export$bfbecae194e14c6f);
$parcel$export(module.exports, "getAqlFromClause", () => $29753dc45ae5b55e$export$dfeec2a4cb0aae8b);

var $iEIQF = parcelRequire("iEIQF");
var $l0V05 = parcelRequire("l0V05");

var $5Dsab = parcelRequire("5Dsab");

var $1dTaH = parcelRequire("1dTaH");
const $29753dc45ae5b55e$var$createTerminalClause = (fieldId, value, operator)=>// TODO: escapeBackslashes serves as a temporary patch to convert jqlTerm into a format suitable for creator API.
    // EM-6563 should resolve this by updating creator API to accept the semantic JQL value for jqlTerm currently returned by hydrateJqlQuery.
    (0, $iEIQF.default).terminalClause((0, $iEIQF.default).field((0, $1dTaH.escapeBackslashes)(fieldId)), (0, $iEIQF.default).operator(operator), (0, $iEIQF.default).byText.valueOperand((0, $1dTaH.wrapWithQuotes)((0, $1dTaH.escapeBackslashes)(value))));
const $29753dc45ae5b55e$export$1625bb7ada97d007 = (ast, clause, fieldId, value, operator)=>{
    if (!clause) {
        if (!value || !ast.query) return ast.represents;
        ast.query.appendClause($29753dc45ae5b55e$var$createTerminalClause(fieldId, value, operator), (0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97));
    } else if (!value) clause.remove();
    else {
        if (clause.clauseType === (0, $e9a0ef16a223cbc7$export$ae56b4ef248a2b6a) && clause.operand?.operandType === (0, $49b29ef7baa2a152$export$38accfc5a5d1c113) && clause.operand.value === value && clause.operator?.value === operator) // If the clause already exists and the value is the same, return the original JQL
        // without modifying the AST. This is to prevent the introduction of stale clause objects.
        return ast.represents;
        clause.replace($29753dc45ae5b55e$var$createTerminalClause(fieldId, value, operator));
    }
    return (0, $l0V05.print)(ast, {
        operatorCase: 'upper'
    });
};
const $29753dc45ae5b55e$var$createAqlTerminalClause = (fieldId, value, operator)=>// TODO: escapeBackslashes serves as a temporary patch to convert jqlTerm into a format suitable for creator API.
    // EM-6563 should resolve this by updating creator API to accept the semantic JQL value for jqlTerm currently returned by hydrateJqlQuery.
    (0, $iEIQF.default).terminalClause((0, $iEIQF.default).field((0, $1dTaH.escapeBackslashes)(fieldId)), (0, $iEIQF.default).operator(operator), // Confirmed with the team that they prefer to use aqlFunction instead of iqlFunction
    (0, $iEIQF.default).byText.valueOperand(`${(0, $5Dsab.AQL_FUNCTION_NAME)}(${(0, $1dTaH.wrapWithQuotes)((0, $1dTaH.escapeBackslashes)(value))})`));
const $29753dc45ae5b55e$export$bfbecae194e14c6f = (ast, clause, fieldId, value, operator)=>{
    if (!clause) {
        if (!value || !ast.query) return ast.represents;
        ast.query.appendClause($29753dc45ae5b55e$var$createAqlTerminalClause(fieldId, value, operator), (0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97));
    } else if (!value) clause.remove();
    else {
        if ($29753dc45ae5b55e$export$dfeec2a4cb0aae8b(clause) === value && clause.operator?.value === operator) // If the clause already exists and the value is the same, return the original JQL
        // without modifying the AST. This is to prevent the introduction of stale clause objects.
        return ast.represents;
        clause.replace($29753dc45ae5b55e$var$createAqlTerminalClause(fieldId, value, operator));
    }
    return (0, $l0V05.print)(ast, {
        operatorCase: 'upper'
    });
};
const $29753dc45ae5b55e$export$dfeec2a4cb0aae8b = (clause)=>clause && clause.clauseType === (0, $e9a0ef16a223cbc7$export$ae56b4ef248a2b6a) && clause.operand && clause.operand.operandType === (0, $49b29ef7baa2a152$export$19c7c729db381f9d) && (clause.operand.function.value.toLowerCase() === (0, $5Dsab.AQL_FUNCTION_NAME).toLowerCase() || clause.operand.function.value.toLowerCase() === (0, $5Dsab.IQL_FUNCTION_NAME).toLowerCase()) && clause.operand.arguments[0].value || '';

});


parcelRegister("6OkIx", function(module, exports) {

$parcel$export(module.exports, "UnsupportedPickerWrapper", () => $0f6f4d78146098db$export$7b689f7721b0be1f);

var $5uXOq = parcelRequire("5uXOq");

var $cgL5K = parcelRequire("cgL5K");

var $92Z2l = parcelRequire("92Z2l");
var $ctz0s = parcelRequire("ctz0s");

var $koVbs = parcelRequire("koVbs");

var $4yuwq = parcelRequire("4yuwq");

var $eWn4R = parcelRequire("eWn4R");

var $jgJNO = parcelRequire("jgJNO");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4Hz9T = parcelRequire("4Hz9T");

var $kG16F = parcelRequire("kG16F");

var $IPsUR = parcelRequire("IPsUR");
const $0f6f4d78146098db$export$7b689f7721b0be1f = ({ activePopupKey: activePopupKey, clause: clause, fieldId: fieldId, fieldLabel: fieldLabel, fieldDescription: fieldDescription, onClose: onClose, onOpen: onOpen, onClear: onClear, onSwitchToJql: onSwitchToJql })=>{
    const isOpen = activePopupKey === fieldId;
    const handleOnTriggerClick = (0, $5uXOq.useCallback)(()=>isOpen ? onClose() : onOpen(), [
        isOpen,
        onClose,
        onOpen
    ]);
    const [ast] = (0, $kG16F.useAST)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onSwitchToJqlWrapper = (0, $5uXOq.useCallback)(()=>{
        if (onSwitchToJql) {
            onSwitchToJql();
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'jqlBuilderBasicUnsupportedField', {});
        }
    }, [
        createAnalyticsEvent,
        onSwitchToJql
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        key: fieldId,
        placement: "bottom-start",
        isOpen: isOpen,
        onClose: onClose,
        popupComponent: (0, $4yuwq.FixedWidthPopupComponent),
        shouldRenderToParent: true,
        messageId: "jql-builder-basic.ui.jql-editor.field.unsupported-picker-wrapper.popup",
        messageType: "transactional",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Hz9T.default), {
                ...triggerProps,
                isInvalid: false,
                isSelected: isOpen,
                hasValues: !!clause,
                onClick: handleOnTriggerClick,
                onClear: ()=>onClear(clause ? (0, $eWn4R.default)(ast, clause) : undefined),
                testId: `jql-builder-basic.ui.jql-editor.picker.filter-button.${fieldId}`,
                fieldDescription: fieldDescription
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                color: "inherit",
                weight: "medium"
            }, clause ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                as: "strong"
            }, fieldLabel) : fieldLabel)),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
                actions: onSwitchToJql ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctz0s.default), {
                    onClick: onSwitchToJqlWrapper
                }, formatMessage((0, $IPsUR.default).switchToJql)) : undefined
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                as: "p"
            }, formatMessage((0, $IPsUR.default).messageToCustomer, {
                fieldLabel: fieldLabel,
                b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, chunks)
            })))
    });
};
var $0f6f4d78146098db$export$2e2bcd8739ae039 = $0f6f4d78146098db$export$7b689f7721b0be1f;

});
parcelRegister("ctz0s", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e844da07d79ea04$export$2e2bcd8739ae039);
/* section-message-action.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $5McnS = parcelRequire("5McnS");
var $MHKc7 = parcelRequire("MHKc7");
var $3Lty3 = parcelRequire("3Lty3");
const $2e844da07d79ea04$var$styles = {
    common: "_11c82smr _syaz14q2 _k48p1wq8 _30l314q2 _9h8h16c2",
    anchor: "_1053w7te _9oik18uv _1bnx8stv _jf4cnqa1 _n0fxw7te _1vhvg3x0",
    pressable: "_bfhk1w7a _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _9oik18uv _1bnx8stv _jf4cnqa1"
};
/**
 * __Section message action__
 *
 * A section message action is designed to work with the `action` prop from
 * `SectionMessage`. It renders either a button or a link depending on whether
 * an `onClick` or `href` prop is supplied, with a dot separator in between actions.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples#actions)
 */ const $2e844da07d79ea04$var$SectionMessageAction = /*#__PURE__*/ (0, $5uXOq.memo)(function SectionMessageAction({ children: children, onClick: onClick, href: href, testId: testId, linkComponent: linkComponent }) {
    if (!linkComponent && (0, $VSDnB.fg)('platform_section_message_action_migration')) {
        if (href) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5McnS.default), {
            testId: testId,
            onClick: onClick,
            href: href,
            xcss: (0, $3JT92.cx)($2e844da07d79ea04$var$styles.common, $2e844da07d79ea04$var$styles.anchor),
            children: children
        });
        if (onClick) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
            testId: testId,
            onClick: onClick,
            xcss: (0, $3JT92.cx)($2e844da07d79ea04$var$styles.common, $2e844da07d79ea04$var$styles.pressable),
            children: children
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            as: "span",
            testId: testId,
            children: children
        });
    }
    return onClick || href ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
        testId: testId,
        appearance: "link",
        spacing: "none",
        onClick: onClick,
        href: href,
        component: href ? linkComponent : undefined,
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
});
var $2e844da07d79ea04$export$2e2bcd8739ae039 = $2e844da07d79ea04$var$SectionMessageAction;

});

parcelRegister("IPsUR", function(module, exports) {

$parcel$export(module.exports, "default", () => $136377dba3587346$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $136377dba3587346$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    all: {
        "id": "jql-builder-basic.jql-editor.field.unsupported-picker-wrapper.all",
        "defaultMessage": "All"
    },
    switchToJql: {
        "id": "jql-builder-basic.jql-editor.field.unsupported-picker-wrapper.switch-to-jql",
        "defaultMessage": "Switch to JQL"
    },
    messageToCustomer: {
        "id": "jql-builder-basic.jql-editor.field.unsupported-picker-wrapper.message-to-customer",
        "defaultMessage": "To search by <b>{fieldLabel}</b>."
    }
});

});



parcelRegister("cm9Cg", function(module, exports) {

$parcel$export(module.exports, "default", () => $6338eaf06f5c720a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $22Gxp = parcelRequire("22Gxp");

var $iEIQF = parcelRequire("iEIQF");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $kM5F6 = parcelRequire("kM5F6");

var $jgJNO = parcelRequire("jgJNO");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $bRlQB = parcelRequire("bRlQB");

var $98azu = parcelRequire("98azu");

var $df3tg = parcelRequire("df3tg");

var $f1i4L = parcelRequire("f1i4L");

var $hq3To = parcelRequire("hq3To");

var $epfOY = parcelRequire("epfOY");
const $6338eaf06f5c720a$export$d9f1e39ff1ffb511 = 'ORDER_BY_DROPDOWN';
/**
 * Replaces the default container element that wraps the picker content
 * so we can control its css properties
 */ const $6338eaf06f5c720a$var$CustomPopupComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, 'data-testid': testId, xcss: _xcss, ...props }, ref)=>// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $6338eaf06f5c720a$var$containerStyle,
        testId: testId,
        ...props,
        ref: ref
    }, children));
const $6338eaf06f5c720a$var$OrderByPicker = ({ ast: ast, onChange: onChange, contextJql: contextJql, hydrationData: hydrationData, viewContext: viewContext, scope: scope })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [internalSelectedFields, setInternalSelectedFields] = (0, $5uXOq.useState)(()=>(0, $epfOY.getNextSelectedOrderByFields)({
            ast: ast,
            hydrationData: hydrationData,
            selectedOrderByFields: []
        }));
    const firePickerAnalytics = (0, $5uXOq.useCallback)((isOpen, orderByFieldCount)=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'clicked',
            actionSubject: 'dropdownMenu',
            actionSubjectId: 'orderByPicker',
            attributes: {
                isOpen: isOpen,
                orderByFieldCount: // So we can determine if the add field button needs to be
                // repositioned as long lists of fields mean it is needing to be
                // scrolled to
                orderByFieldCount
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    const [activePopupKey, { openPopup: openPopup, closePopup: closePopup }] = (0, $98azu.useActivePopupKey)();
    const onOpen = (0, $5uXOq.useCallback)(()=>{
        openPopup($6338eaf06f5c720a$export$d9f1e39ff1ffb511);
        firePickerAnalytics(true, internalSelectedFields.length);
    }, [
        firePickerAnalytics,
        internalSelectedFields.length,
        openPopup
    ]);
    const onClose = (0, $5uXOq.useCallback)(()=>{
        firePickerAnalytics(false, internalSelectedFields.length);
        closePopup($6338eaf06f5c720a$export$d9f1e39ff1ffb511);
    }, [
        closePopup,
        firePickerAnalytics,
        internalSelectedFields.length
    ]);
    const isOpen = activePopupKey === $6338eaf06f5c720a$export$d9f1e39ff1ffb511;
    const buttonId = (0, $22Gxp.useUID)();
    /**
	 * Popup does not want to close when users click browser back / forward buttons so manually
	 * compare the AST fields to the fields in the internal state, if they differ, the JQL was changed
	 * by an external action, so close the picker.
	 */ (0, $5uXOq.useEffect)(()=>{
        const astSortFields = (0, $f1i4L.getAstSortFields)(ast);
        const isInternalChange = (0, $epfOY.compareSortFields)(astSortFields, internalSelectedFields);
        if (!isInternalChange) onClose();
    }, [
        ast,
        internalSelectedFields,
        onClose
    ]);
    /**
	 * Changes to sort fields can come from internal (user interacting with the picker) or external
	 * (jql is changed by other means such as clicking a filter or browser back button). This means
	 * the picker needs to handle both scenarios and update the UI accordingly. This is achieved by
	 * comparing the ast, hydration data and what is currently internally tracked and deciding which
	 * sort fields to set in the next state
	 */ (0, $5uXOq.useEffect)(()=>{
        setInternalSelectedFields((currentInternalSelectedFields)=>(0, $epfOY.getNextSelectedOrderByFields)({
                ast: ast,
                hydrationData: hydrationData,
                selectedOrderByFields: currentInternalSelectedFields
            }));
    }, [
        ast,
        hydrationData
    ]);
    /**
	 * any currently selected field becomes an excluded field so that duplicates cannot be selected
	 * in the picker(s)
	 */ const excludedFields = internalSelectedFields.map((selctedOrderByField)=>selctedOrderByField.jqlTerm);
    /**
	 * each rendered basic-picker within OrderBySelect uses this to fetch the picker options
	 */ const onLoadOptions = (0, $df3tg.useFields)({
        jql: contextJql,
        excludeFields: excludedFields,
        forClause: 'ORDER_BY',
        viewContext: viewContext,
        scope: scope
    });
    /**
	 * attaches to a container element that wraps the picker and will prevent Esc key presses
	 * bubbling outside of the picker.
	 * This is needed for times when the picker might be rendered in a modal and we want
	 * users to be able to press Esc to close the picker, without also closing the modal.
	 */ const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
        if (event.key === 'Escape') {
            isOpen && event.stopPropagation();
            onClose();
        }
    }, [
        isOpen,
        onClose
    ]);
    /**
	 * Called each time the OrderBySelect fields change, are added or removed.
	 * This handler will take the new fields object, use it to update the ast which is printed to a
	 * string and passed to the onChange callback to trigger a new search
	 */ const handleOnChange = (0, $5uXOq.useCallback)((fields)=>{
        // If users have clicked the same option from a picker, no need to trigger a whole new
        // search
        const shouldUpdate = !(0, $epfOY.compareSortFields)(internalSelectedFields, fields);
        if (shouldUpdate) {
            // Set the internal state so changes a immediately visible (optimistic update)
            setInternalSelectedFields(fields);
            // Trigger a new search as a side effect this will then be handled in the useEffects
            if (ast.query) {
                ast.query.replaceOrderBy((0, $iEIQF.default).orderBy(fields.map((f)=>(0, $iEIQF.default).orderByField((0, $iEIQF.default).field(f.jqlTerm), f.direction ? (0, $iEIQF.default).orderByDirection(f.direction) : undefined))));
                onChange((0, $epfOY.printJast)(ast));
            }
        }
    }, [
        ast,
        internalSelectedFields,
        onChange
    ]);
    const handleOnClearAllFields = (0, $5uXOq.useCallback)(()=>{
        setInternalSelectedFields([]);
        if (ast.query) {
            ast.query.removeOrderBy();
            onChange((0, $epfOY.printJast)(ast));
        }
    }, [
        ast,
        onChange
    ]);
    const renderContent = (0, $5uXOq.useCallback)(({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $6338eaf06f5c720a$var$menuStyle,
            role: "presentation",
            ref: setInitialFocusRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kM5F6.default), {
            fields: internalSelectedFields,
            onLoadPickerOptions: onLoadOptions,
            onChange: handleOnChange
        })), Boolean(internalSelectedFields.length) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hq3To.default), {
            onClear: handleOnClearAllFields
        })), [
        internalSelectedFields,
        onLoadOptions,
        handleOnChange,
        handleOnClearAllFields
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        onKeyDown: handleKeyDown,
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        role: "dialog",
        titleId: buttonId,
        isOpen: isOpen,
        onClose: onClose,
        autoFocus: false,
        shouldRenderToParent: true,
        placement: "bottom-start",
        messageId: "jql-builder-basic.ui.jql-editor.order-by-picker.popup",
        messageType: "transactional",
        popupComponent: $6338eaf06f5c720a$var$CustomPopupComponent,
        content: renderContent,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bRlQB.default), {
                isSelected: isOpen,
                buttonId: buttonId,
                triggerProps: triggerProps,
                numberOfFields: internalSelectedFields.length,
                onClick: isOpen ? onClose : onOpen
            })
    }));
};
var $6338eaf06f5c720a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($6338eaf06f5c720a$var$OrderByPicker);
const $6338eaf06f5c720a$var$containerStyle = (0, $8CUq3.xcss)({
    zIndex: 'layer',
    backgroundColor: 'elevation.surface.overlay',
    boxShadow: 'elevation.shadow.overlay',
    width: '300px',
    borderRadius: 'border.radius'
});
const $6338eaf06f5c720a$var$menuStyle = (0, $8CUq3.xcss)({
    maxHeight: '284px',
    padding: 'space.150',
    paddingLeft: 'space.150',
    overflow: 'auto'
});

});
parcelRegister("kM5F6", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3b3e2e87da32132$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kgoHi = parcelRequire("kgoHi");

var $4hhY1 = parcelRequire("4hhY1");

var $fh6nC = parcelRequire("fh6nC");
const $c3b3e2e87da32132$var$BasicOrderBySelect = ({ fields: fields, onLoadPickerOptions: onLoadPickerOptions, onChange: onChange })=>{
    const onChangeField = (0, $5uXOq.useCallback)((index, field)=>{
        const nextFields = fields.map((currentField, currentIndex)=>index === currentIndex ? {
                ...field
            } : currentField);
        onChange(nextFields);
    }, [
        fields,
        onChange
    ]);
    const onRemoveField = (0, $5uXOq.useCallback)((index)=>{
        const nextFields = fields.filter((currentField, currentIndex)=>index !== currentIndex);
        onChange(nextFields);
    }, [
        fields,
        onChange
    ]);
    const onAddnewField = (0, $5uXOq.useCallback)((field)=>{
        const nextFields = [
            ...fields,
            field
        ];
        onChange(nextFields);
    }, [
        fields,
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        gap: "space.100",
        direction: "column"
    }, fields.map((field, fieldIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fh6nC.default), {
            key: fieldIndex,
            field: field,
            fieldIndex: fieldIndex,
            onChange: onChangeField,
            onLoadOptions: onLoadPickerOptions,
            onRemove: onRemoveField
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4hhY1.default), {
        onLoadOptions: onLoadPickerOptions,
        onSelectField: onAddnewField
    }));
};
var $c3b3e2e87da32132$export$2e2bcd8739ae039 = $c3b3e2e87da32132$var$BasicOrderBySelect;

});
parcelRegister("4hhY1", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a9392a077266f8e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");


var $kgoHi = parcelRequire("kgoHi");

var $koVbs = parcelRequire("koVbs");

var $211Xh = parcelRequire("211Xh");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $cSD7y = parcelRequire("cSD7y");

var $a7uqQ = parcelRequire("a7uqQ");

var $5gV63 = parcelRequire("5gV63");

var $i3Ebq = parcelRequire("i3Ebq");
const $7a9392a077266f8e$var$FIELD_ID = 'add-order-by-field';
const $7a9392a077266f8e$var$VALUE = [];
const $7a9392a077266f8e$var$AddFieldPickerOld = ({ onLoadOptions: onLoadOptions, onSelectField: onSelectField })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const handleTriggerClick = (0, $5uXOq.useCallback)((e)=>{
        e.preventDefault();
        setIsOpen((currentisOpen)=>{
            const newOpenState = !currentisOpen;
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: 'dropdownMenu',
                actionSubjectId: 'addOrderByFieldPicker',
                attributes: {
                    isOpen: newOpenState
                }
            });
            return newOpenState;
        });
    }, [
        createAnalyticsEvent
    ]);
    const handlePickerCloseClick = (0, $5uXOq.useCallback)((e)=>{
        e.preventDefault();
        setIsOpen(false);
    }, []);
    const handleFieldChanged = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
        // @ts-expect-error TS inference not working with the SelectedValue type
        // despite explicit checks it always still thinks it might be an array or null
        // not sure of the root cause whether type defs in
        // jira/src/packages/jql-builder/basic-picker/src/common/types.tsx or TS issue at
        // the platform level
        if (newValue === null || Array.isArray(newValue) || !newValue.value || !newValue.label) return null;
        if (actionMeta.action === 'select-option') {
            const updatedField = {
                // @ts-expect-error see above
                displayText: newValue.label,
                // @ts-expect-error see above
                jqlTerm: newValue.value,
                direction: (0, $9f1dbb2b39d4d9a2$export$6d60017b9e092e73)
            };
            onSelectField(updatedField);
            setIsOpen(false);
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'changed',
                actionSubject: 'selectOption'
            }), 'addOrderByFieldPicker');
        }
    }, [
        createAnalyticsEvent,
        onSelectField
    ]);
    const onPickerTrigger = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a7uqQ.default), {
            ariaLabel: formatMessage((0, $i3Ebq.default).addFieldDisplayText),
            triggerProps: triggerProps,
            displayText: formatMessage((0, $i3Ebq.default).addFieldDisplayText),
            onClick: handleTriggerClick,
            isOpen: isOpen
        }), [
        formatMessage,
        handleTriggerClick,
        isOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $211Xh.Picker), {
        isMulti: false,
        isOpen: isOpen,
        id: $7a9392a077266f8e$var$FIELD_ID,
        value: $7a9392a077266f8e$var$VALUE,
        onTrigger: onPickerTrigger,
        onClose: handlePickerCloseClick,
        onChange: handleFieldChanged,
        onLoadOptions: onLoadOptions,
        shouldRenderToParent: true
    }));
};
const $7a9392a077266f8e$var$AddFieldPicker = (0, $cSD7y.componentWithFG)('jql_builder_lazy_picker_to_entrypoint', (0, $5gV63.AddFieldPicker), $7a9392a077266f8e$var$AddFieldPickerOld);
var $7a9392a077266f8e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($7a9392a077266f8e$var$AddFieldPicker);

});
const $9f1dbb2b39d4d9a2$export$ca51f5fd60a74517 = 'ORDER BY';
const $9f1dbb2b39d4d9a2$export$6d60017b9e092e73 = 'ASC';
const $9f1dbb2b39d4d9a2$export$2ea27ea5f2121899 = 'DESC';

parcelRegister("211Xh", function(module, exports) {

$parcel$export(module.exports, "Picker", () => $1262dd3d8e4171bf$export$ba25329847403e11);

var $5uXOq = parcelRequire("5uXOq");

var $1I7E8 = parcelRequire("1I7E8");

var $dC5iT = parcelRequire("dC5iT");

var $4R6GH = parcelRequire("4R6GH");

var $atVFR = parcelRequire("atVFR");

var $fANIs = parcelRequire("fANIs");

var $4yuwq = parcelRequire("4yuwq");
const $1262dd3d8e4171bf$export$ba25329847403e11 = ({ isOpen: isPickerOpen, value: value, onClose: onClose, onClearValues: onClearValues, onRestoreDefaults: onRestoreDefaults, id: id, invalidLabel: invalidLabel, onChange: onChange, formatOptionLabel: formatOptionLabel = (0, $fANIs.default), onLoadOptions: onLoadOptions, enableFullList: enableFullList, operandDisplayValues: operandDisplayValues, showOperandDisplayValuesInFullList: showOperandDisplayValuesInFullList, PopupComponent: PopupComponent, onTrigger: onTrigger, placement: placement = 'bottom-start', zIndex: zIndex, CustomNoOptionsMessage: CustomNoOptionsMessage, pickerComponents: pickerComponents, fallbackPlacements: fallbackPlacements, showOperatorSelect: showOperatorSelect = false, onChangeOperator: onChangeOperator, allowedOperators: allowedOperators, selectedOperator: selectedOperator, isMulti: isMulti, searchInputPlaceholder: searchInputPlaceholder, shouldRenderToParent: shouldRenderToParent = false, experienceAnalyticsAttributes: experienceAnalyticsAttributes, isLoading: isLoading = false, CustomFooter: CustomFooter, isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        role: "presentation",
        onKeyDown: (event)=>{
            if (event.key === 'Escape') {
                // avoid closing a modal on closing a picker with esc key
                isPickerOpen && event.stopPropagation();
                onClose && onClose(event);
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
        key: id,
        zIndex: zIndex,
        placement: placement,
        isOpen: isPickerOpen,
        onClose: onClose,
        popupComponent: PopupComponent ?? (0, $4yuwq.FixedWidthPopupComponent),
        trigger: onTrigger,
        autoFocus: false,
        fallbackPlacements: fallbackPlacements,
        testId: `jql-builder-basic-picker-${id}`,
        shouldRenderToParent: shouldRenderToParent,
        /* Our default popup component supports resizing to fit the viewport. */ shouldFitViewport: PopupComponent === undefined,
        content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $atVFR.default), {
                id: id,
                invalidLabel: invalidLabel,
                enableFullList: enableFullList,
                operandDisplayValues: operandDisplayValues,
                showOperandDisplayValuesInFullList: showOperandDisplayValuesInFullList,
                loadOptions: onLoadOptions,
                onChange: onChange,
                value: value,
                formatOptionLabel: formatOptionLabel,
                onClear: onClearValues,
                onRestoreDefaults: onRestoreDefaults,
                NoOptionsMessage: CustomNoOptionsMessage,
                components: pickerComponents,
                showOperatorSelect: showOperatorSelect,
                onChangeOperator: onChangeOperator,
                allowedOperators: allowedOperators,
                selectedOperator: selectedOperator,
                isMulti: isMulti,
                placeholder: searchInputPlaceholder,
                setInitialFocusRef: setInitialFocusRef,
                experienceAnalyticsAttributes: experienceAnalyticsAttributes,
                isLoading: isLoading,
                isInBetweenColumnPickerEnabled: isInBetweenColumnPickerEnabled,
                CustomFooter: (0, $4R6GH.fg)('jira_inline_field_config_gate') ? CustomFooter : undefined
            })
    }));
$1262dd3d8e4171bf$export$ba25329847403e11.whyDidYouRender = {
    customName: 'Picker'
};
var $1262dd3d8e4171bf$export$2e2bcd8739ae039 = $1262dd3d8e4171bf$export$ba25329847403e11;

});

parcelRegister("a7uqQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $519859d9cc08a45c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $c8Oei = parcelRequire("c8Oei");

var $4R6GH = parcelRequire("4R6GH");
const $519859d9cc08a45c$var$PickerTrigger = ({ triggerProps: triggerProps, displayText: displayText, onClick: onClick, isOpen: isOpen, shouldFitContainer: shouldFitContainer = false, ariaLabel: ariaLabel, triggerRef: triggerRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($519859d9cc08a45c$var$StyledTriggerButton, {
        ...triggerProps,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
            spacing: "spacious",
            label: ""
        }),
        onClick: onClick,
        shouldFitContainer: shouldFitContainer,
        "aria-label": ariaLabel,
        "aria-expanded": isOpen,
        "aria-haspopup": "listbox",
        ...(0, $4R6GH.fg)('jql_builder_lazy_picker_to_entrypoint') ? {
            ref: triggerRef
        } : {}
    }, displayText);
var $519859d9cc08a45c$export$2e2bcd8739ae039 = $519859d9cc08a45c$var$PickerTrigger;
/*
 * Use of jira-jql-builder-basic-picker requires a trigger to be provided as a prop. In jql-builder,
 * atlaskit/button is used as a trigger. However our design spec is based on an atlaskit/select which
 * left aligns text on the trigger. This workaround is left aligning the text so that it looks more
 * like an atlaskit/select trigger.
 * This also restricts us to using legacy button as button/new does not work with `styled()`
 * TODO - https://jplat.jira.atlassian.cloud/browse/EM-7822
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-unsafe-style-overrides
const $519859d9cc08a45c$var$StyledTriggerButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1qpp",
            __cmplp.className
        ])
    });
});

});

parcelRegister("5gV63", function(module, exports) {

$parcel$export(module.exports, "AddFieldPicker", () => $92a314943fae6575$export$8f6a4526207ba288);

var $5uXOq = parcelRequire("5uXOq");


var $kgoHi = parcelRequire("kgoHi");

var $koVbs = parcelRequire("koVbs");

var $F7vyc = parcelRequire("F7vyc");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $a7uqQ = parcelRequire("a7uqQ");

var $i3Ebq = parcelRequire("i3Ebq");
const $92a314943fae6575$var$FIELD_ID = 'add-order-by-field';
const $92a314943fae6575$var$VALUE = [];
const $92a314943fae6575$export$8f6a4526207ba288 = ({ onLoadOptions: onLoadOptions, onSelectField: onSelectField })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const handleTriggerClick = (0, $5uXOq.useCallback)((e)=>{
        e.preventDefault();
        setIsOpen((currentisOpen)=>{
            const newOpenState = !currentisOpen;
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: 'dropdownMenu',
                actionSubjectId: 'addOrderByFieldPicker',
                attributes: {
                    isOpen: newOpenState
                }
            });
            return newOpenState;
        });
    }, [
        createAnalyticsEvent
    ]);
    const handlePickerCloseClick = (0, $5uXOq.useCallback)((e)=>{
        e.preventDefault();
        setIsOpen(false);
    }, []);
    const handleFieldChanged = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
        // @ts-expect-error TS inference not working with the SelectedValue type
        // despite explicit checks it always still thinks it might be an array or null
        // not sure of the root cause whether type defs in
        // jira/src/packages/jql-builder/basic-picker/src/common/types.tsx or TS issue at
        // the platform level
        if (newValue === null || Array.isArray(newValue) || !newValue.value || !newValue.label) return null;
        if (actionMeta.action === 'select-option') {
            const updatedField = {
                // @ts-expect-error see above
                displayText: newValue.label,
                // @ts-expect-error see above
                jqlTerm: newValue.value,
                direction: (0, $9f1dbb2b39d4d9a2$export$6d60017b9e092e73)
            };
            onSelectField(updatedField);
            setIsOpen(false);
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'changed',
                actionSubject: 'selectOption'
            }), 'addOrderByFieldPicker');
        }
    }, [
        createAnalyticsEvent,
        onSelectField
    ]);
    const onPickerTrigger = (0, $5uXOq.useCallback)((triggerProps, triggerRef)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a7uqQ.default), {
            ariaLabel: formatMessage((0, $i3Ebq.default).addFieldDisplayText),
            triggerProps: triggerProps,
            displayText: formatMessage((0, $i3Ebq.default).addFieldDisplayText),
            onClick: handleTriggerClick,
            isOpen: isOpen,
            triggerRef: triggerRef
        }), [
        formatMessage,
        handleTriggerClick,
        isOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $F7vyc.PickerEntryPoint), {
        isMulti: false,
        isOpen: isOpen,
        id: $92a314943fae6575$var$FIELD_ID,
        value: $92a314943fae6575$var$VALUE,
        onTrigger: onPickerTrigger,
        onClose: handlePickerCloseClick,
        onChange: handleFieldChanged,
        onLoadOptions: onLoadOptions,
        shouldRenderToParent: true
    }));
};

});
parcelRegister("i3Ebq", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e68aba17d0161f8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $7e68aba17d0161f8$var$messages = (0, $7VHMR.defineMessages)({
    addFieldDisplayText: {
        "id": "jql-builder-basic-order-by-select.add-field-picker.add-field-display-text",
        "defaultMessage": "Select field"
    }
});
var $7e68aba17d0161f8$export$2e2bcd8739ae039 = $7e68aba17d0161f8$var$messages;

});



parcelRegister("fh6nC", function(module, exports) {

$parcel$export(module.exports, "default", () => $6de3b6002c6b8813$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $hUqzg = parcelRequire("hUqzg");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $211Xh = parcelRequire("211Xh");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $cSD7y = parcelRequire("cSD7y");

var $a7uqQ = parcelRequire("a7uqQ");

var $l2crx = parcelRequire("l2crx");

var $jy8Nw = parcelRequire("jy8Nw");

var $jYRch = parcelRequire("jYRch");

var $3AKNm = parcelRequire("3AKNm");

var $bKfCU = parcelRequire("bKfCU");
const $6de3b6002c6b8813$var$OrderByPickerOld = ({ field: field, fieldIndex: fieldIndex, onChange: onChange, onRemove: onRemove, onLoadOptions: onLoadOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const pickerValue = (0, $5uXOq.useMemo)(()=>[
            {
                optionType: 'option',
                value: field.jqlTerm,
                label: field.displayText
            }
        ], [
        field.displayText,
        field.jqlTerm
    ]);
    const handleRemoveFieldButtonClick = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        e.preventDefault();
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'orderBySelectRemoveFieldClick');
        onRemove(fieldIndex);
    }, [
        fieldIndex,
        onRemove
    ]);
    const handleTriggerClick = (0, $5uXOq.useCallback)((e)=>{
        e.preventDefault();
        setIsOpen((currentisOpen)=>{
            const newOpenState = !currentisOpen;
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: 'dropdownMenu',
                actionSubjectId: 'orderBySelectFieldPicker',
                attributes: {
                    isOpen: newOpenState
                }
            });
            return newOpenState;
        });
    }, [
        createAnalyticsEvent
    ]);
    const handlePickerCloseClick = (0, $5uXOq.useCallback)((e)=>{
        e.preventDefault();
        setIsOpen(false);
    }, []);
    const handleSortDirectionClick = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        e.preventDefault();
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'orderBySelectSortDirectionClick');
        /**
     * It is expected that some order by fields in JQL dont have an explicit direction,
     * E.g. `ORDER BY project` instead of `ORDER BY project ASC`
     * In these cases if the direction is toggled, we add an explicit direction
     */ const updatedField = {
            ...field,
            direction: field.direction ? (0, $jYRch.toggleDirection)(field.direction) : (0, $jy8Nw.FALLBACK_SORT_DIRECTION)
        };
        onChange(fieldIndex, updatedField);
    }, [
        field,
        fieldIndex,
        onChange
    ]);
    const handleFieldChanged = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
        // @ts-expect-error TS inference not working with the SelectedValue type
        // despite explicit checks it always still thinks it might be an array or null
        // not sure of the root cause whether type defs in
        // jira/src/packages/jql-builder/basic-picker/src/common/types.tsx or TS issue at
        // the platform level
        if (newValue === null || Array.isArray(newValue) || !newValue.value || !newValue.label) return null;
        if (actionMeta.action === 'select-option') {
            const updatedField = {
                // @ts-expect-error see above
                displayText: newValue.label,
                // @ts-expect-error see above
                jqlTerm: newValue.value,
                direction: field.direction
            };
            onChange(fieldIndex, updatedField);
            setIsOpen(false);
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'changed',
                actionSubject: 'selectOption'
            }), 'orderByFieldPicker');
        }
    }, [
        createAnalyticsEvent,
        field.direction,
        fieldIndex,
        onChange
    ]);
    const onPickerTrigger = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a7uqQ.default), {
            triggerProps: triggerProps,
            displayText: field.displayText,
            onClick: handleTriggerClick,
            isOpen: isOpen,
            ariaLabel: formatMessage((0, $3AKNm.default).pickerLabel, {
                field: field.displayText
            }),
            shouldFitContainer: true
        }), [
        field.displayText,
        formatMessage,
        handleTriggerClick,
        isOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $6de3b6002c6b8813$var$pickerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $211Xh.Picker), {
        isMulti: false,
        isOpen: isOpen,
        id: `order-by-select-field-${fieldIndex}`,
        value: pickerValue,
        onTrigger: onPickerTrigger,
        onClose: handlePickerCloseClick,
        onChange: handleFieldChanged,
        onLoadOptions: onLoadOptions,
        shouldRenderToParent: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $6de3b6002c6b8813$var$sortButtonContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        position: "bottom",
        content: formatMessage((0, $3AKNm.default).sortButtonTooltip)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            ...tooltipProps,
            onClick: handleSortDirectionClick,
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l2crx.SortDirectionIcon), {
                fieldDisplayText: field.displayText,
                fieldSortDirection: field.direction
            })
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $6de3b6002c6b8813$var$clearButtonContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        position: "bottom",
        content: formatMessage((0, $3AKNm.default).clearButtonTooltip)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            ...tooltipProps,
            appearance: "subtle",
            onClick: handleRemoveFieldButtonClick,
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                as: "span",
                xcss: [
                    $6de3b6002c6b8813$var$iconButtonStyles
                ]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hUqzg))), {
                LEGACY_size: "small",
                label: formatMessage((0, $3AKNm.default).clearButtonLabel, {
                    field: field.displayText
                })
            }))
        }))));
};
const $6de3b6002c6b8813$var$OrderByPicker = (0, $cSD7y.componentWithFG)('jql_builder_lazy_picker_to_entrypoint', (0, $bKfCU.OrderByPicker), $6de3b6002c6b8813$var$OrderByPickerOld);
var $6de3b6002c6b8813$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($6de3b6002c6b8813$var$OrderByPicker);
const $6de3b6002c6b8813$var$sortButtonContainerStyles = (0, $8CUq3.xcss)({
    flex: 'none',
    marginLeft: 'space.075'
});
const $6de3b6002c6b8813$var$clearButtonContainerStyles = (0, $8CUq3.xcss)({
    flex: 'none',
    marginLeft: 'space.150'
});
/**
 * There is a bug with the new Atlaskit IconButton where occasionally the onClick handler is not
 * triggered, when wrapped by a tooltip - https://atlassian.slack.com/archives/CFJ9DU39U/p1718597982581429
 * Instead, using a legacy button but making it appear 32px wide so that it looks like the new icon
 * button. Any narrower and it becomes an a11y issue having such a small click target
 */ const $6de3b6002c6b8813$var$iconButtonStyles = (0, $8CUq3.xcss)({
    display: 'inline-block',
    paddingLeft: 'space.050',
    paddingRight: 'space.050'
});
const $6de3b6002c6b8813$var$pickerContainerStyles = (0, $8CUq3.xcss)({
    flexGrow: '1',
    minWidth: '0'
});

});
parcelRegister("l2crx", function(module, exports) {

$parcel$export(module.exports, "SortDirectionIcon", () => $20144648f5e1180c$export$a6df6c2e349e4183);

var $5uXOq = parcelRequire("5uXOq");

var $588G7 = parcelRequire("588G7");

var $9j532 = parcelRequire("9j532");


var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $dYAoq = parcelRequire("dYAoq");
const $20144648f5e1180c$export$a6df6c2e349e4183 = ({ fieldDisplayText: fieldDisplayText, fieldSortDirection: fieldSortDirection })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span",
        xcss: [
            fieldSortDirection === (0, $9f1dbb2b39d4d9a2$export$6d60017b9e092e73) ? $20144648f5e1180c$var$iconButtonStyles : $20144648f5e1180c$var$displayNoneStyle
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9j532))), {
        LEGACY_size: "small",
        label: formatMessage((0, $dYAoq.default).sortButtonLabelAsc, {
            field: fieldDisplayText
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span",
        xcss: [
            fieldSortDirection === (0, $9f1dbb2b39d4d9a2$export$2ea27ea5f2121899) ? $20144648f5e1180c$var$iconButtonStyles : $20144648f5e1180c$var$displayNoneStyle
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($588G7))), {
        LEGACY_size: "small",
        label: formatMessage((0, $dYAoq.default).sortButtonLabelDesc, {
            field: fieldDisplayText
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span",
        xcss: [
            fieldSortDirection === undefined ? $20144648f5e1180c$var$iconButtonStyles : $20144648f5e1180c$var$displayNoneStyle
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($588G7))), {
        LEGACY_size: "small",
        label: formatMessage((0, $dYAoq.default).sortButtonWithDefaultAscDirectionLabel, {
            field: fieldDisplayText
        })
    })));
};
/**
 * There is a bug with the new Atlaskit IconButton where occasionally the onClick handler is not
 * triggered, when wrapped by a tooltip - https://atlassian.slack.com/archives/CFJ9DU39U/p1718597982581429
 * Instead, using a legacy button but making it appear 32px wide so that it looks like the new icon
 * button. Any narrower and it becomes an a11y issue having such a small click target
 */ const $20144648f5e1180c$var$iconButtonStyles = (0, $8CUq3.xcss)({
    display: 'inline-block',
    paddingLeft: 'space.050',
    paddingRight: 'space.050'
});
/**
 * Used to hide the icon that is not currently mapped to the fieldSortDirection using CSS instead of
 * React.
 *
 * For example:
 * If the fieldSortDirection is ASC, the <ArrowDown> will receive this style and be hidden.
 *
 * using CSS to show the correct icon keeps both icons in the DOM whereas conditionally rendering
 * based on `fieldSortDirection` will remove the unrelated icon from the DOM completely, on click.

 * This removal from the DOM interferes with onClick management in popper:
 * jira/platform/packages/design-system/popup/src/use-close-manager.tsx
 *
 * In the above file, if an element has gone missing from the DOM, the onClose functionality will
 * return early and leave any open pickers still open. Instead I want any open pickers to close if the
 * user clicks on a button elsewhere on the page (such as clicking on this icon when it is in a button)
 */ const $20144648f5e1180c$var$displayNoneStyle = (0, $8CUq3.xcss)({
    display: 'none'
});

});
parcelRegister("588G7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c41b8a7a2a0e885f53178dceb7a8d3e7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3bc46e6d650b1ecb$var$_react = $3bc46e6d650b1ecb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3bc46e6d650b1ecb$var$_arrowDown = $3bc46e6d650b1ecb$var$_interopRequireDefault((parcelRequire("cC5ib")));

var $3bc46e6d650b1ecb$var$_arrowDown2 = $3bc46e6d650b1ecb$var$_interopRequireDefault((parcelRequire("ls8Y7")));
function $3bc46e6d650b1ecb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowDownIcon.
 * This component is ArrowDownIcon, with `UNSAFE_fallbackIcon` set to "ArrowDownIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3bc46e6d650b1ecb$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $3bc46e6d650b1ecb$var$_react.default.createElement($3bc46e6d650b1ecb$var$_arrowDown.default, Object.assign({
        LEGACY_fallbackIcon: $3bc46e6d650b1ecb$var$_arrowDown2.default
    }, props));
$3bc46e6d650b1ecb$var$ArrowDownIcon.Name = 'ArrowDownIconMigration';
var $3bc46e6d650b1ecb$var$_default = module.exports.default = $3bc46e6d650b1ecb$var$ArrowDownIcon;

});
parcelRegister("cC5ib", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d7f5a6659a6d5dd6eaa41936b6c8533f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $92ed238f23140736$var$_react = $92ed238f23140736$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $92ed238f23140736$var$_baseNew = $92ed238f23140736$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $92ed238f23140736$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $92ed238f23140736$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $92ed238f23140736$var$_react.default.createElement($92ed238f23140736$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v11.44l3.72-3.72 1.06 1.06-5 5a.75.75 0 0 1-1.06 0l-5-5 1.06-1.06 3.72 3.72V1z" clip-rule="evenodd"/>`
    }, props));
$92ed238f23140736$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $92ed238f23140736$var$_default = module.exports.default = $92ed238f23140736$var$ArrowDownIcon;

});

parcelRegister("ls8Y7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f9e32b81d01f795b$var$_react = $f9e32b81d01f795b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $f9e32b81d01f795b$var$_arrowDown = $f9e32b81d01f795b$var$_interopRequireDefault((parcelRequire("cC5ib")));
function $f9e32b81d01f795b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f9e32b81d01f795b$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $f9e32b81d01f795b$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11 6v9.586l-3.793-3.793a1 1 0 0 0-1.414 0c-.39.39-.39 1.024 0 1.415l5.5 5.499A1 1 0 0 0 12 19a1 1 0 0 0 .707-.293l5.5-5.499a1 1 0 1 0-1.414-1.415L13 15.586V6a1 1 0 0 0-2 0"/></svg>`
    }, props, {
        newIcon: $f9e32b81d01f795b$var$_arrowDown.default
    }));
$f9e32b81d01f795b$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $f9e32b81d01f795b$var$_default = module.exports.default = $f9e32b81d01f795b$var$ArrowDownIcon;

});


parcelRegister("9j532", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7ae9adc1e99d7e27810a205cdfaded7b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6c69cdd6c9c50ed7$var$_react = $6c69cdd6c9c50ed7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6c69cdd6c9c50ed7$var$_arrowUp = $6c69cdd6c9c50ed7$var$_interopRequireDefault((parcelRequire("kcHZS")));

var $6c69cdd6c9c50ed7$var$_arrowUp2 = $6c69cdd6c9c50ed7$var$_interopRequireDefault((parcelRequire("kAObg")));
function $6c69cdd6c9c50ed7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowUpIcon.
 * This component is ArrowUpIcon, with `UNSAFE_fallbackIcon` set to "ArrowUpIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6c69cdd6c9c50ed7$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $6c69cdd6c9c50ed7$var$_react.default.createElement($6c69cdd6c9c50ed7$var$_arrowUp.default, Object.assign({
        LEGACY_fallbackIcon: $6c69cdd6c9c50ed7$var$_arrowUp2.default
    }, props));
$6c69cdd6c9c50ed7$var$ArrowUpIcon.Name = 'ArrowUpIconMigration';
var $6c69cdd6c9c50ed7$var$_default = module.exports.default = $6c69cdd6c9c50ed7$var$ArrowUpIcon;

});
parcelRegister("kcHZS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd7e8572b743336ba9352499cfa665f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb570e807ab2e210$var$_react = $eb570e807ab2e210$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $eb570e807ab2e210$var$_baseNew = $eb570e807ab2e210$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $eb570e807ab2e210$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eb570e807ab2e210$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $eb570e807ab2e210$var$_react.default.createElement($eb570e807ab2e210$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 15V3.56l3.72 3.72 1.06-1.06-5-5a.75.75 0 0 0-1.06 0l-5 5 1.06 1.06 3.72-3.72V15z" clip-rule="evenodd"/>`
    }, props));
$eb570e807ab2e210$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $eb570e807ab2e210$var$_default = module.exports.default = $eb570e807ab2e210$var$ArrowUpIcon;

});

parcelRegister("kAObg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $efde1844fc0ef421$var$_react = $efde1844fc0ef421$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $efde1844fc0ef421$var$_arrowUp = $efde1844fc0ef421$var$_interopRequireDefault((parcelRequire("kcHZS")));
function $efde1844fc0ef421$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $efde1844fc0ef421$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $efde1844fc0ef421$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.293 5.293-5.5 5.499a1 1 0 0 0 0 1.415 1 1 0 0 0 1.414 0L11 8.414V18a1 1 0 0 0 2 0V8.414l3.793 3.793a1 1 0 1 0 1.414-1.415l-5.5-5.499A1 1 0 0 0 12 5a1 1 0 0 0-.707.293"/></svg>`
    }, props, {
        newIcon: $efde1844fc0ef421$var$_arrowUp.default
    }));
$efde1844fc0ef421$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $efde1844fc0ef421$var$_default = module.exports.default = $efde1844fc0ef421$var$ArrowUpIcon;

});


parcelRegister("dYAoq", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0b1d9323c122e8b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $a0b1d9323c122e8b$var$messages = (0, $7VHMR.defineMessages)({
    sortButtonLabelAsc: {
        "id": "jql-builder-basic-order-by-select.common.sort-direction-icon.sort-button-label-asc",
        "defaultMessage": "{field} ordered by ascending. Reverse order"
    },
    sortButtonLabelDesc: {
        "id": "jql-builder-basic-order-by-select.common.sort-direction-icon.sort-button-label-desc",
        "defaultMessage": "{field} ordered by descending. Reverse order"
    },
    sortButtonWithDefaultAscDirectionLabel: {
        "id": "jql-builder-basic-order-by-select.common.sort-direction-icon.sort-button-with-default-asc-direction-label",
        "defaultMessage": "{field} does not have a sort direction. Set the direction to ascending"
    }
});
var $a0b1d9323c122e8b$export$2e2bcd8739ae039 = $a0b1d9323c122e8b$var$messages;

});


parcelRegister("jy8Nw", function(module, exports) {

$parcel$export(module.exports, "FALLBACK_SORT_DIRECTION", () => $95c9dad05c0aef39$export$252fa5d135c32113);

const $95c9dad05c0aef39$export$252fa5d135c32113 = (0, $9f1dbb2b39d4d9a2$export$6d60017b9e092e73);

});

parcelRegister("jYRch", function(module, exports) {

$parcel$export(module.exports, "toggleDirection", () => $27a4721f54388317$export$1af131c8fc2061e9);

const $27a4721f54388317$export$1af131c8fc2061e9 = (previousDirection)=>previousDirection === (0, $9f1dbb2b39d4d9a2$export$6d60017b9e092e73) ? (0, $9f1dbb2b39d4d9a2$export$2ea27ea5f2121899) : (0, $9f1dbb2b39d4d9a2$export$6d60017b9e092e73);

});

parcelRegister("3AKNm", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bc6f7e14e2fe468$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $2bc6f7e14e2fe468$var$messages = (0, $7VHMR.defineMessages)({
    sortButtonTooltip: {
        "id": "jql-builder-basic-order-by-select.order-by-field-picker.sort-button-tooltip",
        "defaultMessage": "Reverse order direction"
    },
    clearButtonTooltip: {
        "id": "jql-builder-basic-order-by-select.order-by-field-picker.clear-button-tooltip",
        "defaultMessage": "Remove field"
    },
    clearButtonLabel: {
        "id": "jql-builder-basic-order-by-select.order-by-field-picker.clear-button-label",
        "defaultMessage": "Remove {field}"
    },
    pickerLabel: {
        "id": "jql-builder-basic-order-by-select.order-by-field-picker.picker-label",
        "defaultMessage": "{field} selected"
    }
});
var $2bc6f7e14e2fe468$export$2e2bcd8739ae039 = $2bc6f7e14e2fe468$var$messages;

});

parcelRegister("bKfCU", function(module, exports) {

$parcel$export(module.exports, "OrderByPicker", () => $c41eaf646220c221$export$ea1910b400eacd30);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $hUqzg = parcelRequire("hUqzg");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $F7vyc = parcelRequire("F7vyc");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $a7uqQ = parcelRequire("a7uqQ");

var $l2crx = parcelRequire("l2crx");

var $jy8Nw = parcelRequire("jy8Nw");

var $jYRch = parcelRequire("jYRch");

var $3AKNm = parcelRequire("3AKNm");
const $c41eaf646220c221$export$ea1910b400eacd30 = ({ field: field, fieldIndex: fieldIndex, onChange: onChange, onRemove: onRemove, onLoadOptions: onLoadOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const pickerValue = (0, $5uXOq.useMemo)(()=>[
            {
                optionType: 'option',
                value: field.jqlTerm,
                label: field.displayText
            }
        ], [
        field.displayText,
        field.jqlTerm
    ]);
    const handleRemoveFieldButtonClick = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        e.preventDefault();
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'orderBySelectRemoveFieldClick');
        onRemove(fieldIndex);
    }, [
        fieldIndex,
        onRemove
    ]);
    const handleTriggerClick = (0, $5uXOq.useCallback)((e)=>{
        e.preventDefault();
        setIsOpen((currentisOpen)=>{
            const newOpenState = !currentisOpen;
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
                action: 'clicked',
                actionSubject: 'dropdownMenu',
                actionSubjectId: 'orderBySelectFieldPicker',
                attributes: {
                    isOpen: newOpenState
                }
            });
            return newOpenState;
        });
    }, [
        createAnalyticsEvent
    ]);
    const handlePickerCloseClick = (0, $5uXOq.useCallback)((e)=>{
        e.preventDefault();
        setIsOpen(false);
    }, []);
    const handleSortDirectionClick = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        e.preventDefault();
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'orderBySelectSortDirectionClick');
        /**
     * It is expected that some order by fields in JQL dont have an explicit direction,
     * E.g. `ORDER BY project` instead of `ORDER BY project ASC`
     * In these cases if the direction is toggled, we add an explicit direction
     */ const updatedField = {
            ...field,
            direction: field.direction ? (0, $jYRch.toggleDirection)(field.direction) : (0, $jy8Nw.FALLBACK_SORT_DIRECTION)
        };
        onChange(fieldIndex, updatedField);
    }, [
        field,
        fieldIndex,
        onChange
    ]);
    const handleFieldChanged = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
        // @ts-expect-error TS inference not working with the SelectedValue type
        // despite explicit checks it always still thinks it might be an array or null
        // not sure of the root cause whether type defs in
        // jira/src/packages/jql-builder/basic-picker/src/common/types.tsx or TS issue at
        // the platform level
        if (newValue === null || Array.isArray(newValue) || !newValue.value || !newValue.label) return null;
        if (actionMeta.action === 'select-option') {
            const updatedField = {
                // @ts-expect-error see above
                displayText: newValue.label,
                // @ts-expect-error see above
                jqlTerm: newValue.value,
                direction: field.direction
            };
            onChange(fieldIndex, updatedField);
            setIsOpen(false);
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'changed',
                actionSubject: 'selectOption'
            }), 'orderByFieldPicker');
        }
    }, [
        createAnalyticsEvent,
        field.direction,
        fieldIndex,
        onChange
    ]);
    const onPickerTrigger = (0, $5uXOq.useCallback)((triggerProps, triggerRef)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a7uqQ.default), {
            triggerProps: triggerProps,
            displayText: field.displayText,
            onClick: handleTriggerClick,
            isOpen: isOpen,
            ariaLabel: formatMessage((0, $3AKNm.default).pickerLabel, {
                field: field.displayText
            }),
            shouldFitContainer: true,
            triggerRef: triggerRef
        }), [
        field.displayText,
        formatMessage,
        handleTriggerClick,
        isOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $c41eaf646220c221$var$pickerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $F7vyc.PickerEntryPoint), {
        isMulti: false,
        isOpen: isOpen,
        id: `order-by-select-field-${fieldIndex}`,
        value: pickerValue,
        onTrigger: onPickerTrigger,
        onClose: handlePickerCloseClick,
        onChange: handleFieldChanged,
        onLoadOptions: onLoadOptions,
        shouldRenderToParent: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $c41eaf646220c221$var$sortButtonContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        position: "bottom",
        content: formatMessage((0, $3AKNm.default).sortButtonTooltip)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            ...tooltipProps,
            onClick: handleSortDirectionClick,
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l2crx.SortDirectionIcon), {
                fieldDisplayText: field.displayText,
                fieldSortDirection: field.direction
            })
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $c41eaf646220c221$var$clearButtonContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        position: "bottom",
        content: formatMessage((0, $3AKNm.default).clearButtonTooltip)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            ...tooltipProps,
            appearance: "subtle",
            onClick: handleRemoveFieldButtonClick,
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                as: "span",
                xcss: [
                    $c41eaf646220c221$var$iconButtonStyles
                ]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hUqzg))), {
                LEGACY_size: "small",
                label: formatMessage((0, $3AKNm.default).clearButtonLabel, {
                    field: field.displayText
                })
            }))
        }))));
};
const $c41eaf646220c221$var$sortButtonContainerStyles = (0, $8CUq3.xcss)({
    flex: 'none',
    marginLeft: 'space.075'
});
const $c41eaf646220c221$var$clearButtonContainerStyles = (0, $8CUq3.xcss)({
    flex: 'none',
    marginLeft: 'space.150'
});
/**
 * There is a bug with the new Atlaskit IconButton where occasionally the onClick handler is not
 * triggered, when wrapped by a tooltip - https://atlassian.slack.com/archives/CFJ9DU39U/p1718597982581429
 * Instead, using a legacy button but making it appear 32px wide so that it looks like the new icon
 * button. Any narrower and it becomes an a11y issue having such a small click target
 */ const $c41eaf646220c221$var$iconButtonStyles = (0, $8CUq3.xcss)({
    display: 'inline-block',
    paddingLeft: 'space.050',
    paddingRight: 'space.050'
});
const $c41eaf646220c221$var$pickerContainerStyles = (0, $8CUq3.xcss)({
    flexGrow: '1',
    minWidth: '0'
});

});



parcelRegister("hq3To", function(module, exports) {

$parcel$export(module.exports, "default", () => $b62efd4f61bb47e8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $5pW9O = parcelRequire("5pW9O");
const $b62efd4f61bb47e8$var$FooterButton = ({ onClear: onClear })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleClick = (0, $5uXOq.useCallback)((mouseEvent, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'orderByClearSelectedItems', {
            // If number of clicks is 0, button was actioned using the keyboard
            keyboard: mouseEvent.detail === 0
        });
        onClear && onClear();
    }, [
        onClear
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $b62efd4f61bb47e8$var$footerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $b62efd4f61bb47e8$var$buttonStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle-link",
        onClick: handleClick
    }, formatMessage((0, $5pW9O.default).buttonText))));
};
var $b62efd4f61bb47e8$export$2e2bcd8739ae039 = $b62efd4f61bb47e8$var$FooterButton;
const $b62efd4f61bb47e8$var$footerStyle = (0, $8CUq3.xcss)({
    paddingTop: 'space.050',
    paddingBottom: 'space.050',
    justifyContent: 'start',
    borderTop: `1px solid ${"var(--ds-border, #091E4224)"}`
});
const $b62efd4f61bb47e8$var$buttonStyle = (0, $8CUq3.xcss)({
    padding: 'space.050',
    alignSelf: 'center',
    // left padding + left margin should total to 12px to match other picker types.
    marginInlineStart: 'space.100'
});

});
parcelRegister("5pW9O", function(module, exports) {

$parcel$export(module.exports, "default", () => $13292e3ca23ec457$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $13292e3ca23ec457$var$messages = (0, $7VHMR.defineMessages)({
    buttonText: {
        "id": "jql-builder-basic.jql-editor.order-by-picker.footer.button-text",
        "defaultMessage": "Clear selection"
    }
});
var $13292e3ca23ec457$export$2e2bcd8739ae039 = $13292e3ca23ec457$var$messages;

});


parcelRegister("epfOY", function(module, exports) {

$parcel$export(module.exports, "compareSortFields", () => $7bb99237f62b7f8b$export$d1fbc8ef95bdef46);
$parcel$export(module.exports, "getNextSelectedOrderByFields", () => $7bb99237f62b7f8b$export$d06db05a248b8bec);
$parcel$export(module.exports, "printJast", () => $7bb99237f62b7f8b$export$bfda6e07879dd093);

var $l0V05 = parcelRequire("l0V05");

var $f1i4L = parcelRequire("f1i4L");
const $7bb99237f62b7f8b$export$d1fbc8ef95bdef46 = (sortFields1, sortFields2)=>{
    if (sortFields1.length !== sortFields2.length) return false;
    return sortFields1.every((sortField, index)=>sortField.jqlTerm === sortFields2[index].jqlTerm && sortField.direction === sortFields2[index].direction);
};
const $7bb99237f62b7f8b$var$getHydrationDisplayNameMap = (hydrationData)=>{
    const hydrationMap = new Map();
    (hydrationData?.jira?.jqlBuilder?.hydrateJqlQuery ?? hydrationData?.jira?.jqlBuilder?.hydrateJqlQueryForFilter)?.fields?.map((field)=>field.field && field.jqlTerm && hydrationMap.set(field.jqlTerm.toLowerCase(), field.field.displayName ?? ''));
    return hydrationMap;
};
const $7bb99237f62b7f8b$export$d06db05a248b8bec = ({ ast: ast, hydrationData: hydrationData, selectedOrderByFields: selectedOrderByFields })=>{
    const astSortFields = (0, $f1i4L.getAstSortFields)(ast);
    const hydrationDisplayNameMap = $7bb99237f62b7f8b$var$getHydrationDisplayNameMap(hydrationData);
    const nextSelectedOrderByFields = astSortFields.map((astSortField)=>{
        let displayText;
        const hydratedDisplayName = hydrationDisplayNameMap.get(astSortField.jqlTerm.toLowerCase());
        const existingField = selectedOrderByFields.find((selectedOrderByField)=>selectedOrderByField.jqlTerm === astSortField.jqlTerm);
        if (hydratedDisplayName !== undefined) displayText = hydratedDisplayName;
        else displayText = existingField?.displayText ?? '';
        const selectedOrderByField = {
            displayText: displayText,
            jqlTerm: astSortField.jqlTerm,
            direction: astSortField.direction
        };
        return selectedOrderByField;
    });
    return nextSelectedOrderByFields;
};
const $7bb99237f62b7f8b$export$bfda6e07879dd093 = (jast)=>(0, $l0V05.print)(jast, {
        operatorCase: 'upper'
    });

});


parcelRegister("dj8g2", function(module, exports) {

$parcel$export(module.exports, "AsyncRegisterSearchCriteriaToShortcutsDialog", () => $20c233b7135df312$export$f2345c1eb3a17e65);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");

var $a0UwL = parcelRequire("a0UwL");

var $kxZPA = parcelRequire("kxZPA");
var $6Lg6A = parcelRequire("6Lg6A");

var $kQ256 = parcelRequire("kQ256");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $20c233b7135df312$var$RegisterSearchCriteriaToShortcutsDialog = (0, $kxZPA.lazy)(()=>(parcelRequire("k3KIP")), {
    moduleId: "./src/packages/jql-builder/basic/src/ui/jql-editor/register-search-criteria-to-shortcuts-dialog/index.tsx"
});
const $20c233b7135df312$export$f2345c1eb3a17e65 = (props)=>{
    const [{ isShortcutsDialogVisible: isShortcutsDialogVisible }] = (0, $a0UwL.useShortcuts)();
    const { isShortcutsDialogIntegrationAvailable: isShortcutsDialogIntegrationAvailable } = (0, $kQ256.useIntegrateDotDialogContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "issue-navigatior-search-criteria-shortcuts-dialog",
        packageName: "jql-builder-basic"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Lg6A.LazyWait), {
        until: isShortcutsDialogIntegrationAvailable && isShortcutsDialogVisible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-register-shortcut-dialog-actions",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($20c233b7135df312$var$RegisterSearchCriteriaToShortcutsDialog, props))));
};

});
parcelRegister("a0UwL", function(module, exports) {

$parcel$export(module.exports, "useShortcuts", () => $991d4b7077d5c717$export$a1ca853c6e4bb6fb);
$parcel$export(module.exports, "useShortcutsActions", () => $991d4b7077d5c717$export$b331ee6e87b9104c);

var $axjlw = parcelRequire("axjlw");
const $991d4b7077d5c717$export$a1ca853c6e4bb6fb = ()=>(0, $axjlw.useShortcutsStore)();
const $991d4b7077d5c717$export$b331ee6e87b9104c = ()=>{
    const [, actions] = (0, $axjlw.useShortcutsActionsStore)();
    return [
        undefined,
        actions
    ];
};

});
parcelRegister("axjlw", function(module, exports) {

$parcel$export(module.exports, "useShortcutsStore", () => $fefbe59bb1ce22b9$export$a14646bfc7ba8d81);
$parcel$export(module.exports, "useShortcutsActionsStore", () => $fefbe59bb1ce22b9$export$1a29bfef7fa09838);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $f0R9h = parcelRequire("f0R9h");
const $fefbe59bb1ce22b9$export$d4c72bab9d6cc13a = {
    shortcuts: {
        admin: {
            key: 'admin',
            label: 'ADMIN',
            options: [],
            isLoaded: false
        }
    },
    isShortcutsDialogVisible: false,
    isShortcutsLoading: false,
    hasError: false,
    isAdminLoading: false,
    selectedItemKey: null,
    header: null,
    title: undefined
};
const $fefbe59bb1ce22b9$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'shortcuts',
    initialState: // @ts-expect-error - TS2322 - Type '{ readonly shortcuts: { readonly admin: { readonly key: "admin"; readonly label: "ADMIN"; readonly options: readonly []; readonly isLoaded: false; }; }; readonly isShortcutsDialogVisible: false; readonly isShortcutsLoading: false; ... 4 more ...; readonly title: undefined; }' is not assignable to type 'State'.
    $fefbe59bb1ce22b9$export$d4c72bab9d6cc13a,
    actions: $f0R9h
});
const $fefbe59bb1ce22b9$export$a14646bfc7ba8d81 = (0, $3sQ5x.createHook)($fefbe59bb1ce22b9$export$6f57813fe9f31bf9);
const $fefbe59bb1ce22b9$export$1a29bfef7fa09838 = (0, $3sQ5x.createHook)($fefbe59bb1ce22b9$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("f0R9h", function(module, exports) {

$parcel$export(module.exports, "registerShortcuts", () => $d845eb212fa1ca53$export$598ec0e6047cbdca);
$parcel$export(module.exports, "setShortcutsDialogVisibility", () => $d845eb212fa1ca53$export$80ab1e79e32c3021);
$parcel$export(module.exports, "setShortcutsLoading", () => $d845eb212fa1ca53$export$7ed2ac8328423043);
$parcel$export(module.exports, "setHasError", () => $d845eb212fa1ca53$export$645a7c7453685186);
$parcel$export(module.exports, "setHeader", () => $d845eb212fa1ca53$export$604ed74fb893f0e2);
$parcel$export(module.exports, "fetchAdminSections", () => $d845eb212fa1ca53$export$aec87c8c9bde62e6);
$parcel$export(module.exports, "setSelectedItemKey", () => $d845eb212fa1ca53$export$249c9d5b49cd9712);
$parcel$export(module.exports, "dropShortcutsByKeys", () => $d845eb212fa1ca53$export$9cf39adf0dec984);

var $k8IPx = parcelRequire("k8IPx");

var $1qfyE = parcelRequire("1qfyE");

var $8mrJC = parcelRequire("8mrJC");
const $d845eb212fa1ca53$export$598ec0e6047cbdca = (shortcuts)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const newShortcuts = shortcuts.reduce((acc, current)=>{
            acc[current.key] = current;
            return acc;
        }, {
            ...currentState.shortcuts
        });
        setState({
            ...currentState,
            shortcuts: newShortcuts,
            isShortcutsLoading: false
        });
    };
const $d845eb212fa1ca53$export$80ab1e79e32c3021 = (isVisible)=>({ getState: getState, setState: setState })=>{
        setState({
            ...getState(),
            isShortcutsDialogVisible: isVisible
        });
    };
const $d845eb212fa1ca53$export$7ed2ac8328423043 = (isLoading)=>({ getState: getState, setState: setState })=>{
        setState({
            ...getState(),
            isShortcutsLoading: isLoading
        });
    };
const $d845eb212fa1ca53$export$645a7c7453685186 = (hasError)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            hasError: hasError
        });
    };
const $d845eb212fa1ca53$export$604ed74fb893f0e2 = (header, title)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            header: header,
            title: title
        });
    };
const $d845eb212fa1ca53$export$aec87c8c9bde62e6 = ()=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            isAdminLoading: true
        });
        const result = await (0, $1qfyE.default)();
        const shortcuts = result ? (0, $8mrJC.buildAdminSections)(result) : [];
        const newState = getState();
        setState({
            ...newState,
            shortcuts: {
                ...newState.shortcuts,
                admin: {
                    ...newState.shortcuts.admin,
                    key: 'admin',
                    options: shortcuts,
                    isLoaded: true
                }
            },
            hasError: currentState.hasError || !result,
            isAdminLoading: false
        });
    };
const $d845eb212fa1ca53$export$249c9d5b49cd9712 = (item)=>({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            selectedItemKey: item
        });
    };
const $d845eb212fa1ca53$export$9cf39adf0dec984 = (keys)=>({ getState: getState, setState: setState })=>{
        if (!keys.length) return;
        const { shortcuts: shortcuts, ...rest } = getState();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newShortcuts = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(Object.keys(shortcuts), keys).reduce((acc, key)=>{
            acc[key] = shortcuts[key];
            return acc;
        }, {});
        setState({
            ...rest,
            shortcuts: newShortcuts,
            isShortcutsLoading: false
        });
    };

});
parcelRegister("1qfyE", function(module, exports) {

$parcel$export(module.exports, "default", () => $0636f27c00094fd3$export$2e2bcd8739ae039);

var $2YZCu = parcelRequire("2YZCu");

var $7f4tk = parcelRequire("7f4tk");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0636f27c00094fd3$export$2e2bcd8739ae039 = async ()=>{
    try {
        return await (0, $7f4tk.default)('/rest/adminquicksearch/latest/links/default');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('shortcuts-dialog.fetch-admin-links', error.toString());
        return null;
    }
};

});

parcelRegister("8mrJC", function(module, exports) {

$parcel$export(module.exports, "buildAdminSections", () => $9289773ab8ca36d5$export$5f8c94ecd4c9eb76);
const $9289773ab8ca36d5$export$5f8c94ecd4c9eb76 = (parent, result = [])=>{
    if (parent.sections && parent.sections.length) parent.sections.forEach((s)=>$9289773ab8ca36d5$export$5f8c94ecd4c9eb76(s, result));
    if (parent.items && parent.items.length) parent.items.forEach((i)=>result.push({
            key: i.key,
            label: i.label,
            // @ts-expect-error - TS2322 - Type '() => void' is not assignable to type '(event?: Event | undefined) => Promise<undefined> | undefined'.
            onClick: ()=>{
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                window.location.href = i.linkUrl;
            }
        }));
    return result;
};

});




parcelRegister("k3KIP", function(module, exports) {

let $e9a8547850662dd9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e9a8547850662dd9$var$load("amx2m").then(()=>parcelRequire('2e4H4'));

});


parcelRegister("jfT3r", function(module, exports) {

$parcel$export(module.exports, "TextSearchInput", () => $8833bf47df627e44$export$451fab4acd1fe94e);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $gKZoD = parcelRequire("gKZoD");

var $kdfZa = parcelRequire("kdfZa");

var $5p1kJ = parcelRequire("5p1kJ");

var $5rVQI = parcelRequire("5rVQI");

var $eG9rp = parcelRequire("eG9rp");

var $879xD = parcelRequire("879xD");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dCm1o = parcelRequire("dCm1o");

var $6fhxU = parcelRequire("6fhxU");

var $hJajZ = parcelRequire("hJajZ");

var $aFqsz = parcelRequire("aFqsz");

var $4TUUg = parcelRequire("4TUUg");

var $kG16F = parcelRequire("kG16F");

var $8RcVP = parcelRequire("8RcVP");

var $5Sv2f = parcelRequire("5Sv2f");
const $8833bf47df627e44$export$451fab4acd1fe94e = ({ onSearchWrapper: onSearchWrapper, onJourneyStart: onJourneyStart, shouldUseListMarkup: shouldUseListMarkup, placeholder: placeholder })=>{
    (0, $gKZoD.di)(requestAnimationFrame);
    const intl = (0, $koVbs.default)();
    const [ast] = (0, $kG16F.useAST)();
    const [textSearchInputClause] = (0, $kG16F.useTextSearchInputClause)();
    const sendOptionAnalytics = (0, $5Sv2f.useSendOptionAnalytics)();
    const textSearchInputRef = (0, $5uXOq.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const value = (0, $5uXOq.useMemo)(()=>(0, $8RcVP.default).value(textSearchInputClause) || '', [
        textSearchInputClause
    ]);
    const focusTextSearchInput = (0, $5uXOq.useCallback)(()=>{
        // This prevents the shortcut from being fed into the input
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(textSearchInputRef) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(textSearchInputRef.current)) {
            // This is the same way the global search input prevents
            // the shortcut from being fed into the input
            // See: src/packages/navigation-apps/atlassian-navigation/src/ui/integrations/keyboard-shortcuts/index.tsx
            requestAnimationFrame(()=>{
                textSearchInputRef.current?.focus();
            });
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'pressed',
                actionSubject: 'keyboardShortcut'
            }), 'jqlEditorBasicSearchInputKeyboardShortcut', {
                keyPressed: 'f',
                keyboardShortcut: true
            });
        }
    }, [
        createAnalyticsEvent
    ]);
    const onTextFocus = (0, $5uXOq.useCallback)(()=>{
        if (!onJourneyStart) return;
        const analyticsEvent = createAnalyticsEvent({
            action: 'focused',
            actionSubject: 'input'
        });
        const attributes = onJourneyStart();
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'refinementBarSearchInput', attributes);
    }, [
        createAnalyticsEvent,
        onJourneyStart
    ]);
    const { getKeywords: getKeywords } = (0, $eG9rp.useCommandKeywords)();
    const StyledListItemChildComponent = (0, $dCm1o.isVisualRefreshEnabled)() ? (0, $hJajZ.default) : (0, $aFqsz.StyledListItemChild);
    const FieldWrapper = shouldUseListMarkup ? StyledListItemChildComponent : (0, $aFqsz.StyledChild);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $879xD.CommandShortcuts), {
        keyMap: {
            f: {
                callback: focusTextSearchInput,
                registerInCommandPalette: {
                    id: 'jql-builder-basic-jql-editor-text-picker-wrapper-focus-search-input',
                    name: intl.formatMessage((0, $6fhxU.default).searchCurrentPage),
                    keywords: getKeywords('pageSearchSynonyms'),
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kdfZa))), {
                                label: intl.formatMessage((0, $6fhxU.default).searchCurrentPage),
                                color: "var(--ds-icon, #44546F)"
                            })
                    },
                    priority: (0, $5rVQI.COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY).searchOnCurrentPage,
                    section: (0, $5p1kJ.COMMAND_PALETTE_SECTIONS).quickActions,
                    analytics: {
                        action: 'searchCurrentPage'
                    }
                }
            }
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4TUUg.default), {
        label: placeholder !== undefined && (0, $dCm1o.isVisualRefreshEnabled)() ? placeholder : intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $6fhxU.default).refinementSearchIssueTermRefresh : (0, $6fhxU.default).refinementSearch),
        value: value,
        onChange: (keyword)=>{
            onSearchWrapper && onSearchWrapper((0, $8RcVP.default).update(ast, textSearchInputClause, keyword));
        },
        onFocus: onJourneyStart ? onTextFocus : undefined,
        onSendOptionAnalytics: sendOptionAnalytics,
        inputRef: textSearchInputRef
    }));
};

});

parcelRegister("8chE6", function(module, exports) {

$parcel$export(module.exports, "useFieldsToRender", () => $4748af3a23a53cf7$export$4b20ffbea08469cb);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $lW1IZ = parcelRequire("lW1IZ");

var $b1PJk = parcelRequire("b1PJk");

var $fT4qt = parcelRequire("fT4qt");

var $jsBY2 = parcelRequire("jsBY2");
const $4748af3a23a53cf7$export$4b20ffbea08469cb = ({ query: query, loading: loading, fieldsHydrationData: fieldsHydrationData, excludedFields: excludedFields, irremovableFields: irremovableFields })=>{
    const intl = (0, $koVbs.default)();
    const comparator = (0, $jsBY2.useLocaleCompare)();
    const [{ astClauseOrder: astClauseOrder, clausesByFieldId: clausesByFieldId, secondaryClausesByFieldId: secondaryClausesByFieldId }] = (0, $lW1IZ.useSearchState)();
    const [internalState, setInternalState] = (0, $5uXOq.useReducer)((oldState, newState)=>({
            ...oldState,
            ...newState
        }), {
        internalJql: query,
        fieldsToRender: [],
        selectedFields: [],
        optionalFieldsCount: 0,
        showLoadingState: loading
    }, (initialState)=>{
        const { internalJql: internalJql, showLoadingState: showLoadingState } = initialState;
        const { fieldsToRender: fieldsToRender, optionalFieldsCount: optionalFieldsCount } = (0, $b1PJk.gatherFields)({
            selectedFields: [],
            excludedFields: excludedFields,
            intl: intl,
            fieldsHydratedData: fieldsHydrationData,
            irremovableFields: irremovableFields,
            astClauseOrder: astClauseOrder,
            clausesByFieldId: clausesByFieldId,
            secondaryClausesByFieldId: secondaryClausesByFieldId
        });
        const selectedFields = (0, $fT4qt.getSelectedFields)({
            fieldsToRender: fieldsToRender,
            intl: intl,
            comparator: comparator,
            irremovableFields: irremovableFields
        });
        return {
            internalJql: internalJql,
            fieldsToRender: fieldsToRender,
            selectedFields: selectedFields,
            optionalFieldsCount: optionalFieldsCount,
            showLoadingState: showLoadingState
        };
    });
    (0, $5uXOq.useEffect)(()=>{
        const { fieldsToRender: fieldsToRender, selectedFields: selectedFields, internalJql: internalJql } = internalState;
        const isExternalChange = internalJql !== query;
        const { fieldsToRender: newFieldsToRender, optionalFieldsCount: optionalFieldsCount, missingHydration: missingHydration } = (0, $b1PJk.gatherFields)({
            selectedFields: isExternalChange ? [] : selectedFields,
            excludedFields: excludedFields,
            intl: intl,
            fieldsHydratedData: fieldsHydrationData,
            previousFieldToRender: !isExternalChange ? fieldsToRender : [],
            irremovableFields: irremovableFields,
            astClauseOrder: astClauseOrder,
            clausesByFieldId: clausesByFieldId,
            secondaryClausesByFieldId: secondaryClausesByFieldId
        });
        const newSelectedFields = (0, $fT4qt.getSelectedFields)({
            fieldsToRender: newFieldsToRender,
            intl: intl,
            comparator: comparator,
            irremovableFields: irremovableFields
        });
        setInternalState({
            showLoadingState: missingHydration,
            fieldsToRender: newFieldsToRender,
            selectedFields: newSelectedFields,
            optionalFieldsCount: optionalFieldsCount,
            ...isExternalChange ? {
                internalJql: query
            } : {}
        });
    }, // When the query changes, we want to ensure fieldsToRender and selectedFields display as desired.
    // To prevent extraneous calls to useEffect, we leave out all dependencies besides query and fieldsHydrationData.
    // Where required, selectedFields state will be updated before query is.
    // We also assume that ast only changes when query also does.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        query,
        fieldsHydrationData
    ]);
    return {
        internalState: internalState,
        setInternalState: setInternalState
    };
};

});
parcelRegister("fT4qt", function(module, exports) {

$parcel$export(module.exports, "getSelectedFields", () => $3c129c2f5879e65b$export$3edef1dcbe28a0c6);

var $5uXOq = parcelRequire("5uXOq");

var $cgL5K = parcelRequire("cgL5K");

var $6s1PB = parcelRequire("6s1PB");

var $Nu4Sg = parcelRequire("Nu4Sg");

var $kHDIc = parcelRequire("kHDIc");

var $5Dsab = parcelRequire("5Dsab");

var $81SZ3 = parcelRequire("81SZ3");
const $3c129c2f5879e65b$export$3edef1dcbe28a0c6 = ({ fieldsToRender: fieldsToRender, comparator: comparator, intl: intl, irremovableFields: irremovableFields })=>fieldsToRender.filter(({ fieldId: fieldId })=>// should not be an irremovable field
        !irremovableFields.has(fieldId)).sort((a, b)=>comparator(a.fieldLabel || '', b.fieldLabel || '')).map(({ fieldId: fieldId, fieldLabel: fieldLabel, fieldDescription: fieldDescription, picker: picker, fieldTypeDisplayName: fieldTypeDisplayName, shouldShowInContext: shouldShowInContext })=>{
        const isDisabled = picker.searchTemplate === (0, $5Dsab.EPIC_LINK).searchTemplate;
        let isOnlyUnselectable = false;
        let disabledMessage = isDisabled ? intl.formatMessage((0, $81SZ3.default).deprecatedEpicMessage, {
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                    as: "strong",
                    color: "inherit",
                    size: "UNSAFE_small"
                }, chunks)
        }) : undefined;
        if (shouldShowInContext === false) {
            isOnlyUnselectable = true;
            disabledMessage = intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $81SZ3.default).notInContextFieldMessageIssueTermRefresh : (0, $81SZ3.default).notInContextFieldMessage);
        }
        if (isDisabled) {
            isOnlyUnselectable = true;
            disabledMessage = intl.formatMessage((0, $81SZ3.default).deprecatedEpicMessage, {
                strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                        as: "strong",
                        color: "inherit",
                        size: "UNSAFE_small"
                    }, chunks)
            });
        }
        const icon = picker.fieldType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kHDIc.FieldTypeIcon), {
            type: picker.fieldType,
            size: "small"
        }) : undefined;
        const fieldOption = {
            optionType: 'field',
            label: fieldLabel || '',
            value: fieldId,
            isOnlyUnselectable: isOnlyUnselectable,
            disabledMessage: disabledMessage,
            searchTemplate: picker.searchTemplate,
            fieldType: picker.fieldType,
            secondaryLabel: fieldTypeDisplayName && icon ? (0, $Nu4Sg.getSecondaryLabelWithIcon)(icon, fieldTypeDisplayName) : undefined,
            fieldTypeDisplayName: fieldTypeDisplayName,
            fieldDescription: fieldDescription,
            operators: picker.allowedOperators?.map((operator)=>operator.value)
        };
        return fieldOption;
    });

});
parcelRegister("81SZ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3a04109a84cf563$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $c3a04109a84cf563$var$messages = (0, $7VHMR.defineMessages)({
    deprecatedEpicMessage: {
        "id": "jql-builder-basic.utils.deprecated-epic-message",
        "defaultMessage": "<strong>Epic Link</strong> is replaced by <strong>Parent</strong>. Use the <strong>Parent</strong> field instead."
    },
    notInContextFieldMessage: {
        "id": "jql-builder-basic.utils.not-in-context-field-message",
        "defaultMessage": "This field is unavailable for the selected project and/or issue type."
    },
    notInContextFieldMessageIssueTermRefresh: {
        "id": "jql-builder-basic.utils.not-in-context-field-message-issue-term-refresh",
        "defaultMessage": "This field is unavailable for the selected project and/or work type."
    }
});
var $c3a04109a84cf563$export$2e2bcd8739ae039 = $c3a04109a84cf563$var$messages;

});


parcelRegister("jsBY2", function(module, exports) {

$parcel$export(module.exports, "useLocaleCompare", () => $9cbcbff4853a1ba1$export$b0592aef48e26713);

var $5uXOq = parcelRequire("5uXOq");

var $lzeFL = parcelRequire("lzeFL");

var $9OXo1 = parcelRequire("9OXo1");
const $9cbcbff4853a1ba1$export$b0592aef48e26713 = ()=>{
    const { locale: locale } = (0, $9OXo1.useTenantContext)();
    return (0, $5uXOq.useMemo)(()=>{
        const collator = new Intl.Collator((0, $lzeFL.standardizeLocale)(locale), {
            sensitivity: 'base'
        });
        return collator.compare;
    }, [
        locale
    ]);
};

});




//# sourceMappingURL=async-jql-builder-basic-jql-editor.bdfdbe71.js.map
